<!--
 * @Author: caizexin caizexin@kjgb.net
 * @Date: 2023-07-28 09:16:52
 * @LastEditors: caizexin caizexin@kjgb.net
 * @LastEditTime: 2025-12-18 14:17:05
 * @FilePath: \vue-hepha-order\src\views\order\OrderList.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<template>
    <div id="listContainer">
        <div class="queryPanel">
            <div class="queryPanel_form" :class="{'queryPanel_form_show': showForm}">
                <Form
                    :form="queryForm"
                    @handleSelectChange="handleSelectChange"
                    @handlePressEnter="handlePressEnter"
                    @handleInputClear=handleInputClear
                    @handlePickerDateChange="handlePickerDateChange"
                    @handleFetchSearch="handleFetchSearch"
                ></Form>
            </div>
            <div class="queryPanel_btn">
                <a-dropdown-button size="small" @click="handle('search')">
                    <icon-search size="14" style="marginRight:5px;"/>
                    {{ $t('base.search') }}
                    <template #content>
                        <a-doption @click="handle('reset')">
                            <icon-refresh size="14" style="marginRight:5px;"/>
                            {{ $t('base.reset') }}
                        </a-doption>
                    </template>
                </a-dropdown-button>
                <span class="openBtn" v-if="!showForm" @click="showFormPanel(true)">
                    <icon-down-circle size="14"/>
                    {{ $t('base.open') }}
                </span>
                <span class="openBtn" v-else @click="showFormPanel(false)">
                    <icon-up-circle size="14" />
                    {{ $t('base.close') }}
                </span>
            </div>
        </div>

        <Table 
            ref="orderTableRef"
            :table="table"
            @expandRow="expandRow"
            @changePage="changePage"
            @changePageSize="changePageSize"
            @selectRow="selectRow"
            @selectAllRow="selectAllRow"
            @sorterChange="sorterChange"
            @cellClick="cellClick"
        >
            <template v-slot:operate>
                <a-button type="primary" size="mini" v-permission="'setting.order.createOrder'" @click="handle('createOrder')">
                    <icon-plus-circle size="13" style="marginRight:5px;"/>
                    {{ $t('order.create') }}
                </a-button>
                <a-divider direction="vertical" />
                <a-dropdown-button size="mini" v-permission="'setting.order.exportOrder'" :disabled="exportingOrder" @click="handle('exportOrder')">
                    <icon-download size="13" style="marginRight:5px;"/>
                    {{ $t('order.exportOrder') }}
                    <template #content>
                        <a-doption v-permission="'setting.order.exportOrder'" :disabled="exportingOrder" @click="handle('exportOrder')">
                            <icon-download size="13" style="marginRight:5px;"/>
                            {{ $t('order.exportOrder') }}
                        </a-doption>
                        <a-doption v-permission="'setting.order.exportCustomer'" :disabled="exportingCustomer" @click="handle('exportCustomer')">
                            <icon-download size="13" style="marginRight:5px;"/>
                            {{ $t('order.exportCustomer') }}
                        </a-doption>
                    </template>
                </a-dropdown-button>
            </template>

            <!-- 父表格自定义字段 -->
            <!-- <template v-slot:editOrderStatus="{ props }">
                <a-badge :color="getoOderStatus('badgeOrderStatus', props.record.order_status)" :text="props.record.order_status" />
            </template> -->
            <template v-slot:editCourierStatus="{ props }">
                <a-tag v-if="props.record.courier_status !== '-'" :color="getoOderStatus('badgeCourierStatus', props.record.courier_status)">{{ props.record.courier_status }}</a-tag>
                <span v-else>{{props.record.courier_status}}</span>
            </template>
            <template v-slot:editAmount="{ props }">
                <div class="amountBlock" :class="{'amountBlock2':locale == 'zh'}">   
                    <p>
                       <span> {{ $t('order.orderAmount') }}：</span>
                       {{ props.record.order_amount }}
                    </p>
                    <!-- 折叠时显示 Order Amount、Discount、Freight Fee、Payment Terms Discount、Refund Amount、Final Amount（即 Invoice Amount，PAY_AMOUNT） -->
                    <p>
                        <span>{{ $t('order.orderDiscount') }}：</span>
                        {{ props.record.order_discount }}
                    </p>
                    <p>
                        <span>{{ $t('order.cargoFreight') }}：</span>
                        {{ props.record.cargo_freight }}
                    </p>
                    <p>
                        <span>{{ $t('order.payTypeDiscount') }}：</span>
                        {{ props.record.pay_type_discount_display }}
                    </p>
                    <p>
                        <span>{{ $t('order.refundAmount') }}：</span>
                        {{ props.record.refund_amount }}
                    </p>
                    <p>
                        <span>{{ $t('order.finalAmount') }}：</span>
                        {{ props.record.pay_amount }}
                    </p>
                    <div v-if="canViewAmountDetail && props.record.showAmount">
                        <p>
                            <span>{{ $t('order.realPayAmount') }}：</span>
                            {{ props.record.real_pay_amount }}
                        </p>
                        <p>
                            <span>{{ $t('order.orderTax') }}：</span>
                            {{ props.record.order_tax }}
                        </p>
                        <p>
                            <span>{{ $t('order.taxRate') }}：</span>
                            {{ props.record.tax_rate }}
                        </p>    
                    </div>
                    <div class="arrowTop" :class="{'arrowBottom': canViewAmountDetail && props.record.showAmount}">
                        <!-- 无 setting.order.viewAmountDetail 权限（all_query）：箭头置灰、不可点 -->
                        <p v-if="!canViewAmountDetail" style="color: #c9cdd4;cursor: not-allowed;">
                            <icon-down-circle size="14"/>
                        </p>
                        <p style="color: #4393fa;cursor: pointer;" v-else-if="!props.record.showAmount" @click="props.record.showAmount = true">
                            <icon-down-circle size="14"/>
                        </p>
                        <p style="color: #4393fa;cursor: pointer;" v-else @click="props.record.showAmount = false">
                            <icon-up-circle size="14" />
                        </p>
                    </div>
                </div>
            </template>

            <!-- 父表格操作 -->
            <template v-slot:tableOperate="{ props }">
                <a-button 
                    v-permission="'setting.order.shippingApply'" 
                    type="primary" size="mini" 
                    style="margin: 1px;width: 110px;"
                    :disabled="props.record.erp_no == '-' || props.record.order_status_val == '2' || props.record.order_status_val == '6' || props.record.prepaid_flag === 1 || props.record.order_channel_type_val == 4" 
                    @click="handle('deliver',props.record)"
                >{{ $t('order.deliver') }}</a-button>

                <!-- 折叠按钮 -->
                <a-popover position="left" style="width:700px" >
                    <a-button 
                        v-if="!is_hepha_customer"
                        type="primary" 
                        size="mini" 
                        style="margin: 1px;width: 110px;"
                        :disabled="(props.record.order_channel_type_val == -1 && (props.record.order_confirm_flag != 0 || props.record.order_status_val == 6))"
                    >
                        {{$t('base.more') }} <icon-more size="16" style="margin-left:5px;"/> 
                    </a-button>
                    <template #content v-if="props.record.order_channel_type_val != -1 || (props.record.order_channel_type_val == -1 && props.record.order_confirm_flag === 0 && props.record.order_status_val != 6)">
                        <!-- 基础操作 -->
                        <a-divider orientation="center">{{ $t('base.operation') }}</a-divider>
                        <a-button
                            v-permission="'setting.order.createServiceOrder'" 
                            type="text" size="mini" 
                            style="margin:10px 30px;width:150px;border:1px dashed rgba(22,93,255);outline:none" 
                            :style="{'border-color': !(props.record.order_channel_type_val == 0 && (props.record.courier_status_val == 2 || props.record.courier_status_val == 3 || props.record.courier_status_val == 4) && props.record.country == 'Germany')? 'rgba(159,212,253)' : 'rgba(22,93,255)'}"
                            :disabled="!(props.record.order_channel_type_val == 0 && (props.record.courier_status_val == 2 || props.record.courier_status_val == 3 || props.record.courier_status_val == 4) && props.record.country == 'Germany')" 
                            @click="handle('createServiceOrder_line',props.record)"
                        >{{ $t('order.createServiceOrder') }} </a-button>
                        <a-button 
                            v-permission="'setting.order.riskValidate'" 
                            type="text" size="mini"
                            style="margin:10px 30px;width:150px;border:1px dashed rgba(22,93,255);outline:none"
                            :style="{'border-color': props.record.source_val !== 1 ||  props.record.erp_no !== '-' || props.record.order_status_val == '6' || (props.record.source_val == 1 && props.record.risk_level_val == 1) || props.record.order_channel_type_val == 4 || props.record.order_channel_type_val == -1? 'rgba(159,212,253)' : 'rgba(22,93,255)'}"
                            :disabled="props.record.source_val !== 1 || props.record.erp_no !== '-' || props.record.order_status_val == '6' || (props.record.source_val == 1 && (props.record.risk_level_val === '' || props.record.risk_level_val == 1)) || props.record.order_channel_type_val == 4 || props.record.order_channel_type_val == -1"
                            @click="handle('riskValidate',props.record)"
                        >{{ $t('order.riskValidate') }}</a-button>
                        <a-button 
                            v-permission="'setting.order.syncToERP'" 
                            type="text" size="mini"
                            style="margin:10px 30px;width:150px;border:1px dashed rgba(22,93,255);outline:none"
                            :style="{'border-color': !((props.record.order_status_val != '2' && props.record.order_status_val != '6') && props.record.erp_no === '-') || props.record.remark == '915' || (props.record.source_val == 1 && (props.record.risk_level_val == 2 || props.record.risk_level_val == 3) && (props.record.risk_validate_val == 0 || props.record.risk_validate_val == 1) || props.record.order_channel_type_val == -1)? 'rgba(159,212,253)' : 'rgba(22,93,255)'}"
                            :disabled="!((props.record.order_status_val != '2' && props.record.order_status_val != '6') && props.record.erp_no === '-') || props.record.remark == '915' || (props.record.source_val == 1 && (props.record.risk_level_val == 2 || props.record.risk_level_val == 3) && (props.record.risk_validate_val == 0 || props.record.risk_validate_val == 1) || props.record.order_channel_type_val == -1)"
                            @click="handle('syncToERP',props.record)"
                        >{{ $t('order.syncToERP') }}</a-button>
                        <a-button 
                            v-permission="'setting.order.returnExchange'"
                            type="text" status="danger" size="mini" 
                            style="margin:10px 30px;width:150px;border:1px dashed red;outline:none" 
                            :style="{'border-color': props.record.order_type_val == 1 || props.record.order_status_val == '6' || (props.record.erp_no == '-' && (props.record.courier_status_val == '7' || props.record.courier_status_val == '8')) || (props.record.courier_status_val == '0' || props.record.courier_status_val == '1' || props.record.courier_status_val == '5') || props.record.order_channel_type_val == 4 || props.record.order_channel_type_val == -1? 'rgba(251,172,163)' : 'red'}"
                            :disabled="props.record.order_type_val == 1 || props.record.order_status_val == '6' || (props.record.erp_no == '-' && props.record.remark !== '915' && (props.record.courier_status_val == '7' || props.record.courier_status_val == '8')) || (props.record.courier_status_val == '0' || props.record.courier_status_val == '1' || props.record.courier_status_val == '5') || props.record.order_channel_type_val == 4 || props.record.order_channel_type_val == -1"
                            @click="handle('returnExchange',props.record)"
                        >{{ $t('returnExchange.returnExchange') }}</a-button>
                        <a-button 
                            v-permission="'setting.order.cancelSO'" 
                            type="text" size="mini" 
                            style="margin:10px 30px;width:150px;border:1px dashed rgba(22,93,255);outline:none"
                            :style="{'border-color': props.record.order_type_val == 1 || props.record.order_channel_type_val == 4 || props.record.order_channel_type_val == -1? 'rgba(159,212,253)' : 'rgba(22,93,255)'}"
                            :disabled="props.record.order_type_val == 1 || props.record.order_channel_type_val == 4 || props.record.order_channel_type_val == -1"
                            @click="handle('reissue',props.record)"
                        >{{ $t('order.reissue') }}</a-button>
                        <a-button 
                            v-permission="'setting.order.returnFactory'" 
                            type="text" size="mini" 
                            style="margin:10px 30px;width:150px;border:1px dashed rgba(22,93,255);outline:none"
                            :style="{'border-color': props.record.order_type_val == 1 || props.record.order_channel_type_val == 4 || props.record.order_channel_type_val == -1? 'rgba(159,212,253)' : 'rgba(22,93,255)'}"
                            :disabled="props.record.order_type_val == 1 || props.record.order_channel_type_val == 4 || props.record.order_channel_type_val == -1"
                            @click="handle('returnFactory',props.record)"
                        >{{ $t('order.returnFactory') }}</a-button>
                        <a-button 
                            v-permission="'setting.order.cancelSO'" 
                            type="text" status="warning" size="mini" 
                            style="margin:10px 30px;width:150px;border:1px dashed rgba(255,125,0);outline:none"   
                            :style="{'border-color': props.record.erp_no == '-' || props.record.order_status_val == '6' || props.record.order_channel_type_val == 4 || (props.record.courier_status_val != '0' && props.record.courier_status_val != '2' && props.record.courier_status_val != '4' && props.record.courier_status_val != '7' && props.record.courier_status_val != '10' && !(props.record.courier_status_val == 1 && isFinance))? 'rgba(255,207,139)' : 'rbga(255,125,0)'}"
                            :disabled="props.record.erp_no == '-' || props.record.order_status_val == '6' || props.record.order_channel_type_val == 4 || (props.record.courier_status_val != '0' && props.record.courier_status_val != '2' && props.record.courier_status_val != '4' && props.record.courier_status_val != '7' && props.record.courier_status_val != '10' && !(props.record.courier_status_val == 1 && isFinance))"
                            @click="handle('cancelSO',props.record)"
                        >{{ $t('order.cancelSO') }}</a-button>

                        <a-button 
                            v-permission="'setting.inventoryLock.inventoryLockDetail'" 
                            type="text" size="mini" 
                            style="margin:10px 30px;width:150px;border:1px dashed rgba(22,93,255);outline:none"
                            :style="{'border-color': props.record.order_channel_type_val == -1 || props.record.second_hand_flag == 1? 'rgba(159,212,253)' : 'rgba(22,93,255)'}"
                            :disabled="props.record.order_channel_type_val == -1 || props.record.second_hand_flag == 1"
                            @click="handle('inventoryLockDetail',props.record)"
                        >{{ $t('inventoryLock.inventoryLockDetail') }}</a-button>

                        <a-button 
                            v-permission="'setting.order.deleteOrder'" 
                            type="text" status="danger" size="mini"  
                            style="margin:10px 30px;width:150px;border:1px dashed red;outline:none" 
                            :style="{'border-color': !(props.record.source !== 'Shopify' && props.record.erp_no === '-') || props.record.order_channel_type_val == 4 || props.record.order_channel_type_val == -1 || props.record.remark == 915? 'rgba(251,172,163)' : 'red'}"
                            :disabled="!(props.record.source !== 'Shopify' && props.record.erp_no === '-') || props.record.order_channel_type_val == 4 || props.record.order_channel_type_val == -1 || props.record.remark == 915" 
                            @click="handle('delOrder',props.record)"
                        >{{ $t('order.delete') }}</a-button>
                        <a-button 
                            v-permission="'setting.order.editOrder'" 
                            type="text" size="mini" 
                            style="margin:10px 30px;width:150px;border:1px dashed rgba(22,93,255);outline:none"
                            :style="{'border-color': props.record.erp_no !== '-' && props.record.order_channel_type_val == 4 || props.record.order_channel_type_val == -1? 'rgba(159,212,253)' : 'rgba(22,93,255)'}"
                            :disabled="props.record.erp_no !== '-' && props.record.order_channel_type_val == 4 || props.record.order_channel_type_val == -1"
                            @click="handle('editOrder',props.record)"
                        >{{ $t('order.editOrder') }}</a-button>
                        <a-button 
                            v-permission="'setting.order.viewsLogistics'" 
                            type="text" size="mini" 
                            style="margin:10px 30px;width:150px;border:1px dashed rgba(22,93,255);outline:none" 
                            :style="{'border-color': props.record.order_channel_type_val != -1 || props.record.order_confirm_flag != 0? 'rgba(159,212,253)' : 'rgba(22,93,255)'}"
                            :disabled="props.record.order_channel_type_val != -1 || props.record.order_confirm_flag != 0" 
                            @click="handle('confirmVirtualOrder',props.record)"
                        >{{ $t('order.confirmVirtualOrder') }}</a-button>  
                        <a-button 
                            v-permission="'setting.order.viewsLogistics'" 
                            type="text" size="mini" 
                            style="margin:10px 30px;width:150px;border:1px dashed rgba(22,93,255);outline:none" 
                            :style="{'border-color': (props.record.erp_no == '-' || props.record.courier_status == '-' || props.record.order_channel_type_val == 4 || props.record.order_channel_type_val == -1) && props.record.remark != 915? 'rgba(159,212,253)' : 'rgba(22,93,255)'}"
                            :disabled="(props.record.erp_no == '-' || props.record.courier_status == '-' || props.record.order_channel_type_val == 4 || props.record.order_channel_type_val == -1) && props.record.remark != 915" 
                            @click="handle('viewLogistics',props.record)"
                        >{{ $t('order.viewLogistics2') }}</a-button>  
                        <a-button 
                            v-permission="'setting.order.createPrepaymentOrder'" 
                            type="text" size="mini" 
                            style="margin:10px 30px;width:150px;border:1px dashed rgba(22,93,255);outline:none"
                            :style="{'border-color': props.record.erp_no == '-' || props.record.order_channel_type_val != 1 || props.record.prepaid_flag !== 1 || props.record.order_channel_type_val == 4 || props.record.order_channel_type_val == -1? 'rgba(159,212,253)' : 'rgba(22,93,255)'}"
                            :disabled="props.record.erp_no == '-' || props.record.order_channel_type_val != 1 || props.record.prepaid_flag !== 1 || props.record.order_channel_type_val == 4 || props.record.order_channel_type_val == -1" 
                            @click="handle('createPrepaymentOrder',props.record)"
                        >{{ $t('order.createPrepaymentOrder') }}</a-button>  
                        <a-button 
                            v-permission="'setting.order.preInvoiceNo'" 
                            type="text" size="mini"  
                            style="margin:10px 30px;width:150px;border:1px dashed rgba(22,93,255);outline:none;font-size:12px;"
                            :style="{'border-color': props.record.order_channel_type_val !== 0 || props.record.order_channel_type_val == 4 || props.record.order_channel_type_val == -1? 'rgba(159,212,253)' : 'rgba(22,93,255)'}"
                            :disabled="props.record.order_channel_type_val !== 0 || props.record.order_channel_type_val == 4 || props.record.order_channel_type_val == -1" 
                            @click="handle('preInvoiceNo',props.record)"
                        >{{ $t('order.preInvoiceNo') }}</a-button>
                        <a-button 
                            v-if="props.record.order_channel_type_val == 1 || props.record.order_channel_type_val == 5 || userInfo.id == 45"
                            v-permission="'setting.order.downloadConfirmation'" 
                            type="text" size="mini" 
                            style="margin:10px 30px;width:150px;border:1px dashed rgba(22,93,255);outline:none"
                            @click="handle('downloadConfirmation',props.record)"
                        >{{ $t('order.downloadConfirmation') }}</a-button>
                        <a-button 
                            v-if="props.record.order_channel_type_val == 1 || props.record.order_channel_type_val == 5 || userInfo.id == 45"
                            v-permission="'setting.order.sendConfirmation'" 
                            type="text" size="mini" 
                            style="margin:10px 30px;width:150px;border:1px dashed rgba(22,93,255);outline:none" 
                            :style="{'border-color': sending? 'rgba(159,212,253)' : 'rgba(22,93,255)'}"
                            :disabled="sending" 
                            @click="handle('sendConfirmation',props.record)"
                        >
                            <span>{{ props.record.sendConfirmationBtnText }}</span> 
                        </a-button> 
                               

                        <!-- 变更订单状态 -->
                        <a-divider orientation="center" v-if="userInfo.role != '8'">{{ $t('order.changeOrderStatus') }}</a-divider>
                        <a-button
                            v-permission="'setting.order.paid'"
                            type="text" status="success" size="mini"
                            style="margin:10px 30px;width:150px;border:1px dashed rgba(0,180,42);outline:none"  
                            :style="{'border-color': props.record.source == 'Shopify' || props.record.order_status_val == '1'? 'rgba(123,225,136)' : 'rgba(0,180,42)'}"
                            :disabled="props.record.source == 'Shopify' || props.record.order_status_val == '1'"
                            @click="handle('paid',props.record)"
                        >{{ $t('order.pay') }}</a-button>
                        <a-button
                            v-permission="'setting.order.partialPay'"
                            type="text" size="mini"
                            style="margin:10px 30px;width:150px;color:#ff4500;border:1px dashed #ff4500;outline:none;"
                            :style="{'color': props.record.source == 'Shopify' || props.record.order_status_val == '0'? 'rgba(251,172,163)' : 'red', 'border-color': props.record.source == 'Shopify' || props.record.order_status_val == '0'? 'rgba(251,172,163)' : 'red'}"
                            :disabled="props.record.source == 'Shopify' || props.record.order_status_val == '0'"
                            @click="handle('partialPay',props.record)"
                        >{{ $t('order.partialPay') }}</a-button>
                        <a-button
                            v-permission="'setting.order.obligation'"
                            type="text" status="warning" size="mini"
                            style="margin:10px 30px;width:150px;border:1px dashed rgba(255,125,0);outline:none"
                            :style="{'border-color': props.record.source == 'Shopify' || props.record.order_status_val == '7'? 'rgba(255,207,139)' : 'rgba(255,125,0)'}"
                            :disabled="props.record.source == 'Shopify' || props.record.order_status_val == '7'"
                            @click="handle('unPaid',props.record)"
                        >{{ $t('order.obligation') }}</a-button>
                        <a-button
                            v-permission="'setting.order.refundOrder'"
                            type="text" status="danger" size="mini"
                            style="margin:10px 30px;width:150px;border:1px dashed red;outline:none"
                            :style="{'border-color': props.record.order_status_val == '2' || props.record.order_status_val == '6' || props.record.order_channel_type_val == 4 || props.record.order_channel_type_val == -1? 'rgba(251,172,163)' : 'red'}"
                            :disabled="props.record.order_status_val == '2' || props.record.order_status_val == '6' || props.record.order_channel_type_val == 4 || props.record.order_channel_type_val == -1"
                            @click="handle('refundOrder',props.record)"
                        >{{ $t('order.refundOrder') }}</a-button>
                        <a-button
                            v-permission="'setting.order.cancelOrder'"
                            type="text" size="mini"
                            style="margin:10px 30px;width:150px;border:1px dashed rgba(22,93,255);outline:none"
                            :style="{'border-color': props.record.order_status_val == '6' || props.record.order_channel_type_val == 4 || props.record.order_channel_type_val == -1? 'rgba(159,212,253)' : 'rgba(22,93,255)'}"
                            :disabled="props.record.order_status_val == '6' || props.record.order_channel_type_val == 4 || props.record.order_channel_type_val == -1"
                            @click="handle('cancelOrder',props.record)"
                        >{{ $t('order.cancelOrder') }}</a-button>

                        <!-- 记录相关 -->
                        <a-divider orientation="center">{{ $t('base.operationRecord') }}</a-divider>
                        <a-button 
                            v-permission="'setting.order.shoppingRecord'" 
                            type="text" size="mini" 
                            style="margin:10px 30px;width:150px;border:1px dashed #000;outline:none;color:#000" 
                            :style="{'border-color': props.record.courier_status == '-' || props.record.order_channel_type_val == 4 || props.record.order_channel_type_val == -1? '#ccc' : '#000','color': props.record.courier_status == '-' || props.record.order_channel_type_val == 4 || props.record.order_channel_type_val == -1? '#ccc' : '#000'}"
                            :disabled="props.record.courier_status == '-' || props.record.order_channel_type_val == 4 || props.record.order_channel_type_val == -1" 
                            @click="handle('deliverRecord',props.record)"
                        >{{ $t('order.deliverRecord2') }}</a-button>
                        <a-button 
                            v-permission="'setting.order.returnExchangeRecord'"
                            type="text" size="mini" 
                            style="margin:10px 30px;width:150px;border:1px dashed #000;outline:none;color:#000" 
                            :style="{'border-color': !(props.record.courier_status_val == 7 || props.record.courier_status_val == 8 || props.record.courier_status_val == 9 || props.record.courier_status_val == 10) || props.record.order_channel_type_val == 4 || props.record.order_channel_type_val == -1? '#ccc' : '#000', 'color': !(props.record.courier_status_val == 7 || props.record.courier_status_val == 8 || props.record.courier_status_val == 9 || props.record.courier_status_val == 10) || props.record.order_channel_type_val == 4? '#ccc' : '#000'}"
                            :disabled="!(props.record.courier_status_val == 7 || props.record.courier_status_val == 8 || props.record.courier_status_val == 9 || props.record.courier_status_val == 10) || props.record.order_channel_type_val == 4 || props.record.order_channel_type_val == -1"
                            @click="handle('returnExchangeRecord',props.record)"
                        >{{ $t('returnExchange.returnExchangeRecord2') }}</a-button>
                        <a-button 
                            v-permission="'setting.order.reissueRecord'"
                            type="text" size="mini" 
                            style="margin:10px 30px;width:150px;border:1px dashed #000;outline:none;color:#000"
                            :style="{'border-color': props.record.order_type_val == 1 || props.record.order_channel_type_val == 4 || props.record.order_channel_type_val == -1? '#ccc' : '#000', 'color': props.record.order_type_val == 1 || props.record.order_channel_type_val == 4 || props.record.order_channel_type_val == -1? '#ccc' : '#000'}"
                            :disabled="props.record.order_type_val == 1 || props.record.order_channel_type_val == 4 || props.record.order_channel_type_val == -1"
                            @click="handle('reissueRecord',props.record)"
                        >{{ $t('order.reissue') }}</a-button>
                        <a-button 
                            v-permission="'setting.order.returnFactoryRecord'"
                            type="text" size="mini" 
                            style="margin:10px 30px;width:150px;border:1px dashed #000;outline:none;color:#000"
                            :style="{'border-color': props.record.order_type_val == 1 || props.record.order_channel_type_val == 4 || props.record.order_channel_type_val == -1? '#ccc' : '#000', 'color': props.record.order_type_val == 1 || props.record.order_channel_type_val == 4 || props.record.order_channel_type_val == -1? '#ccc' : '#000'}"
                            :disabled="props.record.order_type_val == 1 || props.record.order_channel_type_val == 4 || props.record.order_channel_type_val == -1"
                            @click="handle('returnFactoryRecord',props.record)"
                        >{{ $t('order.returnFactory') }}</a-button>
                        <!-- 取消SO记录  暂时不做限制
                             :disabled="!((props.record.order_status_val == '1' || props.record.order_status_val == '6' || props.record.order_status_val == '7') && props.record.erp_no !== '-')"  
                            :style="{'border-color': !((props.record.order_status_val == '1' || props.record.order_status_val == '6' || props.record.order_status_val == '7') && props.record.erp_no !== '-')? 'rgba(159,212,253)' : 'rgba(22,93,255)'}"
                        -->
                        <a-button 
                            v-permission="'setting.order.cancelSORecord'" 
                            type="text" size="mini" 
                            style="margin:10px 30px;width:150px;border:1px dashed #000;outline:none;color:#000" 
                            :style="{'border-color': props.record.order_channel_type_val == 4 || props.record.order_channel_type_val == -1? '#ccc' : '#000', 'color': props.record.order_channel_type_val == 4 || props.record.order_channel_type_val == -1? '#ccc' : '#000'}"
                            @click="handle('cancelSORecord',props.record)"
                            :disabled="props.record.order_channel_type_val == 4 || props.record.order_channel_type_val == -1"
                        >{{ $t('order.cancelSORecord2') }}</a-button>
                        <a-button 
                            v-permission="'setting.order.refundRecord'" 
                            type="text" size="mini" 
                            style="margin:10px 30px;width:150px;border:1px dashed #000;outline:none;color:#000" 
                            :style="{'border-color': (props.record.refundDisabled && props.record.remark != 915) || props.record.order_channel_type_val == 4 || props.record.order_channel_type_val == -1? '#ccc' : '#000', 'color': (props.record.refundDisabled && props.record.remark != 915) || props.record.order_channel_type_val == 4 || props.record.order_channel_type_val == -1? '#ccc' : '#000'}"
                            :disabled="(props.record.refundDisabled && props.record.remark != 915) || props.record.order_channel_type_val == 4 || props.record.order_channel_type_val == -1"
                            @click="handle('refundRecord',props.record)"
                        >{{ $t('order.refundRecord2') }}</a-button>
                    </template>
                </a-popover>
            </template>

            <template v-slot:columns="{ props }">
                <!-- 父表格自定义字段 -->
                <div v-if="props.column.key == 'order_name'">
                    <a-tooltip :content="t('order.virtualOrder')" v-if="props.record.order_channel_type_val == -1">
                        <span :style="{'padding-left':'0px','color':'#f16e52','cursor':'pointer'}" @click="handle('showDetail', props.record)">
                            {{props.record.order_name}}
                            <icon-exclamation-circle-fill v-if="props.record.order_confirm_flag == 0"/>
                        </span>
                    </a-tooltip>
                    <span v-else :style="{'padding-left':'0px','color':'#165dff','cursor':'pointer'}" @click="handle('showDetail', props.record)">{{props.record.order_name}}</span>
                </div>
                <div v-if="props.column.key == 'source'" style="display:flex">
                    <a-tooltip :content="t('order.prepaidCustomer')">
                        <img v-if="props.record.prepaid_flag == 1" src="@/assets/image/warn.png" alt="" width="18" height="18" style="display:flex;width:18px;margin-right:5px;cursor:pointer;">
                    </a-tooltip>
                    <span style="display:flex;flex:5;">{{props.record.source}}</span>
                </div>
                <div v-if="props.column.key == 'customer_info'">
                        <div style="font-size:12px;color: #666;">{{ $t('base.email')}}：{{ props.record.customer_email }}</div>
                        <a-popover position="top" trigger="click" @popup-visible-change="(val)=>popupVisibleChange(val,props.record)">
                            <a-button type="text" style="padding:0;text-wrap: wrap; text-align: left;">
                                <span style="font-size:12px;color:#666">{{ $t('base.name') }}：</span>
                                {{ props.record.customer_name }}
                            </a-button>
                            <template #content>
                                <div style="display:inline-block;vertical-align: top;">
                                    <div style="font-weight:bold;text-align:center">{{ $t('order.customerInfo') }}</div>
                                    <a-spin :loading="customerInfo_loading" tip="loading..." class="customer_info" style="padding:0 15px;">
                                        <div><span style="font-weight:bold">{{ $t('customer.contactName') }}：</span> {{ customerInfo.name }}</div>
                                        <div><span style="font-weight:bold">{{ $t('customer.contactName2') }}：</span> {{ customerInfo.name2 }}</div>
                                        <div><span style="font-weight:bold">{{ $t('customer.customerPhone') }}：</span> {{ customerInfo.phone }}</div>
                                        <div><span style="font-weight:bold">{{ $t('customer.zip') }}：</span> {{ customerInfo.zip }}</div>
                                        <div><span style="font-weight:bold">{{ $t('customer.customerCity') }}：</span> {{ customerInfo.city }}</div>
                                        <div><span style="font-weight:bold">{{ $t('customer.customerAddr') }}：</span> {{ customerInfo.address }}</div>
                                        <div><span style="font-weight:bold">{{ $t('customer.customerAddr2') }}：</span> {{ customerInfo.address2 }}</div>
                                        <div v-if="props.record.customer_id == props.record.customer_invoice_id"><span style="font-weight:bold">{{ $t('customer.billingAddress') }}：</span> {{ customerInfo.billing_address }}</div>
                                        <div><span style="font-weight:bold">{{ $t('customer.customerCountry') }}：</span> {{ customerInfo.country }}</div>
                                        <div><span style="font-weight:bold">{{ $t('customer.customerEmail') }}：</span> {{ customerInfo.email }}</div>
                                    </a-spin>
                                </div>
                                <div v-if="props.record.customer_id != props.record.customer_invoice_id" style="display:inline-block;vertical-align: top;">
                                    <div style="font-weight:bold;text-align:center;">{{ $t('order.invoiceInfo') }}</div>
                                    <a-spin :loading="customerInfo_loading" tip="loading..." class="customer_info" style="padding:0 15px;border-left:1px solid #eee;">
                                        <div><span style="font-weight:bold">{{ $t('customer.contactName') }}：</span> {{ customerInfo2.name }}</div>
                                        <div><span style="font-weight:bold">{{ $t('customer.contactName2') }}：</span> {{ customerInfo2.name2 }}</div>
                                        <div><span style="font-weight:bold">{{ $t('customer.customerPhone') }}：</span> {{ customerInfo2.phone }}</div>
                                        <div><span style="font-weight:bold">{{ $t('customer.zip') }}：</span> {{ customerInfo2.zip }}</div>
                                        <div><span style="font-weight:bold">{{ $t('customer.customerCity') }}：</span> {{ customerInfo2.city }}</div>
                                        <div><span style="font-weight:bold">{{ $t('customer.customerAddr') }}：</span> {{ customerInfo2.address }}</div>
                                        <div><span style="font-weight:bold">{{ $t('customer.customerAddr2') }}：</span> {{ customerInfo2.address2 }}</div>
                                        <div><span style="font-weight:bold">{{ $t('customer.billingAddress') }}：</span> {{ customerInfo2.billing_address }}</div>
                                        <div><span style="font-weight:bold">{{ $t('customer.customerCountry') }}：</span> {{ customerInfo2.country }}</div>
                                        <div><span style="font-weight:bold">{{ $t('customer.customerEmail') }}：</span> {{ customerInfo2.email }}</div>
                                    </a-spin>
                                </div>
                                <div class="edit_icon" v-if="!is_hepha_customer" style="display:inline-block;vertical-align: top;">
                                    <icon-edit :size="18" @click="editCustomer(customerInfo.customer_entity_id)"/>
                                </div>
                            </template>
                        </a-popover>
                </div>
                <div v-if="props.column.key == 'order_status'" style="font-size:12px;">
                    <a-tooltip :content="props.record.cancel_timestamp" v-if="props.record.order_status_val == 6">
                        <a-badge :color="getoOderStatus('badgeOrderStatus', props.record.order_status)" :text="props.record.order_status" style="cursor: pointer;"/>
                    </a-tooltip>
                    <a-tooltip :content="props.record.refund_timestamp" v-else-if="props.record.order_status_val == 2 || props.record.order_status_val == 4">
                        <a-badge :color="getoOderStatus('badgeOrderStatus', props.record.order_status)" :text="props.record.order_status" style="cursor: pointer;"/>
                    </a-tooltip>
                    <a-badge v-else :color="getoOderStatus('badgeOrderStatus', props.record.order_status)" :text="props.record.order_status" />
                </div>
                <!-- 历史数据（20238月5号前）：remark = '915' -->
                <div v-if="props.record.remark != '915' && props.column.key == 'instruction' && userInfo.role != '8'" class="remark">
                    <a-tooltip :content="props.record.instruction">
                        <div class="remark_content" v-if="props.record.instructionIsText">{{ props.record.instruction }}</div>
                    </a-tooltip>
                    
                    <a-input v-if="!props.record.instructionIsText" :style="{width:'180px'}" v-model="props.record.instruction" />
                    <icon-check v-if="!props.record.instructionIsText" @click="saveComment(props.record)" :style="{display:'inline-block',marginLeft:'5px',color:'green',cursor:'pointer',fontWeight:'blod'}"/>
                    <icon-close v-if="!props.record.instructionIsText" @click="cancelSaveComment(props.record)" :style="{display:'inline-block',marginLeft:'10px',color:'red',cursor:'pointer',fontWeight:'blod'}"/>
                </div>
                <div v-if="props.record.remark == '915' && props.column.key == 'instruction'">-</div>
                <div v-if="props.column.key == 'user_note'">
                    <div style="width:250px;white-space:wrap">
                        <p>{{props.record.user_note}}</p>
                    </div>
                </div>
                <div v-if="props.column.key == 'risk_level'" style="font-size:12px;">
                    <div v-if="props.record.risk_level == '-'">-</div>
                    <div v-else>
                        <a-tag v-if="props.record.risk_level !== '-'" :color="props.record.risk_level_val === 0? 'gray' : props.record.risk_level_val == 1? 'blue' : props.record.risk_level_val == 2? 'orangered' : 'red'">{{ props.record.risk_level }}</a-tag>
                    </div>
                </div>
                <div v-if="props.column.key == 'risk_validate'" style="font-size:12px;">
                    <div v-if="props.record.risk_validate == '-'">-</div>
                    <div v-else>
                        <a-tag v-if="props.record.risk_validate !== '-'" style="" :color="props.record.risk_validate_val == 0? 'gray' : props.record.risk_validate_val == 1? 'gold' : 'green'">{{ props.record.risk_validate }}</a-tag>
                    </div>
                </div>
                <div v-if="props.column.key == 'order_channel_type'" style="font-size:12px;">
                    <a-tag :color="getoOderStatus('tagCustomerType', props.record.order_channel_type)">{{ props.record.order_channel_type }}</a-tag>
                </div>
                

                <!-- 子表格自定义字段 -->
                <div v-if="props.column.key == 'sku'">
                    <span style="padding-left:0;color:#165dff;cursor:pointer;" @click="handle('showLineDetail', props.record)">{{props.record.sku}}</span>
                </div>
                <div v-if="props.column.key == 'cancel_status'">
                    <span style="color:orange" v-if="props.record.cancel_status_val == 0">{{ props.record.cancel_status }}</span>
                    <span style="color:red" v-else-if="props.record.cancel_status_val == 1">{{ props.record.cancel_status }}</span>
                    <span style="color:green" v-else>{{ props.record.cancel_status }}</span>
                </div>
                <div v-if="props.column.key == 'frame_number'">
                    <div v-if="props.record.frame_number.length > 0">
                        <div v-for="(item,index) in props.record.frame_number" :key="index" style="font-size:12px;" :style="{'color':item.vehicle_status == 1?'red' : '#333'}">{{ item.frame_number }}</div>
                    </div>
                    <div v-else>-</div>
                </div>
                <div v-if="props.column.key == 'model_model_year'">
                    <div v-if="props.record.model == '-' && props.record.model_year == '-'" style="font-size:12px">-</div>
                    <div v-else style="font-size:12px">{{ props.record.model }}，{{props.record.model_year}}</div>
                </div>
                <div v-if="props.column.key == 'qty'">
                    <div style="display:flex;font-size:12px" v-if="props.record.quantity != '-'">
                        <span style="display:flex;flex:3;width:70px;justify-content: flex-start;">{{ $t('order.lineQuantity') }}：</span>
                        <span style="display:flex;flex:1;justify-content: flex-end"> {{ props.record.quantity }}</span>
                    </div>
                    <div style="display:flex;font-size:12px" v-if="props.record.ship_quantity != '-'">
                        <span style="display:flex;flex:3;width:70px;justify-content: flex-start;">{{ $t('order.lineShipQuantity') }}：</span>
                        <span style="display:flex;flex:1;justify-content: flex-end"> {{ props.record.ship_quantity }}</span>
                    </div>
                    <div style="display:flex;font-size:12px" v-if="props.record.back_number != '-'">
                        <span style="display:flex;flex:3;width:70px;justify-content: flex-start;">{{ $t('order.lineBackQuantity') }}：</span>
                        <span style="display:flex;flex:1;justify-content: flex-end"> {{ props.record.back_number }}</span>
                    </div>
                    <div style="display:flex;font-size:12px" v-if="props.record.produce_quantity != '-'">
                        <span style="display:flex;flex:3;width:70px;justify-content: flex-start;">{{ $t('order.lineProductQuantity') }}：</span>
                        <span style="display:flex;flex:1;justify-content: flex-end"> {{ props.record.produce_quantity }}</span>
                    </div>
                    <div style="display:flex;font-size:12px" v-if="props.record.cancel_quantity != '-'">
                        <span style="display:flex;flex:3;width:70px;justify-content: flex-start;">{{ $t('order.cancelQty') }}：</span>
                        <span style="display:flex;flex:1;justify-content: flex-end"> {{ props.record.cancel_quantity }}</span>
                    </div>
                </div>
                <div v-if="props.column.key == 'line_amount'">
                    <div style="display:flex;font-size:12px" v-if="props.record.amount != '-'">
                        <span style="display:flex;flex:1;width:70px;justify-content: flex-start;">{{ $t('order.linePrice') }}：</span>
                        <span style="display:flex;flex:1;justify-content: flex-end"> {{ props.record.amount }}</span>
                    </div>
                    <div style="display:flex;font-size:12px" v-if="props.record.discount != '-'">
                        <span style="display:flex;flex:1;width:70px;justify-content: flex-start;">{{ $t('order.discount') }}：</span>
                        <span style="display:flex;flex:1;justify-content: flex-end"> {{ props.record.discount }}</span>
                    </div>
                    <div style="display:flex;font-size:12px" v-if="props.record.pay_amount != '-'">
                        <span style="display:flex;flex:1;width:70px;justify-content: flex-start;">{{ $t('order.payAmount3') }}：</span>
                        <span style="display:flex;flex:1;justify-content: flex-end"> {{ props.record.pay_amount }}</span>
                    </div>
                </div>
                <div v-if="props.column.key == 'user_comment'">
                    <a-tooltip :content="props.record.user_comment">
                        <div class="user_comment" v-if="props.record.user_comment">{{ props.record.user_comment }}</div>
                    </a-tooltip>
                </div>
            </template>

            <!-- 子表格 -->
            <template v-slot:editSKU="{ props }">
                <span v-if="!props.record.isEdit">{{ props.record.sku }}</span>
                <a-select 
                    v-if="props.record.isEdit"
                    :style="{width:'200px'}"
                    @change="(val,opt,key)=>changeSelesctSku(val, props.record)"
                >
                    <a-option v-for="(item,index) in skuOptions" :key="index">{{ item.label }}</a-option>
                </a-select>
            </template>

            <template v-slot:childTableOperate="{ props }">
                <a-button 
                    v-permission="'setting.order.viewVersion'" 
                    type="primary" size="mini"
                    style="padding: 0 5px;"
                    @click="handle('editUserNote',props.record)"
                >{{ $t('order.editUserNote') }}</a-button>
                <!-- <a-button
                    v-permission="'setting.order.viewVersion'"
                    type="text" size="mini"
                    style="padding: 0 5px;"
                    @click="handle('viewVersion',props.record)"
                >{{ $t('order.viewVersion2') }}</a-button> -->
                <!-- <a-button 
                    v-permission="'setting.order.editLine'" 
                    type="text" status="success" size="mini" 
                    style="padding: 0 5px;"
                    v-if="props.record.version !== 915 && props.record.erp_line_no === '-' && !props.record.isEdit" 
                    @click="handle('editOrderLine',props.record)"
                >{{ $t('order.edit2') }}</a-button>
                <a-button 
                    v-permission="'setting.order.editLine'" 
                    type="text" size="mini" 
                    style="padding: 0 5px;"
                    v-if="props.record.version !== 915 && props.record.erp_line_no === '-' && props.record.isEdit" 
                    @click="handle('cancelEditOrderLine',props.record)"
                >{{ $t('order.cancel2') }}</a-button> -->
                <!-- <a-button
                    v-permission="'setting.order.deleteLine'" 
                    type="text" status="danger" size="mini" 
                    style="padding: 0 5px;"
                    v-if="props.record.source !== 'Shopify' && props.record.erp_line_no === '-' && props.record.remark !== 915" 
                    @click="handle('delOrderLine',props.record)"
                >{{ $t('order.delete2') }}</a-button> -->
                <!-- <a-button 
                    v-permission="'setting.order.cancelLineSO'" 
                    type="text" status="warning" size="mini" 
                    style="padding: 0 5px;"
                    v-if="props.record.source != 'Shopify' && props.record.erp_line_no !== '-' && props.record.remark != 915 && props.record.cancel_status_val != 1" 
                    @click="handle('cancelLineSO',props.record)"
                >{{ $t('order.cancelLineSO') }}</a-button> -->
            </template>
        </Table>

        <!-- 编辑订单行 用户备注 -->
        <a-modal
            v-model:visible="editUserNoteVisible"
            :width="600"
            :mask-closable="false"
            draggable
            @ok="handleEditUserNoteOk"
        >
            <template #title>
                <div style="font-weight:bold">{{ $t('order.editUserNote') }}</div>
            </template>
            <div style="text-align:center">
                <a-input
                    v-if="editUserNoteVisible"
                    v-model="rowData.user_note"
                    max-length="100"
                    :style="{width:'520px'}"
                    allow-clear
                    show-word-limit
                 />
            </div>
        </a-modal>

        <!-- 订单详情 -->
        <Detail :row="rowData" :detailVisible="detailVisible" @handleCancel="handleCancelDrawer"></Detail>

        <!-- 订单行详情 -->
        <LineDetail :row="rowData" :detailVisible="lineDetailVisible" @handleCancel="handleLineCancelDrawer"></LineDetail>

        <!-- 新建订单 -->
        <a-modal
            v-model:visible="createOrderVisible" 
            :width="createOrderWidth"
            :mask-closable="false"
            draggable
            :onBeforeOk="onCreateOrderBeforeOk" 
            popup-container="#listContainer"
            @cancel="handleCancelCreateOrder"
        >
            <template #title>
                <div style="font-weight:bold">{{ orderTitle }}</div> 
            </template>

            <a-spin :loading="editOrderloading" :tip="t('base.loading')" style="width:100%">
                <div v-if="orderOperateType == 'edit'" class="editOrderTitle">{{ createOrderForm1.formData.order_name }}</div>
                <div v-if="createOrderForm1.formData.order_channel_type == 4" class="editOrderTitle">{{ t('order.EBikeOrderName') }}{{ ebike_orderTitle }}</div>
                <a-divider orientation="center">{{ $t('order.baseInfo') }}</a-divider>
                <!-- 基础信息 -->
                <Form
                    class="createOrderForm"
                    :form="createOrderForm1" 
                    @handleSelectChange="handleCreateOrderSelectChange"
                    @handleInputNumber="handleCreateOrderInputNumber"
                    @handleInputChange="handleInputChange"
                    @handleInput="handleInput"
                    @handleYearPickerChange="handleYearPickerChange"
                    @handleWeekPickerChange="handleWeekPickerChange"
                    @handleSelectDate="handleSelectDate"
                >
                    <template v-slot:itemPreText="{ props }" >
                        <div class="itemPreText" v-if="props.item.key == 'order_name' && lastValidOrderNo != ''">
                            <a-alert> 
                                <span v-if="lastValidOrderNo != '--'" style="font-size:12px">{{ $t('order.lastValidOrderNo') }} </span> 
                                <span v-if="lastValidOrderNo != '--'" style="font-size:12px;font-weight:600">{{ lastValidOrderNo }}</span>
                                <span v-if="lastValidOrderNo == '--'" style="font-size:12px">{{ $t('order.lastValidOrderNo2') }} </span> 
                            </a-alert>
                        </div>
                        <div class="itemPreText" v-if="props.item.key == 'payment_type' && !!customerPaymentType">
                            <a-alert>
                                <span v-if="!!customerPaymentType" style="font-size:12px">{{ $t('order.customerPaymentTypeTip') }}</span> 
                                <span v-if="!!customerPaymentType" style="font-size:12px;font-weight:600">{{ customerPaymentType }}</span>
                            </a-alert>
                        </div>
                        <div class="itemPreText" v-if="props.item.key == 'order_category' && orderLineExitsSku">
                            <a-alert>
                                <span style="font-size:12px">{{ $t('order.orderCategoryTip') }}</span> 
                            </a-alert>
                        </div>
                        <div class="itemPreText" v-if="props.item.key == 'cargo_freight' && b2bCargoFreight != '-' && b2bCargoFreight !== '' ">
                            <a-alert>
                                <span style="font-size:12px">{{ $t('order.b2bCargoFreightTip') }}: € {{ b2bCargoFreight }}</span>
                            </a-alert>
                        </div>
                    </template>
                    <template v-slot:itemAfterText="{ props }">
                        <div class="itemAfterText" v-if="props.item.key == 'earliest_ship_timestamp'">
                            <a-alert>
                                <span style="font-size:12px">{{ $t('order.earliestShipDateTip') }}</span>
                            </a-alert>
                        </div>
                    </template>
                    <template v-slot:formInputEditAmount="{ props }" >
                        <icon-edit 
                            v-permission="'setting.order.editPayTypeDiscount'"
                            size="20" 
                            style="margin-left:10px;color:#165dff;cursor: pointer;" 
                            @click="handleEditAmount(props.item)" 
                        />
                    </template>
                </Form>
                <a-divider orientation="center">{{ $t('order.customerInfo') }}</a-divider>

                <!-- 客户信息 -->
                <Form
                    class="createOrderForm"
                    :form="createOrderForm3"
                    @handleInputChange="handleInputChange3"
                    @handleSelectChange="handleCreateOrderSelectChange3"
                >
                    <template v-slot:formSelectAddIcon="{ props }" >
                        <icon-plus-circle size="20" v-if="props.item.addIcon" @click="handle('addCustomer',props.item)" style="margin-left:10px;color:#165dff;font-weight:200;cursor: pointer;"/>
                    </template>
                </Form>
                <a-divider orientation="center">{{ $t('order.amountInfo') }}</a-divider>

                <!-- 调整弹窗宽度 -->
                <a-radio-group v-model="activeKey" type="button">
                    <a-radio value="large" @click="handleCreateOrderWidth('large')">{{ $t('base.large')}}</a-radio>
                    <a-radio value="medium" @click="handleCreateOrderWidth('medium')">{{ $t('base.medium')}}</a-radio>
                    <a-radio value="small" @click="handleCreateOrderWidth('small')">{{ $t('base.small')}}</a-radio>
                </a-radio-group>

                <!-- 重新计算汇总金额 -->
                <a-button 
                    v-permission="'setting.order.recalculateAmount'" 
                    v-if="isSyncERP"
                    class="form_btn" 
                    type="primary" 
                    size="small" 
                    style="margin-left:20px;margin-top:-3px;vertical-align: middle;"
                    @click="handle('recalculateAmount')"
                >
                    <icon-sync :size="16" style="margin-right:5px"/>
                    {{ $t('order.recalculateAmount') }}
                </a-button>

                <!-- 订单行信息 -->
                <Table
                    class="deliverTable orderLineTable"
                    :table="orderLineTable"
                    @changePage="changeVersionPage"
                    @changePageSize="changeVersionPageSize"
                >
                    <template v-slot:columns="{ props }">
                        <div v-if="props.column.key == 'sku'">
                            <a-select
                                v-model="props.record.sku"
                                :style="{width:'220px'}"
                                allow-search
                                :allow-clear="orderLineAllowClearSKU"
                                :disabled="props.record.skuDisabled"
                                @change="(val)=>changeSku(val,props.record)"
                                @click="clickSku(props.record)"
                            >
                                <a-option v-for="(item,index) in skuOptions" :key="index">
                                    {{ item.label }}
                                </a-option>
                            </a-select>
                        </div>
                        <div v-if="props.column.key == 'pre_tax_amount'">
                            <a-input
                                v-model="props.record.pre_tax_amount"
                                :style="{width:'120px'}"
                                :disabled="props.record.preTaxAmountDisabled"
                                :error="props.record.error"
                                @input="(val)=>quantityChange(formatterToPoint(val),props.record,'pre_tax_amount')"
                            >
                                <template #prefix>€</template>
                            </a-input>
                        </div>
                        <div v-if="props.column.key == 'amount'">
                            <a-input
                                v-model="props.record.amount"
                                :style="{width:'120px'}"
                                :disabled="props.record.amountDisabled"
                                :error="props.record.error"
                                @input="(val)=>quantityChange(formatterToPoint(val),props.record,'amount')"
                            >
                                <template #prefix>€</template>
                            </a-input>
                        </div>
                        <div v-if="props.column.key == 'quantity'">
                            <a-inputNumber
                                v-model="props.record.quantity"
                                :style="{width:'100px'}"
                                :disabled="props.record.quantityDisabled"
                                :min="1"
                                :max="9999"
                                :precision="0"
                                :hideButton="true"
                                :error="props.record.error"
                                @input="(val)=>quantityChange(val,props.record,'quantity')"
                                @change="(val)=>qtyChange(val,props.record)"
                            ></a-inputNumber>
                        </div>
                        <!-- createOrderForm1.formData.order_channel_type != 1 || (createOrderForm1.formData.order_channel_type == 1 && (props.record.pre_tax_amount == '' || props.record.quantity == '')) -->
                        <div v-if="props.column.key == 'discount_rate'">
                            <a-inputNumber
                                v-model="props.record.discount_rate"
                                :style="{width:'70px'}"
                                :disabled="!props.record.enable || (props.record.pre_tax_amount == '' || props.record.quantity == '')"
                                :min="0"
                                :max="9999"
                                :precision="0"
                                :hideButton="true"
                                @input="(val)=>quantityChange(val,props.record,'discount_rate')"
                            /> %
                            <a-tooltip content="Switch to setting the discount/discount rate">
                                <a-switch
                                    v-if="createOrderForm1.formData.order_channel_type == 1 || createOrderForm1.formData.order_channel_type == 5"
                                    v-model="props.record.enable"
                                    size="small"
                                    @change="(val)=>changeSwitch(val,props.record)"
                                />
                            </a-tooltip>

                        </div>
                        <!-- :disabled="createOrderForm1.formData.order_channel_type == 1 && (props.record.discount_rate !== '' || props.record.discount_rate !== undefined)" -->
                        <div v-if="props.column.key == 'pre_tax_discount'">
                            <a-input
                                v-model="props.record.pre_tax_discount"
                                :style="{width:'120px'}"
                                :error="props.record.error"
                                :disabled="props.record.enable"
                                @input="(val)=>quantityChange(formatterToPoint(val),props.record,'pre_tax_discount')"
                            >
                                <template #prefix>€</template>
                            </a-input>
                        </div>
                        <div v-if="props.column.key == 'discount'">
                            <a-input
                                v-model="props.record.discount"
                                :style="{width:'120px'}"
                                :disabled="props.record.disabled"
                                :error="props.record.error"
                                @input="(val)=>quantityChange(formatterToPoint(val),props.record,'discount')"
                            >
                                <template #prefix>€</template>
                            </a-input>
                        </div>
                        <div v-if="props.column.key == 'pre_tax_extra_discount'">
                            <a-input
                                v-model="props.record.pre_tax_extra_discount"
                                :style="{width:'120px'}"
                                :error="props.record.error"
                                :disabled="props.record.preTaxExtraDiscountDisabled"
                                @input="(val)=>quantityChange(formatterToPoint(val),props.record,'pre_tax_extra_discount')"
                            >
                                <template #prefix>€</template>
                            </a-input>
                        </div>
                        <div v-if="props.column.key == 'extra_discount'">
                            <a-input
                                v-model="props.record.extra_discount"
                                :style="{width:'120px'}"
                                :disabled="true"
                                :error="props.record.error"
                                @input="(val)=>quantityChange(formatterToPoint(val),props.record,'extra_discount')"
                            >
                                <template #prefix>€</template>
                            </a-input>
                        </div>
                        <div v-if="props.column.key == 'pre_tax_pay_amount'">
                            <a-input
                                v-model="props.record.pre_tax_pay_amount"
                                :style="{width:'120px'}"
                                :error="props.record.error"
                                :disabled="true"
                                @input="(val)=>quantityChange(formatterToPoint(val),props.record,'pre_tax_pay_amount')"
                            >
                                <template #prefix>€</template>
                            </a-input>
                        </div>
                        <div v-if="props.column.key == 'pay_amount'">
                            <a-input
                                v-model="props.record.pay_amount"
                                :style="{width:'120px'}"
                                :disabled="true"
                                :error="props.record.error"
                                @change="(val)=>quantityChange(formatterToPoint(val),props.record,'pay_amount')"
                            >
                                <template #prefix>€</template>
                            </a-input>
                        </div>
                        <div v-if="props.column.key == 'tax_rate'">
                            <a-select
                                v-model="props.record.tax_rate"
                                :style="{width:'190px'}"
                                disabled
                                @change="(val)=>changeTaxRate(val,props.record)"
                            >
                                <a-option v-for="(item,index) in taxRateOption" :key="index">
                                    {{ item.label }}
                                </a-option>
                            </a-select>
                        </div>
                        <div v-if="props.column.key == 'order_tax'">
                            <a-input
                                v-model="props.record.order_tax"
                                :style="{width:'120px'}"
                                disabled
                            >
                                <template #prefix>€</template>
                            </a-input>
                        </div>
                        <div v-if="props.column.key == 'handle_timestamp'">
                            <a-date-picker
                                style="width: 180px"
                                v-model="props.record.handle_timestamp"
                                show-time
                                format="YYYY-MM-DD HH:mm:ss"
                                :disabledDate="(current) => setHandleTimestampDisabledDate(current)"
                                :disabled="props.record.shipDateDisabled"
                                @change="onChangeHandleTimestamp"
                                @select="onSelectHandleTimestamp"
                                @ok="(val)=>onOkHandleTimestamp(val, props.record)"
                            />
                        </div>
                    </template>

                    <template v-slot:tableOperate="{ props }">
                        <a-button
                            v-permission="'setting.order.copy'"
                            v-if="!isSyncERP && fromPage != 'DealerBusinessOrder' && fromPage != 'B2BShopOrder' && showAddOrderLineBtn"
                            type="text" size="mini"
                            @click="handle('copy',props.record)"
                        > <icon-copy :size="20"/></a-button>
                        <a-button
                            v-permission="'setting.inventoryLock.viewLockList'"
                            type="text" size="mini"
                            :disabled="props.record.sku == '' || props.record.quantity == ''"
                            @click="handle('view',props.record)"
                        > <icon-storage :size="20"/></a-button>
                        <a-button
                            v-permission="'setting.order.removeLine'"
                            v-if="(!isSyncERP && fromPage != 'DealerBusinessOrder' && fromPage != 'B2BShopOrder' && showAddOrderLineBtn) || createOrderForm1.formData.source == 222"
                            type="text" status="danger" size="mini"
                            :disabled="orderLineTable.datas.length == 1"
                            @click="handle('removeLine',props.record)"
                        > <icon-minus-circle :size="20"/></a-button>
                        <a-button
                            v-permission="'setting.order.syncNewPrice'"
                            v-if="isSyncERP && props.record.product_code == '627.501'"
                            type="text" size="mini"
                            @click="handle('syncNewPrice',props.record)"
                        >
                            <a-tooltip :content="t('order.syncNewPrice') ">
                                <icon-sync :size="20"/>
                            </a-tooltip>
                        </a-button>
                    </template>
                </Table>
                <div class="addIcon" v-if="!isSyncERP && fromPage != 'DealerBusinessOrder' && fromPage != 'B2BShopOrder' && showAddOrderLineBtn " @click="handle('addLine')"><icon-plus /></div>
                <a-divider orientation="center" style="margin-top:80px">{{ $t('order.summary') }}</a-divider>

                <!-- 金额汇总 -->
                <Form
                    class="createOrderForm"
                    :form="createOrderForm2"
                ></Form>
            </a-spin>
        </a-modal>

        <!-- 创建预付款订单，选择订单行 -->
        <a-modal 
            class="deliverModal"
            v-model:visible="createPrePayOrderVisible" 
            width="85%"
            draggable
            :onBeforeOk="onCreatePrePaidOrderBeforeOk" 
        >
            <Table 
                ref="prePayOrderTable"
                class="deliverTable"
                :table="createPrePayOrderTable"
                @selectRow="prePayOrderSelectRow"
                @selectAllRow="prePayOrderSelectAllRow"
            >
                <template #title>
                    <div style="font-weight:bold">{{ $t('base.select') }}</div> 
                </template>

                <template v-slot:columns="{ props }">
                    <div v-if="props.column.key == 'sku'">
                        <span style="padding-left:0;color:#165dff;cursor:pointer;" @click="handle('showLineDetail', props.record)">{{props.record.sku}}</span>
                    </div>
                    <div v-if="props.column.key == 'cancel_status'">
                        <span style="color:red" v-if="props.record.cancel_status_val == 1">{{ props.record.cancel_status }}</span>
                        <span style="color:green" v-else>{{ props.record.cancel_status }}{{props.record.cancel_status_val}}</span>
                    </div>
                    <div v-if="props.column.key == 'frame_number'">
                        <div v-if="props.record.frame_number.length > 0">
                            <div v-for="(item,index) in props.record.frame_number" :key="index" style="font-size:12px;" :style="{'color':item.vehicle_status == 1?'red' : '#333'}">{{ item.frame_number }}</div>
                        </div>
                        <div v-else>-</div>
                    </div>
                    <div v-if="props.column.key == 'model_model_year'">
                        <div v-if="props.record.model == '-' && props.record.model_year == '-'" style="font-size:12px">-</div>
                        <div v-else style="font-size:12px">{{ props.record.model }}，{{props.record.model_year}}</div>
                    </div>
                    <div v-if="props.column.key == 'qty'">
                        <div style="display:flex;font-size:12px" v-if="props.record.quantity != '-'">
                            <span style="display:flex;flex:3;width:70px;justify-content: flex-start;">{{ $t('order.lineQuantity') }}：</span>
                            <span style="display:flex;flex:1;justify-content: flex-end"> {{ props.record.quantity }}</span>
                        </div>
                        <div style="display:flex;font-size:12px" v-if="props.record.prePaid_quantity != '-'">
                            <span style="display:flex;flex:3;width:70px;justify-content: flex-start;">{{ $t('order.linePrePaidQuantity') }}：</span>
                            <span style="display:flex;flex:1;justify-content: flex-end"> {{ props.record.prepaid_quantity }}</span>
                        </div>
                        <div style="display:flex;font-size:12px" v-if="props.record.ship_quantity != '-'">
                            <span style="display:flex;flex:3;width:70px;justify-content: flex-start;">{{ $t('order.lineShipQuantity') }}：</span>
                            <span style="display:flex;flex:1;justify-content: flex-end"> {{ props.record.ship_quantity }}</span>
                        </div>
                        <div style="display:flex;font-size:12px" v-if="props.record.back_number != '-'">
                            <span style="display:flex;flex:3;width:70px;justify-content: flex-start;">{{ $t('order.lineBackQuantity') }}：</span>
                            <span style="display:flex;flex:1;justify-content: flex-end"> {{ props.record.back_number }}</span>
                        </div>
                        <div style="display:flex;font-size:12px" v-if="props.record.produce_quantity != '-'">
                            <span style="display:flex;flex:3;width:70px;justify-content: flex-start;">{{ $t('order.lineProductQuantity') }}：</span>
                            <span style="display:flex;flex:1;justify-content: flex-end"> {{ props.record.produce_quantity }}</span>
                        </div>
                    </div>
                    <div v-if="props.column.key == 'line_amount'">
                        <div style="display:flex;font-size:12px" v-if="props.record.amount != '-'">
                            <span style="display:flex;flex:1;width:70px;justify-content: flex-start;">{{ $t('order.linePrice') }}：</span>
                            <span style="display:flex;flex:1;justify-content: flex-end"> {{ props.record.amount }}</span>
                        </div>
                        <div style="display:flex;font-size:12px" v-if="props.record.pre_amount != '-'">
                            <span style="display:flex;flex:1;width:70px;justify-content: flex-start;">{{ $t('order.lineDepositAmount') }}：</span>
                            <span style="display:flex;flex:1;justify-content: flex-end"> {{ props.record.pre_amount }}</span>
                        </div>
                        <div style="display:flex;font-size:12px" v-if="props.record.tax_rate != '-'">
                            <span style="display:flex;flex:1;width:70px;justify-content: flex-start;">{{ $t('order.taxRate') }}：</span>
                            <span style="display:flex;flex:1;justify-content: flex-end"> {{ props.record.tax_rate }}</span>
                        </div>
                    </div>
                </template>
            </Table>
        </a-modal>

        <!-- 发货 -->
        <a-modal 
            class="deliverModal"
            v-model:visible="visible" 
            width="85%"
            draggable
            :onBeforeOk="onShipBeforeOk" 
            @ok="handleShipOk"
        >
            <template #title>
                <div style="font-weight:bold">{{ $t('order.deliver') }}</div> 
            </template>
            
            <div v-if="visible" style="font-size:17px;font-weight:bold;text-align:center;">{{ rowData.order_name }}</div>
            <Form 
                class="deliverModalForm"
                style="padding:20px"
                :form="deliverForm" 
                @handleSelectChange="handleDeliverSelectChange"
                @handleInput="handleDeliverInput"
            >
                <template v-slot:itemAfterText="{ props }">
                    <div class="itemAfterText" v-if="props.item.key == 'transaction_date' && earliestShipTimestamp != ''">
                        <a-alert style="width:450px">
                            <span style="font-size:12px">{{ $t('order.earliestShipDateTip2') }}{{ earliestShipTimestamp }}{{ $t('order.earliestShipDateTip3') }}</span>
                        </a-alert>
                    </div>
                </template>
            </Form>
            <a-divider orientation="center">
                <div style="font-weight:bold">{{ $t('order.deliverDetailTitle') }}</div>
            </a-divider>

            <a-alert style="margin-bottom:10px">
                <span style="font-size:15px;font-weight:bold;">{{ $t('inventoryLock.shipInStockTip') }}</span>
            </a-alert>

            <a-table 
                class="deliverTable" 
                :columns="deliverTable.columns" 
                :data="deliverTable.datas" 
                v-model:selectedKeys="selectedKeys"
                row-key="id"
                :row-selection="deliverTable.configs.rowSelection"
                :loading="deliverTable.configs.loading" 
                :pagination="false"
                @select="selectShipTableRow"
            >
                <template #totalShipQuantity="{ record }">
                    <div>{{ $t('inventoryLock.total2') }}: {{ record.total_quantity }}</div>
                    <div>{{ $t('inventoryLock.ship') }}: {{ record.ship_quantity }}</div>
                </template> 
                <template #warehouse="{record}">
                    <a-select 
                        v-model="record.warehouse" 
                        :style="{width:'250px'}" 
                        placeholder="Please select ..."
                        :disabled="record.warehouseDisabled"
                        allow-search
                        @change="(val)=>changeWarehouse(val, record)"
                    >
                        <a-option
                            v-for="(item,index) in record.wmsOptions"
                            :key="index"
                            :value="item.value"
                            :disabled="item.disabled"
                        >{{ item.label }}</a-option>
                    </a-select>
                </template>
                <template #rollOverInventory="{record}">
                    <a-select 
                        v-model="record.roll_over_inventory" 
                        :style="{width:'250px'}" 
                        placeholder="Please select ..."
                        @change="(val)=>changeRollOverInventory(val, record)"
                    >
                        <a-option
                            v-for="(item,index) in record.wmsOptions"
                            :key="index"
                            :value="item.value"
                        >{{ item.label }}</a-option>
                    </a-select>
                </template>
                <template #curQuantity="{record}">
                    <a-input-number 
                        v-model="record.curQuantity" 
                        :style="{width:'120px'}" 
                        :placeholder="$t('base.input')"
                        :min="0"
                        :max="record.max"
                        :error="record.curQuantity > record.quantity"
                        @input="(val,inputVal,ev)=>changeInputNumber(val,inputVal,ev,record)"
                    /> 
                </template> 
                <template #transaction_date="{record}">
                    <a-date-picker 
                        v-model="record.transaction_date" 
                        style="width: 160px;" 
                        :disabledDate="(current) => disabledDate(current, record)"
                        @change="(val)=>changeTransactionDate(val)"
                    />
                </template>
                <template #modelModelYear="{record}">
                    <div v-if="record.model == '-' && record.model_year == '-'" style="font-size:12px">-</div>
                    <div v-else style="font-size:12px">{{ record.model }}，{{record.model_year}}</div>
                </template>
                <template #brandPartName="{record}">
                    <div style="font-size:12px;color: #666;">{{ $t('stock.brandName') }}: {{ record.brand_name }}</div>
                    <div style="font-size:12px;color: #666;">{{ $t('stock.partName') }}: {{ record.part_name }}</div>
                </template>
                <!-- <template #InventoryQty="{record}">
                    <div style="display:flex;font-size:12px">
                        <span style="display:flex;flex:1;justify-content: flex-start;">{{ $t('order.referenceInventory') }}：</span>
                        <span style="display:flex;flex:1;justify-content: flex-end"> {{ record.transaction_quantity }}</span>
                    </div>
                    <div style="display:flex;font-size:12px">
                        <span style="display:flex;flex:1;justify-content: flex-start;">{{ $t('order.schedulingQuantity') }}：</span>
                        <span style="display:flex;flex:1;justify-content: flex-end"> {{ record.scheduling_quantity }}</span>
                    </div>
                    <div style="display:flex;font-size:12px">
                        <span style="display:flex;flex:1;justify-content: flex-start;">{{ $t('order.availableQty') }}：</span>
                        <span style="display:flex;flex:1;justify-content: flex-end"> {{ record.available_quantity }}</span>
                    </div>
                </template> -->
            </a-table>
        </a-modal>

        <!-- 同步到ERP -->
        <a-modal 
            class="deliverModal"
            v-model:visible="erpsyncVisible" 
            width="85%"
            draggable
            :footer="false"
        >
            <template #title>
                <div style="font-weight:bold">{{ $t('order.syncToERP') }}</div> 
            </template>

            <Table 
                class="deliverTable"
                :table="erpsyncTable"
            >
                <template v-slot:columns="{ props }">
                    <!-- <div v-if="props.column.dataIndex == 'produce_quantity'">
                        <a-inputNumber
                            v-model="props.record.produce_quantity"
                            :style="{width:'100px'}"
                            :min="0"
                            :hideButton="true"
                            :error="props.record.error"
                            :formatter="formatter"
                            :parser="parser"
                            @input="(val)=>productQuantityChange(val,props.record)"
                        ></a-inputNumber>
                    </div> -->
                </template>
            </Table>
    
            <div class="footerBtn" v-if="erpsyncVisible">
                <!-- <a-button type="outline" size="small" style="margin:0 10px;" @click="handle('saveProductQty')">{{ $t('base.save') }}</a-button> -->
                <a-button type="primary" size="small" style="margin:0 10px;" :disabled="rowData.isSaveProductQty" @click="handle('erpSync')">{{ $t('base.sync') }}</a-button>
            </div>
        </a-modal>

        <!-- 发货记录,查看物流,退款记录,SO取消记录,退换货记录 -->
        <a-modal 
            class="recordModal"
            v-model:visible="modalVisible"
            width="80%"
            draggable
            :fullscreen="fullscreen"
            :render-to-body="false"
            :footer="false"
        >
            <template #title>
               <div style="font-weight:bold">{{ modalTitle }}</div>    
            </template>

            <icon-expand v-if="!fullscreen" :size="20" @click="fullscreen = !fullscreen" class="fullscreenIcon" />
            <icon-shrink v-else :size="20" @click="fullscreen = !fullscreen" class="fullscreenIcon"/>

            <!-- 发货记录 -->
            <Table 
                class="deliverTable"
                v-if="recordVisible"
                :table="recordTable"
                @changePage="changeRecordPage"
                @changePageSize="changeRecordPageSize"
            >
                <template v-slot:columns="{ props }">
                    <div v-if="props.column.key == 'status'">
                        <a-tag v-if="props.record.status !== '-'" :color="getoOderStatus('outboundStatus', props.record.status)">{{ props.record.status }}</a-tag>
                        <span v-else>{{props.record.status}}</span>
                    </div>
                    <div v-if="props.column.key == 'courier_status'">
                        <a-tag v-if="props.record.courier_status !== '-'" :color="getoOderStatus('badgeCourierStatus', props.record.courier_status)">{{ props.record.courier_status }}</a-tag>
                        <span v-else>{{props.record.courier_status}}</span>
                    </div>
                </template>
            </Table>

            <!-- 查看物流 -->
            <LogisticsInfo 
                v-if="logisticsVisible" 
                :row="rowData" 
                :courierStatus="courierStatus" 
                :outboundStatus="outboundStatus"
                :visible="modalVisible && logisticsVisible"
            ></LogisticsInfo>

            <!-- 退款记录 -->
            <Table 
                class="deliverTable"
                v-if="refundRecordVisible"
                :table="refundRecordTable"
            > </Table>

            <!-- 取消SO记录 -->
            <Table 
                class="deliverTable"
                v-if="cancelSORecordVisible"
                :table="cancelSORecordTable"
            > 
                <template v-slot:columns="{ props }">
                    <span style="color:red" v-if="props.record.status == 1">{{ $t('base.fail') }}</span>
                    <span style="color:green" v-if="props.record.status == 2">{{ $t('base.success') }}</span>
                </template>
            </Table>

            <!-- 退换货记录 -->
            <ReturnExchangeRecord 
                v-if="returnExchangeRecordVisible" 
                :rowData="rowData" 
                :active="rowData.active" 
                :visible="modalVisible && returnExchangeRecordVisible"
                @switchTab="switchRecordTab"
            />
        </a-modal>

        <!-- 物流明细 -->
        <a-modal 
            class="recordModal"
            v-model:visible="stepVisible"
            width="45%"
            :footer="false"
        >   
            <template #title>
               <div style="font-weight:bold">{{ $t('order.logisticsDetail') }}</div> 
            </template>

            <div class="courierNo">{{$t('order.courierNo')}}：{{ courier_no }}</div>
            <a-steps
                v-if="stepList.length > 0"
                :current="currentStep"
                direction="vertical"
                type="dot"
            >
                <a-step 
                    v-for="(item,index) in stepList"
                    :key="index"
                    :description="item.date"
                >
                    {{ item.name }}
                    <div class="courierMesg" >
                        <slot name='description'>{{item.message}}</slot>
                    </div>
                </a-step>
            </a-steps>
            <div v-else>{{ $t('order.noCourierInfo') }}</div>
        </a-modal>

        <!-- 新增客户 -->
        <a-modal 
            class="addCustomerModal"
            v-model:visible="addCustomerVisible"
            :width="1200"
            draggable
            :onBeforeOk="onAddCustomerBeforeOk"
            
        >
            <template #title>{{ $t('customer.addCustomer') }}</template>
             <!-- 客户基本信息 -->
             <a-divider orientation="center">{{ $t('customer.baseInfo') }}</a-divider>
            <Form
                class="editForm"
                :form="addBaseInfoForm"
                @handleSelectChange="handleAddCustomerSelectChange"
                @changeRadio="changeRadio">
            </Form>

            <!-- 客户默认地址信息 -->
            <a-divider orientation="center">{{ $t('customer.addressInfo') }}</a-divider>
            <Form
                class="editForm"
                :form="addAddressInfoForm"
                @handleInput="handleAddCustomerInputChange2"
                @handleInputClear="handleAddCustomerInputClear2"
                @handleSelectChange="handleAddCustomerSelectChange2">
            </Form>

            <a-checkbox v-model="checked" style="margin-left:25%">{{ $t('customer.differentAddrTip') }}</a-checkbox>
        
            <!-- 发票地址 -->
            <a-divider v-if="checked" orientation="center" style="margin-top:40px">{{ $t('customer.addressInfo2') }}</a-divider>
            <Form
                v-if="checked"
                class="editForm"
                :form="addInvoiceAddressForm"
                @handleInput="handleAddCustomerInputChange3"
                @handleInputClear="handleAddCustomerInputClear3"
                @handleSelectChange="handleAddCustomerSelectChange3">
            </Form>
            
        </a-modal>

        <!-- 查看订单行版本 -->
        <a-modal 
            class="addCustomerModal"
            v-model:visible="orderLineVersionVisible"
            width="80%"
            :render-to-body="false"
            :footer="false"
            :fullscreen="fullscreen"
        >
            <template #title>{{ $t('order.viewVersion') }}</template>

            <icon-expand v-if="!fullscreen" :size="20" @click="fullscreen = !fullscreen" class="fullscreenIcon" />
            <icon-shrink v-else :size="20" @click="fullscreen = !fullscreen" class="fullscreenIcon"/>

            <Table
                :table="versionTable"
                @changePage="changeVersionPage"
                @changePageSize="changeVersionPageSize"
            ></Table>
        </a-modal>

        <!-- 取消SO -->
        <a-modal 
            class="addCustomerModal"
            v-model:visible="cancelSOVisible"
            width="85%"
            draggable
            :fullscreen="fullscreen"
            :onBeforeOk="onCancelSOBeforeOk"
            @ok="handleCancelSO"
            @cancel="handleCancel"
        >
            <template #title>{{ $t('order.cancelSO') }}</template>

            <icon-expand v-if="!fullscreen" :size="20" @click="fullscreen = !fullscreen" class="fullscreenIcon" />
            <icon-shrink v-else :size="20" @click="fullscreen = !fullscreen" class="fullscreenIcon"/>

            <div style="color:#1890ff;font-weight:600">{{ $t('base.tip') }}: {{ $t('order.cancelSOHeadTip') }}</div>
            <Table
                ref="cancelSOTableRef"
                class="deliverTable"
                :table="cancelSOTable"
                @selectRow="selectRowCancel"
                @selectAllRow="selectAllRowCancel"
                @changePage="changeVersionPage"
                @changePageSize="changeVersionPageSize"
            >
                <template v-slot:cancelSO="{ props }">
                    <span style="color:orange" v-if="props.record.cancel_status_val == 0">{{ props.record.cancel_status }}</span>
                    <span style="color:red" v-else-if="props.record.cancel_status_val == 1">{{ props.record.cancel_status }}</span>
                    <span style="color:green" v-else>{{ props.record.cancel_status }}</span>
                </template>
            </Table>
        </a-modal>

        <!--退换货 -->
        <a-modal
            v-model:visible="returnVisible" 
            :width="returnWidth"
            :mask-closable="false"
            draggable
            :onBeforeOk="onReturnBeforeOk"
            @ok="handleReturnOk"
        >
            <template #title>
                <div style="font-weight:bold">{{ $t('returnExchange.returnAndExchange') }}</div> 
            </template>
            <CreateReturnExchange ref="returnExchangeForm" :row="rowData" :visible="returnVisible" @handleReturnWidth="handleReturnWidth"></CreateReturnExchange>
        </a-modal>

        <!--退款 -->
        <a-modal
            v-model:visible="refundVisible" 
            width="55%"
            draggable
            :onBeforeOk="onRefundBeforeOk"
            @ok="handleRefundOk"
        >
            <template #title>
                <div style="font-weight:bold">{{ $t('order.refund') }}</div> 
            </template>
            <Form 
                :form="refundForm" 
                @handleSelectChange="handleRefundFormSelectChange"
                @handleInputNumberChange="handleInputNumberRefundChange"
                @handleSelectDate="handleRefundSelectDate"
            ></Form>

            <!-- <OrderRefund ref="orderFundTable" :row="rowData"></OrderRefund>  -->
        </a-modal>

        <!-- 补寄 -->
        <a-modal
            v-model:visible="reissueVisible" 
            :width="reissueWidth"
            :mask-closable="false"
            draggable
            :onBeforeOk="onReissueBeforeOk"
        >
            <template #title>
                <div style="font-weight:bold">{{ $t('order.reissue') }}</div> 
            </template>
            <CreateReissue ref="reissueForm" :row="rowData" :visible="reissueVisible" @handleReissueWidth="handleReissueWidth"></CreateReissue>
        </a-modal>

        <!-- 返修 -->
        <a-modal
            v-model:visible="returnFactoryVisible" 
            :width="returnFactoryWidth"
            :mask-closable="false"
            draggable
            :onBeforeOk="onReturnFactoryBeforeOk"
        >
            <template #title>
                <div style="font-weight:bold">{{ $t('order.returnFactory') }}</div> 
            </template>
            <CreateReturnFactory ref="returnFactoryForm" :row="rowData" :visible="returnFactoryVisible" @handleReturnFactoryWidth="handleReturnFactoryWidth"></CreateReturnFactory>
        </a-modal>

        <!-- 验证订单风险等级 -->
        <a-modal
            class="riskModal"
            v-model:visible="riskVisible" 
            :width="500"
            popup-container="#listContainer"
            draggable
            :onBeforeOk="onRiskBeforeOk"
        >
            <template #title>
                <div style="font-weight:bold">{{ $t('order.riskValidate') }}</div> 
            </template>
            <a-select 
                v-model="riskLevel" 
                allow-clear
                style="width: 230px;margin-left:120px"
            >
            <!-- 1: 有风险  2：无风险   -->
                <a-option :value="1">{{ $t('order.confirmedAsRisk') }} </a-option>
                <a-option :value="2">{{ $t('order.relieveRisks') }} </a-option>
            </a-select>
        </a-modal>

        <!-- 下载发票，自定义日期 -->
        <!-- <a-modal
            class="downloadInvoiceModal"
            v-model:visible="downloadInvoiceVisible" 
            :width="650"
            popup-container="#listContainer"
            draggable
            :footer="!downloadInvoiceDisabled || !downloadCustomDateInvoiceDisabled"
            :onBeforeOk="onDownloadInvoiceBeforeOk"
        >
            <template #title>
                <div style="font-weight:bold">{{ $t('order.downloadInvoice') }}</div> 
            </template>

            <a-spin :loading="spinLoading">
                <div style="margin-bottom:10px;color:#165dff">
                    <icon-exclamation-circle size="17"/>
                    {{ $t('order.downloadInvoiceTip') }}
                </div>
                <a-radio-group v-model="downloadType" @change="changeInvoiceType">
                    {{ $t('base.operation') }}：
                    <a-radio value="1" :disabled="downloadInvoiceDisabled">{{ $t('order.redownloadInvoice') }}</a-radio>
                    <a-radio value="2" :disabled="downloadCustomDateInvoiceDisabled">{{ $t('order.downloadCustomDateInvoice') }}</a-radio>
                </a-radio-group>
                <div v-if="downloadType == 2" style="margin-top:15px">
                    <div style="color:#999;margin:10px 0 5px 0">{{$t('base.tip')}}: {{$t('order.invoiceDateTip')}}</div>
                    <span>{{ $t('base.date') }}：</span>
                    <a-date-picker
                        style="width: 220px; margin: 0 24px 24px 0;"
                        :defaultValue="invoice_date"
                        format="YYYY-MM-DD"
                        @change="changeInvoiceDate"
                    />
                </div>
            </a-spin>
        </a-modal> -->

        <!-- 下载订单确认书，自定义日期 -->
        <a-modal
            class="downloadInvoiceModal"
            v-model:visible="downloadConfirmationVisible" 
            :width="750"
            popup-container="#listContainer"
            draggable
            :footer="!downloadConfirmationDisabled || !reDownloadConfirmationDisabled"
            :onBeforeOk="onDownloadConfirmationBeforeOk"
        >
            <template #title>
                <div style="font-weight:bold">{{ $t('order.downloadConfirmation2') }}</div> 
            </template>

            <a-spin :loading="confirmationSpinLoading">
                <div v-if="!reDownloadConfirmationDisabled" style="margin-bottom:10px;color:#165dff">
                    <!-- <icon-exclamation-circle size="17"/> -->
                    <div style="display: inline-block; float: left;">{{ $t('base.tip') }}:</div>
                    <ul style="display: inline-block; margin-top: 0px; width: 85%;">
                        <li>{{ $t('order.downloadConfirmationTip') }}</li>
                    </ul>
                    
                </div>
                <a-radio-group v-model="downloadConfirmationType">
                    {{ $t('base.operation') }}：
                    <a-radio value="1" :disabled="downloadConfirmationDisabled">{{ $t('order.downloadConfirmation') }}</a-radio>
                    <a-radio v-if="!reDownloadConfirmationDisabled" value="2" :disabled="reDownloadConfirmationDisabled">{{ $t('order.reDownloadConfirmation') }}</a-radio>
                </a-radio-group>
            </a-spin>
        </a-modal>

        <!-- 创建服务订单，选择实物订单行 -->
        <a-modal 
            class="deliverModal"
            v-model:visible="createServiceLineVisible"
            :title="t('base.select')" 
            width="80%"
            draggable
            :onBeforeOk="onCreateServiceLineBeforeOk" 
        >
            <Table 
                ref="createServiceLineTableRef"
                class="deliverTable"
                :table="createServiceLineTable"
                @selectRow="createServiceLineTableSelectRow"
                @selectAllRow="createServiceLineTableSelectAllRow"
            ></Table>
        </a-modal>

        <!-- 2025.1.15~2025.2.6期间创建的订单，弹窗提示按新的运费规则，自动计算运费 -->
        <a-modal 
            class="deliverModal"
            v-model:visible="autoComputeFreightVisible"
            :title="t('order.freightConfirm')" 
            :width="600"
            :mask-closable="false"
            :hide-cancel="true"
            :closable="false"
            :onBeforeOk="onAutoComputeFreightBeforeOk" 
        >
            <div>{{ $t('order.autoComputeFreight') }}</div>
        </a-modal>

        <!-- 获取SKU预计发货时间 -->
        <a-modal 
            class="deliverModal"
            v-model:visible="lockTableVisible"
            :title="t('inventoryLock.deliveryDateList')" 
            width="80%"
            draggable
        >
            <Table 
                class="deliverTable"
                :table="lockTable"
            ></Table>
        </a-modal>

        <!-- 订单 库存锁定列表 -->
        <a-modal 
            class="deliverModal"
            v-model:visible="inventoryLockTableVisible"
            :title="t('inventoryLock.inventoryLockDetail')" 
            width="80%"
            draggable
            :footer="null"
        >
            <Table 
                class="deliverTable"
                :table="inventoryLockTable"
            >
                <template v-slot:operate>
                    <a-button
                        v-permission="'setting.inventoryLock.lockInventory'"
                        type="primary"
                        size="small"
                        style="margin-right:15px; margin-left: -20px"
                        @click="handle('lockInventory')"
                    >
                        <icon-lock style="margin-right:10px;"/>
                        {{ $t('inventoryLock.lockInventory') }}
                    </a-button>
                    <a-button
                        v-permission="'setting.inventoryLock.releaseInventory'"
                        type="primary"
                        size="small" 
                        status="danger"
                        :disabled="inventoryLockTable.datas.length == 0"
                        @click="handle('releaseInventory')"
                    >
                        <icon-unlock style="margin-right:10px"/>
                        {{ $t('inventoryLock.releaseInventory') }}
                    </a-button>
                </template>
 
                <template v-slot:columns="{ props }">
                    <div v-if="props.column.key == 'inventory_type'" style="font-size:12px;">
                        <div v-if="props.record.inventory_type == '-'">-</div>
                        <div v-else>
                            <a-tag v-if="props.record.inventory_type !== '-'" :color="props.record.inventory_type_val === 'in_stock'? 'green' : props.record.inventory_type_val == 'in_transit'? 'orange' : 'blue'">{{ props.record.inventory_type }}</a-tag>
                        </div>
                    </div>
                    <div v-if="props.column.key == 'lock_status'" style="font-size:12px;">
                        <div v-if="props.record.lock_status == '-'">-</div>
                        <div v-else>
                            <a-tag v-if="props.record.lock_status !== '-'" :color="props.record.lock_status_val === 0? 'red' : props.record.lock_status_val == 1? 'blue' : 'green'">{{ props.record.lock_status }}</a-tag>
                        </div>
                    </div>
                </template>

                <template v-slot:searchFilter="{ props }">
                    <div class="searchFilter">
                        <a-space direction="vertical">
                        <a-input :model-value="props.filterValue[0]" style="width:164px" @input="(value)=>props.setFilterValue([value])" />
                        <div class="searchFilter-footer">
                            <a-button  style="margin-right:10px" @click="props.handleFilterReset">{{ $t('base.reset') }}</a-button>
                            <a-button type="primary" @click="props.handleFilterConfirm">{{ $t('base.confirm2') }}</a-button>
                        </div>
                        </a-space>
                    </div>
                </template>
            </Table>
        </a-modal>
    </div>
</template>

<script setup>
    import { nextTick, onMounted, reactive, ref, watch, toRefs, h } from 'vue';
    import { OrderApi } from '@/api/OrderApi.js';
    import { InvoiceApi } from '@/api/InvoiceApi.js';
    import { FinancialApi } from '@/api/FinancialApi.js'; 
    import { CustomerApi } from '@/api/CustomerApi.js'; 
    import { DealerApi } from '@/api/DealerApi.js';
    import { StockOutApi } from '@/api/StockOutApi.js';
    import { Message, Modal } from '@arco-design/web-vue';
    import { useRouter, useRoute } from 'vue-router';
    // import screenfull from 'screenfull'
    import Clipboard from 'clipboard';
    import Table from '@/components/Table.vue';
    import Form from '@/components/Form.vue';
    import CreateReturnExchange from './CreateReturnExchange.vue';
    import ReturnExchangeRecord from './ReturnExchangeIndex.vue';
    import CreateReissue from './CreateReissue.vue';
    import CreateReturnFactory from './CreateReturnFactory.vue';
    import LogisticsInfo from './LogisticsInfo.vue';
    import Detail from './Detail.vue';
    import LineDetail from './LineDetail.vue';
    // import OrderRefund from './OrderRefund.vue';
    import { 
        OrderListQuery,
        DeliverForm,
        CreateOrderForm1, 
        CreateOrderForm2,
        CreateOrderForm3, 
        RefundForm,
        // AddCustomerForm,false
        AddCustomerBaseInfoForm,
        AddCustomerAddressInfoForm,
        AddInvoiceAddressForm,
    } from './queryConfig/OrderListQuery.js';
     
    // import moment from 'moment'
    import { dateToTimestamp, timestampToDate, formatterToPoint, formatterToComma, getNowDate, getWeek, hasPermission } from '@/utils/index.js';
    import { useI18n } from 'vue-i18n';
    import { useLocale } from '@/store/index.js';
    import { multiply, add, subtract, divide } from 'accurate-core';
    import dayjs from 'dayjs';
    import { IconSearch } from '@arco-design/web-vue/es/icon';
    
    const router = useRouter()
    const route = useRoute()
    const localeStore = useLocale()
    const { t } = useI18n()

    const FREIGHT = 24.9 // 一辆车的运费

    const userInfo = JSON.parse(sessionStorage.getItem('userInfo'))
    // 金额列「展开明细」按钮权限；all_query 不授予（release-sql/order_amount_detail_permission.sql）
    const canViewAmountDetail = hasPermission('setting.order.viewAmountDetail')
    const hasError = ref(false)
    const reissueHasError = ref(false)
    const returnFactoryHasError = ref(false)
    const showForm = ref(false)
    const orderTableRef = ref(null)
    const visible = ref(false)
    const erpsyncVisible = ref(false)
    const createOrderVisible = ref(false)
    const locale = ref(localStorage.getItem('locale'))
    const timezoneOffset = ref(new Date().getTimezoneOffset() / 60)  // 获取当前时区的偏移量 ， 偏移量=-8 ==> 北京时间   偏移量=-2 ==> 柏林时间
    const timeDiff = ref(6 * 60 * 60 * 1000) // 中国与德国时差
    const preInvoiceNo = ref('')
    const invoice_date = ref(getNowDate())
    const reissueWidth = ref('85%')
    const returnWidth = ref('85%')
    const returnFactoryWidth = ref('85%')
    const createOrderWidth = ref('65%')
    const activeKey = ref('medium')
    const modalTitle = ref('')
    const downloadInvoiceVisible = ref(false)
    const modalVisible = ref(false)
    const recordVisible = ref(false)
    const logisticsVisible = ref(false)
    const refundRecordVisible = ref(false)
    const cancelSORecordVisible = ref(false)
    const addCustomerVisible = ref(false)
    const orderLineVersionVisible = ref(false)
    const cancelSOVisible = ref(false)
    const returnVisible = ref(false)
    const refundVisible = ref(false)
    const reissueVisible = ref(false)
    const returnFactoryVisible = ref(false)
    const returnExchangeRecordVisible = ref(false)
    const createPrePayOrderVisible = ref(false)
    const createServiceLineVisible = ref(false)
    const autoComputeFreightVisible = ref(false)
    const riskVisible = ref(false)
    const lockTableVisible = ref(false)
    const inventoryLockTableVisible = ref(false)
    const editUserNoteVisible = ref(false)
    const fullscreen = ref(false)
    const isSyncERP = ref(false)
    const exportingOrder = ref(false)
    const exportingEBike = ref(false)
    const exportingCustomer = ref(false)
    const exportingUnshipOrder = ref(false)
    const queryForm = reactive(OrderListQuery)
    const deliverForm = reactive(DeliverForm)
    const createOrderForm1 = reactive(CreateOrderForm1)
    const createOrderForm2 = reactive(CreateOrderForm2)
    const createOrderForm3 = reactive(CreateOrderForm3)
    // const addCustomerForm = reactive(AddCustomerForm)
    const addBaseInfoForm = reactive(AddCustomerBaseInfoForm)
    const addAddressInfoForm = reactive(AddCustomerAddressInfoForm)
    const addInvoiceAddressForm = reactive(AddInvoiceAddressForm)
    const refundForm = reactive(RefundForm)
    const checked = ref(false)
    const orderFundTable = ref(null)
    const downloadType = ref('1')
    const downloadInvoiceDisabled = ref(false)
    const downloadCustomDateInvoiceDisabled = ref(false)
    const downloadConfirmationVisible = ref(false)
    const downloadConfirmationDisabled = ref(false)
    const reDownloadConfirmationDisabled = ref(false)
    const confirmationSpinLoading = ref(false)
    const downloadConfirmationType = ref('1')
    const existHistoryInvoice = ref(false) // 是否存在历史发票
    const spinLoading = ref(true)
    const fromPage = ref(false)
    const isFinance = ref(false)
    const detailVisible = ref(false)
    const lineDetailVisible = ref(false)
    const lastValidOrderNo = ref('')
    const showAddOrderLineBtn = ref(true)
    const customerPaymentType = ref(false)
    const is_hepha_customer = ref('')
    const unit_freight = ref(0)
    const cargoFreightNeedChange = ref(false)
    const selectedKeys = ref([])
    const pay_discount_arr = ref([])
    const cash_discount_arr = ref([])
    const pay_day_arr = ref([])
    const pay_discount_opt = ref([])
    const cash_discount_opt = ref([])
    const pay_day_opt = ref([])
    const country_info = ref(null)
    const shipping_cost = ref('')
    const isPersonChange = ref(true)
    const orderLineExitsSku = ref(false)
    const orderLineAllowClearSKU = ref(false)
    const source_optItem = ref(null)
    const b2bCargoFreight = ref('')

    const innerColumns = ref([ 
        {
            // title: 'No.',
            title:'#',
            dataIndex: 'serial',
            key: 'product_name',
            width: '60',
            align: 'center',
            ellipsis:true,
            tooltip:true,
        },
        {
            // title: '产品名称',
            title:t('order.productName'),
            dataIndex: 'product_name',
            key: 'product_name',
            width: '120',
            align: 'center',
            ellipsis:true,
            tooltip:true,
        },
        {
            // title: '车架号',
            title:t('order.frameNumber'),
            dataIndex: 'frame_number',
            key: 'frame_number',
            width: '150',
            align: 'center',
            slotName:'slot'
        },
        {
            // title: 'SKU',
            title:t('order.sku'),
            dataIndex: 'sku',
            key: 'sku',
            width: '190',
            align: 'center',
            ellipsis:true,
            tooltip:true,
            // slotName:'sku',
            slotName:'slot',
        },
        {
            // title: '物料编码',
            title:t('order.inventoryCode'),
            dataIndex: 'inventory_code',
            key: 'inventory_code',
            width: '140',
            align: 'center',
            ellipsis:true,
            tooltip:true,
        },
        {
            // title: '车型',
            title:t('order.modelModelYear'),
            dataIndex: 'model_model_year',
            key: 'model_model_year',
            width: '200',
            align: 'center',
            ellipsis:true,
            tooltip:true,
            slotName:'slot',
        },
        {
            // title: '数量',
            title:t('order.qty'),
            dataIndex: 'qty',
            key: 'qty',
            width: '120',
            align: 'center',
            slotName:'slot',
        },
        {
            // title: '行金额',
            title:t('order.lineAmount'),
            dataIndex: 'line_amount',
            key: 'line_amount',
            width: '170',
            align: 'center',
            slotName:'slot',
        },
        {
            // title: '取消状态',
            title:t('order.cancelStatus'),
            dataIndex: 'cancel_status',
            key: 'cancel_status',
            width: '130',
            align: 'center',
            slotName:'slot'
        },
        {
            // title: '用户备注',
            title:t('order.userNote'),
            dataIndex: 'user_comment',
            key: 'user_comment',
            width: '140',
            align: 'center',
            // ellipsis:true,
            slotName:'slot'
        },
        {
            // title: '操作',
            title:t('order.operate'),
            dataIndex: 'Optional',
            key: 'Optional',
            slotName: 'optional',
            width: '130',
            align: 'center',
            fixed: 'right'
        }
    ])
    const innerConfigs = ref({
        scroll: {
            x: 1000,
            y: 200,
        },
        stripe: false,
        bordered: false,
        size: 'large',
        loading: false,
        // rowSelection:{
        //     type: 'checkbox',
        //     showCheckedAll: true,
        //     onlyCurrent: false,
        // },
        // selected:[],
        pagination: false,
    })
    const table = ref({
        datas:[],
        columns:[
            {
                // title: '订单编号',
                title:t('order.orderName'),
                dataIndex: 'order_name',
                key:'order_name',
                width:'170',
                // align:'center',
                fixed:'left',
                sortable: {
                    sortDirections: ['ascend', 'descend'],
                },
                slotName: 'slot'
            },
            {
                // title: '订单来源',
                title:t('order.orderSource'),
                dataIndex: 'source',
                key:'source',
                width:'150',
                align:'left',
                slotName:'slot',
            },
            {
                // title: 'ERP编号',
                title:t('order.erpNo'),
                dataIndex: 'erp_no',
                key:'erp_no',
                width:'150',
                // align:'center',
            },
            {
                // title: '发货状态',
                title:t('order.deliverStatus'),
                dataIndex: 'courier_status',
                key:'courier_status',
                width:'170',
                // align:'center',
                slotName: 'courier_status'
            },
            {
                // title: '风险等级',
                title:t('order.riskLevel'),
                dataIndex: 'risk_level',
                key:'risk_level',
                width:'100',
                slotName:'slot'
                // align:'center',
            }, 
            {
                // title: '风险验证',
                title:t('order.riskValidate'),
                dataIndex: 'risk_validate',
                key:'risk_validate',
                width:'120',
                slotName:'slot'
                // align:'center',
            }, 
            {
                // title: '备注',
                title:t('order.instruction'),
                dataIndex: 'instruction',
                key:'instruction',
                width:'270',
                slotName:'slot',
                // align:'center',
            },
            {
                // title: '发货方式',
                title:t('order.deliveryType'),
                dataIndex: 'delivery_type',
                key:'delivery_type',
                width:'150',
                // align:'center',
                slotName: 'delivery_type'
            },
            {
                // title: '金额',
                title:t('order.amount'),
                dataIndex: 'amount',
                key:'amount',
                width:'240',
                slotName:'amount'
                // align:'center',
            },
            {
                // title: '订单时间',
                title:t('order.orderTimestamp'),
                dataIndex: 'order_timestamp',
                key:'order_timestamp',
                width:'140',
                // align:'center',
                ellipsis:true,
                tooltip:true,
                sortable: {
                    sortDirections: ['ascend', 'descend'],
                },
            },
            {
                // title: '订单类型',
                title:t('order.orderChannelType'),
                dataIndex: 'order_channel_type',
                key:'order_channel_type',
                width:'130',
                // align:'center',
                slotName: 'slot'
            }, 
            {
                // title: '单据类型',
                title:t('order.orderType'),
                dataIndex: 'order_type',
                key:'order_type',
                width:'150',
                // align:'center',
            }, 
            {
                // title: '客户信息',
                title:t('order.customerInfo'),
                dataIndex: 'customer_info',
                key:'customer_info',
                width:'320',
                // align:'center',
                slotName: 'slot'
            }, 
            {
                // title: '国家',
                title:t('order.country'),
                dataIndex: 'country',
                key:'country',
                width:'130',
                // align:'center',
            },
            {
                title: t('base.operate'),
                dataIndex: 'Optional',
                key:'Optional',
                slotName:'optional',
                width: '160',
                align:'center',
                fixed:'right'
            }
        ],
        configs:{
            scroll:{
                // x:1000,
                y: 480
            },
            stripe:true,
            bordered:true,
            size:'large',
            loading:false,
            pagination:{
                size:'mini',
                current:1,
                pageSize:10,
                total:0,
                pageSizeOptions:[10, 20, 50, 100],
                showJumper:true,
                showPageSize:true,
                showTotal:true,
            },
            
        },
    })
    const recordTable = ref({
        datas:[],
        columns:[
            {
                title: '#',
                dataIndex: 'No',
                key:'No',
                width:'50',
            },
            {
                // title: '订单名称',
                title:t('order.orderName'),
                dataIndex: 'order_name',
                key:'order_name',
                width:'150',
                align:'center',
                ellipsis:true,
                tooltip:true,
            },
            {
                // title: 'MES出库单号',
                title:t('order.deliveryNumber'),
                dataIndex: 'delivery_number',
                key:'delivery_number',
                width:'230',
                align:'center',
                ellipsis:true,
                tooltip:true,
            },
            {
                // title: 'sku',
                title:t('order.sku'),
                dataIndex: 'sku',
                key:'erp_no',
                width:'150',
                align:'center',
                ellipsis:true,
                tooltip:true,
            },
            {
                // title: '产品名称',
                title:t('order.productName'),
                dataIndex: 'product_name',
                key: 'product_name',
                width: '250',
                align: 'center',
                ellipsis:true,
                tooltip:true,
            },
            {
                // title: 'erp编号',
                title:t('order.erpNo'),
                dataIndex: 'erp_no',
                key:'erp_no',
                width:'130',
                align:'center',
                ellipsis:true,
                tooltip:true,
            },
            {
                // title: 'erp行号',
                title:t('order.erpLineNo'),
                dataIndex: 'erp_line_no',
                key:'erp_line_no',
                width:'130',
                align:'center',
                ellipsis:true,
                tooltip:true,
            },
            {
                // title: '物料编码',
                title:t('order.inventoryCode'),
                dataIndex: 'inventory_code',
                key:'inventory_code',
                width:'160',
                align:'center',
                tooltip:true,
                ellipsis:true,
            },
            {
                // title: '车型',
                title:t('order.model'),
                dataIndex: 'model',
                key: 'model',
                width: '150',
                align: 'center',
                ellipsis:true,
                tooltip:true,
            },
            {
                // title: '上市年份',
                title:t('order.modelYear'),
                dataIndex: 'model_year',
                align:'center',
                ellipsis:true,
                tooltip:true,
                show:true,
                width:120,
            },
            {
                // title: '品牌名称',
                title:t('order.brandName'),
                dataIndex: 'brand_name',
                key: 'brand_name',
                width: '150',
                align: 'center',
                ellipsis:true,
                tooltip:true,
            },
            {
                // title: '零件名称',
                title:t('order.partName'),
                dataIndex: 'part_name',
                key: 'part_name',
                width: '150',
                align: 'center',
                ellipsis:true,
                tooltip:true,
            },
            {
                // title: '出库状态',
                title:t('order.outboundStatus'),
                dataIndex: 'status',
                key:'status',
                width:'160',
                align:'center',
                slotName:'slot',
            },
            {
                // title: '物流单号',
                title:t('order.courierNo'),
                dataIndex: 'courier_no',
                key:'courier_no',
                width:'140',
                align:'center',
                tooltip:true,
                ellipsis:true,
            },
            {
                // title: '物流状态',
                title:t('order.courierStatus'),
                dataIndex: 'courier_status',
                key:'courier_status',
                width:'150',
                align:'center',
                slotName:'slot',
            },
            {
                // title: '物流公司',
                title:t('order.courierType'),
                dataIndex: 'courier_type',
                key:'courier_type',
                width:'150',
                align:'center',
                ellipsis:true,
                tooltip:true,
            },
            {
                // title: '发货仓库',
                title:t('order.warehouse'),
                dataIndex: 'warehouse',
                key:'warehouse',
                width:'180',
                align:'center',
                ellipsis:true,
                tooltip:true,
            },
            {
                // title: '需发货数量',
                title:t('order.needShipquantity'),
                dataIndex: 'quantity',
                key:'quantity',
                width:'170',
                align:'center',
            },
            {
                // title: '已发货数量',
                title:t('order.shippedQuantity'),
                dataIndex: 'ship_qty',
                key:'ship_qty',
                width:'140',
                align:'center',
            },
            {
                // title: '客户名称',
                title:t('order.customerName'),
                dataIndex: 'customer_name',
                key:'customer_name',
                width:'200',
                align:'center',
                tooltip:true,
                ellipsis:true,
            },
            {
                // title: '发货日期',
                title:t('order.deliveryDate'),
                dataIndex: 'delivery_date',
                key:'delivery_date',
                width:'180',
                align:'center',
                tooltip:true,
                ellipsis:true,
            }
        ],
        configs:{
            scroll:{
                // x:1000,
                // y:700,
            },
            stripe:true,
            bordered:true,
            size:'large',
            loading:false,
            expandable:'',
            expand:false,
            pagination:{
                current:1,
                pageSize:10,
                total:0,
                pageSizeOptions:[10, 20, 50, 100],
                showJumper:true,
                showPageSize:true,
                showTotal:true,
            },
            
        },
    })
    const refundRecordTable = ref({
        datas:[],
        columns:[
            {
                title: '#',
                dataIndex: 'No',
                key:'No',
                width:'60',
            },
            {
                // title: '订单编号',
                title:t('order.orderName'),
                dataIndex: 'order_name',
                key:'order_name',
                width:'120',
                align:'center',
                ellipsis:true,
                tooltip:true,
            },
            {
                // title: '订单金额',
                title:t('order.orderAmount'),
                dataIndex: 'order_amount',
                key:'order_amount',
                width:'150',
                align:'center',
                tooltip:true,
                ellipsis:true,
            },
            {
                // title: '退款金额',
                title:t('order.refundAmount'),
                dataIndex: 'refund_amount',
                key:'refund_amount',
                width:'150',
                align:'center',
            },
            {
                // title: '退款原因类型',
                title:t('order.refundReasonType'),
                dataIndex: 'reason_type',
                key:'reason_type',
                width:'150',
                align:'center',
            },
            {
                // title: '退款原因',
                title:t('order.refundReason'),
                dataIndex: 'reason',
                key:'reason',
                width:'150',
                align:'center',
            },
            {
                // title: '退款日期',
                title:t('order.refundTimestamp'),
                dataIndex: 'refund_timestamp',
                key:'refund_timestamp',
                width:'150',
                align:'center',
                ellipsis:true,
                tooltip:true,
            },
            {
                // title: '红字发票号'（退款与红字导入写入，没有红字显示 -）
                title:t('order.creditNoteNo'),
                dataIndex: 'credit_note_no',
                key:'credit_note_no',
                width:'150',
                align:'center',
                ellipsis:true,
                tooltip:true,
            },
        ],
        configs:{
            scroll:{
                // x:1000,
                // y:700,
            },
            stripe:true,
            bordered:true,
            size:'large',
            loading:false,
            expandable:'',
            expand:false,
            pagination:false,
        }
    })
    const cancelSORecordTable = ref({
        datas:[],
        columns:[
            {
                title: '#',
                dataIndex: 'No',
                key:'No',
                width:'60',
            },
            {
                // title: 'erp订单号',
                title:t('order.erpNo'),
                dataIndex: 'erp_no',
                key:'erp_no',
                width:'120',
                align:'center',
                ellipsis:true,
                tooltip:true,
            },
            {
                // title: '订单金额',
                title:t('order.erpLineNo'),
                dataIndex: 'erp_line_no',
                key:'erp_line_no',
                width:'150',
                align:'center',
                tooltip:true,
                ellipsis:true,
            },
            {
                // title: '数量',
                title:t('order.quantity'),
                dataIndex: 'quantity',
                key:'quantity',
                width:'150',
                align:'center',
            },
            {
                // title: '类型',
                title:t('order.type'),
                dataIndex: 'type',
                key:'type',
                width:'150',
                align:'center',
                ellipsis:true,
                tooltip:true,
            },
            {
                // title: '同步状态',
                title:t('order.syncStatus'),
                dataIndex: 'status',
                key:'status',
                width:'150',
                align:'center',
                ellipsis:true,
                tooltip:true,
                slotName:'slot'
            },
        ],
        configs:{
            scroll:{
                // x:1000,
                // y:700,
            },
            stripe:true,
            bordered:true,
            size:'large',
            loading:false,
            expandable:'',
            expand:false,
            pagination:false,
        }
    })
    const orderRowData = ref(null)
    const rowData = ref(null)
    const orderLineRowData = ref(null)
    const defaultWarehouse = ref()
    const roleAuth = sessionStorage.getItem('userInfo')? ref(JSON.parse(sessionStorage.getItem('userInfo')).role) : 3
    const courierId = ref()
    const warehouseOptions = ref([])
    // const deliverTable = ref({
    //     datas:[],
    //     columns:[
    //         {
    //             // title: '#',
    //             title: '#',
    //             dataIndex: 'serial',
    //             align:'center',
    //             ellipsis:true,
    //             tooltip:true,
    //             width:60,
    //             show:true,
    //         },
    //         {
    //             // title: '订单编号',
    //             title: t('order.orderName'),
    //             dataIndex: 'order_name',
    //             align:'center',
    //             ellipsis:true,
    //             tooltip:true,
    //             width:160,
    //             show:true,
    //         },
    //         {
    //             // title: 'SKU',
    //             title: t('order.sku'),
    //             dataIndex: 'sku',
    //             align:'center',
    //             ellipsis:true,
    //             tooltip:true,
    //             show:true,
    //             width:160,
    //         },
    //         {
    //             // title: '物料编码',
    //             title: t('order.inventoryCode'),
    //             dataIndex: 'inventory_code',
    //             align:'center',
    //             ellipsis:true,
    //             tooltip:true,
    //             show:true,
    //             width:140,
    //         },
    //         {
    //             // title: 'ERP行号',
    //             title:t('order.erpLineNo'),
    //             dataIndex: 'erp_line_no',
    //             align: 'center',
    //             ellipsis:true,
    //             tooltip:true,
    //             show:true,
    //             width:110,
    //         },
    //         {
    //             // title: '产品名称',
    //             title: t('order.productName'),
    //             dataIndex: 'product_name',
    //             align:'center',
    //             ellipsis:true,
    //             tooltip:true,
    //             show:true,
    //             width:160,
    //         },
    //         {
    //             // title: '车型/年份',
    //             title:t('order.modelModelYear'),
    //             dataIndex: 'model_model_year',
    //             align:'center',
    //             ellipsis:true,
    //             tooltip:true,
    //             show:true,
    //             width:200,
    //             slotName:'modelModelYear',
    //         },
    //         {
    //             // title: '品牌/零件名称',
    //             title:t('stock.brandPartName'),
    //             dataIndex: 'brand_part_name',
    //             align:'center',
    //             ellipsis:true,
    //             tooltip:true,
    //             show:true,
    //             width:160,
    //             slotName:'brandPartName'
    //         },
    //         {
    //             // title: '下单数量',
    //             title: t('order.quantity'),
    //             dataIndex: 'orderQuantity',
    //             align:'center',
    //             ellipsis:true,
    //             tooltip:true,
    //             show:true,
    //             width:100,
    //         },
    //         {
    //             // title: '已发货数量',
    //             title: t('order.shipQuantity'),
    //             dataIndex: 'ship_quantity',
    //             align:'center',
    //             ellipsis:true,
    //             tooltip:true,
    //             show:true,
    //             width:120,
    //         },
    //         {
    //             // title: '库存相关数量',
    //             title: t('order.InventoryQty'),
    //             dataIndex: 'Inventory_qty',
    //             align:'center',
    //             ellipsis:true,
    //             tooltip:true,
    //             show:true,
    //             width:160,
    //             slotName:'InventoryQty',
    //         },
    //         {
    //             // title: '发货仓库',
    //             title: t('order.wms'),
    //             dataIndex: 'warehouse',
    //             align:'center',
    //             width:270,
    //             show:true,
    //             slotName:'warehouse',
    //             fixed:'right',
    //         },
    //         {
    //             // title: '转仓仓库',
    //             title: t('order.rollOverInventory'),
    //             dataIndex: 'roll_over_inventory', 
    //             align:'center',
    //             width:270,
    //             show:false,
    //             slotName:'rollOverInventory',
    //             fixed:'right',
    //         },
    //         {
    //             // title: '预计发货数量',
    //             title: t('order.curQuantity'),
    //             dataIndex: 'curQuantity',
    //             align:'center',
    //             width:160,
    //             show:true,
    //             slotName:'curQuantity',
    //             fixed:'right',
    //         },
    //     ],
    //     configs:{
    //         loading:false,
    //     }
    // })

    const deliverTable = ref({
        datas:[],
        columns:[
            {
                // title: '#',
                title: '#',
                dataIndex: 'serial',
                align:'center',
                ellipsis:true,
                tooltip:true,
                width:60,
                show:true,
            },
            {
                // title: 'SKU',
                title: t('order.sku'),
                dataIndex: 'sku',
                align:'center',
                ellipsis:true,
                tooltip:true,
                show:true,
                width:160,
            },
            {
                // title: '物料编码',
                title: t('order.inventoryCode'),
                dataIndex: 'inventory_code',
                align:'center',
                ellipsis:true,
                tooltip:true,
                show:true,
                width:140,
            },
            {
                // title: 锁定数量',
                title: t('inventoryLock.lockedQTY'),
                dataIndex: 'lock_quantity',
                align:'center',
                ellipsis:true,
                tooltip:true,
                show:true,
                width:100,
            },
            {
                // title: '产品名称',
                title: t('order.productName'),
                dataIndex: 'product_name',
                align:'center',
                ellipsis:true,
                tooltip:true,
                show:true,
                width:160,
            },
            {
                // title: '车型/年份',
                title:t('order.modelModelYear'),
                dataIndex: 'model_model_year',
                align:'center',
                ellipsis:true,
                tooltip:true,
                show:true,
                width:160,
                slotName:'modelModelYear',
            },
            {
                // title: 'ERP行号',
                title:t('order.erpLineNo'),
                dataIndex: 'erp_line_no',
                align: 'center',
                ellipsis:true,
                tooltip:true,
                show:true,
                width:110,
            },
            {
                // title: 数量',
                title: t('inventoryLock.quantity'),
                dataIndex: 'total_ship_quantity',
                align:'center',
                ellipsis:true,
                tooltip:true,
                show:true,
                width:130,
                slotName:'totalShipQuantity',
            },
            {
                // title: 锁定类型',
                title: t('inventoryLock.inventoryType'),
                dataIndex: 'inventory_type',
                align:'center',
                ellipsis:true,
                tooltip:true,
                show:true,
                width:140,
            },
            {
                // title: '发货仓库',
                title: t('order.wms'),
                dataIndex: 'warehouse',
                align:'center',
                width:270,
                show:true,
                slotName:'warehouse',
                fixed:'right',
            },
            {
                // title: '转仓仓库',
                title: t('order.rollOverInventory'),
                dataIndex: 'roll_over_inventory', 
                align:'center',
                width:270,
                show:false,
                slotName:'rollOverInventory',
                fixed:'right',
            },
            {
                // title: '预计发货数量',
                title: t('order.curQuantity'),
                dataIndex: 'curQuantity',
                align:'center',
                width:140,
                show:true,
                slotName:'curQuantity',
                fixed:'right',
            },
            {
                // title: '预计发货时间',
                title: t('order.handleTimestamp'),
                dataIndex: 'transaction_date',
                align:'center',
                width:190,
                show:true,
                slotName:'transaction_date',
                fixed:'right',
            },
        ],
        configs:{
            loading:false,
            rowSelection:{
                type: 'checkbox',
                showCheckedAll: false,
                onlyCurrent: false,
            },
            selected:[],
        }
    })
    const currentStep = ref()
    const stepVisible = ref(false)
    const stepList = ref([])
    const courier_no = ref()
    const customerList = ref([])
    const customerAddressList = ref([])
    const productList = ref([])
    const sending = ref(false)
    const versionTable = ref({
        datas:[],
        columns:[
            {
                title: '#',
                dataIndex: 'No',
                key:'No',
                width:'50',
            },
            {
                // title: 'sku',
                title:t('order.sku'),
                dataIndex: 'sku',
                key:'sku',
                width:'130',
                align:'center',
                ellipsis:true,
                tooltip:true,
            },
            {
                // title: '订单行编号',
                title:t('order.orderLineNo'),
                dataIndex: 'orderLineNo',
                key:'orderLineNo',
                width:'160',
                align:'center',
                ellipsis:true,
                tooltip:true,
            },
            {
                // title: '产品名称',
                title:t('order.productName'),
                dataIndex: 'name',
                key:'name',
                width:'150',
                align:'center',
                ellipsis:true,
                tooltip:true,
            },
            {
                // title: '修改时间',
                title:t('order.versionTime'),
                dataIndex: 'versionTime',
                key:'versionTime',
                width:'180',
                align:'center',
                ellipsis:true,
                tooltip:true,
            },
            {
                // title: 'erp编码',
                title:t('order.inventoryCode'),
                dataIndex: 'inventoryCode',
                key:'inventoryCode',
                width:'170',
                align:'center',
                ellipsis:true,
                tooltip:true,
            },
            {
                // title: '单价',
                title:t('order.price'),
                dataIndex: 'amount',
                key: 'amount',
                width: '120',
                align: 'center',
                ellipsis:true,
                tooltip:true,
            },
            {
                // title: '下单数量',
                title:t('order.quantity'),
                dataIndex: 'quantity',
                key: 'quantity',
                width: '120',
                align: 'center',
                ellipsis:true,
                tooltip:true,
            },
            {
                // title: '支付金额',
                title:t('order.payAmount'),
                dataIndex: 'payAmount',
                key: 'payAmount',
                width: '120',
                align: 'center',
                ellipsis:true,
                tooltip:true,
            },
            {
                // title: '税率',
                title:t('order.taxRate'),
                dataIndex: 'taxRate',
                key: 'taxRate',
                width: '120',
                align: 'center',
                ellipsis:true,
                tooltip:true,
            },
            {
                // title: '预计发货日期',
                title:t('order.handleTimestamp'),
                dataIndex: 'handleTimestamp',
                key:'handleTimestamp',
                width:'160',
                align:'center',
                tooltip:true,
                ellipsis:true,
            },
            {
                // title: '操作人',
                title:t('order.operator'),
                dataIndex: 'userName',
                key:'userName',
                width:'100',
                align:'center',
                tooltip:true,
                ellipsis:true,
            },
        ],
        configs:{
            scroll:{
                // x:1000,
                // y:700,
            },
            stripe:true,
            bordered:true,
            size:'large',
            loading:false,
            expandable:'',
            expand:false,
            pagination:{
                current:1,
                pageSize:10,
                total:0,
                pageSizeOptions:[10, 20, 50, 100],
                showJumper:true,
                showPageSize:true,
                showTotal:true,
            },
        }
    })
    const cancelSOTableRef = ref(null)
    const createServiceLineTableRef = ref(null)
    const cancelSOTable = ref({
        datas:[],
        columns:[
            {
                // title: '产品名称',
                title:t('order.productName'),
                dataIndex: 'product_name',
                key: 'product_name',
                width: '160',
                align: 'center',
                ellipsis:true,
                tooltip:true,
            },
            {
                // title: 'SKU',
                title:t('order.sku'),
                dataIndex: 'sku',
                key: 'sku',
                width: '160',
                align: 'center',
                ellipsis:true,
                tooltip:true,
            },
            {
                // title: '物料编码',
                title:t('order.inventoryCode'),
                dataIndex: 'inventory_code',
                key: 'inventory_code',
                width: '160',
                align: 'center',
                ellipsis:true,
                tooltip:true,
            },
            {
                // title: 'ERP行号',
                title:t('order.erpLineNo'),
                dataIndex: 'erp_line_no',
                key: 'erp_line_no',
                width: '150',
                align: 'center',
                ellipsis:true,
                tooltip:true,
            },
            {
                // title: '需发货数量',
                title:t('order.quantity'),
                dataIndex: 'quantity',
                key: 'quantity',
                width: '120',
                align: 'center',
            },
            {
                // title: '已发货数量',
                title:t('order.shipQuantity'),
                dataIndex: 'ship_quantity',
                key: 'ship_quantity',
                width: '150',
                align: 'center',
            },
            {
                // title: '已取消数量',
                title:t('order.cancelQuantity'),
                dataIndex: 'cancel_quantity',
                key: 'cancel_quantity',
                width: '100',
                align: 'center',
            },
            {
                // title: '单位',
                title:t('order.unitCode'),
                dataIndex: 'unit_code',
                key: 'unit_code',
                width: '80',
                align: 'center',
            },
            {
                // title: '单价',
                title:t('order.price'),
                dataIndex: 'amount',
                key: 'amount',
                width: '170',
                align: 'center',
            },
            {
                // title: '订金金额',
                title:t('order.depositAmount'),
                dataIndex: 'pre_amount',
                key: 'pre_amount',
                width: '220',
                align: 'center',
            },
            {
                // title: '税率',
                title:t('order.taxRate'),
                dataIndex: 'tax_rate',
                key: 'tax_rate',
                width: '100',
                align: 'center',
            },
            {
                // title: '取消状态',
                title:t('order.cancelStatus'),
                dataIndex: 'cancel_status',
                key: 'cancel_status',
                width: '140',
                align: 'center',
                slotName:'slot'
            },
            {
                // title: '扭矩',
                title:t('order.torque'),
                dataIndex: 'torque',
                key: 'torque',
                width: '100',
                align: 'center',
            },
            {
                // title: '预计发货时间',
                title:t('order.handleTimestamp'),
                dataIndex: 'handle_timestamp_val',
                key: 'handle_timestamp_val',
                width: '170',
                align: 'center',
                ellipsis:true,
                tooltip:true,
            }
        ],
        configs:{
            scroll: {
                x: 1000,
                y: 200,
            },
            stripe: false,
            bordered: false,
            size: 'large',
            loading: false,
            expand:false,
            expandable:'',
            rowSelection:{
                type: 'checkbox',
                showCheckedAll: true,
                onlyCurrent: false,
            },
            selected:[],
            pagination: false,
        },
    })
    const isFullScreen = ref(false)
    const customerInfo = ref({})
    const customerInfo2 = ref({})
    const customerInfo_loading = ref(false)
    const sort = ref({})
    const reasonTypeObj = ref([])
    const orderTitle = ref('')
    const ebike_orderTitle = ref('')
    const orderOperateType = ref('add')
    const editOrderloading = ref(false)
    const orderLineColumns = ref([
        {
                // title: 'SKU',
                title:'#',
                dataIndex: 'serial',
                key: 'serial',
                width: '60',
                align: 'center',
                ellipsis:true,
                tooltip:true,
            },
            {
                // title: 'SKU',
                title:t('order.sku'),
                dataIndex: 'sku',
                key: 'sku',
                width: '260',
                align: 'center',
                ellipsis:true,
                tooltip:true,
                slotName:'slot'
            },
            {
                // title: '物料编码',
                title:t('order.inventoryCode'),
                dataIndex: 'inventory_code',
                key: 'inventory_code',
                width: '160',
                align: 'center',
                ellipsis:true,
                tooltip:true,
            },
            {
                // title: '产品名称',
                title:t('order.productName'),
                dataIndex: 'name',
                key: 'name',
                width: '150',
                align: 'center',
                ellipsis:true,
                tooltip:true,
            },
            {
                // title: '颜色',
                title:t('order.frameColor'),
                dataIndex: 'frame_color',
                key: 'frame_color',
                width: '120',
                align: 'center',
            },
            {
                // title: '扭矩',
                title:t('order.torque'),
                dataIndex: 'torque',
                key: 'torque',
                width: '120',
                align: 'center',
            },
            {
                // title: '税前单价',
                title:t('order.preTaxUnitPrice'),
                dataIndex: 'pre_tax_amount',
                key: 'pre_tax_amount',
                width: '170',
                align: 'center',
                show:false,
                slotName:'slot'
            },
            {
                // title: '税后单价',
                title:t('order.afterTaxUnitPrice'),
                dataIndex: 'amount',
                key: 'amount',
                width: '180',
                align: 'center',
                slotName:'slot'
            },
            {
                // title: '数量',
                title:t('order.quantity'),
                dataIndex: 'quantity',
                key: 'quantity',
                width: '120',
                align: 'center',
                slotName:'slot'
            },
            {
                // title: '折扣比例',
                title:t('order.discountRate'),
                dataIndex: 'discount_rate',
                key: 'discount_rate',
                width: '170',
                align: 'center',
                slotName:'slot'
            },
            {
                // title: '税前折扣',
                title:t('order.preTaxDiscount'),
                dataIndex: 'pre_tax_discount',
                key: 'pre_tax_discount',
                width: '160',
                align: 'center',
                show:false,
                slotName:'slot'
            },
            {
                // title: '税后折扣',
                title:t('order.afterTaxDiscount'),
                dataIndex: 'discount',
                key: 'discount',
                width: '175',
                align: 'center',
                slotName:'slot'
            },
            {
                // title: '税前额外折扣',
                title:t('order.preTaxExtraDiscount'),
                dataIndex: 'pre_tax_extra_discount',
                key: 'pre_tax_extra_discount',
                width: '190',
                align: 'center',
                show:false,
                slotName:'slot'
            },
            {
                // title: '税后额外折扣',
                title:t('order.afterTaxExtraDiscount'),
                dataIndex: 'extra_discount',
                key: 'extra_discount',
                width: '190',
                align: 'center',
                slotName:'slot'
            },
            {
                // title: '税前支付金额',
                title:t('order.preTaxPayAmount'),
                dataIndex: 'pre_tax_pay_amount',
                key: 'pre_tax_pay_amount',
                width: '180',
                align: 'center',
                show:false,
                slotName:'slot'
            },
            {
                // title: '税后支付金额',
                title:t('order.afterTaxPayAmount'),
                dataIndex: 'pay_amount',
                key: 'pay_amount',
                width: '180',
                align: 'center',
                slotName:'slot'
            },
            {
                // title: '税率',
                title:t('order.taxRate'),
                dataIndex: 'tax_rate',
                key: 'tax_rate',
                width: '210',
                align: 'center',
                slotName:'slot'
            },
            {
                // title: '税额',
                title:t('order.orderTax'),
                dataIndex: 'order_tax',
                key: 'order_tax',
                width: '140',
                align: 'center',
                slotName:'slot'
            },
            {
                // title: '用户备注',
                title:t('order.userNote'),
                dataIndex: 'user_comment',
                key: 'user_comment',
                width: '140',
                align: 'center',
            },
            {
                // title: '预计发货时间',
                title:t('order.handleTimestamp'),
                dataIndex: 'handle_timestamp',
                key: 'handle_timestamp',
                width: '200',
                align: 'center',
                slotName:'slot'
            },
            // {
            //     // title: '退款时间',
            //     title:t('order.refundTimestamp'),
            //     dataIndex: 'refund_timestamp',
            //     key: 'refund_timestamp',
            //     width: '100',
            //     align: 'center',
            // },
            {
                title: t('base.operate'),
                dataIndex: 'Optional',
                key:'Optional',
                slotName:'optional',
                width: '180',
                align:'center',
                fixed:'right'
            }
    ])
    const orderLineTable = ref({
        datas:[],
        columns:[],
        configs:{
            scroll: {
                x: 1000,
                // y: 200,
            },
            stripe: false,
            bordered: true,
            expand:false,
            expandable:'',
            size: 'large',
            loading: false,
            expand:false,
            pagination: false,
        },
    })
    const taxRateOption = ref([])
    const paymentTypeOptions = ref([])
    const erpsyncTable = ref({
        datas:[],
        columns:[
            {
                // title: '订单编号',
                title: t('order.orderName'),
                dataIndex: 'order_name',
                align:'center',
                ellipsis:true,
                tooltip:true,
            },
            {
                // title: 'SKU',
                title: t('order.sku'),
                dataIndex: 'sku',
                align:'center',
                ellipsis:true,
                tooltip:true,
            },
            {
                // title: '物料编码',
                title: t('order.inventoryCode'),
                dataIndex: 'inventory_code',
                align:'center',
                ellipsis:true,
                tooltip:true,
            },
            // {
            //     // title: 'ERP行号',
            //     title:t('order.erpLineNo'),
            //     dataIndex: 'erp_line_no',
            //     align: 'center',
            //     ellipsis:true,
            //     tooltip:true,
            // },
            {
                // title: '产品名称',
                title: t('order.productName'),
                dataIndex: 'product_name',
                width:'220',
                align:'center',
                ellipsis:true,
                tooltip:true,
            },
            // {
            //     // title: '参考库存',
            //     title: t('order.referenceInventory'),
            //     dataIndex: 'transaction_quantity',
            //     align:'center',
            //     ellipsis:true,
            //     tooltip:true,
            // },
            {
                // title: '下单数量',
                title: t('order.quantity'),
                dataIndex: 'quantity',
                align:'center',
                ellipsis:true,
                tooltip:true,
            },
            // {
            //     // title: '生产数量',
            //     title: t('order.productQuantity'),
            //     dataIndex: 'produce_quantity',
            //     align:'center',
            //     ellipsis:true,
            //     tooltip:true,
            //     slotName:'slot'
            // },
            // {
            //     // title: '已发货数量',
            //     title: t('order.shipQuantity'),
            //     dataIndex: 'ship_quantity',
            //     align:'center',
            //     ellipsis:true,
            //     tooltip:true,
            // },
            // {
            //     // title: '计划出库数量',
            //     title: t('order.schedulingQuantity'),
            //     dataIndex: 'scheduling_quantity',
            //     align:'center',
            //     ellipsis:true,
            //     tooltip:true,
            // },
            // {
            //     // title: '预计发货数量',
            //     title: t('order.curQuantity'),
            //     dataIndex: 'curQuantity',
            //     align:'center',
            //     width:'130',
            //     slotName:'curQuantity'
            // },
        ],
        configs:{
            scroll: {
                x: 1000,
                y: 200,
            },
            loading:false,
            expand:false,
            expandable:'',
            pagination:false
        }
    })
    const createPrePayOrderTable = ref({
        datas:[],
        columns: [ 
            {
                // title: 'No.',
                title:'#',
                dataIndex: 'serial',
                key: 'product_name',
                width: '60',
                align: 'center',
                ellipsis:true,
                tooltip:true,
            },
            {
                // title: '产品名称',
                title:t('order.productName'),
                dataIndex: 'product_name',
                key: 'product_name',
                width: '160',
                align: 'center',
                ellipsis:true,
                tooltip:true,
            },
            {
                // title: '车架号',
                title:t('order.frameNumber'),
                dataIndex: 'frame_number',
                key: 'frame_number',
                width: '160',
                align: 'center',
                slotName:'slot'
            },
            {
                // title: 'SKU',
                title:t('order.sku'),
                dataIndex: 'sku',
                key: 'sku',
                width: '200',
                align: 'center',
                ellipsis:true,
                tooltip:true,
            },
            {
                // title: '物料编码',
                title:t('order.inventoryCode'),
                dataIndex: 'inventory_code',
                key: 'inventory_code',
                width: '140',
                align: 'center',
                ellipsis:true,
                tooltip:true,
            },
            {
                // title: '车型',
                title:t('order.modelModelYear'),
                dataIndex: 'model_model_year',
                key: 'model_model_year',
                width: '200',
                align: 'center',
                ellipsis:true,
                tooltip:true,
                slotName:'slot',
            },
            {
                // title: '数量',
                title:t('order.qty'),
                dataIndex: 'qty',
                key: 'qty',
                width: '120',
                align: 'center',
                slotName:'slot',
            },
            {
                // title: '行金额',
                title:t('order.lineAmount'),
                dataIndex: 'line_amount',
                key: 'line_amount',
                width: '170',
                align: 'center',
                slotName:'slot',
            },
            {
                // title: '取消状态',
                title:t('order.cancelStatus'),
                dataIndex: 'cancel_status',
                key: 'cancel_status',
                width: '140',
                align: 'center',
                slotName:'slot'
            },
            {
                // title: '预计发货时间',
                title:t('order.handleTimestamp'),
                dataIndex: 'handle_timestamp_val',
                key: 'handle_timestamp_val',
                width: '130',
                align: 'center',
                ellipsis:true,
                tooltip:true,
            },  
        ],
        configs:{
            scroll: {
                x: 1000,
                y: 200,
            },
            loading:false,
            expand:false,
            expandable:'',
            rowSelection:{
                type: 'checkbox',
                showCheckedAll: true,
                onlyCurrent: false,
            },
            selected:[],
            pagination:false
        }
    })
    const riskLevel = ref('')
    const cancelSOTableDataLength = ref(0) 
    const prePayOrderTable = ref(null)
    const earliestShipTimestamp = ref('')
    const createServiceLineTable = ref({
        datas:[],
        columns: [ 
            {
                // title: 'No.',
                title:'#',
                dataIndex: 'serial',
                key: 'serial',
                width: '60',
                align: 'center',
                ellipsis:true,
                tooltip:true,
            },
            {
                // title: '订单号',
                title:t('order.orderName'),
                dataIndex: 'order_name',
                key: 'order_name',
                width: '160',
                align: 'center',
                ellipsis:true,
                tooltip:true,
            },
            {
                // title: 'SKU',
                title:t('order.sku'),
                dataIndex: 'bind_sku',
                key: 'bind_sku',
                width: '200',
                align: 'center',
                ellipsis:true,
                tooltip:true,
            },
            {
                // title: '产品名称',
                title:t('order.productName'),
                dataIndex: 'product_name',
                key: 'product_name',
                width: '160',
                align: 'center',
                ellipsis:true,
                tooltip:true,
            },
            {
                // title: '发货数量',
                title:t('order.shipQty'),
                dataIndex: 'ship_qty',
                key: 'ship_qty',
                width: '120',
                align: 'center',
            },
            {
                // title: '投保数量',
                title:t('order.serviceCount'),
                dataIndex: 'service_count',
                key: 'service_count',
                width: '120',
                align: 'center',
            },
            {
                // title: '签收时间',
                title:t('order.signTime'),
                dataIndex: 'sign_time',
                key: 'sign_time',
                width: '120',
                align: 'center',
            },
        ],
        configs:{
            scroll: {
                x: 1000,
                y: 200,
            },
            loading:false,
            expand:false,
            expandable:'',
            rowSelection:{
                type: 'checkbox',
                showCheckedAll: true,
                onlyCurrent: false,
            },
            selected:[],
            pagination:false
        }
    })

    const lockTable = ref({
        datas:[],
        columns: [ 
            {
                // title: 'No.',
                title:'#',
                dataIndex: 'serial',
                key: 'serial',
                width: '60',
                align: 'center',
                ellipsis:true,
                tooltip:true,
            },
            {
                // title: 'SKU',
                title:t('order.sku'),
                dataIndex: 'sku',
                key: 'sku',
                width: '200',
                align: 'center',
                ellipsis:true,
                tooltip:true,
            },
            {
                // title: 'quantity',
                title:t('inventoryLock.quantity'),
                dataIndex: 'quantity',
                key: 'quantity',
                width: '200',
                align: 'center',
                ellipsis:true,
                tooltip:true,
            },
            {
                // title: 'type',
                title:t('inventoryLock.type'),
                dataIndex: 'inventory_type',
                key: 'inventory_type',
                width: '200',
                align: 'center',
                ellipsis:true,
                tooltip:true,
            },
            {
                // title: '预计发货时间',
                title:t('inventoryLock.estimatedShippingDate'),
                dataIndex: 'eta',
                key: 'eta',
                width: '200',
                align: 'center',
                ellipsis:true,
                tooltip:true,
            },
        ],
        configs:{
            scroll: {
                x: 1000,
                y: 200,
            },
            loading:false,
            expand:false,
            expandable:'',
            pagination:false
        }
    })

    const inventoryLockTable = ref({
        datas:[],
        columns: [ 
            {
                // title: 'No.',
                title:'#',
                dataIndex: 'serial',
                key: 'serial',
                width: '60',
                align: 'center',
                ellipsis:true,
                tooltip:true,
            },
            {
                // title: 'SKU',
                title:t('order.sku'),
                dataIndex: 'sku',
                key: 'sku',
                width: '200',
                align: 'center',
                ellipsis:true,
                tooltip:true,
                filterable: {
                    filter: (value, record) => record.sku.includes(value),
                    slotName: 'searchFilter',
                    icon: () => h(IconSearch)
                }
            },
            {
                // title: 'quantity',
                title:t('inventoryLock.lockedQTY'),
                dataIndex: 'quantity',
                key: 'quantity',
                width: '200',
                align: 'center',
                ellipsis:true,
                tooltip:true,
            },
            {
                // title: 'type',
                title:t('inventoryLock.inventoryType'),
                dataIndex: 'inventory_type',
                key: 'inventory_type',
                width: '200',
                align: 'center',
                ellipsis:true,
                tooltip:true,
                slotName:'slot',
                filterable: {
                    filters: [
                        {
                            text:t('inventoryLock.inStock'),
                            value:t('inventoryLock.inStock'),
                        },
                        {
                            text:t('inventoryLock.inTransit'),
                            value:t('inventoryLock.inTransit'),
                        },
                        {
                            text:t('inventoryLock.productionPlan'),
                            value:t('inventoryLock.productionPlan'),
                        }
                    ],
                    multiple: true,
                    filter: (value, row) =>{
                        return value.includes(row.inventory_type) 
                    },
                }
            },
            {
                // title: '预计发货时间',
                title:t('inventoryLock.estimatedShippingDate'),
                dataIndex: 'plan_timestamp',
                key: 'plan_timestamp',
                width: '200',
                align: 'center',
                ellipsis:true,
                tooltip:true,
            },
            {
                // title: '已发货数量',
                title:t('inventoryLock.shippedQTY'),
                dataIndex: 'reserved_quantity',
                key: 'reserved_quantity',
                width: '200',
                align: 'center',
                ellipsis:true,
                tooltip:true,
            },
            {
                // title: '状态',
                title:t('inventoryLock.lockStatus'),
                dataIndex: 'lock_status',
                key: 'lock_status',
                width: '200',
                align: 'center',
                ellipsis:true,
                tooltip:true,
                slotName:'slot',
                filterable: {
                    filters: [
                        {
                            text:t('inventoryLock.locked'),
                            value:t('inventoryLock.locked'),
                        },
                        {
                            text:t('inventoryLock.overdue'),
                            value:t('inventoryLock.overdue'),
                        },
                        {
                            text:t('inventoryLock.finish'),
                            value:t('inventoryLock.finish'),
                        }
                    ],
                    multiple: true,
                    filter: (value, row) =>{
                        return value.includes(row.lock_status) 
                    },
                }
            },
        ],
        configs:{
            scroll: {
                x: 1000,
                y: 200,
            },
            loading:false,
            expand:false,
            expandable:'',
            pagination:false
        }
    })

    const skuOptions = ref([])
    const orderStatus = ref({  // 订单状态
        '-1':t('order.finalPayment'), // 尾款单
        '0':t('order.partialPay'), // 部分付款
        '1':t('order.pay'), // 支付
        '2':t('order.refund'), // 全额退款
        // '3':t('order.returnsAndRefund'),
        '4':t('order.partialRefund'), // 部分退款
        // '5':t('order.partialReturnsAndRefund'),
        '6':t('order.canceled'), // 取消
        '7':t('order.obligation') // 待付款
    })
    const returnExchangeForm = ref(null)
    const reissueForm = ref(null)
    const returnFactoryForm = ref(null)

    const courierStatus = ref({ // 发货状态
        0:t('order.unship'),
        1:t('order.plan'),
        2:t('order.partialShip'),
        3:t('order.shiped'),
        4:t('order.signedFor'),
        5:t('order.cancel'),
        7:t('order.partialReturn'),
        8:t('order.return'),
        9:t('order.exchange'),
        10:t('order.partialExchange'),
        99:t('order.noNeedToShip'),
    })

    const outboundStatus = ref({ // 出库状态
        0:t('order.initial'),
        1:t('order.unOutbound'),
        4:t('stock.outScanned'),
        2:t('order.outbound'),
        3:t('stock.cancelOutbound2'),
    })
    const orderSource = ref({}) // 订单来源

    const showFormPanel = (val)=>{
        showForm.value = val
    }

    const handle = async (type,row)=>{
        switch(type){
            case 'search':
                table.value.configs.pagination.current = 1
                queryForm.formData.begin_date = !queryForm.formData.order_date? '' : dateToTimestamp(`${queryForm.formData.order_date[0]} 00:00:00`)
                queryForm.formData.end_date = !queryForm.formData.order_date? '' : dateToTimestamp(`${queryForm.formData.order_date[1]} 23:59:59`) 
                getOrderHead()
                break;
            case 'reset': 
                if(route.query.fromPage == 'DealerBusinessOrder2' || route.query.fromPage == 'B2BShopOrder2'){
                    router.replace({path:'/OrderList/OrderList'})
                }

                queryForm.formField.forEach(item=>{
                    queryForm.formData[item.key] = ''
                })
                queryForm.formData.customer_name = ''
                queryForm.formData.begin_date = ''
                queryForm.formData.end_date = ''
                table.value.configs.pagination.current = 1
                
                getOrderHead()
                break;
            case 'createServiceOrder_line':
                createServiceLineTableRef.value.selectedKeys = []
                createServiceLineTableRef.value.selectedData = []
                createServiceLineVisible.value = true
                rowData.value = row
                getPhysicalOrderLine(row)
                break;
            case 'createOrder':
            case 'createServiceOrder':
                isSyncERP.value = false
                createOrderVisible.value = true
                editOrderloading.value = true
                orderLineAllowClearSKU.value = true
                orderOperateType.value = 'add'
                orderTitle.value = orderOperateType.value == 'add'? t('order.create') : t('order.editOrder')

                getOrderSource()
                await getTax()
                await getPaymentType()
                await getCustomerList()
                
                // 重置
                createOrderForm1.formField.forEach(item=>{
                    createOrderForm1.formData[item.key] = ''
                    if(item.key == 'order_status'){
                        item.options[3].disabled = type == 'createServiceOrder'
                    }
                    if(item.key == 'second_hand_flag'){
                        createOrderForm1.formData[item.key] = 0
                    }
                    if(item.key == 'cargo_freight'){
                        item.showItemPreText = false
                    }
                    if(item.key == 'delivery_timeliness'){
                        item.options[1].disabled = false
                    }
                })
                createOrderForm2.formField.forEach(item=>{
                    createOrderForm2.formData[item.key] = ''
                })
                createOrderForm3.formField.forEach(item=>{
                    createOrderForm3.formData[item.key] = ''
                })
                unit_freight.value = 0

                createOrderForm1.formData.erp_no = ''
                createOrderForm1.formData.order_type = 0
                createOrderForm1.formData.predict_delivery_year = `${new Date().getFullYear()}`
                createOrderForm1.formData.pay_type_discount = 0
                createOrderForm1.formData.cargo_freight = 0
                createOrderForm1.formData.tax_rate = taxRateOption.value[0].value

                // 创建服务订单
                let order_timestamp_item = createOrderForm1.formField.find(i=> i.key == 'order_timestamp')
                if(type == 'createServiceOrder'){
                    ebike_orderTitle.value = rowData.value.order_name
                    createOrderForm1.formData.source = 222 // 渠道来源自动带出Insurance
                    createOrderForm1.formData.bind_order_id = rowData.value.id
                    createOrderForm1.formData.bind_order_name = rowData.value.order_name
                    createOrderForm1.formData.courier_status = 99
                    createOrderForm1.formData.predict_delivery_year = ''
                    order_timestamp_item.disabledDate = true
                    order_timestamp_item.disabledDateType = 'current'

                    handleCreateOrderSelectChange(222,'','source')
                    getCustomerAddressList()
                    createOrderForm3.formData.customer_entity_id = rowData.value.customer_entity_id
                    createOrderForm3.formData.customer_id = rowData.value.customer_id
                    createOrderForm3.formData.customer_invoice_id = rowData.value.customer_invoice_id
                    createOrderForm3.formData.name2 = rowData.value.name2 || ''
                    createOrderForm3.formData.customer_email = rowData.value.customer_email
                    createOrderForm3.formData.customer_type = Number(rowData.value.customer_type_val)
                    createOrderForm3.formData.country = rowData.value.country
                    createOrderForm3.formData.customer_name = rowData.value.customer_name
                    
                    await getProductList('100.100')
                    showAddOrderLineBtn.value = false
                }else{
                    await getProductList()
                   
                    order_timestamp_item.disabledDate = false
                    order_timestamp_item.disabledDateType = ''

                    showAddOrderLineBtn.value = true
                } 

                createOrderForm1.formField.forEach(i=>{
                    if(type == 'createServiceOrder'){
                        i.disabled = [
                            'order_type','source','courier_status','second_hand_flag','delivery_type','predict_delivery_year',
                            'predict_week_date','earliest_ship_timestamp','cargo_freight','order_channel_type',
                            'payment_type','payment_type_discount','tax_type','pay_type_discount','pay_type_discount2'
                        ].includes(i.key)
                    }else{
                        i.disabled = [
                            'order_channel_type','second_hand_flag','payment_type','pay_with_days_discount_rate',
                            'payment_day','payment_type_discount','tax_type','pay_type_discount','pay_type_discount2',
                        ].includes(i.key)
                    }

                    if(i.key == 'pay_with_days_day'){
                        i.disabled = createOrderForm1.formData.order_channel_type != 1 && createOrderForm1.formData.order_channel_type != 5
                    }
                    
                    i.show = !['order_use','back_flag','user_note','order_category','winter_flag','payment_due_date','delivery_timeliness'].includes(i.key)
                })
                createOrderForm3.formField.forEach(i=>{
                    i.disabled = !['customer_entity_id','customer_id','customer_invoice_id'].includes(i.key)
                    i.addIcon = ['customer_entity_id'].includes(i.key)

                    if(i.key == 'customer_id' || i.key == 'customer_invoice_id'){
                        i.options = []
                    }
                })

                let bind_sku_index = orderLineColumns.value.findIndex(i=> i.key == 'bind_sku')
                if(bind_sku_index !== -1) orderLineColumns.value.splice(bind_sku_index, 1)

                if(type == 'createServiceOrder'){
                    let sku_index = orderLineColumns.value.findIndex(i=> i.key == 'sku')
                    orderLineColumns.value.splice(sku_index, 0, {
                        title:t('order.bindSku'),
                        dataIndex: 'bind_sku',
                        key: 'bind_sku',
                        width: '260',
                        align: 'center',
                        ellipsis:true,
                        tooltip:true,
                    })
                }

                orderLineTable.value.columns = []
                orderLineColumns.value.forEach(i=>{
                    if(i.show !== undefined) i.show = false
                    if((i.show !== undefined && i.show) || i.show == undefined){
                        i.erp_line_no = ''
                        orderLineTable.value.columns.push(i)
                    }
                })
                
                orderLineTable.value.datas = []
                handle('addLine')

                editOrderloading.value = false

                console.log(createOrderForm1.formData.winter_flag, 'win 777')
                break;
            case 'editOrder':
                rowData.value = row
                let ship_qty = await getOrderLockStatus(row)
                if(ship_qty > 0){
                    Modal.warning({
                        title: t('base.tip'),
                        titleAlign:'start',
                        hideCancel:true,
                        width:500,
                        content: t('inventoryLock.editUnlockTip'),
                        okText:t('base.ok'),
                        cancelText:t('base.cancel'),
                        onOk:()=>{}
                    })
                }else{
                    if(row.erp_no !== '-'){
                        Modal.warning({
                            title: t('base.tip'),
                            titleAlign:'start',
                            hideCancel:false,
                            width:500,
                            content: ()=> h('div',{},[
                                h('p',`${t('order.editOrderConfirmTip')}`),
                                h('p',`${t('order.editOrderConfirmTip1')}`),
                                h('p',`${t('order.editOrderConfirmTip2')}`)
                            ]),
                            okText:t('base.ok'),
                            cancelText:t('base.cancel'),
                            onOk:()=>{
                                getEditContent(row)
                            }
                        })
                    }else{
                        let order_timestamp_item = createOrderForm1.formField.find(i=> i.key == 'order_timestamp')
                        let bind_sku_index = orderLineColumns.value.findIndex(i=> i.key == 'bind_sku')
                        if(bind_sku_index !== -1) orderLineColumns.value.splice(bind_sku_index, 1)

                        if(row.order_channel_type_val == 4){
                            await getProductList('100.100')
                            let sku_index = orderLineColumns.value.findIndex(i=> i.key == 'sku')
                            orderLineColumns.value.splice(sku_index, 0, {
                                title:t('order.bindSku'),
                                dataIndex: 'bind_sku',
                                key: 'bind_sku',
                                width: '260',
                                align: 'center',
                                ellipsis:true,
                                tooltip:true,
                            })
                            showAddOrderLineBtn.value = false
                        }else{
                            await getProductList()
                            order_timestamp_item.disabledDate = false
                            order_timestamp_item.disabledDateType = ''
                            showAddOrderLineBtn.value = true
                        }

                        getEditContent(row)
                    }
                }
                break;
            case 'confirmVirtualOrder': // 确认虚拟订单，转成C&C订单
                // console.log('虚拟订单确认')
                rowData.value = row

                await getProductList()
                let order_timestamp = createOrderForm1.formField.find(i=> i.key == 'order_timestamp')
                order_timestamp.disabledDate = false
                order_timestamp.disabledDateType = ''
                showAddOrderLineBtn.value = true

                confirmVirtualOrderToC2COrder(row)
                break;
            case 'createPrepaymentOrder':
                createPrePayOrderVisible.value = true
                rowData.value = row
                prePayOrderTable.value.selectedKeys = []
                prePayOrderTable.value.selectedData = []
                getOrderLine(row.id, row, 'createPrepaymentOrder')
                break;
            case 'showDetail':
                rowData.value = JSON.parse(JSON.stringify(row))
                detailVisible.value = true
                break;
            case 'showLineDetail':
                rowData.value = JSON.parse(JSON.stringify(row))
                lineDetailVisible.value = true
                break;
            case 'inventoryLockDetail':
                inventoryLockTableVisible.value = true
                rowData.value = row
                getLockInventoryList(row)
                break;
            case 'lockInventory':
                Modal.confirm({
                    title: t('base.tip'),
                    titleAlign:'start',
                    width:500,
                    content: t('inventoryLock.lockTip'),
                    okText:t('base.ok'),
                    cancelText:t('base.cancel'),
                    onOk:()=>{
                        inventoryLockTable.value.configs.loading = true
                        lockInventory()
                    }
                })
                break;
            case 'releaseInventory':
                Modal.confirm({
                    title: t('base.tip'),
                    titleAlign:'start',
                    width:500,
                    content: t('inventoryLock.releasedTip'),
                    okText:t('base.ok'),
                    cancelText:t('base.cancel'),
                    onOk:()=>{
                        inventoryLockTable.value.configs.loading = true
                        releaseInventory()
                    }
                })
                break;
            case 'deliver':
                // console.log(row,'rrrtttwww',dateToTimestamp(getNowDate()) , row.earliest_ship_timestamp_val)
                let noShip = await vaildShipDateRange(row)
                if(!noShip){
                    Modal.warning({
                        title: t('base.tip'),
                        titleAlign:'start',
                        hideCancel:true,
                        width:500,
                        content: t('order.noShipTip'),
                        okText:t('base.ok'),
                        cancelText:t('base.cancel'),
                        onOk:()=>{}
                    })
                    return
                }else if(Number(dateToTimestamp(getNowDate())) < row.earliest_ship_timestamp_val){
                    Modal.warning({
                        title: t('base.tip'),
                        titleAlign:'start',
                        hideCancel:true,
                        width:500,
                        content: t('order.earliestShipDateTip2') + row.earliest_ship_timestamp + t('order.earliestShipDateTip4'),
                        okText:t('base.ok'),
                        cancelText:t('base.cancel'),
                        onOk:()=>{}
                    })
                    return
                }

                // if(!row.selected || row.selected.length == 0){
                //     Modal.warning({
                //         title: t('base.tip'),
                //         titleAlign:'start',
                //         hideCancel:true,
                //         width:500,
                //         content: t('order.deliverTip'),
                //         okText:t('base.ok'),
                //         cancelText:t('base.cancel'),
                //         onOk:()=>{}
                //     })
                //     return
                // }else 
                // if(row.selected.length > 15){
                //     Modal.warning({
                //         title: t('base.tip'),
                //         titleAlign:'start',
                //         hideCancel:true,
                //         width:500,
                //         content: t('order.deliverOrderLineMaxQtyTip'),
                //         okText:t('base.ok'),
                //         cancelText:t('base.cancel'),
                //         onOk:()=>{}
                //     })
                //     return
                // }

                if(row.customer_type_val === 0 && (row.order_status_val == 7 || row.order_status_val == 0)){
                    Modal.warning({
                        title: t('base.tip'),
                        titleAlign:'start',
                        hideCancel:false,
                        content: row.order_status_val == 7? t('order.deliverConfirmTip1') : t('order.deliverConfirmTip2'),
                        okText:t('base.ok'),
                        cancelText:t('base.cancel'),
                        onOk:()=>{
                            visible.value = true
                            rowData.value = row
                            deliver(row)
                        }
                    })
                }else{
                    visible.value = true
                    rowData.value = row
                    deliver(row)
                }

                earliestShipTimestamp.value = !row.earliest_ship_timestamp_val? '' : timestampToDate(row.earliest_ship_timestamp_val * 1000)
                break;
            case 'deliverRecord':
                resetVisible()
                modalTitle.value = t('order.deliverRecord')
                modalVisible.value = true
                recordVisible.value = true
                fullscreen.value = false
                rowData.value = row
                getDeliverRecord(row)
                break;
            case 'viewLogistics':
                resetVisible()
                modalTitle.value = t('order.viewLogistics')
                modalVisible.value = true
                logisticsVisible.value = true
                fullscreen.value = false
                rowData.value = row
                break;
            case 'refundRecord':
                resetVisible()
                modalTitle.value = t('order.refundRecord')
                modalVisible.value = true
                refundRecordVisible.value = true
                fullscreen.value = false
                getRefundRecord(row)
                break;
            case 'downloadInvoice':
                rowData.value = row
                downloadInvoiceVisible.value = true
                spinLoading.value = true
                invoice_date.value = getNowDate()
                validIsExistInvoice(row)
                break;
            case 'deleteInvoice':
                Modal.warning({
                    title: t('base.tip'),
                    titleAlign: 'start',
                    hideCancel: false,
                    content: t('base.delConfirmTip'),
                    cancelText: t('base.cancel'),
                    okText: t('base.ok'),
                    onOk: () => {
                        deleteInvoice(row)
                    }
                });
                break;
            case 'syncToERP':
                erpsyncVisible.value = true
                getErpSyncTableOrderLine(row.id, row)
                rowData.value = row
                break;
            case 'delOrder':
                Modal.warning({
                    title: t('base.tip'),
                    titleAlign:'start',
                    hideCancel:false,
                    content: t('base.delConfirmTip') + ` 【${row.order_name}】?`,
                    okText:t('base.ok'),
                    cancelText:t('base.cancel'),
                    onOk:()=>{
                        delOrder(row)
                    }
                });
                break;
            case 'paid':
                Modal.warning({
                    title: t('base.tip'),
                    titleAlign:'start',
                    hideCancel:false,
                    content: t('order.changeConfirmTip'),
                    okText:t('base.ok'),
                    cancelText:t('base.cancel'),
                    onOk:()=>{
                        editOrderStatus(row,1)
                    }
                });
                break; 
            case 'partialPay':
                Modal.warning({
                    title: t('base.tip'),
                    titleAlign:'start',
                    hideCancel:false,
                    content: t('order.changeConfirmTip5'),
                    okText:t('base.ok'),
                    cancelText:t('base.cancel'),
                    onOk:()=>{
                        editOrderStatus(row,0)
                    }
                });
                break;
            case 'unPaid':
                Modal.warning({
                    title: t('base.tip'),
                    titleAlign:'start',
                    hideCancel:false,
                    content: t('order.changeConfirmTip4'),
                    okText:t('base.ok'),
                    cancelText:t('base.cancel'),
                    onOk:()=>{
                        editOrderStatus(row,7)
                    }
                });
                break;
            case 'cancelOrder':
                let shipQty2 = await getOrderLockStatus(row)
                if(shipQty2 > 0){
                    Modal.warning({
                        title: t('base.tip'),
                        titleAlign:'start',
                        hideCancel:true,
                        width:500,
                        content: t('inventoryLock.editUnlockTip'),
                        okText:t('base.ok'),
                        cancelText:t('base.cancel'),
                        onOk:()=>{}
                    })
                }else{
                    if(row.erp_no !== '-'){
                        Modal.warning({
                            title: t('base.tip'),
                            titleAlign:'start',
                            hideCancel:true,
                            content: t('order.cancelERPSOTip'),
                            okText:t('base.ok'),
                        });
                    }else{
                        Modal.warning({
                            title: t('base.tip'),
                            titleAlign:'start',
                            hideCancel:false,
                            content: t('order.changeConfirmTip2'),
                            okText:t('base.ok'),
                            cancelText:t('base.cancel'),
                            onOk:()=>{
                                cancelOrder(row,6)
                            }
                        });
                    }
                }
                break;
            case 'refundOrder':
                refundVisible.value = true
                rowData.value = row
                refundForm.formData.order_name = row.order_name
                refundForm.formData.order_amount = Number(row.order_amount_val)
                refundForm.formData.pay_amount = Number(row.pay_amount_val)
                refundForm.formData.refund_amount = ''
                refundForm.formData.current_amount = ''
                refundForm.formData.refund_amount = ''
                refundForm.formData.refund_date = ''
                refundForm.formData.reason_type = ''
                refundForm.formData.reason = ''
                break;
            case 'delOrderLine':
                Modal.warning({
                    title: t('base.tip'),
                    titleAlign:'start',
                    hideCancel:false,
                    content: t('base.delConfirmTip'),
                    okText:t('base.ok'),
                    cancelText:t('base.cancel'),
                    onOk:()=>{
                        delOrderLine(row)
                    }
                });
                break;
            case 'cancelLineSO':
                    Modal.warning({
                        title: t('base.tip'),
                        titleAlign:'start',
                        content: t('order.cancelSOConfirmTip'),
                        hideCancel:false,
                        okText:t('base.ok'),
                        cancelText:t('base.cancel'),
                        onOk:()=>{
                            cancelLineSO(row)
                        }
                    });
                break;
            case 'addCustomer':
                addCustomerVisible.value = true
                checked.value = false
                addBaseInfoForm.formField.forEach(item=>{
                    addBaseInfoForm.formData[item.key] = ''
                    if(item.key == 'email_service_flag'){
                        item.required = false
                        item.show = false 
                    }
                    if(item.key == 'email') item.disabled = true
                })
                addAddressInfoForm.formField.forEach(item=>{
                    if(item.key !== 'address_type') addAddressInfoForm.formData[item.key] = ''
                    else addAddressInfoForm.formData[item.key] = 0

                    if(item.key == 'house_number') item.disabled = true
                })
                addInvoiceAddressForm.formField.forEach(item=>{
                    if(item.key !== 'address_type') addInvoiceAddressForm.formData[item.key] = ''
                    else addInvoiceAddressForm.formData[item.key] = 1

                    if(item.key == 'house_number') item.disabled = true
                })
                break;
            case 'viewVersion':
                orderLineVersionVisible.value = true
                fullscreen.value = false
                getOrderLineRecord(row)
                break;
            case 'sendInvoice':
                getSendInvoiceCount(row)
                break;
            case 'cancelSO':
                let shipQty3 = await getOrderLockStatus(row)
                if(shipQty3 > 0){
                    Modal.warning({
                        title: t('base.tip'),
                        titleAlign:'start',
                        hideCancel:true,
                        width:500,
                        content: t('inventoryLock.editUnlockTip'),
                        okText:t('base.ok'),
                        cancelText:t('base.cancel'),
                        onOk:()=>{}
                    })
                }else{
                    cancelSOVisible.value = true
                    row.selected = []
                    rowData.value = row
                    fullscreen.value = false
                    getCancelSOOrderLine(row.id,row)
                }
                break;
            case 'cancelSORecord':
                resetVisible()
                modalTitle.value = t('order.cancelSORecord')
                modalVisible.value = true
                cancelSORecordVisible.value = true
                fullscreen.value = false
                getCancelSORecord(row)
                break;
            case 'returnExchange':
                returnVisible.value = true
                rowData.value = row
                break;
            case 'returnExchangeRecord':
                resetVisible()
                modalTitle.value = row.courier_status_val == 9 || row.courier_status_val == 10? t('returnExchange.exchangeRecord') : t('returnExchange.returnExchangeRecord')
                modalVisible.value = true
                returnExchangeRecordVisible.value = true
                fullscreen.value = false
                rowData.value = row
                rowData.value.active = row.courier_status_val == 9 || row.courier_status_val == 10? 2 : 1
                break;
            case 'addLine': // 创建订单-新增订单行
                let itemIndex = taxRateOption.value.findIndex(i=> i.value == createOrderForm1.formData.tax_rate)
                if(createOrderForm1.formData.order_channel_type == 4){
                    orderLineTable.value.datas = []
                    createServiceLineTable.value.configs.selected.forEach(i=>{
                        orderLineTable.value.datas.push({
                            serial: orderLineTable.value.datas.length + 1,
                            sku:'',
                            bind_sku: i.bind_sku,
                            bind_order_line_id: i.bind_order_line_id,
                            stock_out_id: i.stock_out_id,
                            ship_qty: i.ship_qty,
                            inventory_code:'-',
                            name:'-',
                            frame_color:'-',
                            torque:'-',
                            amount:'',
                            pre_tax_amount:'',
                            quantity:'',
                            discount_rate:'',
                            discount:'',
                            pre_tax_discount:'',
                            extra_discount:'',
                            pre_tax_extra_discount:'',
                            pay_amount:'',
                            pre_tax_pay_amount:'',
                            tax_rate: taxRateOption.value[itemIndex].label,
                            tax_rate_val: taxRateOption.value[itemIndex].value,
                            order_tax:'',
                            handle_timestamp: '',
                            disabled: createOrderForm1.formData.tax_type == 1,
                            preTaxExtraDiscountDisabled: true,
                            shipDateDisabled:true,
                        })
                    })
                }else{
                    if(orderLineTable.value.datas.length == 50){
                        Message.error(t('order.orderLineMaxQtyTip'))
                        return
                    }
                    // orderLineTable.value.datas = []
                    orderLineTable.value.datas.push({
                        serial: orderLineTable.value.datas.length + 1,
                        sku:'',
                        inventory_code:'-',
                        name:'-',
                        frame_color:'-',
                        torque:'-',
                        amount:'',
                        pre_tax_amount:'',
                        quantity:'',
                        discount:'',
                        pre_tax_discount:'',
                        extra_discount:'',
                        pre_tax_extra_discount:'',
                        pay_amount:'',
                        pre_tax_pay_amount:'',
                        tax_rate: taxRateOption.value[itemIndex].label,
                        tax_rate_val: taxRateOption.value[itemIndex].value,
                        order_tax:'',
                        handle_timestamp:createOrderForm1.formData.order_channel_type == 1? getNowDate() : '',
                        disabled: createOrderForm1.formData.tax_type == 1,
                        preTaxExtraDiscountDisabled: true,
                    })
                }
                break;
            case 'copy': // 新建订单-复制订单行
                if(orderLineTable.value.datas.length == 50){
                    Message.error(t('order.orderLineMaxQtyTip'))
                    return
                }

                let newRow = JSON.parse(JSON.stringify(row))
                newRow.sku = ''
                newRow.inventory_code = '-'
                newRow.name = '-'
                newRow.torque = '-' 
                newRow.id = ''
                newRow.order_line_no = ''

                if(createOrderForm1.formData.order_channel_type == 1){
                    newRow.discount_rate = ''
                    newRow.pre_tax_discount = ''
                    newRow.discount = ''
                }

                orderLineTable.value.datas.push(newRow)
                computedCopySummary()
                break;
            case 'view':
                lockTableVisible.value = true
                getPlanDateBySKUQTY(row)
                break;
            case 'removeLine': // 新建订单-删除订单行
                orderLineTable.value.datas.forEach((i,index)=> {i.index = index})
                let tableItem = orderLineTable.value.datas.find(i=> i.index == row.index)
                orderLineTable.value.datas.splice(tableItem.index,1)
                orderLineTable.value.datas.forEach((i,index)=>{
                    i.serial = index + 1
                })
                computedCopySummary()
                break;
            case 'syncNewPrice': // 新建订单-同步最新单价
                // console.log(row,'rrruuuuu')
                row.category_code = row.product_code
                row.syncNewPrice = true
                await getBikePriceBySku(row, row)
                break;
            case 'reissue':
                reissueVisible.value = true
                rowData.value = row
                // console.log(rowData.value,'hhkk')
                break;
            case 'returnFactory':
                returnFactoryVisible.value = true
                rowData.value = row
                // console.log(rowData.value,'hhkk')
                break;
            case 'reissueRecord':
                resetVisible()
                modalTitle.value = t('returnExchange.reissueRecord')
                modalVisible.value = true
                returnExchangeRecordVisible.value = true
                fullscreen.value = false
                rowData.value = row
                rowData.value.active = 3
                break; 
            case 'returnFactoryRecord':
                resetVisible()
                modalTitle.value = t('returnExchange.returnFactoryRecord')
                modalVisible.value = true
                returnExchangeRecordVisible.value = true
                fullscreen.value = false
                rowData.value = row
                rowData.value.active = 4
                break;
            case 'saveProductQty':
                for(let i=0; i<erpsyncTable.value.datas.length; i++){
                    let item = erpsyncTable.value.datas[i]
                    if(item.produce_quantity === ''){
                        Message.error(t('order.productQuantity')+' '+t('base.noEmpty'))
                        return
                    }
                    if(item.produce_quantity > item.quantity ){
                        Message.error(t('order.productQuantityErrorTip'))
                        return
                    }
                }
                saveProductQty()
                break;
            case 'erpSync':
                Modal.warning({
                    title: t('base.tip'),
                    titleAlign:'start',
                    content: t('order.syncConfirmTip'),
                    hideCancel:false,
                    okText:t('base.ok'),
                    cancelText:t('base.cancel'),
                    onOk:()=>{
                        syncToERP(rowData.value)
                    }
                });
                break;
            case 'exportOrder':
                Modal.warning({
                    title: t('base.tip'),
                    titleAlign:'start',
                    content: t('stock.exportConfirmTip'),
                    hideCancel:false,
                    okText:t('base.ok'),
                    cancelText:t('base.cancel'),
                    onOk:()=>{
                        exportFile('exportOrder')
                    }
                });
                break;
            case 'exportEBike':
                Modal.warning({
                    title: t('base.tip'),
                    titleAlign:'start',
                    content: t('stock.exportConfirmTip'),
                    hideCancel:false,
                    okText:t('base.ok'),
                    cancelText:t('base.cancel'),
                    onOk:()=>{
                        exportFile('exportEBike')
                    }
                });
                break;
            case 'exportCustomer':
                Modal.warning({
                    title: t('base.tip'),
                    titleAlign:'start',
                    content: t('stock.exportConfirmTip'),
                    hideCancel:false,
                    okText:t('base.ok'),
                    cancelText:t('base.cancel'),
                    onOk:()=>{
                        exportFile('exportCustomer')
                    }
                });
                break;
            case 'exportUnshipOrder':
                Modal.warning({
                    title: t('base.tip'),
                    titleAlign:'start',
                    content: t('stock.exportConfirmTip'),
                    hideCancel:false,
                    okText:t('base.ok'),
                    cancelText:t('base.cancel'),
                    onOk:()=>{
                        exportUnshipOrder()
                    }
                });
                break;
            case 'riskValidate':
                riskVisible.value = true
                rowData.value = row
                break;
            case 'preInvoiceNo':
                getPreInvoiceNo(row)
                break;
            case 'downloadConfirmation':
                rowData.value = row
                // 没有 setting.order.reGenerateConfirmation 的角色（如 all_query）不显示"生成订单确认书"
                reDownloadConfirmationDisabled.value = !hasPermission('setting.order.reGenerateConfirmation')
                downloadConfirmationDisabled.value = true
                downloadConfirmationType.value = ''
                downloadConfirmationVisible.value = true
                spinLoading.value = true
                validIsExistConfirmation(row)
                break;
            case 'sendConfirmation':
                Modal.warning({
                    title: t('base.tip'),
                    titleAlign:'start',
                    content: t('order.sendConfirmationMsg'),
                    hideCancel:false,
                    okText:t('base.ok'),
                    cancelText:t('base.cancel'),
                    onOk:()=>{
                        sendConfirmation(row)
                    }
                });
                break;
            case 'recalculateAmount': // 重新计算汇总金额
                let line_arr = [], bike_count = 0
                orderLineTable.value.datas.map(i=>{
                    // console.log(i.tax_rate_val,'i.tax_rate', i)
                    i.pre_tax_pay_amount = multiply(Number(subtract(formatterToPoint(i.pre_tax_amount), formatterToPoint(i.pre_tax_discount))), i.quantity).toFixed(2)
                    i.pay_amount = multiply(Number(subtract(formatterToPoint(i.amount), formatterToPoint(i.discount))), i.quantity).toFixed(2)
                    i.order_tax = divide(multiply(i.pay_amount, i.tax_rate_val), add(1, i.tax_rate_val)).toFixed(1)
                    if(i.quantity !== 0){
                        line_arr.push(i)
                    } 

                    if(i.product_code == '627.501'){
                        bike_count += i.quantity
                    }
                })

                // 计算运费，仅2B
                if(createOrderForm1.formData.order_channel_type == 1 || createOrderForm1.formData.order_channel_type == 5){
                    createOrderForm1.formData.cargo_freight = formatterToComma(multiply(bike_count, FREIGHT), String(createOrderForm2.formData.order_amount).indexOf('.') != -1)
                    createOrderForm2.formData.total_freight = formatterToComma(multiply(createOrderForm1.formData.cargo_freight, 1+Number(createOrderForm1.formData.tax_rate)), String(createOrderForm2.formData.order_amount).indexOf('.') != -1)
                }else if(createOrderForm1.formData.order_channel_type == 0){
                    createOrderForm2.formData.total_freight = formatterToComma(createOrderForm1.formData.cargo_freight, String(createOrderForm2.formData.order_amount).indexOf('.') != -1)
                }
                
                createOrderForm2.formData.order_amount = 0
                createOrderForm2.formData.order_discount = 0
                line_arr.forEach(i=>{
                    createOrderForm2.formData.order_amount += multiply(Number(formatterToPoint(i.amount)), i.quantity)
                    createOrderForm2.formData.order_discount += i.discount == 0 || i.discount === ''? 0 : multiply(Number(formatterToPoint(i.discount)), i.quantity) 
                })
                createOrderForm2.formData.order_amount = createOrderForm2.formData.order_amount.toFixed(2)
                createOrderForm2.formData.order_discount = createOrderForm2.formData.order_discount.toFixed(2)
                break;
            case 'editUserNote':
                editUserNoteVisible.value = true
                rowData.value = row
                break;
        }
    }

    const changeSwitch = (val, row)=>{
        row.enable = val
        if(!val) row.discount_rate = ''
    }

    const handleEditUserNoteOk = async()=>{
        let param = {
            id: rowData.value.id,
            user_note: rowData.value.user_note,
        }
        let res = await OrderApi.getInstance().editLineUserNote(param, rowData.value.id)
        if(res.code == 0){
            Message.success(t('base.editSuccess'))
            editUserNoteVisible.value = false
            getOrderHead()
        }else{
            Message.error(res.msg)
        }
    }

    const handleCancelDrawer = ()=>{
        detailVisible.value = false
    }

    const handleLineCancelDrawer = ()=>{
        lineDetailVisible.value = false
    }

    // 获取库存仓库下拉配置
    const getWarehouseConfig = async()=>{
        let param = {
            dict_code: "config",
            dict_sub_code:'bom_available_warehouse',
        }
        let res = await OrderApi.getInstance().getWarehouseConfig(param)
        if(res.code == 0){
            return res.data.map(item => item.dict_sub_value)
        }else{
            Message.error(res.msg)
        }
    }

    // 发货
    const deliver = async (row)=>{
        // console.log(row,'deliiiiii')
        courierId.value = ''
        selectedKeys.value = []
        deliverTable.value.configs.selected = []
        let shipListData = await getShipOrderLineList(row)
        resetDeliverForm(row)

        // 控制字段显示
        let arr = []
        deliverTable.value.columns.map(i=>{
            if(i.dataIndex == 'roll_over_inventory'){
                i.show = (row.order_type_val == 1 && row.back_flag_val == 'YES') || (row.order_type_val == 1 && row.order_use == 'TRANSFER_WAREHOUSE')
            } 
            if(i.show) arr.push(i)
        })
        deliverTable.value.columns = [...arr]

        // 过滤整车仓库
        let warehouse_arr = ['HFFG01','HFFG05','HF_OP04','HF_OP02','HFRM01','HFRM03','HFRM04']
        let wmsOptions = []
        warehouseOptions.value.filter(item=>{
            wmsOptions.push({
                ...item,
                disabled: warehouse_arr.includes(item.value),
            })
        })
                
        // 根据订单id是否相同，过滤订单行
        const availableWarehouseValues = await getWarehouseConfig()
        deliverTable.value.datas = []
        shipListData.forEach((i,index)=>{
            let wmsOptions2 = []
            if(i.second_hand_flag == undefined){
                warehouseOptions.value.filter(m=> {
                    const isSpecialCategory = i.product_info?.category_code == '627.501'
                    const disabled = isSpecialCategory? ['HF_OP02','HF_OP04','HFRM01'].includes(m.value) : !availableWarehouseValues.includes(m.value)
                    wmsOptions2.push({
                        ...m,
                        disabled
                        // disabled: (i.product_info.category_code == '627.501' && (m.value == 'HF_OP02' || m.value == 'HF_OP04' || m.value == 'HFRM01')) || (i.product_info.category_code != '627.501' && m.value != 'HFRM03' && m.value != 'HFRM05'),
                    })
                })
            }
            deliverTable.value.datas.push({
                    serial:index + 1,
                    erp_no: row.erp_no,
                    customer_name: row.customer_name,
                    country: row.country,
                    customer_id: row.customer_id,
                    customer_entity_id: row.customer_entity_id,
                    order_id: i.order_id,
                    id: i.id,

                    sku:i.sku,
                    inventory_code:i.inventory_code,
                    erp_line_no: !i.erp_line_no? '-' : i.erp_line_no,
                    product_name: i.product_info.english_name,
                    category_code: i.product_info.category_code,
                    model: i.product_info.model,
                    model_year: i.product_info.model_year,
                    lock_quantity: i.lock_info? i.lock_info.quantity : 0,
                    total_quantity: i.quantity,
                    ship_quantity: i.ship_quantity,
                    inventory_type: !i.lock_info? '-' : i.lock_info.inventory_type == 'in_stock'? t('inventoryLock.inStock') : i.lock_info.inventory_type == 'in_transit'? t('inventoryLock.inTransit') : t('inventoryLock.productionPlan'),
                    curQuantity:'',
                    max: i.product_info.category_code == '627.501'? 15 : 100, // 整车15，零配件100上限
                    roll_over_inventory: row.order_type_val == 1 && row.back_flag_val == 'YES' || row.order_type_val == 1 && row.order_use == 'TRANSFER_WAREHOUSE'? 'HFFG04' : '',
                    // warehouse: !i.product_map? '' : i.product_map.category_code == '627.501'? 'HFFG01' : 'HFRM01',
                    warehouse: i.product_info.category_code == '627.501' && i.lock_info? i.lock_info.warehouse : '',
                    transaction_date: i.product_info.category_code == '627.501' && i.lock_info? timestampToDate(i.lock_info.plan_timestamp * 1000) : '', 
                    plan_timestamp: i.lock_info? i.lock_info.plan_timestamp : '',
                    wmsOptions: i.second_hand_flag == 1? wmsOptions : wmsOptions2,
                    // warehouseDisabled: i.sku == 'UPGRADESOFT10' || i.sku == 'UPGRADESOFT20',
                    warehouseDisabled: (i.second_hand_flag === undefined || i.second_hand_flag == 0) && i.product_info.category_code == '627.501',
                    disabledCheck: i.lock_quantity == 0 || i.inventory_type !== 'in_stock'
            })
        })
        // console.log(deliverTable.value.datas,'dddddd 222')



        // 获取库存数量和可用数量
        // deliverTable.value.datas.map(async (i)=>{
        //     i.transaction_quantity = await getInventories(i.warehouse, i.sku) // 库存数量
        //     i.scheduling_quantity = await getSchedulingQuantity(i.warehouse, i.inventory_code) // 占用数量
        //     i.available_quantity = Number(i.transaction_quantity) - Number(i.scheduling_quantity) > 0? Number(i.transaction_quantity) - Number(i.scheduling_quantity) : 0 // 可用数量
        // })
    }

    const resetDeliverForm = (row)=>{
        deliverForm.formField.forEach(i=>{
            i.required = false
            deliverForm.formData[i.key] = ''
            deliverForm.formData['courier_type'] = ''
            // deliverForm.formData['transaction_date'] = row.selected[0].handle_timestamp * 1000 
        })
    }

    const changeTransactionDate = (val)=>{
        console.log(val,'changeTransactionDate')
    }

    // 退货，换货，补寄，返修记录切换
    const switchRecordTab = (val)=>{
        modalTitle.value = val == 1? t('returnExchange.returnExchangeRecord') : val == 2? t('returnExchange.exchangeRecord') : val == 3? t('returnExchange.reissueRecord') : t('returnExchange.returnFactoryRecord')
    }

    // 导出订单/导出订单车辆
    const exportFile = async (type)=>{
        let param = {}
        for(let key in queryForm.formData){
            if(key !== 'order_date' && key !== 'customer_name' && key !== 'customer_entity_id'){
                param[key] = queryForm.formData[key]
            }
        }
        Message.success(t('base.exporting'))
        type == 'exportOrder'? exportingOrder.value = true : exportingCustomer.value = true
        let res = type == 'exportOrder'? await OrderApi.getInstance().exportOrder(param) : await OrderApi.getInstance().exportCustomer(param)
        if(!res.code){
            let blob = new Blob([res])
            let a = document.createElement('a')
            a.href = URL.createObjectURL(blob)
            a.download = type == 'exportOrder'? `${t('order.exportOrderData')}.xlsx` : `${t('order.exportCustomerData')}.xlsx`
            a.style.display = 'none'
            document.body.appendChild(a)
            a.click()
            URL.revokeObjectURL(a.href)
            document.body.removeChild(a)
            Message.success(t('base.exportSuccess'))
            type == 'exportOrder'? exportingOrder.value = false : exportingCustomer.value = false
        }else{  
            Message.error(res.msg)
        }
    }

    // 导出未发货订单
    const exportUnshipOrder = async()=>{
        let param = {
            begin_date: 1704038400
        }
        Message.success(t('base.exporting'))
        exportingUnshipOrder.value = true
        let res = await OrderApi.getInstance().exportUnshipOrder(param)
        if(!res.code){
            let blob = new Blob([res])
            let a = document.createElement('a')
            a.href = URL.createObjectURL(blob)
            a.download = `${t('order.exportUnshipOrderData')}.xlsx`
            a.style.display = 'none'
            document.body.appendChild(a)
            a.click()
            URL.revokeObjectURL(a.href)
            document.body.removeChild(a)
            Message.success(t('base.exportSuccess'))
            exportingUnshipOrder.value = false
        }else{  
            Message.error(res.msg)
        }
    }

    // 运费规则变更通知弹窗
    const onAutoComputeFreightBeforeOk = async()=>{
        computeCargoFreight()
        return true
    }

    // 编辑时获取订单详情
    const getEditContent = async (row)=>{
        // console.log(row,'edit row')
        isSyncERP.value = row.erp_no && row.erp_no !== '-'
        editOrderloading.value = true
        createOrderVisible.value = true
        orderOperateType.value = 'edit'
        orderLineAllowClearSKU.value = true
        orderTitle.value = orderOperateType.value == 'add'? t('order.create') : t('order.editOrder')

        getCustomerList()
        await getOrderLine(row.id,row)
        await getTax()
        await getPaymentType()

        // 订单已经同步到ERP
        createOrderForm1.formField.forEach(i=>{
            if(row.order_channel_type_val != 4){ // 非保险订单
                if(isSyncERP.value){ // 已同步到ERP的订单
                    i.disabled = ['order_type','order_use','back_flag','source','order_name','order_timestamp','courier_status'].includes(i.key)
                }else{ // 未同步到ERP的订单
                    i.disabled = row.order_type_val == 1 && ['order_type','source'].includes(i.key)
                }
                if(i.key == 'tax_type') i.disabled = true
                if(i.key == 'payment_type_discount') i.disabled = true
                if(i.key == 'pay_type_discount') i.disabled = true
                if(i.key == 'order_channel_type') i.disabled = true
                if(i.key == 'user_note') i.disabled = true
                if(i.key == 'order_category') i.disabled = true
                if(i.key == 'payment_due_date') i.disabled = true
            }else{ // 保险订单
                i.disabled = [
                    'order_type','source','courier_status','second_hand_flag','delivery_type','predict_delivery_year',
                    'predict_week_date','earliest_ship_timestamp','cargo_freight','order_channel_type',
                    'payment_type','payment_type_discount','tax_type','pay_type_discount','pay_type_discount2',
                ].includes(i.key)
            }

            // B2B Shop的订单禁止 修改订单名称
            if(i.key == 'order_name') i.disabled = row.expand_order_source && row.expand_order_source == 3

            if(i.key == 'pay_with_days_discount'){
                if(row.payment_type == 'by invoice') item.name = 'order.payWithin14daysDiscount'
                if(row.payment_type == 'By Invoice 90 days') item.name = 'order.payWithin90daysDiscount'
            }
        })

        createOrderForm3.formField.forEach(i=>{
            if(isSyncERP.value){
                i.disabled = !['customer_invoice_id'].includes(i.key)
                i.addIcon = false
            }else{
                i.disabled = !['customer_entity_id','customer_id','customer_invoice_id'].includes(i.key)
                i.addIcon = ['customer_entity_id'].includes(i.key)
            }
        })

        let order_status_item = createOrderForm1.formField.find(i=> i.key == 'order_status')
        let label_item = order_status_item.options.find(i=> i.value == 6)
        label_item.disabled = isSyncERP.value

        let order_use_item = createOrderForm1.formField.find(i=> i.key == 'order_use')
        let back_flag_item = createOrderForm1.formField.find(i=> i.key == 'back_flag')
        let user_note_item = createOrderForm1.formField.find(i=> i.key == 'user_note')
        let order_category_item = createOrderForm1.formField.find(i=> i.key == 'order_category')
        
        user_note_item.show = false
        order_use_item.show = row.order_type_val == 1
        back_flag_item.show = row.order_type_val == 1 && row.order_use != 'TRANSFER_WAREHOUSE'
        order_category_item.show = row.order_channel_type_val == 1
        
        // 提示支付方式
        let source_item = createOrderForm1.formField.find(i=> i.key == 'source')
        let optItem = source_item.options.find(i=> i.value == row.source_val)
        let formItem2 = createOrderForm1.formField.find(i=> i.key == 'payment_type')
        formItem2.showItemPreText = optItem.type == 1 && optItem.payment
        customerPaymentType.value = optItem.payment

        // 获取渠道运费
        shipping_cost.value = optItem.shipping_cost === ''? '' : Number(optItem.shipping_cost)
        console.log(shipping_cost.value, '编辑 shipping_cost 渠道运费')

        // console.log(row,'edit row')
        createOrderForm1.formData.erp_no = isSyncERP.value? row.erp_no : ''
        createOrderForm1.formData.order_id = row.id
        createOrderForm1.formData.order_no = row.order_no
        createOrderForm1.formData.order_type = row.order_type_val
        createOrderForm1.formData.order_use = row.order_use
        createOrderForm1.formData.back_flag = row.back_flag_val
        createOrderForm1.formData.source = row.source_val
        createOrderForm1.formData.order_channel_type = row.order_channel_type_val
        createOrderForm1.formData.customer_erp_code = row.customer_erp_code
        createOrderForm1.formData.order_name = row.order_name
        createOrderForm1.formData.order_status = row.order_status_val
        createOrderForm1.formData.courier_status = row.courier_status_val
        createOrderForm1.formData.second_hand_flag = row.second_hand_flag !== undefined? row.second_hand_flag : 0
        createOrderForm1.formData.delivery_type = row.delivery_type == '-'? '' : row.delivery_type
        createOrderForm1.formData.tax_rate = row.tax_rate_val
        createOrderForm1.formData.tax_type = Number(row.tax_type)
        createOrderForm1.formData.payment_type = row.payment_type
        createOrderForm1.formData.pay_with_days_day = createOrderForm1.formData.order_channel_type != 1 && createOrderForm1.formData.order_channel_type != 5? '0' : row.pay_with_days_day == undefined? '14' : `${row.pay_with_days_day}`
        createOrderForm1.formData.order_category = row.order_channel_type_val != 1? '' : row.order_category? row.order_category : 0
        createOrderForm1.formData.expand_order_source = row.expand_order_source
        createOrderForm1.formData.delivery_timeliness = createOrderForm1.formData.delivery_type == ''? '' : createOrderForm1.formData.order_channel_type != 1 && createOrderForm1.formData.order_channel_type != 5? '' : row.delivery_timeliness == undefined? 0 : row.delivery_timeliness

        // 是否冬季折扣
        if(row.expand_order_source == 5){
            createOrderForm1.formData.winter_flag = row.winter_flag == undefined? 0 : row.winter_flag
            createOrderForm1.formData.payment_due_date = createOrderForm1.formData.winter_flag == 1 && (row.payment_type == 'By Invoice' || row.payment_type == 'SEPA')? '2026-05-01' : ''
        } 
        let winter_flag_item = createOrderForm1.formField.find(i=> i.key == 'winter_flag')
        let payment_due_date_item = createOrderForm1.formField.find(i=> i.key == 'payment_due_date')
        let payment_day_item = createOrderForm1.formField.find(i=> i.key == 'payment_day')
        winter_flag_item.show = row.expand_order_source == 5
        payment_due_date_item.show = row.expand_order_source == 5 && (row.payment_type == 'By Invoice' || row.payment_type == 'SEPA') && createOrderForm1.formData.winter_flag == 1
        payment_day_item.show = !payment_due_date_item.show
        

        // 设置支付折扣，现金折扣，账期下拉配置
        setDiscountOpt(optItem)

        createOrderForm1.formData.payment_type_discount = !row.payment_type_discount? '0' : row.payment_type_discount, // row.payment_type_discount.indexOf('%') > -1? row.payment_type_discount : Number(row.payment_type_discount) * 100 + '%'
        createOrderForm1.formData.pay_with_days_discount_rate = row.pay_with_days_discount_rate == undefined? '0' : row.pay_with_days_discount_rate
        createOrderForm1.formData.payment_day = row.payment_day == undefined? '0' : `${row.payment_day}`
        createOrderForm1.formData.pay_type_discount = !row.pay_type_discount? 0 : timezoneOffset.value == '-8'? Number(row.pay_type_discount) : formatterToComma(Number(row.pay_type_discount), timezoneOffset.value == '-8')
        createOrderForm1.formData.cargo_freight = row.cargo_freight == '-'? 0 : timezoneOffset.value == '-8'? Number(row.cargo_freight.split('€')[1].trim()) : formatterToComma(Number(row.cargo_freight.split('€')[1].trim()), timezoneOffset.value == '-8')
        createOrderForm1.formData.instruction = row.instruction
        createOrderForm1.formData.order_timestamp = row.order_timestamp
        createOrderForm1.formData.earliest_ship_timestamp = row.earliest_ship_timestamp
        createOrderForm1.formData.predict_week_date = !row.predict_week_date? '' : row.predict_week_date
        createOrderForm1.formData.predict_delivery_week = row.predict_delivery_week
        createOrderForm1.formData.predict_delivery_year = !row.predict_delivery_year? '' : `${row.predict_delivery_year}`


        createOrderForm3.formData.customer_entity_id = row.customer_entity_id
        createOrderForm3.formData.customer_id = row.customer_id
        createOrderForm3.formData.customer_invoice_id = row.customer_invoice_id
        createOrderForm3.formData.name2 = row.name2 || ''
        createOrderForm3.formData.customer_email = row.customer_email
        createOrderForm3.formData.customer_type = Number(row.customer_type_val)
        createOrderForm3.formData.country = row.country
        createOrderForm3.formData.customer_name = row.customer_name
        createOrderForm3.formData.order_confirm_mail = row.order_confirm_mail
        createOrderForm3.formData.file_lang_code = row.file_lang_code

        if(createOrderForm3.formData.country !== '') setLangTemp()

        createOrderForm2.formData.order_amount = timezoneOffset.value == '-8'? Number(row.order_amount_val).toFixed(2) : formatterToComma(Number(row.order_amount_val), timezoneOffset.value == '-8')
        createOrderForm2.formData.quantity = row.quantity
        createOrderForm2.formData.order_discount = !row.order_discount_val? 0 : timezoneOffset.value == '-8'? Number(row.order_discount_val) : formatterToComma(Number(row.order_discount_val), timezoneOffset.value == '-8')
        createOrderForm2.formData.extra_discount = !row.extra_discount? 0 : timezoneOffset.value == '-8'? Number(row.extra_discount) : formatterToComma(Number(row.extra_discount), timezoneOffset.value == '-8')
        createOrderForm2.formData.order_tax = timezoneOffset.value == '-8'? Number(row.order_tax_val) : formatterToComma(Number(row.order_tax_val), timezoneOffset.value == '-8')
        createOrderForm2.formData.pay_amount = timezoneOffset.value == '-8'? Number(row.pay_amount_val).toFixed(2) : formatterToComma(Number(row.pay_amount_val), timezoneOffset.value == '-8')
        createOrderForm2.formData.pay_with_days_discount = timezoneOffset.value == '-8'? Number(row.pay_with_days_discount_val).toFixed(2) : formatterToComma(Number(row.pay_with_days_discount_val), timezoneOffset.value == '-8')
                
        // console.log(createOrderForm1.formData.order_channel_type,createOrderForm1.formData.order_channel_type == 1,'aaaaaa kkmm')
        createOrderForm1.formField.forEach(i=>{
            if(i.key == 'payment_type'){
                i.required = createOrderForm3.formData.customer_type == 1
                i.disabled = !(createOrderForm1.formData.order_channel_type == 1 || createOrderForm1.formData.order_channel_type == 5)
            } 
            if(i.key == 'order_status'){
                i.options[3].disabled = row.order_channel_type_val == 4
            }
            if(i.key == 'second_hand_flag'){
                i.disabled = !(createOrderForm1.formData.order_channel_type == 0 || createOrderForm1.formData.order_channel_type == 1 || createOrderForm1.formData.order_channel_type == 3) || ((createOrderForm1.formData.order_channel_type == 0 || createOrderForm1.formData.order_channel_type == 1 || createOrderForm1.formData.order_channel_type == 3) && row.courier_status_val != 0)
            }
            // console.log(createOrderForm1.formData, createOrderForm1.formData.order_channel_type != 1 && createOrderForm1.formData.order_channel_type != 5, '编辑jjjjjjjjjjj')
            if(i.key == 'pay_with_days_day'){
                i.disabled = createOrderForm1.formData.order_channel_type != 1 && createOrderForm1.formData.order_channel_type != 5
            }
            if(i.key == 'order_category'){
                orderLineExitsSku.value = createOrderForm1.formData.order_channel_type == 1
                i.showItemPreText = orderLineExitsSku.value
                i.disabled = orderLineExitsSku.value
            }
            if(i.key == 'delivery_timeliness'){
                let order_channel_type = createOrderForm1.formData.order_channel_type
                i.show = (order_channel_type == 1 || order_channel_type == 5) && createOrderForm1.formData.delivery_type == 'courier'
                i.disabled = (order_channel_type != 1 && order_channel_type != 5) || (order_channel_type != 1 && order_channel_type != 5 && shipping_cost.value !== '')

                let country = createOrderForm3.formData.country
                i.options[1].disabled = country !== 'Germany' && country !== 'Austria'
            }
            if(i.key == 'cargo_freight'){
                i.showItemPreText = false
            }
        })

        orderLineTable.value.columns = []
        if(Number(row.tax_type) == 1){
            orderLineColumns.value.forEach(i=>{
                if(i.show !== undefined){
                    i.show = true
                }
                if((i.show !== undefined && i.show) || i.show == undefined){
                    orderLineTable.value.columns.push(i)
                }
            })
        }else{
            orderLineColumns.value.forEach(i=>{
                if(i.show !== undefined) i.show = false
                if((i.show !== undefined && i.show) || i.show == undefined){
                     orderLineTable.value.columns.push(i)
                }
            })
        }

        if(row.child.innerDatas.length > 0){
            orderLineTable.value.datas = []

            if(row.order_channel_type_val == 4){
                await getServiceBindQuery(row)
            }

            row.child.innerDatas.forEach((i,index)=>{
                orderLineTable.value.datas.push({
                    serial: index + 1,
                    id: i.id,
                    bind_sku: i.bind_sku,
                    bind_order_line_id: i.bind_order_line_id,
                    stock_out_id: i.stock_out_id,
                    order_id:row.id,
                    sku:i.sku,
                    inventory_code:i.inventory_code,
                    name:i.product_name,
                    frame_color: i.product_map == undefined? '-' : i.product_map.frame_color? i.product_map.frame_color : '-',
                    torque:i.torque,
                    pre_tax_amount: timezoneOffset.value == '-8'? divide(Number(i.amount_val), 1 + Number(row.tax_rate_val)) : formatterToComma(divide(Number(i.amount_val), 1 + Number(row.tax_rate_val)).toFixed(2), timezoneOffset.value == '-8'),
                    amount:timezoneOffset.value == '-8'? Number(i.amount_val).toFixed(2) : formatterToComma(Number(i.amount_val).toFixed(2), timezoneOffset.value == '-8'),
                    quantity:i.quantity,
                    discount_rate:i.discount_rate == undefined? '' : Number(i.discount_rate),
                    pre_tax_discount: timezoneOffset.value == '-8'? divide(Number(i.discount_val), 1 + Number(row.tax_rate_val)).toFixed(2) : formatterToComma(divide(Number(i.discount_val), 1 + Number(row.tax_rate_val)).toFixed(2), timezoneOffset.value == '-8'),
                    discount: !i.discount_val? '' : timezoneOffset.value == '-8'? Number(i.discount_val) : formatterToComma(Number(i.discount_val), timezoneOffset.value == '-8'),
                    pre_tax_extra_discount: timezoneOffset.value == '-8'? divide(Number(i.extra_discount), 1 + Number(row.tax_rate_val)) : formatterToComma(divide(Number(i.extra_discount), 1 + Number(row.tax_rate_val)).toFixed(2), timezoneOffset.value == '-8'),
                    extra_discount: !i.extra_discount? '' : timezoneOffset.value == '-8'? Number(i.extra_discount) : formatterToComma(Number(i.extra_discount), timezoneOffset.value == '-8'),
                    pre_tax_pay_amount: timezoneOffset.value == '-8'? divide(Number(i.pay_amount_val), 1 + Number(row.tax_rate_val)).toFixed(2) : formatterToComma(divide(Number(i.pay_amount_val), 1 + Number(row.tax_rate_val)).toFixed(2), timezoneOffset.value == '-8'),
                    pay_amount: timezoneOffset.value == '-8'? Number(i.pay_amount_val).toFixed(2) : formatterToComma(Number(i.pay_amount_val).toFixed(2), timezoneOffset.value == '-8'),
                    tax_rate:i.tax_rate,
                    tax_rate_val:row.tax_rate_val,
                    order_tax:  timezoneOffset.value == '-8'? multiply(divide(Number(i.pay_amount_val), 1 + Number(row.tax_rate_val)), Number(row.tax_rate_val)).toFixed(2) : formatterToComma(multiply(divide(Number(i.pay_amount_val), 1 + Number(row.tax_rate_val)), Number(row.tax_rate_val)).toFixed(2), timezoneOffset.value == '-8'),
                    handle_timestamp:i.handle_timestamp_val == '-'? '' : i.handle_timestamp_val,
                    disabled: createOrderForm1.formData.tax_type == 1,
                    preTaxExtraDiscountDisabled: true,
                    amountDisabled: i.product_code == '627.501',
                    preTaxAmountDisabled: i.product_code == '627.501',
                    skuDisabled: isSyncERP.value,
                    quantityDisabled: isSyncERP.value,
                    shipDateDisabled: createOrderForm1.formData.courier_status != 0,
                    line_order_amount: multiply(Number(i.amount_val), i.quantity),
                    erp_line_no: isSyncERP.value && i.erp_line_no? i.erp_line_no : '',
                    product_code: i.product_map == undefined? '' : i.product_map.category_code? i.product_map.category_code : '',
                    order_line_no: i.order_line_no == '-'? '' : i.order_line_no,
                    cancel_status_val: i.cancel_status_val == undefined? '' : i.cancel_status_val,
                    user_comment: i.user_comment,
                    enable: createOrderForm1.formData.order_channel_type == 1 || createOrderForm1.formData.order_channel_type == 5
                })
            })
        }
        getCustomerAddressList()
        editOrderloading.value = false

        // 订单数据 兼容处理
        // 2025-1-15之前的订单遵循以前规则，无需弹窗提醒；
        // 2025-1-15至2025-2-7期间的订单，编辑时，按最新运费规则，需弹窗提醒；
        // 2025-2-7及之后的订   单，按最新规则，编辑时，无需弹窗提醒；
        let limit_date1 = dateToTimestamp('2025-2-7')
        let limit_date2 = dateToTimestamp('2025-1-15')
        let order_date = dateToTimestamp(row.order_timestamp)
        // console.log(order_date >= limit_date2, order_date < limit_date1, '编辑编辑编辑', order_date, limit_date2, limit_date1)
        if(order_date >= limit_date2 && order_date < limit_date1 && (createOrderForm1.formData.order_channel_type == 0 || createOrderForm1.formData.order_channel_type == 1)){
            autoComputeFreightVisible.value = true
        }

        console.log(createOrderForm1.formData.cargo_freight, '编辑运费')
        if(createOrderForm1.formData.order_channel_type !== '' && createOrderForm3.formData.country !== ''){
            unit_freight.value = await getFreight(createOrderForm1.formData.order_channel_type, createOrderForm3.formData.country)
        }
    }

    // 确认虚拟订单，转成C&C订单
    const confirmVirtualOrderToC2COrder = async(row)=>{
        // console.log(row,'edit row')
        editOrderloading.value = true
        createOrderVisible.value = true
        orderOperateType.value = 'add'
        orderTitle.value = t('order.create')
                
        let customerObjByPickUpId = await getERPCodeAndCustomerByPickUpId(row.pick_up_id)
        let item = createOrderForm1.formField.find(i=> i.key == 'source')
        let source_id = ''
        if(customerObjByPickUpId){
            source_id = item.options.find(i=> i.code == customerObjByPickUpId.erp_code).value
        }else{
            Modal.warning({
                title: t('base.tip'),
                titleAlign:'start',
                content: t('order.customerObjByPickUpIdTip'),
                hideCancel:true,
                okText:t('base.ok'),
                cancelText:t('base.cancel'),
                onOk:()=>{
                    createOrderVisible.value = false
                }
            })
        }
        

        await getCustomerList()
        await getOrderLine(row.id,row)
        await getTax()
        await getPaymentType()

        createOrderForm1.formField.forEach(i=>{
            i.disabled = [
                'order_type','source','order_name','second_hand_flag','tax_type','payment_type_discount',
                'pay_type_discount','order_channel_type','user_note',
            ].includes(i.key)

            // 虚拟订单确认，禁止修改订单名称
            if(i.key == 'pay_with_days_discount'){
                if(row.payment_type == 'by invoice') item.name = 'order.payWithin14daysDiscount'
                if(row.payment_type == 'By Invoice 90 days') item.name = 'order.payWithin90daysDiscount'
            }
        })

        createOrderForm3.formField.forEach(i=>{
            i.disabled = !['customer_entity_id','customer_id','customer_invoice_id'].includes(i.key)
            i.addIcon = ['customer_entity_id'].includes(i.key)
        })

        let order_status_item = createOrderForm1.formField.find(i=> i.key == 'order_status')
        let label_item = order_status_item.options.find(i=> i.value == 6)
        label_item.disabled = isSyncERP.value

        let order_use_item = createOrderForm1.formField.find(i=> i.key == 'order_use')
        let back_flag_item = createOrderForm1.formField.find(i=> i.key == 'back_flag')
        let user_note_item = createOrderForm1.formField.find(i=> i.key == 'user_note')
        user_note_item.show = false
        order_use_item.show = row.order_type_val == 1
        back_flag_item.show = row.order_type_val == 1 && row.order_use != 'TRANSFER_WAREHOUSE'

        // 提示支付方式
        let source_item = createOrderForm1.formField.find(i=> i.key == 'source')
        let optItem = source_item.options.find(i=> i.value == source_id)
        let formItem2 = createOrderForm1.formField.find(i=> i.key == 'payment_type')
        formItem2.showItemPreText = optItem.type == 1 && optItem.payment
        customerPaymentType.value = optItem.payment

        // console.log(row,'edit row', row.order_timestamp)
        createOrderForm1.formData.erp_no = ''
        createOrderForm1.formData.virtual_order_id = row.id
        createOrderForm1.formData.order_no = row.order_no
        createOrderForm1.formData.order_type = row.order_type_val
        createOrderForm1.formData.order_use = row.order_use
        createOrderForm1.formData.back_flag = row.back_flag_val
        createOrderForm1.formData.source = source_id
        createOrderForm1.formData.order_channel_type = 5
        createOrderForm1.formData.customer_erp_code = customerObjByPickUpId.erp_code
        createOrderForm1.formData.order_name = `${row.order_name}-${customerObjByPickUpId.erp_code}`
        createOrderForm1.formData.order_status = 7
        createOrderForm1.formData.courier_status = 0
        createOrderForm1.formData.second_hand_flag = 0
        createOrderForm1.formData.delivery_type = 'courier'
        createOrderForm1.formData.tax_rate = row.tax_rate_val
        createOrderForm1.formData.tax_type = 1
        createOrderForm1.formData.payment_type = row.payment_type
        createOrderForm1.formData.delivery_timeliness = createOrderForm1.formData.delivery_type == ''? '' : createOrderForm1.formData.order_channel_type != 5? '' : row.delivery_timeliness == undefined? 0 : row.delivery_timeliness

        // 设置支付折扣，现金折扣，账期下拉配置
        setDiscountOpt(optItem)


        createOrderForm1.formData.payment_type_discount = '0' //!row.payment_type_discount? '0' : row.payment_type_discount.indexOf('%') > -1? row.payment_type_discount : Number(row.payment_type_discount) * 100 + '%'
        createOrderForm1.formData.pay_type_discount = 0 //!row.pay_type_discount? 0 : timezoneOffset.value == '-8'? Number(row.pay_type_discount) : formatterToComma(Number(row.pay_type_discount), timezoneOffset.value == '-8')
        createOrderForm1.formData.pay_with_days_discount_rate = row.pay_with_days_discount_rate == undefined? '0' : row.pay_with_days_discount_rate
        createOrderForm1.formData.payment_day = row.payment_day == undefined? '0' : `${row.payment_day}`
        createOrderForm1.formData.cargo_freight = 0 // row.cargo_freight == '-'? 0 : timezoneOffset.value == '-8'? Number(row.cargo_freight.split('€')[1].trim()) : formatterToComma(Number(row.cargo_freight.split('€')[1].trim()), timezoneOffset.value == '-8')
        createOrderForm1.formData.instruction = row.instruction
        createOrderForm1.formData.order_timestamp = getNowDate() //dateToTimestamp(`${getNowDate()} 00:00:00`) * 1000,
        createOrderForm1.formData.earliest_ship_timestamp = '' //row.earliest_ship_timestamp
        createOrderForm1.formData.predict_week_date = '' // !row.predict_week_date? '' : row.predict_week_date
        createOrderForm1.formData.predict_delivery_week = '' //row.predict_delivery_week
        createOrderForm1.formData.predict_delivery_year = '' //!row.predict_delivery_year? '' : `${row.predict_delivery_year}`


        // console.log(customerList.value,'customerList.value')
        let custoner_item = customerList.value.find(i=> i.id == customerObjByPickUpId.customer_entity_id)
        // console.log(custoner_item,'custoner_item')
        
        createOrderForm3.formData.customer_entity_id = customerObjByPickUpId.customer_entity_id
        createOrderForm3.formData.customer_id = customerObjByPickUpId.address_id
        createOrderForm3.formData.customer_invoice_id = customerObjByPickUpId.address_id
        createOrderForm3.formData.name2 = ''
        createOrderForm3.formData.customer_email = custoner_item.email
        createOrderForm3.formData.customer_name = custoner_item.name
        createOrderForm3.formData.customer_type = 1
        createOrderForm3.formData.country = customerObjByPickUpId.customer_info.country
        createOrderForm3.formData.order_confirm_mail = customerObjByPickUpId.customer_info.email
        createOrderForm3.formData.file_lang_code = row.file_lang_code

        if(createOrderForm3.formData.country !== '') setLangTemp()

        createOrderForm2.formData.order_amount = 0 
        createOrderForm2.formData.c2c_extra_amount = multiply(subtract(createOrderForm2.formData.order_amount, createOrderForm2.formData.order_discount), 0.05).toFixed(2)
        createOrderForm2.formData.c2c_extra_rate = 0.05
        createOrderForm2.formData.quantity = row.quantity
        createOrderForm2.formData.order_discount = 0 
        createOrderForm2.formData.extra_discount = 0
        createOrderForm2.formData.order_tax = 0 
        createOrderForm2.formData.pay_amount = 0
        createOrderForm2.formData.pay_with_days_discount = 0
                
        createOrderForm1.formField.forEach(i=>{
            if(i.key == 'payment_type'){
                i.required = createOrderForm3.formData.customer_type == 1
            }
            if(i.key == 'delivery_timeliness'){
                let order_channel_type = createOrderForm1.formData.order_channel_type
                i.show = order_channel_type == 5 && createOrderForm1.formData.delivery_type == 'courier'
                i.disabled = order_channel_type != 5 || (order_channel_type != 5 && shipping_cost.value !== '')

                let country = createOrderForm3.formData.country
                i.disabled = country !== 'Germany' && country !== 'Austria'
            }
            if(i.key == 'cargo_freight'){
                i.showItemPreText = false
            }
        })

        orderLineTable.value.columns = []
        if(createOrderForm1.formData.tax_type == 1){
            orderLineColumns.value.forEach(i=>{
                if(i.show !== undefined){
                    i.show = true
                }
                if((i.show !== undefined && i.show) || i.show == undefined){
                    orderLineTable.value.columns.push(i)
                }
            })
        }else{
            orderLineColumns.value.forEach(i=>{
                if(i.show !== undefined) i.show = false
                if((i.show !== undefined && i.show) || i.show == undefined){
                     orderLineTable.value.columns.push(i)
                }
            })
        }

        cargoFreightNeedChange.value = true
        computeCargoFreight()
        orderLineTable.value.datas = []
        if(row.child.innerDatas.length > 0){
            row.child.innerDatas.forEach(async(i,index)=>{
                let priceObj = await getPriceBySkuForVirtualOrder(i)
                let price = priceObj.length == 0? '' : priceObj[0].unit_price
                let amount = multiply(price, add(1, row.tax_rate_val)).toFixed(2)
                let pre_tax_pay_amount = multiply(price, i.quantity).toFixed(2)
                let pay_amount = multiply(amount, i.quantity).toFixed(2)
                let order_tax = multiply(divide(pay_amount, 1 + Number(row.tax_rate_val)), Number(row.tax_rate_val)).toFixed(2)

                createOrderForm2.formData.order_amount = Number(createOrderForm2.formData.order_amount) + multiply(amount, i.quantity)
                createOrderForm2.formData.c2c_extra_amount = multiply(subtract(createOrderForm2.formData.order_amount, createOrderForm2.formData.order_discount), 0.05).toFixed(2)
                createOrderForm2.formData.order_tax = Number(createOrderForm2.formData.order_tax) + Number(order_tax)
                createOrderForm2.formData.pay_amount = Number(createOrderForm2.formData.pay_amount) + Number(pay_amount)
                console.log(createOrderForm2.formData.order_amount,'order_amount', order_tax, pay_amount, createOrderForm2.formData.quantity, createOrderForm2.formData.order_tax)

                orderLineTable.value.datas.push({
                    serial: index + 1,
                    id: i.id,
                    order_id:row.id,
                    sku:i.sku,
                    inventory_code:i.inventory_code,
                    name:i.product_name,
                    frame_color: i.product_map == undefined? '-' : i.product_map.frame_color? i.product_map.frame_color : '-',
                    torque:i.torque,

                    pre_tax_amount: price == ''? '' : price, 
                    amount: price == ''? '' : amount, 
                    quantity: i.quantity,
                    discount_rate:i.discount_rate == undefined? '' : Number(i.discount_rate),
                    pre_tax_discount: '',
                    discount: '',
                    pre_tax_extra_discount: '',
                    extra_discount: '',
                    pre_tax_pay_amount: pre_tax_pay_amount,
                    pay_amount: pay_amount,
                    tax_rate: i.tax_rate,
                    tax_rate_val: row.tax_rate_val,
                    order_tax: order_tax,
                    
                    handle_timestamp: dateToTimestamp(`${getNowDate()} 00:00:00`) * 1000,
                    disabled: createOrderForm1.formData.tax_type == 1,
                    preTaxExtraDiscountDisabled: true,
                    amountDisabled: true,
                    preTaxAmountDisabled: i.product_code == '627.501',
                    skuDisabled: false,
                    quantityDisabled: false,
                    shipDateDisabled: false,
                    line_order_amount: multiply(Number(amount), i.quantity),
                    erp_line_no: '',
                    product_code: i.product_map == undefined? '' : i.product_map.category_code? i.product_map.category_code : '',
                    order_line_no: '',
                    cancel_status_val: '',
                    enable: createOrderForm1.formData.order_channel_type == 1 || createOrderForm1.formData.order_channel_type == 5
                })
            })
            
        }
        getCustomerAddressList()
        editOrderloading.value = false
    }

    // 保险订单行匹配实物订单行
    const getServiceBindQuery = async (row)=>{
        let param = {
            service_order_id: row.id
        }
        let res = await OrderApi.getInstance().getServiceBindQuery(param)
        if(res.code == 0){
            row.child.innerDatas.forEach(i=>{
                res.data.forEach(m=>{
                    if(i.id == m.service_line_id){
                        i.bind_sku = m.line_sku
                        i.bind_order_line_id = m.line_id
                        i.stock_out_id = m.line_stock_out_id
                    }
                })
            })
            createOrderForm1.formData.bind_order_id = res.data[0].order_id
            createOrderForm1.formData.bind_order_name = res.data[0].order_name
            ebike_orderTitle.value = res.data[0].order_name
        }else{
            Message.error(res.msg)
        }
    }

    const handleReissueWidth = (val)=>{
        // console.log(val,'vvgg')
        reissueWidth.value = val == 'large'? '100%' : val == 'medium'? '85%' : '65%' 
    }

    const handleReturnWidth = (val)=>{
        // console.log(val,'vvgg')
        returnWidth.value = val == 'large'? '100%' : val == 'medium'? '85%' : '65%' 
    }

    const handleReturnFactoryWidth = (val)=>{
        returnFactoryWidth.value = val == 'large'? '100%' : val == 'medium'? '85%' : '65%' 
    }
    
    const handleCreateOrderWidth = (val)=>{
        createOrderWidth.value = val == 'large'? '100%' : val == 'medium'? '85%' : '65%' 
    }

    const resetVisible = ()=>{
        recordVisible.value = false
        logisticsVisible.value = false
        refundRecordVisible.value = false
        cancelSORecordVisible.value = false
        returnExchangeRecordVisible.value = false
    }

    const handleWeekPickerChange = (val)=>{
        createOrderForm1.formData.predict_delivery_week = getWeek(val)
    }

    const handleSelectDate = (val, date, item)=>{
        // console.log(val,date,item,'select date')

        let earliest_ship_timestamp = dateToTimestamp(val)
        orderLineTable.value.datas.forEach(i=>{
            if(dateToTimestamp(i.handle_timestamp) < earliest_ship_timestamp){
                i.handle_timestamp = ''
            }
        })


        // 日期防呆
        // if(createOrderForm1.formData.order_channel_type != 4){
            if(item.key == 'order_timestamp' && orderOperateType.value == 'add'){ // 新增时-订单只能建在当月
                let yearMonth = `${val.split(' ')[0].split('-')[0]}-${val.split(' ')[0].split('-')[1]}`
                let currentYearMonth = `${getNowDate().split('-')[0]}-${getNowDate().split('-')[1]}`

                if(yearMonth != currentYearMonth){
                    Modal.warning({
                        title: t('base.tip'),
                        titleAlign:'start',
                        content: t('order.orderDateCurMonthTip'),
                        hideCancel:true,
                        okText:t('base.ok'),
                        cancelText:t('base.cancel'),
                        onOk:()=>{
                            createOrderForm1.formData.order_timestamp = ''
                        }
                    });
                }
            }else if(item.key == 'order_timestamp' && orderOperateType.value == 'edit'){ // 编辑时-订单只能建在当月
                // console.log(rowData.value,'order_timestamp 22222222')
                let yearMonth = `${val.split(' ')[0].split('-')[0]}-${val.split(' ')[0].split('-')[1]}`
                let currentYearMonth = `${rowData.value.order_timestamp.split('-')[0]}-${rowData.value.order_timestamp.split('-')[1]}`
                // console.log(yearMonth, currentYearMonth,'currentYearMonth')

                if(yearMonth != currentYearMonth){
                    Modal.warning({
                        title: t('base.tip'),
                        titleAlign:'start',
                        content: t('order.orderDateCurMonthTip'),
                        hideCancel:true,
                        okText:t('base.ok'),
                        cancelText:t('base.cancel'),
                        onOk:()=>{
                            createOrderForm1.formData.order_timestamp = rowData.value.order_timestamp
                        }
                    });
                }
            }else if(item.key == 'earliest_ship_timestamp'){ // 不能小于订单日期
                let earliest_ship_timestamp = dateToTimestamp(val.split(' ')[0]) 
                let order_timestamp = dateToTimestamp(createOrderForm1.formData.order_timestamp.split(' ')[0])
                
                if(earliest_ship_timestamp < order_timestamp){
                    Modal.warning({
                        title: t('base.tip'),
                        titleAlign:'start',
                        content: t('order.earliestShipmentDate'),
                        hideCancel:true,
                        okText:t('base.ok'),
                        cancelText:t('base.cancel'),
                        onOk:()=>{
                            createOrderForm1.formData.earliest_ship_timestamp = ''
                        }
                    });
                } 
            }
        // }
        // else{
        //     let limitDate = Number(last_sign_time.value) + 24 * 60 * 60 * 15
        //     let selectDate = dateToTimestamp(val)  // Number(dateToTimestamp(`${val.split(' ')[0]} 23:59:59`))
        //     console.log(dateToTimestamp(val) < limitDate, selectDate, limitDate)
        //     if( selectDate < limitDate){
        //         Modal.warning({
        //             title: t('base.tip'),
        //             titleAlign:'start',
        //             content: t('order.serviceOrderDateTip'),
        //             hideCancel:true,
        //             okText:t('base.ok'),
        //             cancelText:t('base.cancel'),
        //             onOk:()=>{
        //                 createOrderForm1.formData.order_timestamp = ''
        //             }
        //         });
        //     }
        // }
    }

    const handleYearPickerChange = (val, item)=>{
        if(item.key == 'predict_delivery_year'){ // 不能小于订单日期年份
            let year = createOrderForm1.formData.order_timestamp.split(' ')[0].split('-')[0]
            if(val < year){
                Modal.warning({
                    title: t('base.tip'),
                    titleAlign:'start',
                    content: t('order.preShipmentYearTip'),
                    hideCancel:true,
                    okText:t('base.ok'),
                    cancelText:t('base.cancel'),
                    onOk:()=>{
                        createOrderForm1.formData.predict_delivery_year = ''
                    }
                });
            } 
        }
    }

    // 单击单元格
    const cellClick = (row,column)=>{
        // console.log(column,'col')
        if(column.key == 'instruction'){
            row.instructionIsText = false
        }
    }

    // 取消保存备注
    const cancelSaveComment = (row)=>{
        row.instructionIsText = true
        getOrderHead()
    }

    // 保存备注
    const saveComment = async (row)=>{
        let param = {
            instruction:row.instruction,
        }
        let res = await OrderApi.getInstance().saveComment(row.id,param)
        if(res.code == 0){
            Message.success(t('base.saveSuccess'))
            row.instructionIsText = true
            getOrderHead()
        }else{
            Message.error(res.msg)
        }
    }

    const vaild = (data)=>{
        let courierTypeArr = ['Cargoboard','DHL','ZUFALL','SIMPLELOGISTIK','Raben']
        if(courierTypeArr.includes(deliverForm.formData.courier_type) && !deliverForm.formData.courier_no){
            Message.error(t('order.courierNo')+' '+t('base.noEmpty'))
            return false
        }

        if(deliverTable.value.configs.selected.length == 0){
            Message.error(t('base.selectData'))
            return false
        }

        // for(let i=0; i<deliverTable.value.datas.length; i++){
        //     let item = deliverTable.value.datas[i]
        //     if(!item.curQuantity){
        //         Message.error(t('order.quantityTip2'))
        //         return false
        //     }else if(item.curQuantity !== '' && item.ship_quantity == '-' && item.curQuantity > item.orderQuantity){
        //         Message.error(t('order.quantityTip'))
        //         return false
        //     }else if(item.curQuantity !== '' && item.ship_quantity !== '-' && item.curQuantity + item.ship_quantity > item.orderQuantity){
        //         Message.error(t('order.quantityTip3'))
        //         return false
        //     }
        // }

        let wms_arr = []
        for(let i=0; i<deliverTable.value.configs.selected.length; i++){
            let item = deliverTable.value.configs.selected[i]
            if(!item.curQuantity){
                Message.error(t('order.quantityTip2'))
                return false
            }else if(item.second_hand_flag == 0 && item.category_code == '627.501' && item.curQuantity !== '' && item.curQuantity > item.lock_quantity){
                Message.error(t('order.quantityTip4'))
                return false
            }else if(!item.warehouse){
                Message.error(t('order.quantityTip7'))
                return false
            }else if(!item.transaction_date){
                Message.error(t('order.quantityTip6'))
                return false
            }else if(item.category_code == '627.501' && !wms_arr.includes(item.warehouse)){
                wms_arr.push(item.warehouse)
            }
        }

        console.log(wms_arr.length,'len')
        if(wms_arr.length > 1){
            Message.error(t('order.quantityTip9'))
            return false
        } 
        

        // let order_ship_date = dateToTimestamp(deliverForm.formData.transaction_date)
        // if(rowData.value.earliest_ship_timestamp_val != '' && order_ship_date < rowData.value.earliest_ship_timestamp_val){
        //     Modal.warning({
        //         title: t('base.tip'),
        //         titleAlign:'start',
        //         width:600,
        //         content:t('order.shipDateTip'),
        //         hideCancel:true,
        //         okText:t('base.ok'),
        //         onOk:()=>{},
        //     })
        //     return false
        // }


        return true
    }

    // 发货前校验
    const onShipBeforeOk = ()=>{
        return vaild(deliverForm.formData)
    }

    // 确认发货
    const handleShipOk = async ()=>{
        if(!!deliverForm.formData.courier_type && (deliverForm.formData.courier_no !== '' || deliverForm.formData.courier_url !== '')){
            await getCourierId()
        }
        
        // console.log(deliverTable.value.datas,'deliverTable.value.datas')
        let param = deliverTable.value.configs.selected.map(i=>{
            console.log(dateToTimestamp(i.transaction_date), 'ppop', i.transaction_date)
            return {
                courier_id:courierId.value,
                org_id:203,
                status:0,
                order_id: i.order_id,
                erp_no: i.erp_no,
                customer_name: i.customer_name,
                country: i.country,
                customer_id: i.customer_id,
                customer_entity_id: i.customer_entity_id,
                order_line_id: i.id,
                erp_line_no:i.erp_line_no,
                inventory_code:i.inventory_code,
                quantity: i.curQuantity,
                transaction_date: dateToTimestamp(i.transaction_date),
                courier_no: deliverForm.formData.courier_no,
                courier_url: deliverForm.formData.courier_url,
                courier_type: deliverForm.formData.courier_type,
                // transaction_date: !deliverForm.formData.transaction_date? '' : dateToTimestamp(deliverForm.formData.transaction_date),
                warehouse:i.warehouse,
                roll_over_inventory:i.roll_over_inventory,
            }
        })
        // console.log(param,'param')
        orderDelivery(param, param[0].order_id)
    }

    // 发货
    const orderDelivery = async (param,id)=>{
        table.value.configs.loading = true
        let res = await OrderApi.getInstance().orderDelivery(param, id)
        if(res.code == 0){
            Message.success(t('base.operateSuccess'))
            table.value.configs.loading = false
            getOrderHead()
        }else{
            Message.error(res.msg)
            table.value.configs.loading = false
        }
    }
    
    // 列表查询-select
    const handleSelectChange = ( val, opt, key )=>{
        // console.log(val,opt,key,'val,opt,key')
        if(key == 'customer_entity_id'){
            if(!val){
                queryForm.formData.customer_name = ''
            }else{
                let item = queryForm.formField.find(i=> i.key == 'customer_entity_id')
                let opt = item.options.find(i=> i.value == val)
                queryForm.formData.customer_name = opt.label
            }
        }
        // else if(key == 'sku'){
        //     let courier_status_item = queryForm.formField.find(i=> i.key == 'courier_status')
        //     if(val !== ''){
        //         courier_status_item.allowClear = false
        //         courier_status_item.options.forEach(i=>{
        //             i.disabled = i.value !== 0 && i.value !== 2
        //         })
        //         queryForm.formData.courier_status = 0
        //     }else{
        //         courier_status_item.allowClear = true
        //         courier_status_item.options.forEach(i=>{
        //             i.disabled = false
        //         })
        //         queryForm.formData.courier_status = ''
        //     }
        // }
        else{
            queryForm.formData[key] = val
        }
        table.value.configs.pagination.current = 1
        getOrderHead()
    }

    // 列表查询-下拉远程搜索
    const handleFetchSearch = (val,key)=>{
        // console.log(val,key,'val,key')
        getAddressName(val)
    }

    // 列表查询-input
    const handleInputClear = (val,item)=>{
        table.value.configs.pagination.current = 1
        getOrderHead()
    }
    const handlePressEnter = (val,item)=>{
        table.value.configs.pagination.current = 1
        getOrderHead()
    }

    const popupVisibleChange = (val,row)=>{
        if(val){
            if(row.customer_id == row.customer_invoice_id){
                getCustomer(row.customer_id)
            }else{
                getCustomer(row.customer_id)
                getCustomerInvoice(row.customer_invoice_id)
            }
        } 
    }   

    const handlePickerDateChange = (val,item)=>{
        table.value.configs.pagination.current = 1
        queryForm.formData.begin_date = !val? '' : dateToTimestamp(`${val[0]} 00:00:00`)
        queryForm.formData.end_date = !val? '' : dateToTimestamp(`${val[1]} 23:59:59`) 
        getOrderHead()
    }

    const handleInputNumberRefundChange = (item,val)=>{
        if(val > refundForm.formData.pay_amount){
            item.helpMasg = t('order.refundAmountVaildMsg')
            item.error=  true
            refundForm.formData.current_amount = ''
            return
        }else{
            item.helpMasg = ''
            item.error=  false
        }
        refundForm.formData.current_amount = Number(subtract(refundForm.formData.pay_amount,val).toFixed(2))
    }

    const handleRefundSelectDate = (val,date,item)=>{
        // console.log(rowData.value.order_timestamp,'kkkk')
        if(item.key == 'refund_date'){
            let order_timestamp = dateToTimestamp(rowData.value.order_timestamp)
            let back_timestamp = dateToTimestamp(val.split(' ')[0])
            if(back_timestamp < order_timestamp){
                Modal.warning({
                    title: t('base.tip'),
                    titleAlign:'start',
                    content: t('order.refundDateTip'),
                    hideCancel:true,
                    okText:t('base.ok'),
                    cancelText:t('base.cancel'),
                    onOk:()=>{
                        createOrderForm1.formData.refund_date = ''
                    }
                });
            }
        }
    }

    // 选择sku
    const changeSelesctSku = (val, row)=>{
        // console.log(val, row,'val, opt, key2222')
        Modal.warning({
            title: t('base.tip'),
            titleAlign: 'start',
            hideCancel: false,
            content: t('order.changeSKUTip'),
            okText: t('base.ok'),
            cancelText: t('base.cancel'),
            onOk: () => {
                let item = skuOptions.value.find(i=> i.value == val)
                row.inventory_code = item.code
                editOrderLine(val,row)
            }
        });
    }

    // 选择需发货数据
    const selectShipTableRow = (rowKeys, rowKey, record)=>{
        console.log(rowKeys, rowKey, record, 'rowKey')
        let selectedData = deliverTable.value.configs.selected
        selectedKeys.value = rowKey
        if(rowKeys.includes(rowKey)){
            selectedData.push(record)
        }else{
            let itemIndex = selectedData.findIndex(i=> i.id == rowKey)
            selectedData.splice(itemIndex,1)
        }
        console.log(deliverTable.value.configs.selected, 'selectedData')
    }

     // 变更仓库，获取可用库存
    const changeWarehouse = async (val,row)=>{
        // console.log(val,row,'kkkkkkk')

        // deliverTable.value.configs.loading = true
        // deliverTable.value.datas.forEach(async i=>{
        //     if(i.sku !== 'UPGRADESOFT10' && i.sku !== 'UPGRADESOFT20'){ 
        //         i.warehouse = val 
        //     } 
        //     i.transaction_quantity = await getInventories(val, i.sku)    
        //     i.scheduling_quantity = await getSchedulingQuantity(val, i.inventory_code)
        //     i.available_quantity = Number(i.transaction_quantity) - Number(i.scheduling_quantity) > 0? Number(i.transaction_quantity) - Number(i.scheduling_quantity) : 0 // 可用数量
        // })
        // deliverTable.value.configs.loading = false
    }

    const changeRollOverInventory = async (val,row)=>{}

    const handleDeliverSelectChange = ( val, opt, key )=>{
        // console.log(val, opt, key, 'val, opt, key')
        let courierTypeArr = ['Cargoboard','DHL','ZUFALL','Factory','SIMPLELOGISTIK','Raben']
        let item = deliverForm.formField.find(i=> i.key == 'courier_no')
        item.required = courierTypeArr.includes(val)
        deliverForm.formData.courier_no = deliverForm.formData.courier_type == 'Factory'? '000000' : ''
    }

    // 编辑订单行
    const editOrderLine = async (sku,row)=>{
        let param = {
            sku:sku,
            inventory_code:row.inventory_code,
        }
        let res = await OrderApi.getInstance().editOrderLine(row.id,param)
        if(res.code === 0){
            Message.success(t('base.saveSuccess'))
            row.isEdit = false
            row.sku = sku
        }else{
            Message.error(res.msg)
        }
    }

    // 订单变更为支付/取消状态/未付款
    const editOrderStatus = async (row,orderStatus)=>{
        let param = {
            order_status:orderStatus,
        }
        let res = await OrderApi.getInstance().editOrderStatus(row.id,param)
        if(res.code === 0){
            Message.success(t('base.saveSuccess'))
            getOrderHead()
        }else{
            Message.error(res.msg)
        }
    }  
    
    
    // 订单变更为取消
    const cancelOrder = async (row,orderStatus)=>{
        let param = {
            order_status:orderStatus,
            id:row.id,
        }
        let res = await OrderApi.getInstance().cancelOrder(row.id,param)
        if(res.code === 0){
            Message.success(t('base.saveSuccess'))
            getOrderHead()
        }else{
            Message.error(res.msg)
        }
    }  

    // 确认退款校验
    const onRefundBeforeOk = ()=>{
        if(refundForm.formData.refund_amount === ''){
            Message.error(t('order.refundAmount') + ' ' + t('base.noEmpty'))
            return false
        }else if(refundForm.formData.refund_amount > refundForm.formData.pay_amount){
            Message.error(t('order.refundAmountVaildMsg'))
            return false
        }else if(refundForm.formData.refund_date == ''){
            Message.error(t('order.refundTimestamp') + ' ' + t('base.noEmpty'))
            return false
        }
        return true
    }

    // 订单变更为退款状态
    const handleRefundOk = async ()=>{
        let param = {
            order_id:rowData.value.id,
            order_name:rowData.value.order_name,
            order_amount:rowData.value.order_amount_val,
            refund_amount: refundForm.formData.refund_amount,
            current_amount: refundForm.formData.current_amount,
            refund_timestamp: dateToTimestamp(refundForm.formData.refund_date),
            reason_type: refundForm.formData.reason_type,
            reason: refundForm.formData.reason,
        }
        // console.log(param,'parammmmmm')
        let res = await OrderApi.getInstance().refundSave(param)
        if(res.code === 0){
            Message.success(t('base.saveSuccess'))
            getOrderHead()
        }else{
            Message.error(res.msg)
        }
    }   

    // 编辑支付折扣金额
    const handleEditAmount = (row)=>{
        // console.log(row,'rowwwww')
        row.disabled = !row.disabled
    }

    // 创建订单-基本信息相关select
    const handleCreateOrderSelectChange = (val, opt, key)=>{
        console.log(val, opt, key, '基本信息下拉')
        if(key == 'order_type'){
            const order_use_item = createOrderForm1.formField.find(i=> i.key == 'order_use')
            const back_flag_item = createOrderForm1.formField.find(i=> i.key == 'back_flag')
            const source_item = createOrderForm1.formField.find(i=> i.key == 'source')
            
            order_use_item.show = val == 1
            back_flag_item.show = val == 1
            createOrderForm1.formData.order_use = ''
            createOrderForm1.formData.back_flag = ''
            source_item.disabled = val == 1
            createOrderForm1.formData.source = val == 1? 55 : ''
            if(val == 1) handleCreateOrderSelectChange(55,'','source')
            if(val == 0) createOrderForm1.formData.order_channel_type = ''

            if(val == 0){
                skuOptions.value = []
                productList.value.forEach(i=>{
                    skuOptions.value.push({
                        label:i.sku,
                        value:i.sku,
                        code:i.inventory_code,
                        category_code: i.category_code,
                    })
                })
            }
        }
        if(key == 'order_use'){
            let back_flag_item = createOrderForm1.formField.find(i=> i.key == 'back_flag')
            back_flag_item.show = val != 'TRANSFER_WAREHOUSE'
            skuOptions.value = []
            if(val == 'AFTER_SALES_PART'){
                productList.value.forEach(i=>{
                    if(i.category_code == '000.000'){
                        skuOptions.value.push({
                            label:i.sku,
                            value:i.sku,
                            code:i.inventory_code,
                            category_code: i.category_code,
                        })
                    }
                })

                orderLineTable.value.datas.forEach(i=>{
                    i.sku = ''
                    i.frame_color = '-'
                    i.torque = '-'
                    i.inventory_code = '-'
                    i.name = '-'
                })
            }else{
                productList.value.forEach(i=>{
                    skuOptions.value.push({
                        label:i.sku,
                        value:i.sku,
                        code:i.inventory_code,
                        category_code: i.category_code,
                    })
                })
            }
        }
        if(key == 'source'){
            createOrderForm1.formData.payment_type = ''
            createOrderForm1.formData.payment_type_discount = ''

            let item = createOrderForm1.formField.find(i=> i.key == 'source')
            let optItem = item.options.find(i=> i.value == val)
            // source_optItem.value = optItem

            console.log(optItem,'optItem')
            console.log(createOrderForm1.formData.source,'source')

            // 不活跃的经销商，禁止建单
            if(optItem && optItem.active_flag == 0){
                Modal.warning({
                    title: t('base.tip'),
                    titleAlign:'start',
                    width:450,
                    content:t('order.dealerInactiveTip') + ' sales@hepha.com',
                    hideCancel:true,
                    okText:t('base.ok'),
                    onOk:()=>{
                        createOrderForm1.formData.source = ''
                        lastValidOrderNo.value = ''
                        let order_name_item = createOrderForm1.formField.find(i=> i.key == 'order_name')
                        order_name_item.showItemPreText = false
                    },
                })
            }

            createOrderForm1.formData.customer_erp_code = !optItem? '' : optItem.code
            createOrderForm1.formData.tax_type = !optItem? '' : optItem.tax_flag == 'Y'? 0 : 1  
            
            handleCreateOrderSelectChange(createOrderForm1.formData.tax_type, '', 'tax_type')
            // console.log(optItem && history.state.fromPage != 'B2BShopOrder',' kkppuuuuuuuuuuuu')
            if(optItem && history.state.fromPage != 'B2BShopOrder'){
                getLastOrderNumber(val)
            }else{
                let order_name_item = createOrderForm1.formField.find(i=> i.key == 'order_name')
                order_name_item.showItemPreText = false
            }

            if(optItem.code == 'ODE0021'){
                createOrderForm1.formData.order_channel_type = 4
            }else{
                if(createOrderForm1.formData.order_type == 0 && !!optItem && optItem.type == 0){
                    createOrderForm1.formData.order_channel_type = 0
                }else if(createOrderForm1.formData.order_type == 0 && !!optItem && optItem.type == 1){
                    createOrderForm1.formData.order_channel_type = 1
                }else if(createOrderForm1.formData.order_type == 1){
                    createOrderForm1.formData.order_channel_type = 3
                } 
            }

            // 是否二手车
            let second_hand_flag_item = createOrderForm1.formField.find(i=> i.key == 'second_hand_flag')
            second_hand_flag_item.disabled = !(createOrderForm1.formData.order_channel_type == 0 || createOrderForm1.formData.order_channel_type == 1 || createOrderForm1.formData.order_channel_type == 3)
            createOrderForm1.formData.second_hand_flag = 0

            // 提示支付方式
            let formItem2 = createOrderForm1.formField.find(i=> i.key == 'payment_type')
            formItem2.showItemPreText = !optItem? false : optItem.type == 1 && optItem.payment
            customerPaymentType.value = optItem.payment

            // 获取渠道运费
            shipping_cost.value = optItem.shipping_cost === ''? '' : Number(optItem.shipping_cost)
            console.log(shipping_cost.value, 'shipping_cost 渠道运费')

            // 设置现金折扣比例天数
            console.log(createOrderForm1.formData.order_channel_type,'chanle type', createOrderForm1.formData.order_channel_type != 1 && createOrderForm1.formData.order_channel_type != 5)
            let payWithDaysDay_item = createOrderForm1.formField.find(i=> i.key == 'pay_with_days_day')
            payWithDaysDay_item.disabled = createOrderForm1.formData.order_channel_type != 1 && createOrderForm1.formData.order_channel_type != 5
            createOrderForm1.formData.pay_with_days_day = createOrderForm1.formData.order_channel_type != 1 && createOrderForm1.formData.order_channel_type != 5? '0' : '14'


            // B2B/C&C 根据支付方式选择支付折扣、现金折扣、账期
            formItem2.required = createOrderForm1.formData.order_channel_type == 1
            isPersonChange.value = false
            createOrderForm1.formData.payment_type = optItem.payment
            setDiscountOpt(optItem)
            setDiscountValue(optItem, isPersonChange.value)
            console.log(isPersonChange.value, '渠道变更 666')

            // 手动创建b2b订单 订单类型 普通/整车/零件
            if(history.state.fromPage != 'B2BShopOrder'){
                createOrderForm1.formData.order_category = orderOperateType.value == 'add' && createOrderForm1.formData.order_channel_type == 1? 0 : ''
                createOrderForm1.formField.find(i=>i.key == 'order_category').show = createOrderForm1.formData.order_channel_type == 1
                createOrderForm1.formField.find(i=>i.key == 'order_category').disabled = createOrderForm1.formData.order_channel_type != 1
                orderLineExitsSku.value = createOrderForm1.formData.order_channel_type != 1
                createOrderForm1.formData.order_category = 0
                createOrderForm1.formField.find(i=>i.key == 'order_category').showItemPreText = orderLineExitsSku.value
            }

            // // DZB方式，税率不能选0%
            // let form_item = createOrderForm1.formField.find(i=>i.key == 'tax_rate')
            // let tax_rate_item = form_item.options.find(i=>i.value == '0.00')
            // tax_rate_item.disabled = createOrderForm1.formData.payment_type == 'DZB'
            // console.log(tax_rate_item,'tax_rate_item', createOrderForm1.formData.payment_type)

            handleCreateOrderSelectChange(optItem.payment,null,'payment_type')

            // 根据渠道取，如果payment = DZB，则支付方式只能为DZB
            // if(optItem != undefined && optItem.payment == 'DZB'){
            //     formItem2.options.forEach(i=>{
            //         if(i.value != 'DZB'){
            //             i.disabled = true
            //         }
            //     })
            //     createOrderForm1.formData.payment_type = 'DZB'
            //     handleCreateOrderSelectChange('DZB',null,'payment_type')
            // }else{
            //     formItem2.options.forEach(i=>{
            //         i.disabled = false
            //     })
            //     createOrderForm1.formData.payment_type = ''
            //     handleCreateOrderSelectChange('',null,'payment_type')
            // }
            

            for(let i=0; i<orderLineTable.value.datas.length; i++){
                let item = orderLineTable.value.datas[i]
                item.sku = ''
                item.pre_tax_amount = ''
                item.amount = ''
                item.preTaxExtraDiscountDisabled = true
                item.enable = createOrderForm1.formData.order_channel_type == 1 || createOrderForm1.formData.order_channel_type == 5
                item.handle_timestamp = createOrderForm1.formData.order_channel_type == 1? getNowDate() : ''
            }
        }

        if(key == 'order_category'){
            skuOptions.value = []
            if(val == 0){
                productList.value.forEach(i=>{
                    skuOptions.value.push({
                        label:i.sku,
                        value:i.sku,
                        code:i.inventory_code,
                        category_code: i.category_code,
                    })
                })
            }else if(val == 1){
                productList.value.forEach(i=>{
                    if(i.category_code == '627.501'){
                        skuOptions.value.push({
                            label:i.sku,
                            value:i.sku,
                            code:i.inventory_code,
                            category_code: i.category_code,
                        })
                    }
                })
            }else if(val == 2){
                productList.value.forEach(i=>{
                    if(i.category_code == '000.000'){
                        skuOptions.value.push({
                            label:i.sku,
                            value:i.sku,
                            code:i.inventory_code,
                            category_code: i.category_code,
                        })
                    }
                })
            }
            console.log(skuOptions.value, 'skuOptions.value')
        }

        if(key == 'delivery_type'){
            let delivery_timeliness_item = createOrderForm1.formField.find(i=> i.key == 'delivery_timeliness')
            if(val == 'courier'){
                delivery_timeliness_item.show = true
                createOrderForm1.formData.delivery_timeliness = 0
                console.log('物流方式')
                computeCargoFreight()
            }else{
                delivery_timeliness_item.show = false
                createOrderForm1.formData.delivery_timeliness = ''
                createOrderForm1.formData.cargo_freight = 0
            }
        }

        if(key == 'delivery_timeliness'){
            console.log(val, 'delivery_timeliness')
            cargoFreightNeedChange.value = true
            if(!!createOrderForm3.formData.country){
                console.log('物流时效')
                computeCargoFreight()
            }
        }

        if(key == 'tax_type'){
            orderLineTable.value.columns = []
            orderLineColumns.value.forEach(i=>{
                if(val == 1){
                    if(i.show !== undefined){
                        i.show = true
                    }
                    if((i.show !== undefined && i.show) || i.show == undefined){
                        orderLineTable.value.columns.push(i)
                    }
                }else{
                    if(i.show !== undefined){
                        i.show = false
                    }
                    if(i.show == undefined){
                        orderLineTable.value.columns.push(i)
                    }
                }
            })


            // 重置数据
            orderLineTable.value.datas.forEach(i=>{
                i.disabled = createOrderForm1.formData.tax_type == 1
                i.skuDisabled = isSyncERP.value
                i.quantityDisabled = isSyncERP.value
                i.shipDateDisabled = createOrderForm1.formData.courier_status != 0
                i.amount = ''
                i.quantity = ''
                i.discount_rate = ''
                i.discount = ''
                i.extra_discount = ''
                i.pay_amount = ''
                i.pre_tax_amount = ''
                i.pre_tax_discount = ''
                i.pre_tax_extra_discount = ''
                i.pre_tax_pay_amount = ''
                i.line_order_amount = ''
                i.order_tax = ''
                i.enable = createOrderForm1.formData.order_channel_type == 1 || createOrderForm1.formData.order_channel_type == 5
            })

            createOrderForm1.formData.pay_type_discount = 0
            createOrderForm1.formData.cargo_freight = 0
            createOrderForm2.formField.forEach(i=>{
                createOrderForm2.formData[i.key] = ''
            })
        }

        if(key == 'tax_rate'){
            // console.log(key,'进 税率')
            let item = taxRateOption.value.find(i=>i.value == val)
            orderLineTable.value.datas.forEach(i=>{
                i.tax_rate = item.label
                i.tax_rate_val = item.value
            })
            // console.log(orderLineTable.value.datas,'mm')

            if(createOrderForm1.formData.tax_type == 0){ // 含税，重新计算汇总数据的税额
                let pay_amount = formatterToPoint(createOrderForm2.formData.pay_amount)
                let tax_rate = val
                if(tax_rate != ''){
                    createOrderForm2.formData.order_tax = formatterToComma(Number(multiply(divide(pay_amount,1 + Number(tax_rate)), Number(tax_rate)).toFixed(2)), String(createOrderForm2.formData.order_amount).indexOf('.') != -1)
                    orderLineTable.value.datas.forEach(i=>{
                        i.order_tax = i.pay_amount == ''? '' : formatterToComma(Number(multiply(divide(Number(formatterToPoint(i.pay_amount)), 1 + Number(val)), Number(val)).toFixed(2)), String(createOrderForm2.formData.order_amount).indexOf('.') != -1)
                    })
                }
            }else{// 不含税，重新计算汇总数据的税额、计算行含税金额
                // console.log('计算税率')
                let order_discount = formatterToPoint(createOrderForm2.formData.order_discount)
                let extra_discount = formatterToPoint(createOrderForm2.formData.extra_discount)
                createOrderForm2.formData.order_amount = 0
                order_discount = 0
                extra_discount = 0
                orderLineTable.value.datas.forEach(i=>{
                    i.amount = i.pre_tax_amount == ''? '' : formatterToComma(Number(multiply(Number(formatterToPoint(i.pre_tax_amount)), 1 + Number(val)).toFixed(3)), String(i.pre_tax_amount).indexOf('.') != -1)
                    i.discount = i.pre_tax_discount == ''? '' : formatterToComma(Number(multiply(Number(formatterToPoint(i.pre_tax_discount)), 1 + Number(val)).toFixed(3)), String(i.pre_tax_amount).indexOf('.') != -1)
                    i.extra_discount = i.pre_tax_extra_discount == ''? '' : formatterToComma(Number(multiply(Number(formatterToPoint(i.pre_tax_extra_discount)), 1 + Number(val)).toFixed(3)), String(i.pre_tax_amount).indexOf('.') != -1)
                    i.pay_amount = i.pre_tax_amount == ''? '' : formatterToComma(Number(multiply(Number(formatterToPoint(i.pre_tax_pay_amount)), 1 + Number(val)).toFixed(3)), String(i.pre_tax_amount).indexOf('.') != -1)
                    i.order_tax = i.pay_amount == ''? '' : formatterToComma(multiply(divide(Number(formatterToPoint(i.pay_amount)), 1 + Number(val)), Number(val)).toFixed(2), String(i.pre_tax_amount).indexOf('.') != -1)

                    i.line_order_amount = multiply(Number(formatterToPoint(i.amount)), Number(i.quantity))
                    createOrderForm2.formData.order_amount = formatterToComma(Number(add(Number(formatterToPoint(createOrderForm2.formData.order_amount)), i.line_order_amount).toFixed(2)), String(i.amount).indexOf('.') != -1)
                    order_discount = !!i.discount? add(Number(formatterToPoint(order_discount)), multiply(formatterToPoint(i.discount),i.quantity)) : formatterToPoint(order_discount)
                    extra_discount = !!i.extra_discount? add(Number(formatterToPoint(extra_discount)), multiply(formatterToPoint(i.extra_discount),i.quantity)) : formatterToPoint(extra_discount)
                })
                createOrderForm2.formData.order_discount = formatterToComma(Number(order_discount), String(createOrderForm2.formData.order_amount).indexOf('.') != -1)
                createOrderForm2.formData.extra_discount = formatterToComma(Number(extra_discount), String(createOrderForm2.formData.order_amount).indexOf('.') != -1)
            }

            // 客户信息-语言模板设置
            setLangTemp()

        }

        if(key == 'payment_type' || key == 'payment_type_discount'){
            console.log(val,'payment_type 44444444', isPersonChange.value)
            if(key == 'payment_type'){ 
                if(createOrderForm1.formData.expand_order_source == 5){
                    createOrderForm1.formData.winter_flag = 0 // val == 'SEPA' || val == 'By Invoice'? 1 : 0
                    let winter_flag_item = createOrderForm1.formField.find(i=> i.key == 'winter_flag')
                    console.log(winter_flag_item,'winter_flag_item')
                    let payment_due_date_item = createOrderForm1.formField.find(i=> i.key == 'payment_due_date')
                    let payment_day_item = createOrderForm1.formField.find(i=> i.key == 'payment_day')
                    winter_flag_item.show = true
                    winter_flag_item.disabled = val != 'SEPA' && val != 'By Invoice'
                    payment_due_date_item.show = createOrderForm1.formData.winter_flag == 1 && (val == 'By Invoice' || val == 'SEPA')
                    payment_day_item.show = !payment_due_date_item.show
                    createOrderForm1.formData.payment_due_date = (val == 'SEPA' || val == 'By Invoice') && createOrderForm1.formData.winter_flag == 1? '2026-05-01' : ''
                }

                let source_item = createOrderForm1.formField.find(i=> i.key == 'source')
                let optItem = source_item.options.find(i=> i.value == createOrderForm1.formData.source)
                setDiscountOpt(optItem, isPersonChange.value)
                setDiscountValue(optItem, isPersonChange.value)
            }
            isPersonChange.value = true
            console.log(isPersonChange.value, 'isPersonChange 77777')

            // if(val == ''){
            //     createOrderForm1.formData.payment_type_discount = ''
            //     createOrderForm1.formData.pay_type_discount = 0
            // }else{
            //     let item = paymentTypeOptions.value.find(i=> i.value == val)
            //     createOrderForm1.formData.payment_type_discount = item.paymentTypeDiscount * 100 + '%'
            // }

            // SEPA支付方式，则支付折扣 = (订单总金额（含税）- 订单折扣)/(1 + 税率) * 0.02， 
            // DZB支付方式，则支付折扣1 = (订单总金额（含税）- 订单折扣)/(1 + 税率) * 0.01,
            // 其他支付方式，支付折扣 = 订单总金额（含税）* 0
            // 最新规则20250522：所有支付方式，计算支付折扣 = (订单总金额（含税）- 订单折扣)/(1 + 税率) * 支付折扣比例
            let discount_rate = createOrderForm1.formData.payment_type_discount // createOrderForm1.formData.payment_type == 'SEPA'? 0.02 : createOrderForm1.formData.payment_type == 'DZB'? 0.01 : 0
            console.log(discount_rate, 'discount_rate wwwww', createOrderForm1.formData.order_channel_type_val)
            let pre_tax_pay_amount_total = divide(subtract(formatterToPoint(createOrderForm2.formData.order_amount),formatterToPoint(createOrderForm2.formData.order_discount)),1+Number(createOrderForm1.formData.tax_rate))
            let pre_tax_pay_amount_total_new = createOrderForm1.formData.order_channel_type == 5? add(multiply(pre_tax_pay_amount_total, 0.05), pre_tax_pay_amount_total) : pre_tax_pay_amount_total

            console.log(pre_tax_pay_amount_total_new, 'pre_tax_pay_amount_total_new')
            createOrderForm1.formData.pay_type_discount = formatterToComma(multiply(pre_tax_pay_amount_total_new, discount_rate).toFixed(2), String(createOrderForm2.formData.order_amount).indexOf('.') != -1)
            // if(val == 'SEPA' && createOrderForm2.formData.order_amount !== ''){
            //     createOrderForm1.formData.pay_type_discount = formatterToComma(multiply(pre_tax_pay_amount_total_new, discount_rate).toFixed(2), String(createOrderForm2.formData.order_amount).indexOf('.') != -1)
            // }else if(val == 'DZB' && createOrderForm2.formData.order_amount !== ''){
            //     createOrderForm1.formData.pay_type_discount = formatterToComma(multiply(pre_tax_pay_amount_total_new, discount_rate).toFixed(2), String(createOrderForm2.formData.order_amount).indexOf('.') != -1)
            // }else{
            //     createOrderForm1.formData.pay_type_discount = 0
            // }

            let pay_type_discount = multiply(formatterToPoint(createOrderForm1.formData.pay_type_discount), 1 + Number(createOrderForm1.formData.tax_rate))
            createOrderForm2.formData.total_payment_discount = formatterToComma(add(pay_type_discount, 0).toFixed(2), String(createOrderForm2.formData.order_amount).indexOf('.') != -1)

            let order_amount = formatterToPoint(createOrderForm2.formData.order_amount)
            let order_discount = formatterToPoint(createOrderForm2.formData.order_discount)
            let extra_discount = formatterToPoint(createOrderForm2.formData.extra_discount)
            let cargo_freight = formatterToPoint(createOrderForm1.formData.cargo_freight)   

            let c2c_extra_amount = 0
            createOrderForm2.formData.c2c_extra_amount = 0
            if(createOrderForm1.formData.order_channel_type == 5){
                createOrderForm2.formData.c2c_extra_amount = multiply(subtract(order_amount, order_discount), 0.05).toFixed(2)
                c2c_extra_amount = createOrderForm2.formData.c2c_extra_amount
            }

            if(cargo_freight !== ''){
                cargo_freight = createOrderForm1.formData.tax_type == 1? multiply(cargo_freight, 1 + Number(createOrderForm1.formData.tax_rate)) : cargo_freight
            }
            if(!!order_discount && !!extra_discount && cargo_freight !== ''){
                createOrderForm2.formData.pay_amount = Number(subtract(add(order_amount,c2c_extra_amount), subtract(add(add(order_discount,extra_discount), formatterToPoint(createOrderForm2.formData.total_payment_discount)),cargo_freight)).toFixed(2))
                createOrderForm2.formData.pay_amount = formatterToComma(Number(createOrderForm2.formData.pay_amount), String(createOrderForm2.formData.order_amount).indexOf('.') != -1)
            }


            if(createOrderForm1.formData.payment_type == 'By Invoice'){
                set14discount()
            }else{
                createOrderForm2.formData.pay_with_days_discount = 0
            }
        }

        if(key == 'winter_flag'){
            if(createOrderForm1.formData.expand_order_source == 5){
                let payment_due_date_item = createOrderForm1.formField.find(i=> i.key == 'payment_due_date')
                let payment_day_item = createOrderForm1.formField.find(i=> i.key == 'payment_day')
                payment_due_date_item.show = val == 1 && (createOrderForm1.formData.payment_type == 'By Invoice' || createOrderForm1.formData.payment_type == 'SEPA')
                payment_day_item.show = !payment_due_date_item.show
                
                createOrderForm1.formData.payment_due_date = val == 1 && (createOrderForm1.formData.payment_type == 'By Invoice' || createOrderForm1.formData.payment_type == 'SEPA')? '2026-05-01' : ''
                if(val == 1 && (createOrderForm1.formData.payment_type == 'By Invoice' || createOrderForm1.formData.payment_type == 'SEPA')){
                    createOrderForm1.formData.payment_day = ''
                }
                else if(val == 0 && (createOrderForm1.formData.payment_type == 'By Invoice' || createOrderForm1.formData.payment_type == 'SEPA')){
                    // let item = createOrderForm1.formField.find(i=> i.key == 'source')
                    // let optItem = item.options.find(i=> i.value == createOrderForm1.formData.source)
                    // console.log(optItem, 'paymmmmmm ')
                    createOrderForm1.formData.payment_day = pay_day_opt.value[0].value
                }
            }
        }

        if(key == 'pay_with_days_discount_rate'){
            console.log(val, '现金折扣')
            if(createOrderForm1.formData.payment_type == 'By Invoice'){
                set14discount()
            }else{
                createOrderForm2.formData.pay_with_days_discount = 0
            }
        }
    }

    // 创建订单-基本信息相关input
    const handleInputChange = (item,val)=>{
        // console.log(item,val,'item,val11111111111', createOrderForm1.formData.order_channel_type)
        if(!val && item.key == 'cargo_freight'){
            createOrderForm1.formData.cargo_freight = 0
        }

        
        if(item.key == 'order_name'){ // 区分 2C订单 和 2B订单
            let source_arr = [3,5,6,12,82,170]
            let reg = history.state.fromPage != 'DealerBusinessOrder' && history.state.fromPage != 'B2BShopOrder' && createOrderForm1.formData.order_channel_type != 1 && !source_arr.includes(createOrderForm1.formData.source)
                    ? /^[A-NP-Za-np-z0-9#-_]{6,50}$/
                    : /^[A-Za-z0-9#-_]{6,50}$/
                    
            let bool = reg.test(createOrderForm1.formData.order_name)
            // console.log(bool,'bool')

            if(!bool){
                Modal.warning({
                    title: t('base.tip'),
                    titleAlign:'start',
                    hideCancel:true,
                    width:500,
                    content: history.state.fromPage != 'DealerBusinessOrder' && history.state.fromPage != 'B2BShopOrder' && createOrderForm1.formData.order_channel_type != 1? t('order.orderNameRuleTip') : t('order.orderNameRuleTip2'),
                    okText:t('base.ok'),
                    cancelText:t('base.cancel'),
                    onOk:()=>{}
                })
            }
        }
    }

    // 创建订单-基本信息相关InputNumber
    const handleInput = (item,val)=>{
        // console.log(item,val,'item,val 33333333')

        if(item.key == 'order_name'){
            // console.log(history.state.fromPage,'history.state.fromPage') 
            let source_arr = [3,5,6,12,82,170] // 亚马逊(seller 和 vendor)，官网，jobrad, Deutsche Dienstrad, businessbike,bikeleasing不设置
            if(history.state.fromPage == 'DealerBusinessOrder' || history.state.fromPage == 'B2BShopOrder' || createOrderForm1.formData.order_channel_type == 1 ){ // 2B订单
                createOrderForm1.formData.order_name = val.replace(/[o!@$%&*?+=(){};:|^""<>'',.\s+]*/g, '');
            }else if(source_arr.includes(createOrderForm1.formData.source)){ // 2C订单 排除这几个渠道来源
                createOrderForm1.formData.order_name = val.replace(/[!@$%&*?+=(){}_;:|^""<>'',.\s+]*/g, '');
            }else{ // 2C订单
                createOrderForm1.formData.order_name = val.replace(/[Oo!@$%&*?+=(){}_;:|^""<>'',.\s+]*/g, '');
            }
        }
        if(item.key == 'pay_type_discount' || item.key == 'cargo_freight'){
            // 计算汇总-支付金额   SEPA：支付金额 = 订单总金额-订单折扣-额外折扣-支付折扣+运费  DZB：支付金额 = 订单总金额-订单折扣-额外折扣-支付折扣1-支付折扣2+运费
            let order_amount = formatterToPoint(createOrderForm2.formData.order_amount)
            let order_discount = formatterToPoint(createOrderForm2.formData.order_discount)
            let order_extrar_discount = formatterToPoint(createOrderForm2.formData.extra_discount)

            let c2c_extra_amount = 0
            createOrderForm2.formData.c2c_extra_amount = 0
            if(createOrderForm1.formData.order_channel_type == 5){
                createOrderForm2.formData.c2c_extra_amount = multiply(subtract(order_amount, order_discount), 0.05).toFixed(2)
                c2c_extra_amount = createOrderForm2.formData.c2c_extra_amount
            }

            let pay_type_discount = 0,
                cargo_freight = 0,
                pre_tax_pay_amount_total = divide(subtract(formatterToPoint(createOrderForm2.formData.order_amount),formatterToPoint(createOrderForm2.formData.order_discount)),1+Number(createOrderForm1.formData.tax_rate)) 

            if(item.key == 'pay_type_discount'){
                if(val !== ''){
                    pay_type_discount = createOrderForm1.formData.tax_type == 1? multiply(formatterToPoint(val), 1 + Number(createOrderForm1.formData.tax_rate)) : formatterToPoint(val)
                    pay_type_discount = formatterToComma(Number(pay_type_discount), String(createOrderForm2.formData.order_amount).indexOf('.') != -1)
                }

                cargo_freight = createOrderForm1.formData.tax_type == 1
                            ? multiply(formatterToPoint(createOrderForm1.formData.cargo_freight), 1 + Number(createOrderForm1.formData.tax_rate)) 
                            : formatterToPoint(createOrderForm1.formData.cargo_freight)

                cargo_freight = formatterToComma(Number(cargo_freight), String(createOrderForm2.formData.order_amount).indexOf('.') != -1)
            }
            if(item.key == 'cargo_freight'){
                console.log('运费')
                if(val !== ''){
                    cargo_freight = createOrderForm1.formData.tax_type == 1? multiply(formatterToPoint(val), 1 + Number(createOrderForm1.formData.tax_rate)) : formatterToPoint(val)
                    cargo_freight = formatterToComma(Number(cargo_freight), String(createOrderForm2.formData.order_amount).indexOf('.') != -1)
                }

                pay_type_discount = createOrderForm1.formData.tax_type == 1
                                ? multiply(formatterToPoint(createOrderForm1.formData.pay_type_discount), 1 + Number(createOrderForm1.formData.tax_rate)) 
                                : formatterToPoint(createOrderForm1.formData.pay_type_discount)

                pay_type_discount = formatterToComma(Number(pay_type_discount), String(createOrderForm2.formData.order_amount).indexOf('.') != -1)
            }

            createOrderForm2.formData.total_payment_discount = formatterToComma(add(formatterToPoint(pay_type_discount), 0).toFixed(2), String(createOrderForm2.formData.order_amount).indexOf('.') != -1)
            if(createOrderForm1.formData.order_channel_type == 1 || createOrderForm1.formData.order_channel_type == 5){
                createOrderForm2.formData.total_freight = formatterToComma(multiply(formatterToPoint(createOrderForm1.formData.cargo_freight), 1 + Number(createOrderForm1.formData.tax_rate)).toFixed(2), String(createOrderForm2.formData.order_amount).indexOf('.') != -1)
            }else if(createOrderForm1.formData.order_channel_type == 0){
                createOrderForm2.formData.total_freight = formatterToComma(createOrderForm1.formData.cargo_freight, String(createOrderForm2.formData.order_amount).indexOf('.') != -1)
            }
            
            
            if(!!order_amount && !!order_discount && !!order_extrar_discount){
                createOrderForm2.formData.pay_amount = Number(subtract(add(order_amount,c2c_extra_amount), subtract(add(add(order_discount, order_extrar_discount), formatterToPoint(createOrderForm2.formData.total_payment_discount)), formatterToPoint(cargo_freight))).toFixed(2))
            }else if(!!order_amount && !!order_discount && !order_extrar_discount){
                createOrderForm2.formData.pay_amount = Number(subtract(add(order_amount,c2c_extra_amount), subtract(add(order_discount, formatterToPoint(createOrderForm2.formData.total_payment_discount)), formatterToPoint(cargo_freight))).toFixed(2))
            }else if(!!order_amount && !order_discount && !!order_extrar_discount){
                createOrderForm2.formData.pay_amount = Number(subtract(add(order_amount,c2c_extra_amount), subtract(add(order_extrar_discount, formatterToPoint(createOrderForm2.formData.total_payment_discount)), formatterToPoint(cargo_freight))).toFixed(2))
            }else if(!!order_amount && !order_discount && !order_extrar_discount){
                createOrderForm2.formData.pay_amount = Number(subtract(add(order_amount,c2c_extra_amount), subtract(formatterToPoint(createOrderForm2.formData.total_payment_discount), formatterToPoint(cargo_freight))).toFixed(2))
            }

            createOrderForm2.formData.pay_amount = formatterToComma(Number(createOrderForm2.formData.pay_amount), String(createOrderForm2.formData.order_amount).indexOf('.') != -1)
            
            if(createOrderForm1.formData.payment_type == 'By Invoice'){
                set14discount()
            }else{
                createOrderForm2.formData.pay_with_days_discount = 0
            }
        }
        if(item.key == 'cargo_freight'){
            createOrderForm1.formData.cargo_freight = val.replace(/-/g, '')
        }
    }
    
    // 创建订单-客户信息相关select
    const handleCreateOrderSelectChange3 = async(val, opt, key, row)=>{
        console.log(val,opt,key,'客户信息')
        
        if(key == 'customer_entity_id'){
            if(val == ''){
                createOrderForm3.formData.customer_id = ''
                createOrderForm3.formData.customer_invoice_id = ''
                createOrderForm3.formData.customer_email = ''
                createOrderForm3.formData.customer_name = ''
                createOrderForm3.formData.customer_type = ''
                createOrderForm3.formData.country  = ''
                return
            }

            // 带出发货地址和发票地址
            await getCustomerAddressList()
            let itemArr = customerAddressList.value.filter(i=>{
                if(i.customer_entity_id == val) return i
            })
            console.log(itemArr,'itemArr')
            
            let item = customerList.value.find(i=> i.id == val)
            createOrderForm3.formData.customer_email = val !== ''? item.email : ''
            createOrderForm3.formData.customer_name = val !== ''? item.name : ''
            createOrderForm3.formData.customer_type = val !== ''? item.type : ''

            if(history.state.fromPage != 'B2BShopOrder'){
                let opt1 = itemArr.find(i=> i.first_flag == 1 && i.address_type == 0)
                let opt1_no_first = itemArr.find(i=> !i.first_flag && i.address_type == 0)
                let opt2 = itemArr.find(i=> i.first_flag == 1 && i.address_type == 1)
                let opt2_no_first = itemArr.find(i=> !i.first_flag && i.address_type == 1)
                console.log(opt1, 'opt1' , opt1_no_first)
                
                createOrderForm3.formData.customer_id = val == ''? '' : opt1? opt1.id : opt1_no_first? opt1_no_first.id : ''
                createOrderForm3.formData.customer_invoice_id = val == ''? '' : opt2? opt2.id : opt2_no_first? opt2_no_first.id : opt1_no_first.id
                createOrderForm3.formData.country = val == ''? '' : opt2? opt2.country : opt2_no_first? opt2_no_first.country : opt1? opt1.country : opt1_no_first? opt1_no_first.country : ''
            
                if(history.state.fromPage != 'DealerBusinessOrder'){
                    createOrderForm3.formData.order_confirm_mail = val == ''? '' : opt1? opt1.order_confirm_mail : opt1_no_first? opt1_no_first.order_confirm_mail : ''
                }else{
                    createOrderForm3.formData.order_confirm_mail = ''
                }
            }else{
                console.log(row,'row', row.customer_id, row.customer_invoice_id)
                createOrderForm3.formData.customer_id = row.customer_id
                createOrderForm3.formData.customer_invoice_id = row.customer_invoice_id
                createOrderForm3.formData.country = row.country
                createOrderForm3.formData.order_confirm_mail = row.customer_email
            }

            if(createOrderForm1.formData.expand_order_source == 5){
                let country = createOrderForm3.formData.country
                if(country == 'Germany' || country == 'Austria' || country == 'Italy'){
                    createOrderForm1.formData.pay_with_days_discount_rate = '0.03'
                    createOrderForm1.formData.pay_with_days_day = '14'
                }else{
                    createOrderForm1.formData.pay_with_days_discount_rate = '0.03'
                    createOrderForm1.formData.pay_with_days_day = '30'
                }
            }

            // console.log(createOrderForm3.formData.country, 'country 777888')
            let country = createOrderForm3.formData.country
            if(country != 'Germany' && country != 'Austria' && createOrderForm1.formData.delivery_timeliness == 1){
                Modal.warning({
                    title: t('base.tip'),
                    content: t('order.deliveryTimelinessTipContent'),
                    okText: t('base.ok'),
                    onOk: () => {
                        // createOrderForm1.formData.delivery_timeliness = 1
                    }
                })
            }


            // 设置语言模板
            setLangTemp()

        }
        if(key == 'customer_id'){
            createOrderForm3.formData.customer_id = val
            let opt = customerAddressList.value.find(i=> i.id == val)
            if(history.state.fromPage != 'DealerBusinessOrder'){
                createOrderForm3.formData.order_confirm_mail = val == ''? '' : opt? opt.order_confirm_mail : ''
            }
        }
        if(key == 'customer_invoice_id'){
            createOrderForm3.formData.customer_invoice_id = val
            let opt2 = customerAddressList.value.find(i=> i.id == val)
            createOrderForm3.formData.country = val == ''? '' : opt2? opt2.country : ''
        }
        if(key == 'customer_entity_id' || key == 'customer_invoice_id'){
            // 2C订单: 如果税率不为0时，根据国家带出税率, 税率为0时，则不用
            if(createOrderForm1.formData.order_channel_type == 0 && val != ''){
                if(createOrderForm1.formData.tax_rate != '0.00' && createOrderForm3.formData.country == 'Italy'){
                    createOrderForm1.formData.tax_rate = '0.22'
                    handleCreateOrderSelectChange('0.22',undefined,'tax_rate')
                }else if(createOrderForm1.formData.tax_rate != '0.00' &&  (createOrderForm3.formData.country == 'France' || createOrderForm3.formData.country == 'Austria')){
                    createOrderForm1.formData.tax_rate = '0.20'
                    handleCreateOrderSelectChange('0.20',undefined,'tax_rate')
                }else if(createOrderForm1.formData.tax_rate != '0.00' &&  (createOrderForm3.formData.country == 'Germany' || createOrderForm3.formData.country == '')){
                    createOrderForm1.formData.tax_rate = '0.19'
                    handleCreateOrderSelectChange('0.19',undefined,'tax_rate')
                }
            }
        }
    }

    // 创建订单-客户信息相关input
    const handleInputChange3 = (item,val)=>{
        // console.log(item,val, 'item,val 333333')
        if(item.key == 'order_confirm_mail'){
            let reg = /^[_A-Za-z0-9-\+]+(\.[_A-Za-z0-9-]+)*@[A-Za-z0-9-]+(\.[A-Za-z0-9]+)*(\.[A-Za-z]{2,})$/
            if(!reg.test(val)){
                Message.error(t('order.emailFormatTip'))
                return
            }
        }
    }

    // 设置支付折扣，现金折扣，账期下拉配置
    const setDiscountOpt = (optItem, bool)=>{
            let payment = !bool? optItem.payment : createOrderForm1.formData.payment_type
            // console.log(optItem.payment,'手到 optItem.payment')

            let formItem3 = createOrderForm1.formField.find(i=> i.key == 'payment_type_discount')
            let formItem4 = createOrderForm1.formField.find(i=> i.key == 'pay_with_days_discount_rate')
            let formItem5 = createOrderForm1.formField.find(i=> i.key == 'payment_day')
            formItem3.disabled = !(createOrderForm1.formData.order_channel_type == 1 || createOrderForm1.formData.order_channel_type == 5)
            formItem4.disabled = !((createOrderForm1.formData.order_channel_type == 1 || createOrderForm1.formData.order_channel_type == 5) && createOrderForm1.formData.payment_type == 'By Invoice')
            formItem5.disabled = !(createOrderForm1.formData.order_channel_type == 1 || createOrderForm1.formData.order_channel_type == 5)

            formItem3.options = [], formItem4.options = [], formItem5.options = []

            // console.log(optItem, 'optItem.payment 9999988888')
            pay_discount_arr.value.forEach(i=> {
                if(i.dict_sub_name == createOrderForm1.formData.payment_type){
                    formItem3.options.push({
                        label: `${Number(i.dict_sub_value) * 100}%`,
                        value: i.dict_sub_value == '0.00'? '0' : i.dict_sub_value
                    })
                    pay_discount_opt.value = formItem3.options
                }
            })
            cash_discount_arr.value.forEach(i=> {
                if(i.dict_sub_name == createOrderForm1.formData.payment_type){
                    formItem4.options.push({
                        label: `${Number(i.dict_sub_value) * 100}%`,
                        value: i.dict_sub_value == '0.00'? '0' : i.dict_sub_value
                    })
                    cash_discount_opt.value = formItem4.options
                }
            })
            pay_day_arr.value.forEach(i=> {
                if(i.dict_sub_name == createOrderForm1.formData.payment_type){
                    formItem5.options.push({
                        label: i.dict_sub_value,
                        value: i.dict_sub_value,
                    })
                    pay_day_opt.value = formItem5.options
                }
            })

            // console.log(formItem3.options, formItem4.options, formItem5.options,'渠道 支付方式，下拉')
    }

    const setDiscountValue = (optItem, bool)=>{
        // 支付方式根据channel获取，不可修改
        // console.log(optItem,bool, !bool, '变更渠道', createOrderForm1.formData.payment_day, isPersonChange.value)
            if(!bool){
                // console.log(optItem, 'optItem.payment 不可修改不可修改',createOrderForm1.formData)
                // console.log(pay_discount_opt.value, cash_discount_opt.value, pay_day_opt.value,'渠道 B2B')
                if(createOrderForm1.formData.order_channel_type == 1 || createOrderForm1.formData.order_channel_type == 5){
                    createOrderForm1.formData.payment_type = optItem.payment
                    createOrderForm1.formData.payment_type_discount = optItem.payment_type_discount == ''? pay_discount_opt.value[0].value : optItem.payment_type_discount
                    createOrderForm1.formData.pay_with_days_discount_rate = `${optItem.payment_with_days_discount}`
                    createOrderForm1.formData.payment_day = optItem.payment_day

                    if(createOrderForm1.formData.expand_order_source == 5 && createOrderForm1.formData.payment_type == 'By Invoice' && createOrderForm1.formData.winter_flag == 1){
                        let country= createOrderForm3.formData.country
                        if(country == 'Germany' || country == 'Austria' || country == 'Italy'){
                            createOrderForm1.formData.pay_with_days_discount_rate = '0.03'
                            createOrderForm1.formData.pay_with_days_day = '14'
                        }else{
                            createOrderForm1.formData.pay_with_days_discount_rate = '0.03'
                            createOrderForm1.formData.pay_with_days_day = '30'
                        }
                    }
                }else{
                    createOrderForm1.formData.payment_type_discount = 0
                    createOrderForm1.formData.pay_with_days_discount_rate = 0
                    createOrderForm1.formData.payment_day = 0
                }
                // console.log(createOrderForm1.formData.payment_day, optItem.payment_day, isPersonChange.value,'payment_day 不可修改bbbbbbbbb')
            }else{
                // 手动变更支付方式
                // console.log(pay_discount_opt.value[0], cash_discount_opt.value[0], pay_day_opt.value[0],'手动变更支付方式', createOrderForm1.formData.payment_day, isPersonChange.value)
                createOrderForm1.formData.payment_type_discount = pay_discount_opt.value[0].value
                if(createOrderForm1.formData.payment_type == 'By Invoice'){
                    if(createOrderForm1.formData.expand_order_source == 5 && createOrderForm1.formData.winter_flag == 1){
                        let country= createOrderForm3.formData.country
                        if(country == 'Germany' || country == 'Austria' || country == 'Italy'){
                            createOrderForm1.formData.pay_with_days_discount_rate = '0.03'
                            createOrderForm1.formData.pay_with_days_day = '14'
                        }else{
                            createOrderForm1.formData.pay_with_days_discount_rate = '0.03'
                            createOrderForm1.formData.pay_with_days_day = '30'
                        } 
                    }else{
                        createOrderForm1.formData.pay_with_days_discount_rate = '0.01' // cash_discount_opt.value[0].value
                    }
                }else {
                    createOrderForm1.formData.pay_with_days_discount_rate = '0'
                    createOrderForm1.formData.pay_with_days_day = '14'
                }
                createOrderForm1.formData.payment_day = pay_day_opt.value[0].value
            }

            // DZB方式，税率不能选0%
            let form_item = createOrderForm1.formField.find(i=>i.key == 'tax_rate')
            let tax_rate_item = form_item.options.find(i=>i.value == '0.00')
            tax_rate_item.disabled = createOrderForm1.formData.payment_type == 'DZB'
    }

    // 设置客户信息-语言模板
    const setLangTemp = async ()=>{
        country_info.value = await getEUFlagLang(createOrderForm3.formData.country)
        let form_item = createOrderForm3.formField.find(i=> i.key == 'file_lang_code')
        // console.log(createOrderForm1.formData.tax_rate, country_info.value.eu_flag, '设置语言模板')
        form_item.disabled = !(createOrderForm1.formData.tax_rate == '0.00' && country_info.value.eu_flag == 1)
        // console.log(country_info.value,'country_info', createOrderForm1.formData.tax_rate)

        if(createOrderForm1.formData.tax_rate == '0.00' && country_info.value.eu_flag == 0){ // 0税 & 非欧盟国：EN
            createOrderForm3.formData.file_lang_code = 'EN'
        }else if(createOrderForm1.formData.tax_rate == '0.00' && country_info.value.eu_flag == 1){ // 0税 & 欧盟国：默认EN，可选DE；奥地利默认DE, 可选EN
            if(createOrderForm3.formData.country == 'Austria'){
                createOrderForm3.formData.file_lang_code = 'DE'
            }else{
                createOrderForm3.formData.file_lang_code = 'EN'
            }
        }else if(createOrderForm1.formData.tax_rate != '0.00'){ // 非0税：DE
            createOrderForm3.formData.file_lang_code = 'DE'
        }
    }

    // 新增客户-select
    const handleAddCustomerSelectChange = async (val, opt, key)=>{
        console.log(val, opt, key,'val, opt, key')
        if(key == 'source'){
            const item = addBaseInfoForm.formField.find(i=> i.key == 'source')
            const optItem = item.options.find(i=> i.value == val)
            console.log(optItem,'optItem')
            addBaseInfoForm.formData.erp_code = optItem.code
            addBaseInfoForm.formData.type = optItem.type

            const email_service_flag_item = addBaseInfoForm.formField.find(i=> i.key == 'email_service_flag')
            email_service_flag_item.required = val == 10
            email_service_flag_item.show = val == 10
            addBaseInfoForm.formData.email_service_flag = ''

            const email_item = addBaseInfoForm.formField.find(i=> i.key == 'email')
            email_item.disabled = val == 10
            addBaseInfoForm.formData.email = ''

            const email_item2 = addAddressInfoForm.formField.find(i=> i.key == 'email')
            email_item2.disabled = val == 10
            addAddressInfoForm.formData.email = ''

            const email_item3 = addInvoiceAddressForm.formField.find(i=> i.key == 'email')
            email_item3.disabled = val == 10
            addInvoiceAddressForm.formData.email = ''

            if(val == 10){
                let address_info = JSON.parse(await getDefaultAddress())
                addAddressInfoForm.formData.email = address_info.email
                addAddressInfoForm.formData.phone = address_info.phone
                addAddressInfoForm.formData.zip = address_info.zip
                addAddressInfoForm.formData.country = address_info.country
                addAddressInfoForm.formData.country_code = address_info.country_code
                addAddressInfoForm.formData.state = address_info.state
                addAddressInfoForm.formData.city = address_info.city
                addAddressInfoForm.formData.address = address_info.address
            }else{
                addAddressInfoForm.formData.email = ''
                addAddressInfoForm.formData.phone = ''
                addAddressInfoForm.formData.zip = ''
                addAddressInfoForm.formData.country = ''
                addAddressInfoForm.formData.country_code = ''
                addAddressInfoForm.formData.state = ''
                addAddressInfoForm.formData.city = ''
                addAddressInfoForm.formData.address = ''
            }
        }
        if(key == 'country'){
           const item = addBaseInfoForm.formField.find(i=> i.key == 'country')
           const optItem = item.options.find(i=> i.value == val)
           addBaseInfoForm.formData.country_code = optItem.code
        }
    }

    const changeRadio = (key)=>{
        if(key == 'email_service_flag'){
            const email_item = addBaseInfoForm.formField.find(i=> i.key == 'email')
            email_item.disabled = addBaseInfoForm.formData.email_service_flag == 'NO'
            addBaseInfoForm.formData.email = addBaseInfoForm.formData.email_service_flag == 'NO'? 'service@hepha.com' : ''

            const email_item2 = addAddressInfoForm.formField.find(i=> i.key == 'email')
            email_item2.disabled = addBaseInfoForm.formData.email_service_flag == 'NO'
            addAddressInfoForm.formData.email = addBaseInfoForm.formData.email_service_flag == 'NO'? 'service@hepha.com' : ''
        
            const email_item3 = addInvoiceAddressForm.formField.find(i=> i.key == 'email')
            email_item3.disabled = addBaseInfoForm.formData.email_service_flag == 'NO'
            addInvoiceAddressForm.formData.email = addBaseInfoForm.formData.email_service_flag == 'NO'? 'service@hepha.com' : ''
        }
    }

    // 勾选复选框
    const changeCheck = ()=>{
        console.log(checked.value,'ck')
        if(checked.value){
            const email_item = addInvoiceAddressForm.formField.find(i=> i.key == 'email')
            email_item.disabled = addBaseInfoForm.formData.email_service_flag == 'NO'
            addInvoiceAddressForm.formData.email = addBaseInfoForm.formData.email_service_flag == 'NO'? 'service@hepha.com' : ''
        }else{
            const email_item = addInvoiceAddressForm.formField.find(i=> i.key == 'email')
            email_item.disabled = false
            addInvoiceAddressForm.formData.email = ''
        }
    }

    // 新增地址-select
    const handleAddCustomerSelectChange2 = (val, opt, key)=>{
        console.log(val, opt, key,'val, opt, key')
        if(key == 'country'){
           const item = addAddressInfoForm.formField.find(i=> i.key == 'country')
           const optItem = item.options.find(i=> i.value == val)
           addAddressInfoForm.formData.country_code = optItem.code
        }
    }

    const handleAddCustomerInputChange2 = (item, val)=>{
        if(item.key == 'street'){
            addAddressInfoForm.formData.address = !addAddressInfoForm.formData.house_number? val : `${val} ${addAddressInfoForm.formData.house_number}`
            let house_number_item = addAddressInfoForm.formField.find(i=> i.key == 'house_number')
            house_number_item.disabled = false
        }
        if(item.key == 'house_number'){
            addAddressInfoForm.formData.address = `${addAddressInfoForm.formData.street} ${val}`
        }
    }

    const handleAddCustomerInputChange3 = (item, val)=>{
        if(item.key == 'street'){
            addInvoiceAddressForm.formData.address = !addInvoiceAddressForm.formData.house_number? val : `${val} ${addInvoiceAddressForm.formData.house_number}`
            let house_number_item = addInvoiceAddressForm.formField.find(i=> i.key == 'house_number')
            house_number_item.disabled = false
        }
        if(item.key == 'house_number'){
            addInvoiceAddressForm.formData.address = `${addInvoiceAddressForm.formData.street} ${val}`
        }
    }

    const handleAddCustomerInputClear2 = (val, item)=>{
        if(item.key == 'street'){
            addAddressInfoForm.formData.address = addAddressInfoForm.formData.house_number
            let house_number_item = addAddressInfoForm.formField.find(i=> i.key == 'house_number')
            house_number_item.disabled = true
        }
        if(item.key == 'house_number'){
            addAddressInfoForm.formData.address = addAddressInfoForm.formData.street
        }
    }

    const handleAddCustomerInputClear3 = (val, item)=>{
        if(item.key == 'street'){
            addInvoiceAddressForm.formData.address = addInvoiceAddressForm.formData.house_number
            let house_number_item = addInvoiceAddressForm.formField.find(i=> i.key == 'house_number')
            house_number_item.disabled = true
        }
        if(item.key == 'house_number'){
            addInvoiceAddressForm.formData.address = addInvoiceAddressForm.formData.street
        }
    }

    // 创建订单-选择订单行发货日期
    const onOkHandleTimestamp = (val,row)=>{
        let order_ship_timestamp = dateToTimestamp(val)
        let order_earliest_ship_timestamp = dateToTimestamp(createOrderForm1.formData.earliest_ship_timestamp)
        if(!!createOrderForm1.formData.earliest_ship_timestamp && order_ship_timestamp < order_earliest_ship_timestamp){
             Modal.warning({
                title: t('base.tip'),
                titleAlign:'start',
                width:600,
                content:t('order.shipDateTip'),
                hideCancel:true,
                okText:t('base.ok'),
                onOk:()=>{
                    row.handle_timestamp = ''
                },
             })
        }
    }

    // 新增发票地址-select
    const handleAddCustomerSelectChange3 = (val, opt, key)=>{
        // console.log(val, opt, key,'val, opt, key')
        if(key == 'country'){
           const item = addInvoiceAddressForm.formField.find(i=> i.key == 'country')
           const optItem = item.options.find(i=> i.value == val)
           addInvoiceAddressForm.formData.country_code = optItem.code
        }
    }

    const selectRowCancel = (val)=>{
        // console.log(val,'mmmm')
        rowData.value.selected = val
    }

    const selectAllRowCancel = (val)=>{
        // console.log(val,'kkkkk')
        rowData.value.selected = val
    }

    const onCancelSOBeforeOk = ()=>{
        // console.log(rowData.value,'sss')
        if(isFinance.value){
            if (rowData.value.selected && rowData.value.selected.length == 0) {
                Message.error(t('base.selectData'))
                return false
            }  
        }else{
            cancelSOTable.value.datas.forEach(i=>{
                if(!i.disabled){
                    cancelSOTableRef.value.selectedKeys.push(i.id)
                    cancelSOTableRef.value.selectedData.push(i.id)
                    rowData.value.selected.push(i)
                }
            })
        }
        
        return true
    }

    // 确认取消SO
    const handleCancelSO = ()=>{
        Modal.warning({
            title: t('base.tip'),
            titleAlign: 'start',
            hideCancel: false,
            content: t('order.cancelConfirmTip'),
            okText: t('base.ok'),
            cancelText: t('base.cancel'),
            onOk: () => {
                cancelSO(rowData.value)
            }
        });
    }

    // 取消操作
    const handleCancel = ()=>{
        cancelSOTableRef.value.selectedKeys = []
        cancelSOTableRef.value.selectedData = []
        orderTableRef.value.expandedKeys = []
        orderTableRef.value.selectedKeys = []
    }

    // 移除小数点
    const formatter = (value)=> {
      return String(value).replace(/\./g, '')
    }

    // 解析时再次移除小数点
    const parser = (value) => { 
      return value.replace(/\./g, '')
    }

    // const productQuantityChange = (val,row)=>{
    //     // console.log(val,'rrrooo')
    //     val = val.replace(/[^\d]/g, "")
    //     if(val > row.quantity){
    //         row.error = true
    //         Message.error(t('order.productQuantityErrorTip'))
    //         return
    //     }else{
    //         row.error = false
    //     }
    // }

    // 同步订单到erp时，设置订单行的生产数量
    // const saveProductQty = async ()=>{
    //     let param = erpsyncTable.value.datas.map(i=>{
    //         return {
    //             line_id:i.id,
    //             produce_quantity:i.produce_quantity
    //         }
    //     })
    //     let res = await OrderApi.getInstance().updateProduce(param)
    //     if(res.code == 0){
    //         rowData.value.isSaveProductQty = false
    //         Message.success(t('base.saveSuccess'))
    //     }else{
    //         Message.error(res.msg)
    //     }
    // }

    // 同步订单到ERP
    const syncToERP = async (row)=>{
        table.value.configs.loading = true
        let res = await OrderApi.getInstance().syncToERP(row.id)
        if(res.code == 0){
            Message.success(t('base.syncSuccess'))
            erpsyncVisible.value = false
            getOrderHead()
            table.value.configs.loading = false
        }else{
            Message.error(res.msg)
        }
    }

    // so取消
    const cancelSO = async (row)=>{
        // console.log(row,'row')
        let arr = [],  cancelArr = []
        // 勾选的行
        row.selected.forEach(i=>{
            if(!i.disabled){
                arr.push({
                    org_id:'203',
                    order_id:i.order_id,
                    erp_no:i.erp_no,
                    order_line_id:i.id,
                    erp_line_no:i.erp_line_no,
                    quantity: i.ship_quantity == '-'? i.quantity : i.quantity - i.ship_quantity,
                    validity_quantity: i.ship_quantity == '-'? 0 : i.ship_quantity,
                    type:'CANCEL',
                    status:'0',
                })
            }
        })
        // console.log(arr,'arr')
        // 未勾选的行
        let all_flag = row.selected.length == cancelSOTableDataLength.value? 1 : 0     // 1:全选   0：部分勾选
        let res = await OrderApi.getInstance().cancelSO(arr, row.id, all_flag)
        if(res.code == 0){
            Message.success(t('base.cancelSuccess'))
            cancelSOTableRef.value.selectedKeys = []
            cancelSOTableRef.value.selectedData = []
            cancelSOVisible.value = false
            getOrderHead()
        }else{
            Modal.error({
                title: t('base.tip'),
                titleAlign: 'start',
                content: res.msg,
                okText: t('base.ok'),
                onOk:()=>{
                    cancelSOTableRef.value.selectedKeys = []
                    cancelSOTableRef.value.selectedData = []
                    orderTableRef.value.expandedKeys = []
                    orderTableRef.value.selectedKeys = []
                }
            });
        }
    }

    const delOrder = async (row)=>{
        let res = await OrderApi.getInstance().delOrder(row.id)
        if(res.code == 0){
            Message.success(t('base.delSuccess'))
            getOrderHead()
        }else{
            Message.error(res.msg)
        }
    }

    const delOrderLine = async (row)=>{
        let res = await OrderApi.getInstance().delOrderLine(row.id)
        if(res.code == 0){
            Message.success(t('base.delSuccess'))
            getOrderHead()
        }else{
            Message.error(res.msg)
        }
    }

    // 订单行取消SO同步
    const cancelLineSO = async (row)=>{
        let arr = []
        orderRowData.value.child.innerDatas.forEach(i=>{
            if(i.cancel_status_val == 1){
                arr.push(i)
            }
        })

        let allFlag = arr.length == orderRowData.value.child.innerDatas.length - 1? 1 : 0  // 1:全部取消  0：部分取消
        let param = [{
            order_id:row.order_id,
            erp_no:row.erp_no,
            erp_line_no:row.erp_line_no,
            order_line_id:row.id,
            quantity:row.quantity,
            type:'CANCEL',
            status:0,
        }]
        let res = await OrderApi.getInstance().cancelSO(param,row.order_id,allFlag)
        if(res.code == 0){
            Message.success(t('base.cancelSuccess'))
            getOrderHead()
        }else{
            Message.error(res.msg)
        }
    }

    const changePage = (current)=>{
        table.value.configs.pagination.current = current
        getOrderHead()
    }

    const changePageSize = (pageSize)=>{
        table.value.configs.pagination.current = 1
        table.value.configs.pagination.pageSize = pageSize
        getOrderHead()
    }

    const changeRecordPage = (current)=>{
        table.value.configs.pagination.current = current
        getDeliverRecord(rowData.value)
    }

    const changeRecordPageSize = (pageSize)=>{
        table.value.configs.pagination.current = 1
        table.value.configs.pagination.pageSize = pageSize
        getDeliverRecord(rowData.value)
    }

    const changeVersionPage = (current)=>{
        versionTable.value.configs.pagination.current = current
        getOrderLineRecord(rowData.value)
    }

    const changeVersionPageSize = (pageSize)=>{
        versionTable.value.configs.pagination.current = 1
        versionTable.value.configs.pagination.pageSize = pageSize
        getOrderLineRecord(rowData.value)
    }

    const expandRow = (rowKey,record)=>{
        // console.log(rowKey,record,'rowKey,record',orderTableRef.value.expandedKeys)
        orderTableRef.value.expandedKeys = orderTableRef.value.expandedKeys.length !== 0? [record.id] : []
        orderTableRef.value.selectedKeys = []
        orderRowData.value = record
        table.value.datas.forEach(item=>{
            if(item.selected) item.selected = []
        })
        getOrderLine(record.id, record)
    }

    const selectRow = (selected)=>{
        // console.log(selected,'sel')
        orderRowData.value.selected = selected
    }

    const selectAllRow = (selected)=>{
        // console.log(selected,'selAll',orderRowData.value)
        orderRowData.value.selected = selected
    }

    const prePayOrderSelectRow = (selected)=>{
        // console.log(selected,'sel')
        createPrePayOrderTable.value.configs.selected = selected
    }

    const prePayOrderSelectAllRow = (selected)=>{
        // console.log(selected,'selAll',orderRowData.value)
        createPrePayOrderTable.value.configs.selected = selected
    }

    const formatMoney = (item,key, payCurrency)=>{
        return item[key] == undefined? '-' : 
                roleAuth.value === 3? '******' :
                payCurrency == 'EUR'? '€ ' + Number(item[key]).toFixed(2) : Number(item[key]).toFixed(2)
    }

    const changeInputNumber = (val,inputVal,ev,row)=>{
        console.log(val,row,'hhggg', val > row.total_quantity - row.ship_quantity)
        if(row.second_hand_flag == 0 && row.category_code == '627.501' && val > row.lock_quantity){
            Modal.warning({
                title: t('base.tip'),
                titleAlign: 'start',
                hideCancel: true,
                content: t('order.quantityTip4'),
                okText: t('base.ok'),
                onOk: () => {}
            })
        }else if(val > row.total_quantity - row.ship_quantity){
            Modal.warning({
                title: t('base.tip'),
                titleAlign: 'start',
                hideCancel: true,
                content: t('order.quantityTip8'),
                okText: t('base.ok'),
                onOk: () => {}
            })
        }
        // else if(val > Number(row.available_quantity) || row.available_quantity == 0){
        //     Modal.info({
        //         title: t('base.tip'),
        //         titleAlign: 'start',
        //         hideCancel: true,
        //         content: t('order.quantityTip5'),
        //         okText: t('base.ok'),
        //         onOk: () => {}
        //     })
        // }
    }

    const disabledDate = (current, row)=>{
        // console.log(row.plan_timestamp, 'ggg', row, dateToTimestamp(row.plan_timestamp))
        if(row.transaction_date){
            let everyDay_timestamp = dateToTimestamp(timestampToDate(new Date(current).getTime()).split(' ')[0]) // 日期组件每天日期
            return everyDay_timestamp < dateToTimestamp(row.plan_timestamp)
        }else{
            return false
        }
    }

    const clickSku = (row)=>{
        orderLineRowData.value = {...row}
    }

    const handleDeliverInput = (item,val)=>{
        if(item.key == 'courier_no'){
            deliverForm.formData[item.key] = val.replace(/[^a-zA-Z0-9]/g,'')
        }
    }

    // 创建订单-订单行选择sku
    const changeSku = async (val,row)=>{
        const item = productList.value.find(i=> i.sku == val)
        console.log(item, 'iiiiiiii')

        if(val == '' && history.state.fromPage != 'B2BShopOrder'){
            console.log('测试')
            orderLineExitsSku.value = orderLineTable.value.datas.some(i=> i.sku != '')
            let order_category_item = createOrderForm1.formField.find(i=> i.key == 'order_category')
            order_category_item.showItemPreText = orderLineExitsSku.value
            order_category_item.disabled = orderLineExitsSku.value
            return
        }

        // 是否获取整车价格
        if(
            createOrderForm1.formData.order_channel_type == 0 || 
            createOrderForm1.formData.order_channel_type == 1 || 
            createOrderForm1.formData.order_channel_type == 5
        ){
            row.amountDisabled = true
            row.preTaxAmountDisabled = true
            row.pre_tax_amount = ''
            row.amount = ''
            await getBikePriceBySku(item, row)
            console.log(row,'amount')

            if(row.priceIsNull) return
        }else{
            row.pre_tax_amount = ''
            row.amount = ''
            row.amountDisabled = createOrderForm1.formData.tax_type == 1
            row.preTaxAmountDisabled = false
        }
        
        // 校验是否存在相同的sku
        row.inventory_code = '-'
        row.product_code = ''
        row.name = '-'
        row.frame_color = '-'
        row.torque = '-'
        for(let i=0; i<orderLineTable.value.datas.length; i++){
            let item = orderLineTable.value.datas[i]
            if(orderLineTable.value.datas.length > 1 && item.inventory_code !== '-' && item.sku == val){
                Message.error(t('order.sameSKUExists'))
                row.sku = ''
                return
            }
        }

        item.frame_color = !item.frame_color? '-' : item.frame_color
        item.frame_nm = !item.frame_nm? '-' : item.frame_nm + ' Nm'
        item.frame_shape = !item.frame_shape? '-' : item.frame_shape
        item.frame = !item.frame? '-' : item.frame

        // console.log(createOrderForm1.formData.order_channel_type,'bbnn')
        if(createOrderForm1.formData.order_channel_type != 4){
            Modal.warning({
                title: t('base.tip'),
                titleAlign:'start',
                width:600,
                content: ()=> h('div',{},[
                    h('p',{style:{fontWeight:'bold', fontSize:'17px'}},`${t('order.confirmProduct')}`),
                    h('div',{style:{color:'#ed923b'}},[
                        h('span',{style:{display:'inline-block',width:'100px',textAlign:'right'}},`${t('order.productName2')}： `),
                        h('span',`${item.english_name}`)
                    ]),
                    h('div',{style:{color:'#ed923b'}},[
                        h('span',{style:{display:'inline-block',width:'100px',textAlign:'right'}},`${t('order.sku')}： `),
                        h('span',`${item.sku}`)
                    ]),
                    h('div',{style:{color:'#ed923b'}},[
                        h('span',{style:{display:'inline-block',width:'100px',textAlign:'right'}},`${t('order.unitPrice')}： `),
                        h('span', row.amount == undefined? '-' : `€ ${row.amount}`)
                    ]),
                    h('div',{style:{color:'#ed923b'}},[
                        h('span',{style:{display:'inline-block',width:'100px',textAlign:'right'}},`${t('product.frameColor')}： `),
                        h('span',`${item.frame_color}`)
                    ]),
                    h('div',{style:{color:'#ed923b'}},[
                        h('span',{style:{display:'inline-block',width:'100px',textAlign:'right'}},`${t('order.torque')}： `),
                        h('span',`${item.frame_nm}`)
                    ]),
                    h('div',{style:{color:'#ed923b'}},[
                        h('span',{style:{display:'inline-block',width:'100px',textAlign:'right'}},`${t('order.frameShape')}： `),
                        h('span',`${item.frame_shape}`)
                    ]),
                    h('div',{style:{color:'#ed923b'}},[
                        h('span',{style:{display:'inline-block',width:'100px',textAlign:'right'}},`${t('product.frame')}： `),
                        h('span',`${item.frame}`)
                    ]),

                    h('div',{style:{color:'#ed923b'}},[
                        h('span',{style:{display:'inline-block',width:'100px',textAlign:'right'}},`${t('order.model')}： `),
                        h('span',item.model == undefined? '-' : `${item.model}`)
                    ]),
                    h('div',{style:{color:'#ed923b'}},[
                        h('span',{style:{display:'inline-block',width:'100px',textAlign:'right'}},`${t('order.modelYear')}： `),
                        h('span',item.model_year == undefined? '-' : `${item.model_year}`)
                    ]),
                    h('div',{style:{color:'#ed923b'}},[
                        h('span',{style:{display:'inline-block',width:'100px',textAlign:'right'}},`${t('order.brandName')}： `),
                        h('span', item.brand_name == undefined? '-' : `${item.brand_name}`)
                    ]),
                    h('div',{style:{color:'#ed923b'}},[
                        h('span',{style:{display:'inline-block',width:'100px',textAlign:'right'}},`${t('order.partName')}： `),
                        h('span', item.part_name == undefined? '-' : `${item.part_name}`)
                    ]),
                ]),
                hideCancel:true,
                okText:t('base.ok'),
                cancelText:t('base.cancel'),
                onOk:()=>{
                    row.inventory_code = item.inventory_code
                    row.product_code = item.category_code
                    row.name = item.english_name
                    row.frame_color = item.frame_color
                    row.torque = item.torque

                    orderLineExitsSku.value = orderLineTable.value.datas.some(i=> i.sku != '')
                    let order_category_item = createOrderForm1.formField.find(i=> i.key == 'order_category')
                    order_category_item.showItemPreText = orderLineExitsSku.value
                    order_category_item.disabled = orderLineExitsSku.value

                    // 计算订单头运费
                    console.log('变更sku')
                    cargoFreightNeedChange.value = createOrderForm1.formData.order_channel_type == 5 && orderOperateType.value == 'add'
                    computeCargoFreight()
                },
                onCancel:()=>{
                    row.sku = orderLineRowData.value.sku
                    row.inventory_code = orderLineRowData.value.inventory_code
                    row.product_code = orderLineRowData.value.product_code || ''
                    row.name = orderLineRowData.value.name || '-'
                    row.frame_color = orderLineRowData.value.frame_color || '-'
                    row.torque = orderLineRowData.value.torque
                }
            });
        }else{
            row.inventory_code = item.inventory_code
            row.product_code = item.category_code
            row.name = item.english_name
            row.frame_color = item.frame_color
            row.torque = item.torque
        }
    }

    // 创建订单-订单行选择税率
    const changeTaxRate = (val,row)=>{
        // console.log(val,row,'val,row')
        let item = taxRateOption.value.find(i=>i.label == val)
        row.tax_rate_val = item.value
    }

    // 创建服务订单-订单行填写数量
    const qtyChange = async (val,row)=>{
        // console.log(val,row,'vvvbbbb')
        if(createOrderForm1.formData.order_channel_type == 4){
            let res = await vaildOrderServiceBindCcount(val,row)
            if(!res){
                Modal.warning({
                    title: t('base.tip'),
                    titleAlign:'start',
                    content: t('order.serviceOrdreLineQtyTip'),
                    hideCancel:true,
                    okText:t('base.ok'),
                    cancelText:t('base.cancel'),
                    onOk:()=>{}
                });
            }
        }
    }

    // 校验订单行历史投保数量
    const vaildOrderServiceBindCcount = async (val,row)=>{
        let param = {
            order_line_id:row.bind_order_line_id,
        }
        let res = await OrderApi.getInstance().vaildOrderServiceBindCcount(param)
        if(res.code == 0){
            return val <= row.ship_qty - res.data
        }else{
            Message.error(res.msg)
        }
    }

    // 创建订单-订单行输入框
    const quantityChange = (val,row,key)=>{
        // console.log(val,row,key,'quantityChange')
        // 计算行-支付金额
        if(key == 'amount' && row.quantity != '' && !row.syncNewPrice){
            row.pay_amount = !!row.discount && !!row.extra_discount
                            ? subtract(multiply(Number(val), Number(row.quantity)), multiply(Number(row.quantity), add(Number(formatterToPoint(row.discount)), Number(formatterToPoint(row.extra_discount)))))
                            : !!row.discount && !row.extra_discount
                            ? subtract(multiply(Number(val), Number(row.quantity)),multiply( Number(row.quantity), Number(formatterToPoint(row.discount))))
                            : !row.discount && !!row.extra_discount
                            ? subtract(multiply(Number(val), Number(row.quantity)), multiply( Number(row.quantity), Number(formatterToPoint(row.extra_discount))))
                            : multiply(Number(val), Number(row.quantity))
            row.pay_amount = formatterToComma(Number(row.pay_amount.toFixed(3)), String(row.amount).indexOf('.') != -1)
        }
        if(key == 'quantity' && row.amount != ''){
            row.pay_amount = !!row.discount && !!row.extra_discount
                             ? subtract(multiply(Number(formatterToPoint(row.amount)), Number(val)), multiply(Number(val), add(Number(formatterToPoint(row.discount)), Number(formatterToPoint(row.extra_discount)))))
                             : !!row.discount && !row.extra_discount
                             ? subtract(multiply(Number(val), Number(formatterToPoint(row.amount))), multiply(Number(val), Number(formatterToPoint(row.discount))))
                             : !row.discount && !!row.extra_discount
                             ? subtract(multiply(Number(val), Number(formatterToPoint(row.amount))), multiply(Number(val), Number(formatterToPoint(row.extra_discount))))
                             : multiply(Number(formatterToPoint(row.amount)), Number(val))

            row.pay_amount = formatterToComma(Number(row.pay_amount.toFixed(3)), String(row.amount).indexOf('.') != -1)
            
            // 计算运费金额
            cargoFreightNeedChange.value = false
            console.log('计算运费金额')
            computeCargoFreight('keyIsQuantity', row, val)
        }
        if(key == 'discount' && row.quantity != '' && row.amount != ''){
            row.pay_amount = !!val && !row.extra_discount? subtract(multiply(Number(formatterToPoint(row.amount)), Number(row.quantity)), multiply(Number(row.quantity), Number(val)))
                            : !val && !!row.extra_discount? subtract(multiply(Number(formatterToPoint(row.amount)), Number(row.quantity)), multiply(Number(row.quantity), Number(formatterToPoint(row.extra_discount))))
                            : !val && !row.extra_discount? multiply(Number(formatterToPoint(row.amount)), Number(row.quantity))
                            : subtract(multiply(Number(formatterToPoint(row.amount)), Number(row.quantity)), multiply(Number(row.quantity), add(Number(val), Number(formatterToPoint(row.extra_discount)))))

            row.pay_amount = formatterToComma(Number(row.pay_amount.toFixed(3)), String(row.amount).indexOf('.') != -1)
        }
        if(key == 'extra_discount' && row.quantity != '' && row.amount != ''){
            row.pay_amount = !!val && !row.discount? subtract(multiply(Number(formatterToPoint(row.amount)), Number(row.quantity)), multiply(Number(row.quantity), Number(val)))
                            : !val && !!row.discount? subtract(multiply(Number(formatterToPoint(row.amount)), Number(row.quantity)), multiply(Number(row.quantity), Number(formatterToPoint(row.discount))))
                            : !val && !row.discount? multiply(Number(formatterToPoint(row.amount)), Number(row.quantity))
                            : subtract(multiply(Number(formatterToPoint(row.amount)), Number(row.quantity)), multiply(Number(row.quantity), add(Number(formatterToPoint(row.discount)), Number(val))))

            row.pay_amount = formatterToComma(Number(row.pay_amount.toFixed(3)), String(row.amount).indexOf('.') != -1)
        }

        // B2B订单，计算行-税前单价
        if(key == 'discount_rate'){
            row.pre_tax_discount = val === undefined? '' : multiply(Number(formatterToPoint(row.pre_tax_amount)), Number(val/100))

            console.log(row.pre_tax_discount, '[pppppppp]', Number(row.pre_tax_amount), val,  Number(val/100))


            quantityChange(row.pre_tax_discount, row, 'pre_tax_discount')
        }

        // 计算行-税后单价      税后单价 = 税前单价 * (1 + 税率)
        if(key == 'pre_tax_amount'){
            // console.log(row,'rrttt',createOrderForm1.formData.order_channel_type, row)
            row.amount = val != undefined? Number(multiply(Number(val), 1 + Number(row.tax_rate_val)).toFixed(3))  : ''
            row.amount = formatterToComma(Number(row.amount), String(row.pre_tax_amount).indexOf('.') != -1)
        }
        // 计算行-税后折扣
        if(key == 'pre_tax_discount'){
            row.discount = val != undefined? Number(multiply(Number(val), 1 + Number(row.tax_rate_val)).toFixed(3))  : ''
            row.discount = formatterToComma(Number(row.discount), String(row.pre_tax_discount).indexOf('.') != -1)
        }
        // 计算行-税后额外折扣
        if(key == 'pre_tax_extra_discount'){
            row.extra_discount = val != undefined? Number(multiply(Number(val), 1 + Number(row.tax_rate_val)).toFixed(3)) : ''
            row.extra_discount = formatterToComma(Number(row.extra_discount), String(row.pre_tax_extra_discount).indexOf('.') != -1)
        }

        // 计算行-支付金额
        if(key == 'pre_tax_amount' && row.quantity != '' && !row.syncNewPrice){
            // 计算税前支付金额
            row.pre_tax_pay_amount = !!row.pre_tax_discount && !!row.pre_tax_extra_discount
                            ? subtract(multiply(Number(val), Number(row.quantity)), multiply(Number(row.quantity), add(Number(formatterToPoint(row.pre_tax_discount)), Number(formatterToPoint(row.pre_tax_extra_discount)))))
                            : !!row.pre_tax_discount && !row.pre_tax_extra_discount
                            ? subtract(multiply(Number(val), Number(row.quantity)),multiply(Number(row.quantity), Number(formatterToPoint(row.pre_tax_discount))))
                            : !row.pre_tax_discount && !!row.pre_tax_extra_discount
                            ? subtract(multiply(Number(val), Number(row.quantity)), multiply(Number(row.quantity), Number(formatterToPoint(row.pre_tax_extra_discount))))
                            : multiply(Number(val), Number(row.quantity))

            row.pre_tax_pay_amount = formatterToComma(Number(row.pre_tax_pay_amount.toFixed(3)), String(row.amount).indexOf('.') != -1)

            // 计算税后支付金额
            row.pay_amount = !!row.discount && !!row.extra_discount
                            ? subtract(multiply(Number(formatterToPoint(row.amount)), Number(row.quantity)), multiply(Number(row.quantity), add(Number(formatterToPoint(row.discount)), Number(formatterToPoint(row.extra_discount)))))
                            : !!row.discount && !row.extra_discount
                            ? subtract(multiply(Number(formatterToPoint(row.amount)), Number(row.quantity)),multiply( Number(row.quantity), Number(formatterToPoint(row.discount))))
                            : !row.discount && !!row.extra_discount
                            ? subtract(multiply(Number(formatterToPoint(row.amount)), Number(row.quantity)), multiply( Number(row.quantity), Number(formatterToPoint(row.extra_discount))))
                            : multiply(Number(formatterToPoint(row.amount)), Number(row.quantity))

            row.pay_amount = formatterToComma(Number(row.pay_amount.toFixed(3)), String(row.amount).indexOf('.') != -1)
        }
        if(key == 'quantity' && row.pre_tax_amount != ''){
            // 计算税前支付金额
            row.pre_tax_pay_amount = !!row.pre_tax_discount && !!row.pre_tax_extra_discount
                             ? subtract(multiply(Number(formatterToPoint(row.pre_tax_amount)), Number(val)), multiply(Number(val), add(Number(formatterToPoint(row.pre_tax_discount)), Number(formatterToPoint(row.pre_tax_extra_discount)))))
                             : !!row.pre_tax_discount && !row.pre_tax_extra_discount
                             ? subtract(multiply(Number(val), Number(formatterToPoint(row.pre_tax_amount))), multiply(Number(val), Number(formatterToPoint(row.pre_tax_discount))))
                             : !row.pre_tax_discount && !!row.pre_tax_extra_discount
                             ? subtract(multiply(Number(val), Number(formatterToPoint(row.pre_tax_amount))), multiply(Number(val), Number(formatterToPoint(row.pre_tax_extra_discount))))
                             : multiply(Number(formatterToPoint(row.pre_tax_amount)), Number(val))

            row.pre_tax_pay_amount = formatterToComma(Number(row.pre_tax_pay_amount.toFixed(3)), String(row.amount).indexOf('.') != -1)
        }
        if(key == 'pre_tax_discount' && row.quantity != '' && row.pre_tax_amount != ''){
            // 计算税前支付金额
            row.pre_tax_pay_amount = !!val && !row.pre_tax_extra_discount? subtract(multiply(Number(formatterToPoint(row.pre_tax_amount)), Number(row.quantity)), multiply(Number(row.quantity), Number(val)))
                            : !val && !!row.pre_tax_extra_discount? subtract(multiply(Number(formatterToPoint(row.pre_tax_amount)), Number(row.quantity)), multiply(Number(row.quantity), Number(formatterToPoint(row.pre_tax_extra_discount))))
                            : !val && !row.pre_tax_extra_discount? multiply(Number(formatterToPoint(row.pre_tax_amount)), Number(row.quantity))
                            : subtract(multiply(Number(formatterToPoint(row.pre_tax_amount)), Number(row.quantity)), multiply(Number(row.quantity), add(Number(val), Number(formatterToPoint(row.pre_tax_extra_discount)))))

            row.pre_tax_pay_amount = formatterToComma(Number(row.pre_tax_pay_amount.toFixed(3)), String(row.amount).indexOf('.') != -1)

            // 计算税后支付金额
            row.pay_amount = !!row.discount && !row.extra_discount? subtract(multiply(Number(formatterToPoint(row.amount)), Number(row.quantity)), multiply(Number(row.quantity), Number(formatterToPoint(row.discount))))
                            : !row.discount && !!row.extra_discount? subtract(multiply(Number(formatterToPoint(row.amount)), Number(row.quantity)), multiply(Number(row.quantity), Number(formatterToPoint(row.extra_discount))))
                            : !row.discount && !row.extra_discount? multiply(Number(formatterToPoint(row.amount)), Number(row.quantity))
                            : subtract(multiply(Number(formatterToPoint(row.amount)), Number(row.quantity)), multiply(Number(row.quantity), add(Number(formatterToPoint(row.discount)), Number(formatterToPoint(row.extra_discount)))))
            
            row.pay_amount = formatterToComma(Number(row.pay_amount.toFixed(3)), String(row.amount).indexOf('.') != -1)
        }
        if(key == 'pre_tax_extra_discount' && row.quantity != '' && row.pre_tax_amount != ''){
            // 计算税前支付金额
            row.pre_tax_pay_amount = !!val && !row.pre_tax_discount? subtract(multiply(Number(formatterToPoint(row.pre_tax_amount)), Number(row.quantity)), multiply(Number(row.quantity), Number(val)))
                            : !val && !!row.pre_tax_discount? subtract(multiply(Number(formatterToPoint(row.pre_tax_amount)), Number(row.quantity)), multiply(Number(row.quantity), Number(formatterToPoint(row.pre_tax_discount))))
                            : !val && !row.pre_tax_discount? multiply(Number(formatterToPoint(row.pre_tax_amount)), Number(row.quantity))
                            : subtract(multiply(Number(formatterToPoint(row.pre_tax_amount)), Number(row.quantity)), multiply(Number(row.quantity), add(Number(formatterToPoint(row.pre_tax_discount)), Number(val))))
            
            row.pre_tax_pay_amount = formatterToComma(Number(row.pre_tax_pay_amount.toFixed(3)), String(row.amount).indexOf('.') != -1)

            // 计算税后支付金额
            row.pay_amount = !!row.extra_discount && !row.discount? subtract(multiply(Number(formatterToPoint(row.amount)), Number(row.quantity)), multiply(Number(row.quantity), Number(formatterToPoint(row.extra_discount))))
                            : !row.extra_discount && !!row.discount? subtract(multiply(Number(formatterToPoint(row.amount)), Number(row.quantity)), multiply(Number(row.quantity), Number(formatterToPoint(row.discount))))
                            : !row.extra_discount && !row.discount? multiply(Number(formatterToPoint(row.amount)), Number(row.quantity))
                            : subtract(multiply(Number(formatterToPoint(row.amount)), Number(row.quantity)), multiply(Number(row.quantity), add(Number(formatterToPoint(row.discount)), Number(formatterToPoint(row.extra_discount)))))

            row.pay_amount = formatterToComma(Number(row.pay_amount.toFixed(3)), String(row.amount).indexOf('.') != -1)
        }

        // 计算行-税额   税额 = （单价*数量 - 折扣）/ (1 + 税率) * 税率
        if((key == 'amount' || key == 'pre_tax_amount') && row.quantity !== ''  && !row.syncNewPrice){
            row.order_tax = row.pay_amount != ''? Number(multiply(divide(formatterToPoint(row.pay_amount),1 + Number(row.tax_rate_val)), Number(row.tax_rate_val)).toFixed(2)) : ''
            row.order_tax = formatterToComma(Number(row.order_tax), String(row.amount).indexOf('.') != -1)
        } 
        if(key == 'quantity' && row.amount !== ''){
            row.order_tax = row.pay_amount != ''? Number(multiply(divide(formatterToPoint(row.pay_amount),1 + Number(row.tax_rate_val)), Number(row.tax_rate_val)).toFixed(2)) : ''
            row.order_tax = formatterToComma(Number(row.order_tax), String(row.amount).indexOf('.') != -1)
        }
        if((key == 'discount' || key == 'pre_tax_discount') && row.amount !== '' && row.quantity !== ''){
            row.order_tax = row.pay_amount != ''? Number(multiply(divide(formatterToPoint(row.pay_amount),1 + Number(row.tax_rate_val)), Number(row.tax_rate_val)).toFixed(2)) : ''
            row.order_tax = formatterToComma(Number(row.order_tax), String(row.amount).indexOf('.') != -1)
        } 
        if((key == 'extra_discount' || key == 'pre_tax_extra_discount') && row.amount !== '' && row.quantity !== ''){
            row.order_tax = row.pay_amount != ''? Number(multiply(divide(formatterToPoint(row.pay_amount),1 + Number(row.tax_rate_val)), Number(row.tax_rate_val)).toFixed(2)) : ''
            row.order_tax = formatterToComma(Number(row.order_tax), String(row.amount).indexOf('.') != -1)
        } 


        // 计算汇总-订单金额（含税模式）
        if(key == 'amount' && row.quantity != ''){
            // console.log(row,'aaaaaa',val)
            row.line_order_amount = multiply(Number(val), Number(row.quantity))
            createOrderForm2.formData.order_amount = 0
            orderLineTable.value.datas.forEach(i=>{
                createOrderForm2.formData.order_amount = add(Number(createOrderForm2.formData.order_amount), formatterToPoint(i.line_order_amount))
            })
            createOrderForm2.formData.order_amount = formatterToComma(Number(createOrderForm2.formData.order_amount.toFixed(2)), String(row.amount).indexOf('.') != -1)
        }
        if(key == 'quantity' && row.amount != ''){
            row.line_order_amount = multiply(Number(formatterToPoint(row.amount)), Number(val))
            createOrderForm2.formData.order_amount = 0
            createOrderForm2.formData.quantity = 0
            orderLineTable.value.datas.forEach(i=>{
                createOrderForm2.formData.order_amount = add(Number(formatterToPoint(createOrderForm2.formData.order_amount)), formatterToPoint(i.line_order_amount))
                createOrderForm2.formData.quantity = add(Number(createOrderForm2.formData.quantity), i.quanatity)
            })
            createOrderForm2.formData.order_amount = formatterToComma(Number(createOrderForm2.formData.order_amount.toFixed(2)), String(row.amount).indexOf('.') != -1)
        }

        // 计算汇总-订单金额（不含税模式）
        if(key == 'pre_tax_amount' && row.quantity != ''){
            let after_tax_amount = multiply(Number(val), 1 + Number(row.tax_rate_val)) 
            row.line_order_amount = multiply(Number(after_tax_amount), Number(row.quantity))
            createOrderForm2.formData.order_amount = 0
            orderLineTable.value.datas.forEach(i=>{
                createOrderForm2.formData.order_amount = add(Number(formatterToPoint(createOrderForm2.formData.order_amount)), formatterToPoint(i.line_order_amount))
            })
            createOrderForm2.formData.order_amount = formatterToComma(Number(createOrderForm2.formData.order_amount.toFixed(2)), String(row.pre_tax_amount).indexOf('.') != -1)
        }

        // 计算汇总-订单数量（含税模式）
        if(key == 'quantity'){
            row.quantity = val
            createOrderForm2.formData.quantity = 0
            let order_discount = formatterToPoint(createOrderForm2.formData.order_discount)
            let order_extra_discount = formatterToPoint(createOrderForm2.formData.extra_discount)
            order_discount = 0
            order_extra_discount = 0
            orderLineTable.value.datas.forEach(i=>{
                createOrderForm2.formData.quantity = add(Number(createOrderForm2.formData.quantity), i.quantity)
                order_discount = i.discount == undefined
                                ? Number(order_discount) : i.quantity == undefined
                                ? Number(order_discount) : add(order_discount, multiply(formatterToPoint(i.discount), i.quantity))

                order_extra_discount = i.extra_discount == undefined
                                    ? Number(order_extra_discount) : i.quantity == undefined
                                    ? Number(order_extra_discount) : add(order_extra_discount, multiply(formatterToPoint(i.extra_discount), i.quantity))
            })
            createOrderForm2.formData.order_discount = formatterToComma(Number(order_discount.toFixed(2)), String(createOrderForm2.formData.order_amount).indexOf('.') != -1)
            createOrderForm2.formData.extra_discount = formatterToComma(Number(order_extra_discount.toFixed(2)), String(createOrderForm2.formData.order_amount).indexOf('.') != -1)
        }

        // 计算汇总-订单折扣    单行总折扣 = 数量 * 折扣，   订单折扣 = 各订单行折扣之和
        if(key == 'discount' || key == 'pre_tax_discount'){
            key == 'discount'? row.discount = formatterToComma(val, String(row.amount).indexOf('.') != -1) : row.pre_tax_discount = formatterToComma(val, String(row.amount).indexOf('.') != -1)
            let order_discount = formatterToPoint(createOrderForm2.formData.order_discount)
            order_discount = 0
            orderLineTable.value.datas.forEach(i=>{
                order_discount = i.discount == undefined
                                 ? Number(order_discount) : i.quantity == undefined
                                 ? Number(order_discount) : add(order_discount, multiply(formatterToPoint(i.discount), i.quantity))
            })
            createOrderForm2.formData.order_discount =  formatterToComma(Number(order_discount.toFixed(2)), String(createOrderForm2.formData.order_amount).indexOf('.') != -1)
        }

        // 计算汇总-订单额外折扣     单行总额外折扣 = 数量 * 额外折扣，   订单额外折扣 = 各订单行额外折扣之和
        if(key == 'extra_discount' || key == 'pre_tax_extra_discount'){
            key == 'extra_discount'? row.extra_discount = formatterToComma(val, String(row.amount).indexOf('.') != -1) : row.pre_tax_extra_discount = formatterToComma(val, String(row.amount).indexOf('.') != -1)
            let order_extra_discount = formatterToPoint(createOrderForm2.formData.extra_discount)
            order_extra_discount = 0
            orderLineTable.value.datas.forEach(i=>{
                order_extra_discount = i.extra_discount == undefined
                                       ? Number(order_extra_discount) : i.quantity == undefined
                                       ? Number(order_extra_discount) : add(order_extra_discount, multiply(formatterToPoint(i.extra_discount), i.quantity))
            })
            createOrderForm2.formData.extra_discount =  formatterToComma(Number(order_extra_discount.toFixed(2)), String(createOrderForm2.formData.order_amount).indexOf('.') != -1)
        }
    }

    // 计算汇总-复制订单行后
    const computedCopySummary = ()=>{
        let order_discount = formatterToPoint(createOrderForm2.formData.order_discount)
        let order_extra_discount = formatterToPoint(createOrderForm2.formData.extra_discount)
        createOrderForm2.formData.order_amount = 0
        createOrderForm2.formData.quantity = 0
        order_discount = 0
        order_extra_discount = 0
        orderLineTable.value.datas.forEach((i,index)=>{
            i.serial = index + 1
            createOrderForm2.formData.order_amount = formatterToComma(add(Number(formatterToPoint(createOrderForm2.formData.order_amount)), multiply(Number(formatterToPoint(i.amount)), Number(i.quantity))), String(i.amount).indexOf('.') != -1)
            createOrderForm2.formData.quantity = add(Number(createOrderForm2.formData.quantity), i.quantity)
            order_discount = i.discount == undefined
                            ? Number(order_discount) : i.quantity == undefined
                            ? Number(order_discount) : add(order_discount, multiply(formatterToPoint(i.discount), i.quantity))

            order_extra_discount = i.extra_discount == undefined
                                ? Number(order_extra_discount) : i.quantity == undefined
                                ? Number(order_extra_discount) : add(order_extra_discount, multiply(formatterToPoint(i.extra_discount), i.quantity))
        })

        createOrderForm2.formData.order_discount = formatterToComma(Number(order_discount.toFixed(2)), String(createOrderForm2.formData.order_amount).indexOf('.') != -1)
        createOrderForm2.formData.extra_discount = formatterToComma(Number(order_extra_discount.toFixed(2)), String(createOrderForm2.formData.order_amount).indexOf('.') != -1)
    }

    

    const getoOderStatus = (type, data)=>{
        
        // 订单状态
        const badgeOrderStatus = [
            {
                type:t('order.finalPayment'), // 尾款单
                color:'arcoblue',
            },
            {
                type:t('order.partialPay'), // 部分支付
                color:'#ff4500',
            },
            {
                type:t('order.pay'), // 支付
                color:'green',
            },
            {
                type:t('order.refund'), // 退款
                color:'pink',
            },
            {
                type:t('order.returnsAndRefund'), // 退货退款
                color:'orange',
            },
            {
                type:t('order.partialRefund'), // 部分退款
                color:'gold',
            },
            {
                type:t('order.partialReturnsAndRefund'), // 部分退货退款
                color:'pinkpurple',
            },
            {
                type:t('order.canceled'), // 已取消
                color:'gray',
            },
            {
                type:t('order.obligation'), // 待付款
                color:'#ad0606',
            },
        ]

        // 发货状态
        const badgeCourierStatus = [
            {
                type:t('order.unship'), // 未发货
                color:'magenta',
            },
            {
                type:t('order.plan'), // 计划发货
                color:'blue',
            },
            {
                type:t('order.partialShip'), // 部分发货
                color:'orange',
            },
            {
                type:t('order.shiped'), // 已发货
                color:'lime',
            },
            {
                type:t('order.signedFor'), // 已签收
                color:'green',
            },
            {
                type:t('order.canceled'), // 已关闭
                color:'#86909c',
            },
            {
                type:t('order.partialReturn'), // 部分退货
                color:'#ea7ccc',
            },
            {
                type:t('order.partialExchange'), // 部分换货
                color:'#afb2f5',
            },
            {
                type:t('order.return'), // 退回
                color:'#f71ebb',
            },
            {
                type:t('order.exchange'), // 更换
                color:'#6e74e0',
            },
            {
                type:t('order.noNeedToShip'), // 无需发货
                color:'#333',
            },
            {
                type:'-',
                color:'gray',
            },
        ]

        // 出库状态
        const outboundStatus = [
            {
                type:t('order.initial'), // 初始
                color:'#ccc',
            },
            {
                type:t('order.unOutbound'), // 未出库
                color:'red',
            },
            {
                type:t('stock.outScanned'), // 已扫描
                color:'blue',
            },
            {
                type:t('order.outbound'), // 已出库
                color:'green',
            },
            {
                type:t('stock.cancelOutbound2'), // 取消出库
                color:'orange',
            },
        ]

        const tagCustomerType = [
            { 
                type:t('order.user'), // 用户
                color:'blue',
            },
            {
                type:t('order.dealer'), // 经销商
                color:'green',
            },
            {
                type:t('order.ECommerceVendor'), // E-Commerce Vendor
                color:'yellow',
            },
            {
                type:t('order.notForSale'), // 非销售
                color:'orange',
            },
            {
                type:t('order.service'), // 服务
                color:'pinkpurple',
            },
            {
                type:t('order.virtual'), // 虚拟订单
                color:'red',
            },
            {
                type:t('order.c2c'), // C&C
                color:'cyan',
            },
        ]

        const typeObj = {
            'badgeOrderStatus':badgeOrderStatus,
            'badgeCourierStatus':badgeCourierStatus,
            'tagCustomerType':tagCustomerType,
            'outboundStatus':outboundStatus,
        }
        let item = typeObj[type].find(i=> i.type == data)
        return item && item.color
    }

    // 列表排序
    const sorterChange = (dataIndex,direction)=>{
        // console.log(dataIndex,direction,'dataIndex,direction')
        sort.value = {dataIndex,direction}
        table.value.configs.pagination.current = 1
        getOrderHead()
    }

    // 获取订单列表
    const getOrderHead = async ()=>{
        let arr = ['order_name','frame_number','erp_no']
        queryForm.formField.forEach(i=>{
            if(arr.includes(i.key)){
                queryForm.formData[i.key] = queryForm.formData[i.key].trim()
            }
        })
        let {
            order_name, frame_number, order_no, order_status, source, courier_status, order_channel_type, country, customer_entity_id,customer_id,
            customer_email, create_by, instruction, order_type, begin_date, end_date, risk_level, erp_no, sku, second_hand_flag
        } = { ...queryForm.formData }
        let param = {
            order_name, frame_number, order_no, order_status, source, courier_status, order_channel_type, country, customer_entity_id,customer_id,
            customer_email, create_by, instruction, order_type, begin_date, end_date, risk_level, erp_no,sku, second_hand_flag,
            sort_column:sort.value.dataIndex == 'order_timestamp'? 'ORDER_TIMESTAMP' : sort.value.dataIndex == 'order_name'? 'ID' : '',
            sort_rule:sort.value.direction == 'ascend'? 'ASC' : sort.value.direction == 'descend'? 'DESC' : '',
        }
        let page_num = table.value.configs.pagination.current
        let page_size = table.value.configs.pagination.pageSize
        table.value.configs.loading = true
        let res = await OrderApi.getInstance().getOrderHead(param,page_num,page_size)
        if(res.code == 0){
            let data = res.data.records
            table.value.datas = []
            let orderStatusArr = ['2','4'] 
            data.forEach((item,index) => {
                table.value.datas.push({
                    ...item,
                    No:index + 1,
                    order_status_val: item.order_status,
                    source_val: item.source,
                    courier_status_val: item.courier_status,
                    refundDisabled: !orderStatusArr.includes(`${item.order_status}`),
                    order_status: orderStatus.value[`${item.order_status}`],
                    courier_status: item.courier_status == undefined? '-' : courierStatus.value[item.courier_status],
                    customer_type_val: item.customer_type,
                    customer_type: item.customer_type == 0? t('order.user') : item.customer_type == 1? t('order.dealer') : item.customer_type == 2? t('order.ECommerceVendor') : t('order.notForSale'),
                    order_channel_type_val: item.order_channel_type,
                    order_channel_type: item.order_channel_type == 0? t('order.user') : item.order_channel_type == 1? t('order.dealer') : item.order_channel_type == 2? t('order.ECommerceVendor') : item.order_channel_type == 3? t('order.notForSale') : item.order_channel_type == 4? t('order.service') : item.order_channel_type == -1? t('order.virtual') : t('order.c2c'),
                    order_type_val: item.order_type,
                    order_type: item.order_type == undefined? '-' : item.order_type == 0? t('order.sale') : t('order.unSale'),
                    source: orderSource.value[item.source],
                    order_amount_val: item.order_amount,
                    pay_amount_val: item.pay_amount,
                    pay_with_days_discount_val:item.pay_with_days_discount == undefined? 0 : item.pay_with_days_discount,
                    order_amount: formatMoney(item,'order_amount','EUR'),
                    real_pay_amount_val: item.real_pay_amount,
                    real_pay_amount: formatMoney(item, 'real_pay_amount','EUR'),
                    order_discount_val: item.order_discount == ''? '-' : item.order_discount,
                    order_discount:  item.order_discount == ''? '-' : formatMoney(item,'order_discount','EUR'), 
                    cargo_freight: item.cargo_freight == ''? '-' : formatMoney(item,'cargo_freight','EUR'), 
                    pay_type_discount_display: item.pay_type_discount == ''? '-' : formatMoney(item,'pay_type_discount','EUR'),
                    order_tax_val: item.order_tax,
                    order_tax: item.order_tax == ''? '-' : formatMoney(item,'order_tax','EUR'), 
                    tax_rate_val: item.tax_rate == undefined? '-' : item.tax_rate.toFixed(2),
                    tax_rate: item.tax_rate == undefined? '-' : item.tax_rate * 100 + '%',
                    pay_amount: formatMoney(item,'pay_amount','EUR'),
                    refund_amount: item.refund_amount == ''? '-' : formatMoney(item,'refund_amount','EUR'),
                    erp_no: !item.erp_no? '-' : item.erp_no,
                    order_timestamp_val:item.order_timestamp,
                    order_timestamp: timestampToDate(item.order_timestamp * 1000).split(' ')[0],
                    earliest_ship_timestamp_val: item.earliest_ship_timestamp,
                    earliest_ship_timestamp: !item.earliest_ship_timestamp? '' : timestampToDate(item.earliest_ship_timestamp * 1000).split(' ')[0],
                    refund_timestamp: item.refund_timestamp == undefined? '-' : `${t('order.refundDate')}: ${timestampToDate(item.refund_timestamp * 1000)}`,
                    create_date: !item.create_timestamp? '-' : timestampToDate(item.create_timestamp * 1000).split(' ')[0],
                    child:{
                        innerDatas:[],
                        innerColumns:innerColumns.value,
                        innerConfigs:innerConfigs.value,
                    },
                    rowData:item,
                    instructionIsText:true,
                    create_user: !item.create_user? '-' : item.create_user,
                    back_flag_val: item.back_flag,
                    back_flag: !item.back_flag? '-' : item.back_flag == 'YES'? t('order.isReturn') : t('order.notReturn'),
                    order_use: !item.order_use? '-' : item.order_use,
                    user_note: !item.user_note? '-' : item.user_note,
                    showAmount:false,
                    delivery_type: item.delivery_type? item.delivery_type : '-',
                    risk_level_val: item.risk_level == undefined? '' : item.risk_level,
                    risk_validate_val: item.risk_validate == undefined? 0 : item.risk_validate,
                    risk_level: item.risk_level === 0? t('order.none') : item.risk_level == 1? t('order.lowRisk') : item.risk_level == 2? t('order.mediumRisk') : item.risk_level == 3? t('order.highRisk') : '-',
                    risk_validate: item.risk_validate == undefined || item.risk_validate == 0? t('order.noValid') : item.risk_validate == 2? t('order.isRelieve') : item.risk_validate == 1? t('order.isValid') : '-',
                    sendBtnText: !item.invoice_send_number? t('order.sendInvoice2') : t('order.reSend'),
                    sendConfirmationBtnText: t('order.sendConfirmation'),
                    cancel_timestamp: item.cancel_timestamp == undefined? '-' : `${t('order.cancelDate')}: ${timestampToDate(item.cancel_timestamp * 1000)}`,
                    prepaid_flag: item.prepaid_flag == undefined? '' : item.prepaid_flag
                })
            });
            // console.log(table.value.datas,'table.value.datas')
            table.value.configs.pagination.total = res.data.total
            table.value.configs.loading = false

            orderTableRef.value.expandedKeys = []
            orderTableRef.value.selectedKeys = []
        }else{
            Message.error(res.msg)
        }
    }

    const getOrderLine = async (id, row, type)=>{
        let param = {
            order_id: id,
        }

        let item = null
        if(type != 'createPrepaymentOrder'){
            item = table.value.datas.find(i=> i.id == id)
            item.child.innerConfigs.loading = true
        }else{
            param.prepaid_flag  = 'YES'
        }
        
        let res = await OrderApi.getInstance().getOrderLine(param)
        if(res.code == 0){
            res.data.forEach(i=>{
                i.order_id = row.id
                i.erp_no = row.erp_no
                i.customer_name = row.customer_name
                i.country = row.country
                i.order_name = row.order_name
                i.source = row.source
                i.frame_number = i.frame_number,
                i.order_line_no = i.order_line_no == undefined? '-' : i.order_line_no
                i.erp_line_no = !i.erp_line_no? '-' : i.erp_line_no
                i.product_name = i.product_map == undefined? '-' : i.product_map.english_name
                i.inventory_code = i.inventory_code == undefined? '-' : i.inventory_code
                i.inventory = i.inventory == undefined? '-' :  i.inventory 
                i.model = i.product_map == undefined? '-' : i.product_map.model == undefined? '-' : i.product_map.model
                i.model_year = i.product_map == undefined ? '-' : i.product_map.model_year == undefined? '-' : i.product_map.model_year
                i.brand_name = i.product_map == undefined? '-' : i.product_map.brand_name == undefined? '-' : i.product_map.brand_name
                i.part_name = i.product_map == undefined? '-' : i.product_map.part_name == undefined? '-' : i.product_map.part_name
                i.courier_status = i.courier_status == undefined? '-' : courierStatus.value[i.courier_status]
                i.quantity = i.quantity == undefined? '-' : i.quantity
                i.ship_quantity = i.ship_quantity == undefined? '-' :i.ship_quantity
                i.scheduling_quantity = i.scheduling_quantity == undefined? '-' : i.scheduling_quantity,
                i.back_number = i.back_number == undefined? '-' : i.back_number,
                i.produce_quantity = i.produce_quantity == undefined? '-' : i.produce_quantity,
                i.back_status = i.back_status == undefined? '-' : i.back_status == 1? t('order.returning') : i.back_status == 2? t('order.swaping') :  i.back_status == 3? t('order.returned') : t('order.swaped'),
                i.unit_code = i.product_map == undefined? '-' : i.product_map.unit_code
                i.pay_currency = row.pay_currency
                i.amount_val = i.amount
                i.discount_val = i.discount
                i.pay_amount_val = i.pay_amount
                i.amount = formatMoney(i,'amount','EUR') 
                i.discount = formatMoney(i,'discount','EUR')
                i.pay_amount = formatMoney(i,'pay_amount','EUR')
                i.invoice_amount = formatMoney(i,'invoice_amount','EUR')
                i.pre_amount = i.pre_amount == undefined? '-' : formatMoney(i,'pre_amount','EUR'),
                i.handle_timestamp_val = i.handle_timestamp == undefined? '-' : timestampToDate(i.handle_timestamp * 1000).split(' ')[0],
                i.torque = i.torque == undefined? '-' : i.torque
                i.tax_rate = i.tax_rate == undefined? '-' : i.tax_rate * 100 + '%'
                i.order_status_val = row.order_status_val
                i.cancel_status_val = i.cancel_status == undefined? '-' : i.cancel_status
                i.cancel_status = i.cancel_status == undefined? t('order.notCancel') : i.cancel_status == 0? t('order.partialCanceled') : t('order.canceled')
                i.cancel_quantity = i.cancel_quantity == undefined? '-' : i.cancel_quantity,
                i.isEdit = false
                i.disabled = i.erp_line_no == '-' || 
                            (i.ship_quantity !== '-' && i.ship_quantity >= i.quantity) ||  
                            (row.order_status_val == 1 && i.pre_amount !== '-' && !row.order_child_no) || 
                            i.cancel_status_val == 1 || i.product_code == '100.100' // 是否允许发货    
                i.user_comment = i.user_note == undefined? '-' : i.user_note
                i.enable = createOrderForm1.formData.order_channel_type == 1 || createOrderForm1.formData.order_channel_type == 5
            })
            // console.log(res.data,'res.data')

            if(type != 'createPrepaymentOrder'){
                item.child.innerDatas = []
                res.data.forEach(i=>{ // 不展示没有sku的数据
                    if(!!i.sku){
                        item.child.innerDatas.push(i)
                    }
                })

                // console.log(item.child.innerDatas,'child')
                item.child.innerDatas.forEach((i,index)=>{
                    i.serial = index + 1
                })
                item.child.innerConfigs.loading = false
                // item.child.innerConfigs.rowSelection.showCheckedAll = item.child.innerDatas.length < 16
            }
            if(type == 'createPrepaymentOrder'){
                createPrePayOrderTable.value.datas = []
                res.data.forEach((i,index)=>{
                    i.serial = index + 1
                    i.disabled = i.quantity == i.prepaid_quantity
                    createPrePayOrderTable.value.datas.push(i)
                })
                
            }
        }else{
            Message.error(res.msg)
        }
    }

    // 取消SO，获取订单行
    const getCancelSOOrderLine = async (id,row)=>{
        let param = {
            order_id: id,
        }
        cancelSOTable.value.configs.loading = true
        let res = await OrderApi.getInstance().getOrderLine(param)
        if(res.code == 0){
            res.data.forEach(i=>{
                i.order_id = row.id
                i.erp_no = row.erp_no
                i.customer_name = row.customer_name
                i.country = row.country
                i.order_name = row.order_name
                i.source = row.source
                i.order_line_no = i.order_line_no == undefined? '-' : i.order_line_no
                i.erp_line_no = i.erp_line_no == undefined? '-' : i.erp_line_no
                i.product_name = i.product_map == undefined? '-' : i.product_map.english_name
                i.inventory_code = i.inventory_code == undefined? '-' : i.inventory_code
                i.inventory = i.inventory == undefined? '-' :  i.inventory 
                i.quantity = i.quantity == undefined? '-' : i.quantity
                i.ship_quantity = i.ship_quantity == undefined? '-' :i.ship_quantity
                i.unit_code = i.product_map == undefined? '-' : i.product_map.unit_code
                i.pay_currency = row.pay_currency
                i.amount = formatMoney(i,'amount','EUR') 
                i.discount = formatMoney(i,'discount','EUR')
                i.pay_amount = formatMoney(i,'pay_amount','EUR')
                i.pre_amount = i.pre_amount == undefined? '-' : formatMoney(i,'pre_amount','EUR'),
                i.handle_timestamp_val = i.handle_timestamp == undefined? '-' : timestampToDate(i.handle_timestamp * 1000),
                i.torque = i.torque == undefined? '-' : i.torque
                i.tax_rate = i.tax_rate == undefined? '-' : i.tax_rate * 100 + '%'
                i.order_status_val = row.order_status_val
                i.cancel_quantity = i.cancel_quantity == undefined? '-' : i.cancel_quantity
                i.cancel_status_val = i.cancel_status == undefined? '-' : i.cancel_status
                i.cancel_status = i.cancel_status == undefined? t('order.notCancel') : i.cancel_status == 0? t('order.partialCanceled') : t('order.fullCanceled')
                i.disabled = row.erp_no == '-' || i.erp_line_no == '-' || i.courier_status_val == 3 || i.quantity == 0 || 
                            (i.ship_quantity !== '-' && (i.ship_quantity > i.quantity || i.ship_quantity == i.quantity)) || i.cancel_status_val == 1  // 是否允许取消SO, 已出库/状态为已取消，都不能取消SO
            })

            let cancelSOTable_arr = []
            cancelSOTable.value.datas = []
            res.data.forEach(i=>{ // 不展示没有sku的数据
                if(!!i.sku && !i.disabled){
                    cancelSOTable.value.datas.push(i) // 可取消SO的订单行
                }

                if(!!i.sku) cancelSOTable_arr.push(i)
            })

            // 整个订单的订单行总数
            cancelSOTableDataLength.value = cancelSOTable_arr.length

            cancelSOTable.value.configs.loading = false

            // 根据角色判断，是否显示复选框
            // let roleArr = userInfo.role.split(',')
            // isFinance.value = roleArr.some(i=> i == '4')
            if(isFinance.value){
                cancelSOTable.value.configs.rowSelection = {
                    type: 'checkbox',
                    showCheckedAll: true,
                    onlyCurrent: false,
                }
            }else{
                cancelSOTable.value.configs.rowSelection = null
            }
        }else{
            Message.error(res.msg)
        }
    }

    // 同步erp时设置生产数量，获取订单行
    const getErpSyncTableOrderLine = async (id,row)=>{
        let param = {
            order_id: id,
        }
        erpsyncTable.value.configs.loading = true
        let res = await OrderApi.getInstance().getOrderLine(param)
        if(res.code == 0){
            res.data.forEach(i=>{
                i.order_id = row.id
                i.erp_no = row.erp_no
                i.customer_name = row.customer_name
                i.country = row.country
                i.order_name = row.order_name
                i.source = row.source
                i.order_line_no = i.order_line_no == undefined? '-' : i.order_line_no
                i.erp_line_no = i.erp_line_no == undefined? '-' : i.erp_line_no
                i.product_name = i.product_map == undefined? '-' : i.product_map.english_name
                i.quantity = i.quantity == undefined? '-' : i.quantity
                // i.produce_quantity = i.produce_quantity == undefined? '' : i.produce_quantity
                i.error = false
            })

            erpsyncTable.value.datas = []
            let arr = []
            res.data.forEach(i=>{ // 不展示没有sku的数据
                if(!!i.sku){
                    erpsyncTable.value.datas.push(i)
                    if(i.produce_quantity === ''){
                        arr.push(i)
                    }
                }
            })

            row.isSaveProductQty = arr.length > 0
            erpsyncTable.value.configs.loading = false
        }else{
            Message.error(res.msg)
        }
    }

    // 创建订单校验
    const vaildCreateOrder = async ()=>{
        let formItem2 = createOrderForm1.formField.find(i=>i.key == 'payment_type')

        let year = '', yearMonth = '', currentYearMonth = ''
        if(createOrderForm1.formData.order_timestamp){
            year = createOrderForm1.formData.order_timestamp.split(' ')[0].split('-')[0]
            let month = createOrderForm1.formData.order_timestamp.split(' ')[0].split('-')[1]
            yearMonth = `${year}-${month}`
            
            let cur_year = getNowDate().split('-')[0]
            let cur_month = getNowDate().split('-')[1]
            currentYearMonth = `${cur_year}-${cur_month}`

            // console.log(yearMonth,'yearMonth', currentYearMonth, currentYearMonth == yearMonth, createOrderForm1.formData.predict_delivery_year)
            // console.log(dateToTimestamp(createOrderForm1.formData.earliest_ship_timestamp.split(' ')[0]), dateToTimestamp(createOrderForm1.formData.order_timestamp.split(' ')[0]), dateToTimestamp(createOrderForm1.formData.earliest_ship_timestamp.split(' ')[0]) < dateToTimestamp(createOrderForm1.formData.order_timestamp.split(' ')[0]))
        }

        if(createOrderForm1.formData.order_type == 1 && createOrderForm1.formData.order_use === ''){
            Message.error(t('order.orderUse') +' '+ t('base.noEmpty'))
            return false
        }else if(createOrderForm1.formData.order_type == 1 && createOrderForm1.formData.order_use != 'TRANSFER_WAREHOUSE' && createOrderForm1.formData.back_flag === ''){
            Message.error(t('order.backFlag') +' '+ t('base.noEmpty'))
            return false
        }else if(createOrderForm1.formData.source === ''){
            Message.error(t('order.orderSource') +' '+ t('base.noEmpty'))
            return false
        }else if(!createOrderForm1.formData.order_name){
            Message.error(t('order.orderName') +' '+ t('base.noEmpty'))
            return false
        }else if(createOrderForm1.formData.order_status === ''){
            Message.error(t('order.orderStatus') +' '+ t('base.noEmpty'))
            return false
        }else if(!createOrderForm1.formData.order_timestamp){
            Message.error(t('order.orderTimestamp') +' '+ t('base.noEmpty'))
            return false
        }else if(formItem2.required && createOrderForm1.formData.payment_type === ''){
            Message.error(t('order.paymentType') +' '+ t('base.noEmpty'))
            return false
        }else if(createOrderForm1.formData.pay_type_discount === ''){
            Message.error(t('order.payTypeDiscount') +' '+ t('base.noEmpty'))
            return false
        }else if(createOrderForm1.formData.cargo_freight === ''){
            Message.error(t('order.cargoFreight') +' '+ t('base.noEmpty'))
            return false
        }else if(createOrderForm3.formData.customer_entity_id === ''){
            Message.error(t('order.customerName') +' '+ t('base.noEmpty'))
            return false
        }else if(createOrderForm3.formData.customer_id === ''){
            Message.error(t('order.defaultAddress') +' '+ t('base.noEmpty'))
            return false
        }else if(createOrderForm3.formData.customer_invoice_id === ''){
            Message.error(t('order.invoiceAddress') +' '+ t('base.noEmpty'))
            return false
        }

        for(let i=0; i<orderLineTable.value.datas.length; i++){
            let item = orderLineTable.value.datas[i]
            if(!item.sku){
                Message.error(t('order.sku') +' '+ t('base.noEmpty'))
                return false
            }
            else if(item.amount == ''){
                Message.error(t('order.amount') +' '+ t('base.noEmpty'))
                return false
            }
            else if(item.quantity == '' && item.cancel_status_val == ''){
                Message.error(t('order.quantity') +' '+ t('base.noEmpty'))
                return false
            }
            else if(orderOperateType.value == 'createPrepaidOrder' && item.quantity > item.max_quantity){
                Modal.confirm({
                    title: t('base.tip'),
                    titleAlign:'start',
                    hideCancel:true,
                    content:`SKU 【${item.sku}】` + t('order.exceedingMaxQty') + item.max_quantity + t('order.exceedingMaxQty2'),
                    okText:t('base.ok'),
                    onOk:()=>{},
                })
                return false
            }
            else if(!item.handle_timestamp && createOrderForm1.formData.order_channel_type != 4){
                Message.error(t('order.handleTimestamp') +' '+ t('base.noEmpty'))
                return false
            }
        }

        if(!createOrderForm2.formData.order_amount){
            Message.error(t('order.orderAmount') +' '+ t('base.noEmpty'))
            return false
        }else if(createOrderForm2.formData.quantity == 0){
            Modal.confirm({
                title: t('base.tip'),
                titleAlign:'start',
                hideCancel:true,
                width:500,
                content:t('order.quantityNoZero'),
                okText:t('base.ok'),
            })
            return false
        }else if(createOrderForm2.formData.pay_amount === ''){
            Message.error(t('order.payAmount') +' '+ t('base.noEmpty'))
            return false
        }else if(createOrderForm2.formData.pay_amount < 0){
            Message.error(t('order.payAmount') +' '+ t('base.notLess0'))
            return false
        }

        await createOrder()
        if(hasError.value){
            return false
        }


        return true
    }

    // 确认创建订单
    const onCreateOrderBeforeOk = ()=>{
        return vaildCreateOrder()
    }

    // 创建订单
    const createOrder = async ()=>{
        createOrderForm1.formField.forEach(i=>{
            if(i.key == 'courier_status'){
                createOrderForm1.formData[i.key] = createOrderForm1.formData[i.key] == ''? 0 : createOrderForm1.formData[i.key]
            }
            if(i.key == 'pay_type_discount' || i.key == 'cargo_freight'){
                createOrderForm1.formData[i.key] = formatterToPoint(createOrderForm1.formData[i.key])
            }
        })
        createOrderForm2.formField.forEach(i=>{
            if(i.key != 'quantity'){
                createOrderForm2.formData[i.key] = createOrderForm2.formData[i.key] == ''? 0 : formatterToPoint(createOrderForm2.formData[i.key])
            }else{
                createOrderForm2.formData[i.key] = createOrderForm2.formData[i.key] == ''? 0 : createOrderForm2.formData[i.key]
            }
        })

        let item = createOrderForm1.formField.find(i=> i.key == 'source')
        let optItem = item.options.find(i=> i.value == createOrderForm1.formData.source)
        createOrderForm1.formData.prepaid_flag = optItem.prepaid_flag  // 是否预付客户 0:否   1：是
        createOrderForm1.formData.bike_quantity = 0
        createOrderForm1.formData.pay_currency = 'EUR'
        if(orderOperateType.value == 'add') {
            createOrderForm1.formData.order_no = new Date().getTime().toString().slice(0,10)
        }

        let order_line_vos = orderLineTable.value.datas.map((i,index)=>{
            if(i.product_code == '627.501'){  // 计算整车数量
                createOrderForm1.formData.bike_quantity += i.quantity
            }

            let obj_line = {}
            if(orderOperateType.value == 'createPrepaidOrder'){ // 预付款订单
                obj_line = {
                    order_id: i.order_id,
                    order_line_id: i.id,
                    status:1,
                    order_name:createOrderForm1.formData.order_name,
                    erp_line_no: i.erp_line_no == '-'? '' : i.erp_line_no,
                    sku:i.sku,
                    inventory_code:i.inventory_code,
                    product_code:i.product_code,
                    amount:formatterToPoint(i.amount),
                    quantity:i.quantity,
                    discount_rate: i.discount_rate,
                    discount:formatterToPoint(i.discount),
                    extra_discount:formatterToPoint(i.extra_discount),
                    pay_amount:formatterToPoint(i.pay_amount),
                    order_tax:formatterToPoint(i.order_tax),
                    tax_rate:i.tax_rate_val,
                    handle_timestamp:dateToTimestamp(i.handle_timestamp)
                }
                return obj_line
            }else if(createOrderForm1.formData.order_channel_type == 4){ // 保险订单
                obj_line = {
                    order_line_no: !i.order_line_no? Number(new Date().getTime().toString().slice(0,10)) + index + 1 : i.order_line_no, // 用于后端区分行
                    bind_order_line_id: i.bind_order_line_id,
                    bind_sku:i.bind_sku,
                    stock_out_id: i.stock_out_id,
                    sku:i.sku,
                    inventory_code:i.inventory_code,
                    product_code:i.product_code,
                    amount:formatterToPoint(i.amount),
                    quantity:i.quantity,
                    discount_rate: i.discount_rate,
                    discount:formatterToPoint(i.discount),
                    extra_discount:formatterToPoint(i.extra_discount),
                    pay_amount:formatterToPoint(i.pay_amount),
                    tax_rate:i.tax_rate_val,
                    order_tax:formatterToPoint(i.order_tax),
                    name:i.name,
                    torque:i.torque,
                    handle_timestamp:''
                }
                return !i.id? obj_line : { ...obj_line, id: i.id, order_id: i.order_id, erp_line_no: i.erp_line_no }
            }else if(createOrderForm1.formData.order_channel_type == 5){ // 保存虚拟订单
                obj_line = {
                    order_line_no: !i.order_line_no? Number(new Date().getTime().toString().slice(0,10)) + index + 1 : i.order_line_no, // 用于后端区分行
                    sku:i.sku,
                    inventory_code:i.inventory_code,
                    product_code:i.product_code,
                    amount:formatterToPoint(i.amount),
                    quantity:i.quantity,
                    discount_rate: i.discount_rate,
                    discount:formatterToPoint(i.discount),
                    extra_discount:formatterToPoint(i.extra_discount),
                    pay_amount:formatterToPoint(i.pay_amount),
                    tax_rate:i.tax_rate_val,
                    order_tax:formatterToPoint(i.order_tax),
                    name:i.name,
                    torque:i.torque,
                    user_note: i.user_note,
                    handle_timestamp:dateToTimestamp(i.handle_timestamp)
                }

                if(orderOperateType.value == 'add'){
                    return obj_line
                }else if(orderOperateType.value == 'edit'){
                    return { ...obj_line, id: i.id, order_id: i.order_id, erp_line_no: i.erp_line_no }
                }
                // return !i.id? obj_line : { ...obj_line, id: i.id, order_id: i.order_id, erp_line_no: i.erp_line_no }


            }else{
                obj_line = {
                    order_line_no: !i.order_line_no? Number(new Date().getTime().toString().slice(0,10)) + index + 1 : i.order_line_no, // 用于后端区分行
                    sku:i.sku,
                    inventory_code:i.inventory_code,
                    product_code:i.product_code,
                    amount:formatterToPoint(i.amount),
                    quantity:i.quantity,
                    discount_rate: i.discount_rate,
                    discount:formatterToPoint(i.discount),
                    extra_discount:formatterToPoint(i.extra_discount),
                    pay_amount:formatterToPoint(i.pay_amount),
                    tax_rate:i.tax_rate_val,
                    order_tax:formatterToPoint(i.order_tax),
                    name:i.name,
                    torque:i.torque,
                    user_note: i.user_note,
                    handle_timestamp:dateToTimestamp(i.handle_timestamp)
                }

                return !i.id? obj_line : { ...obj_line, id: i.id, order_id: i.order_id, erp_line_no: i.erp_line_no }
            }
        })

        if(createOrderForm1.formData.order_channel_type == 5 && orderOperateType.value == 'edit'){
            createOrderForm2.formData.c2c_extra_rate = 0.05
        }

        createOrderForm3.formData.order_confirm_mail = !createOrderForm3.formData.order_confirm_mail? null : createOrderForm3.formData.order_confirm_mail
        console.log(createOrderForm3.formData, 'createOrderForm3.formData 555555555')
        let obj = {
            ...createOrderForm1.formData,
            ...createOrderForm2.formData,
            ...createOrderForm3.formData,
            order_timestamp: dateToTimestamp(createOrderForm1.formData.order_timestamp),
            earliest_ship_timestamp: !createOrderForm1.formData.earliest_ship_timestamp? '' : dateToTimestamp(createOrderForm1.formData.earliest_ship_timestamp),
            pay_type_discount:formatterToPoint(createOrderForm1.formData.pay_type_discount),
            payment_due_date: !createOrderForm1.formData.payment_due_date? '' : dateToTimestamp(`${createOrderForm1.formData.payment_due_date} 00:00:00`),
            // payment_type_discount: createOrderForm1.formData.payment_type_discount.split('%')[0]/100,
        }

        if(orderOperateType.value == 'createPrepaidOrder'){
            obj.order_lines = order_line_vos
        }else{
            obj.order_line_vos = order_line_vos
            obj.risk_validate = 2
            obj.risk_level = 1
        }
        let param = orderOperateType.value == 'add' || orderOperateType.value == 'createPrepaidOrder'? obj : {...obj, id:createOrderForm1.formData.order_id} 

        // console.log(param,'创建订单提交')
        let res = history.state.fromPage == 'DealerBusinessOrder'
                ? await DealerApi.getInstance().savebusinessOrder(param)  // 业务订单生成订单
                : history.state.fromPage == 'B2BShopOrder'
                ? await DealerApi.getInstance().saveB2BOrder(param)  // B2B Shop订单生成订单
                : orderOperateType.value == 'createPrepaidOrder'
                ? await OrderApi.getInstance().createPrePaidOrder(param) // 创建预付款订单
                : createOrderForm1.formData.order_channel_type == 4
                ? await OrderApi.getInstance().createServiceOrder(param) // 创建服务订单
                : createOrderForm1.formData.order_channel_type == 5 && orderOperateType.value == 'add'
                ? await OrderApi.getInstance().createC2COrder(param) // 创建C&C订单
                : await OrderApi.getInstance().createOrder(param) // 创建普通订单
        if(res.code == 0){
            if(isSyncERP.value){
                Modal.warning({
                    title: t('base.tip'),
                    titleAlign:'start',
                    hideCancel:true,
                    width:500,
                    content: ()=> h('div',{},[
                        h('p',`${t('base.editSuccess')}!`),
                        h('p',`${t('order.editOrderConfirmTip3')}`),
                        h('p',`${t('order.editOrderConfirmTip2')}`),
                    ]),
                    okText:t('base.ok'),
                    onOk:()=>{}
                })
            }else{
                orderOperateType.value == 'add' || orderOperateType.value == 'createPrepaidOrder'
                    ? Message.success(t('order.createSuccess')) 
                    : Message.success(t('base.editSuccess'))
            }
        
            hasError.value = false
            if(history.state.fromPage == 'DealerBusinessOrder'){ // 跳转回经销商业务订单列表
                router.push('/OrderList/DealerBusinessOrder')
            }else if(history.state.fromPage == 'B2BShopOrder'){ // 跳转回B2B Shop订单列表
                router.push('/OrderList/B2BShopOrderList')
            }else{
                getOrderHead()
            }
        }else{
            Message.error(res.msg)
            hasError.value = true
        }
    }

    // 创建预付款订单
    const onCreatePrePaidOrderBeforeOk = async()=>{
        createPrepaidOrder(rowData.value)
    }

    // 新增客户前校验
    const onAddCustomerBeforeOk = async ()=>{
        let email_pattern = /^[a-zA-Z0-9_.-]+@[a-zA-Z0-9-]+(\.[a-zA-Z0-9-]+)*\.[a-zA-Z0-9]{2,}$/
        let base_email_bool = email_pattern.test(addBaseInfoForm.formData.email)
        let address_email_bool = email_pattern.test(addAddressInfoForm.formData.email)
        let invoice_address_email_bool = email_pattern.test(addInvoiceAddressForm.formData.email)

        if(!addBaseInfoForm.formData.name){ // 客户基本信息
            Message.error(t('customer.customerName') + ' ' + t('base.noEmpty'))
            return false
        }else if(!addBaseInfoForm.formData.source){
            Message.error(t('order.orderSource') + ' ' + t('base.noEmpty'))
            return false
        }else if(addBaseInfoForm.formData.type === ''){
            Message.error(t('customer.customerType') + ' ' + t('base.noEmpty'))
            return false
        }else if(!addBaseInfoForm.formData.email){ 
            Message.error(t('customer.customerEmail') + ' ' + t('base.noEmpty'))
            return false
        }else if(!!addBaseInfoForm.formData.email && !base_email_bool){ 
            Message.error(t('customer.customerEmailFormatError'))
            return false
        }else if(!addBaseInfoForm.formData.country){
            Message.error(t('customer.customerCountry') + ' ' + t('base.noEmpty'))
            return false
        }else if(!addAddressInfoForm.formData.name){ // 客户默认地址信息
            Message.error(t('customer.customerName') + ' ' + t('base.noEmpty'))
            return false
        }else if(addAddressInfoForm.formData.email === ''){
            Message.error(t('customer.customerEmail') + ' ' + t('base.noEmpty'))
            return false
        }else if(!!addAddressInfoForm.formData.email && !address_email_bool){ 
            Message.error(t('customer.customerEmailFormatError'))
            return false
        }else if(addAddressInfoForm.formData.phone === ''){
            Message.error(t('customer.customerPhone') + ' ' + t('base.noEmpty'))
            return false
        }else if(addAddressInfoForm.formData.zip === ''){
            Message.error(t('customer.zip') + ' ' + t('base.noEmpty'))
            return false
        }else if(!addAddressInfoForm.formData.country){
            Message.error(t('customer.customerCountry') + ' ' + t('base.noEmpty'))
            return false
        }else if(!addAddressInfoForm.formData.city){
            Message.error(t('customer.customerCity') + ' ' + t('base.noEmpty'))
            return false
        }else if(!addAddressInfoForm.formData.street){
            Message.error(t('dealer.street') + ' ' + t('base.noEmpty'))
            return false
        }else if(addAddressInfoForm.formData.address === ''){
            Message.error(t('customer.customerAddr') + ' ' + t('base.noEmpty'))
            return false
        }else if(!addAddressInfoForm.formData.house_number){
            Message.error(t('dealer.houseNumber') + ' ' + t('base.noEmpty'))
            return false
        }else if(checked.value && !addInvoiceAddressForm.formData.name){  // 客户发票地址信息
            Message.error(t('customer.customerName') + ' ' + t('base.noEmpty'))
            return false
        }else if(checked.value && addInvoiceAddressForm.formData.email === ''){
            Message.error(t('customer.customerEmail') + ' ' + t('base.noEmpty'))
            return false
        }else if(checked.value && !!addInvoiceAddressForm.formData.email && !invoice_address_email_bool){ 
            Message.error(t('customer.customerEmailFormatError'))
            return false
        }else if(checked.value && addInvoiceAddressForm.formData.phone === ''){
            Message.error(t('customer.customerPhone') + ' ' + t('base.noEmpty'))
            return false
        }else if(checked.value && addInvoiceAddressForm.formData.zip === ''){
            Message.error(t('customer.zip') + ' ' + t('base.noEmpty'))
            return false
        }else if(checked.value && !addInvoiceAddressForm.formData.country){
            Message.error(t('customer.customerCountry') + ' ' + t('base.noEmpty'))
            return false
        }else if(checked.value && !addInvoiceAddressForm.formData.city){
            Message.error(t('customer.customerCity') + ' ' + t('base.noEmpty'))
            return false
        }else if(checked.value && !addInvoiceAddressForm.formData.street){
            Message.error(t('dealer.street') + ' ' + t('base.noEmpty'))
            return false
        }else if(checked.value && addInvoiceAddressForm.formData.address === ''){
            Message.error(t('customer.customerAddr') + ' ' + t('base.noEmpty'))
            return false
        }else if(checked.value && !addInvoiceAddressForm.formData.house_number){
            Message.error(t('dealer.houseNumber') + ' ' + t('base.noEmpty'))
            return false
        }

        let flag = await handleAddCustomer()

        return flag
    }

    const handleAddCustomer = async ()=>{
        let invoiceAddrForm = checked.value? addInvoiceAddressForm.formData : addAddressInfoForm.formData
        let param = {
           ...addBaseInfoForm.formData,
           email_service_flag: addBaseInfoForm.formData.email_service_flag == 'YES'? 1 : addBaseInfoForm.formData.email_service_flag == 'NO'? 0 : '',
           order_address_vos:[{
                ...addAddressInfoForm.formData,
                first_flag:1,
                type: addBaseInfoForm.formData.type,
                source: addBaseInfoForm.formData.source,
                erp_code: addBaseInfoForm.formData.erp_code,
           },{
                ...invoiceAddrForm,
                first_flag:1,
                address_type:1,
                type: addBaseInfoForm.formData.type,
                source: addBaseInfoForm.formData.source,
                erp_code: addBaseInfoForm.formData.erp_code,
           }]
        }

        // 回填数据前先禁用
        let item = createOrderForm3.formField.find(i=>i.key == 'customer_entity_id')
        let delivery_item = createOrderForm3.formField.find(i=>i.key == 'customer_id')
        let invoice_item = createOrderForm3.formField.find(i=>i.key == 'customer_invoice_id')
        item.disabled = true
        delivery_item.disabled = true
        invoice_item.disabled = true

        let res = await CustomerApi.getInstance().addCustomer(param)
        if(res.code == 0){
            Message.success(t('base.addSuccess'))

            await getCustomerList()
            
            // 自动带出相关数据
            createOrderForm3.formData.customer_entity_id = res.data.entity.id
            createOrderForm3.formData.name2 = res.data.entity.name2
            createOrderForm3.formData.customer_email = res.data.entity.email
            createOrderForm3.formData.customer_type = res.data.entity.type
            createOrderForm3.formData.customer_name = res.data.entity.name

            await getCustomerAddressList()
            // console.log(res.data.customerAddresses,'addr')
            createOrderForm3.formData.customer_id = res.data.customerAddresses[0].id
            createOrderForm3.formData.customer_invoice_id = res.data.customerAddresses[1].id
            createOrderForm3.formData.country = res.data.customerAddresses[1].country

            // 数据回填完，解禁
            item.disabled = false
            delivery_item.disabled = false
            invoice_item.disabled = false

            // 根据国家带出税率
            // console.log(createOrderForm1.formData.order_channel_type,'gggg')
            if(createOrderForm1.formData.order_channel_type == 0){
                if(createOrderForm1.formData.tax_rate != '0.00' && createOrderForm3.formData.country == 'Italy'){
                    createOrderForm1.formData.tax_rate = '0.22'
                    handleCreateOrderSelectChange('0.22',undefined,'tax_rate')
                }else if(createOrderForm1.formData.tax_rate != '0.00' && (createOrderForm3.formData.country == 'France' || createOrderForm3.formData.country == 'Austria')){
                    createOrderForm1.formData.tax_rate = '0.20'
                    handleCreateOrderSelectChange('0.20',undefined,'tax_rate')
                }else if(createOrderForm1.formData.tax_rate != '0.00' && (createOrderForm3.formData.country == 'Germany' || createOrderForm3.formData.country == '')){
                    createOrderForm1.formData.tax_rate = '0.19'
                    handleCreateOrderSelectChange('0.19',undefined,'tax_rate')
                }
            }

            return true
            
        }else{
            Message.error(res.msg)
            item.disabled = false
            delivery_item.disabled = false
            invoice_item.disabled = false

            return false
        }
    }

    // 发送发票
    const sendInvoice = async (orderName, row)=>{
        Message.success(t('base.sending'))
        sending.value = true
        let res = await OrderApi.getInstance().sendInvoiceToEmail(encodeURIComponent(orderName))
        if(res.code == 0){
           Message.success(t('base.sendSuccess'))
           sending.value = false
           row.sendBtnText = t('order.reSend')
        }else{
            Message.error(res.msg)
            sending.value = false
        }
    }

    // 获取发送发票次数
    const getSendInvoiceCount = async(row)=>{
        let res = await OrderApi.getInstance().getSendInvoiceCount(row.id)
        if(res.code == 0){
           Modal.warning({
                title: t('base.tip'),
                titleAlign: 'start',
                hideCancel: false,
                content: res.data == undefined || res.data == 0? t('order.sendInvoiceMsg') : ()=>h('div',{style:'font-weight:bold'}, t('order.sendInvoiceMsg2') + res.data + t('order.sendInvoiceMsg3') + t('order.sendInvoiceMsg4')), 
                cancelText: t('base.cancel'),
                okText: t('base.ok'),
                onOk: () => {
                    sendInvoice(row.order_name, row)
                }
            });
        }else{
            Message.error(res.msg)
        }
    }

    // 删除发票
    const deleteInvoice = async(row)=>{
        let res = await OrderApi.getInstance().deleteInvoice(encodeURIComponent(row.order_name))
        if(res.code == 0){
            Message.success(t('base.delSuccess'))
            getOrderHead()
        }else{
            Message.error(res.msg)
        }
    }

    const changeInvoiceType = ()=>{
        // console.log(existHistoryInvoice.value,'kk')
        if(!existHistoryInvoice.value){
            invoice_date.value = getNowDate()
        }
    }

    // 检查发票是否存在
    const validIsExistInvoice = async(row)=>{
        let res = await OrderApi.getInstance().validIsExistInvoice(row.id, 1)
        if(res.code == 0){
            downloadInvoiceDisabled.value = res.data == undefined
            downloadType.value = ''
            if(!!res.data) invoice_date.value = timestampToDate(res.data.create_timestamp * 1000).split(' ')[0]
            existHistoryInvoice.value = !!res.data
            validDownloadInvoice(row)
        }else{
            Message.error(res.msg)
        }
    }

    // 检验是否可以下载自定义日期发票
    const validDownloadInvoice = async(row)=>{
        let res = await OrderApi.getInstance().validDownloadInvoice(row.id)
        if(res.code == 0){
            downloadCustomDateInvoiceDisabled.value = false
            if(downloadInvoiceDisabled.value && downloadCustomDateInvoiceDisabled.value){
                downloadType.value = ''
            }else if(downloadInvoiceDisabled.value && !downloadCustomDateInvoiceDisabled.value){
                downloadType.value = '2'
            }else{
                downloadType.value = '1'
            }

            spinLoading.value = false
        }else{
            downloadCustomDateInvoiceDisabled.value = true
            if(downloadInvoiceDisabled.value && downloadCustomDateInvoiceDisabled.value){
                downloadType.value = ''
            }else{
                downloadType.value = '1'
            }

            spinLoading.value = false
        }
    }

    // 自定义发票日期
    const changeInvoiceDate = (dateString, date)=>{
        // console.log(dateString, date,'dateString, date')
        invoice_date.value = dateString
    }

    // 确认下载发票
    // const onDownloadInvoiceBeforeOk = async ()=>{
        // if(downloadType.value == '2' && !invoice_date.value){
        //     Message.error(t('base.selectData'))
        //     return false
        // }

        // table.value.configs.loading = true
        // let url = downloadType.value == '1'? import.meta.env.VITE_BASE_URL + `/invoice/download/${encodeURIComponent(rowData.value.order_name)}`
        //                                         : import.meta.env.VITE_BASE_URL + `/invoice/rebuild/${encodeURIComponent(rowData.value.order_name)}?invoice_date=${dateToTimestamp(invoice_date.value) * 1000}` 
        // let a = document.createElement('a')
        // a.href = url
        // a.style.display = 'none'
        // document.body.appendChild(a)
        // a.click()
        // document.body.removeChild(a)
        // setTimeout(()=>{
        //     table.value.configs.loading = false
        //     getOrderHead()
        // },1500) 

        // downloadInvoiceVisible.value = false
    // }

    // 检查确认书是否存在
    const validIsExistConfirmation = async(row)=>{
        let res = await OrderApi.getInstance().validIsExistInvoice(row.id, 4)
        if(res.code == 0){
            downloadConfirmationDisabled.value = res.data.length == 0
            downloadConfirmationType.value = downloadConfirmationDisabled.value? '2' : '1'
        }else{
            Message.error(res.msg)
        }
    }

    // 确认下载订单确认书
    const onDownloadConfirmationBeforeOk = async ()=>{
        // 兜底：无权限时不允许走生成分支（含接口返回前的短暂状态）
        if(downloadConfirmationType.value == '2' && reDownloadConfirmationDisabled.value){
            return false
        }
        if(downloadConfirmationType.value != '1' && downloadConfirmationType.value != '2'){
            return false
        }
        let param = {
            order_number: rowData.value.order_name,
            invoice_type: 4,
        }
        table.value.configs.loading = true
        let res = downloadConfirmationType.value == '1'
            ? await InvoiceApi.getInstance().downloadInvoice(param)
            : await InvoiceApi.getInstance().genertaeOrderInvoice(param)

        if(!res.code){
            let blob = new Blob([res],{type: 'application/octet-stream'})
            let a = document.createElement('a')
            a.href = URL.createObjectURL(blob)
            a.download = `${rowData.value.order_name}.pdf`
            a.style.display = 'none'
            document.body.appendChild(a)
            a.click()
            URL.revokeObjectURL(a.href)
            document.body.removeChild(a)
            setTimeout(()=>{
                table.value.configs.loading = false
                getOrderHead()
                Message.success(t('base.downloadSuccess'))
            },1500) 
            downloadConfirmationVisible.value = false
        }else{
            Message.error(res.msg)
            table.value.configs.loading = false
        }
    }

    // 发送确认书
    const sendConfirmation = async (row)=>{
        Message.success(t('base.sending'))
        let res = await OrderApi.getInstance().sendConfirmationToEmail(encodeURIComponent(row.order_name))
        if(res.code == 0){
            Message.success(t('base.sendSuccess'))
            row.sendBtnText = t('order.sending')
        }else{
            Message.error(res.msg)
        }
    }

    // 验证订单风险等级
    const onRiskBeforeOk = async ()=>{
        if(riskLevel.value === ''){
            Message.error(t('base.select'))
            return false
        }
        let res = await OrderApi.getInstance().vaildOrderRiskLevel(riskLevel.value,rowData.value.id)
        if(res.code == 0){
            riskLevel.value == 2? Message.success(t('order.confirmeSuccessful')) : Message.success(t('order.relieveSuccessful')) 
            table.value.configs.pagination.current = 1
            getOrderHead()
            return true
        }else{
            Message.error(res.msg)
        }
    }

    // 确认退换货前校验
    const onReturnBeforeOk =  ()=>{
        let { rowData, createReturnExchangeForm1, createReturnExchangeForm2, createReturnExchangeForm3, selected } = {...returnExchangeForm.value}

        if(createReturnExchangeForm1.formData.status === ''){
            Message.error(t('returnExchange.status')+ ' ' + t('base.noEmpty'))
            return false
        }

        else if(!createReturnExchangeForm2.formData.back_reason_type){
            Message.error(t('returnExchange.backReasonType')+ ' ' + t('base.noEmpty'))
            return false
        }else if(!createReturnExchangeForm2.formData.back_reason){
            Message.error(t('returnExchange.backReason')+ ' ' + t('base.noEmpty'))
            return false
        }else if(!createReturnExchangeForm2.formData.back_timestamp ){
            Message.error(t('returnExchange.backTimestamp')+ ' ' + t('base.noEmpty'))
            return false
        }else if(createReturnExchangeForm1.formData.type == 1 && !createReturnExchangeForm2.formData.back_factory ){
            Message.error(t('returnExchange.backFactory')+ ' ' + t('base.noEmpty'))
            return false
        }else if(createReturnExchangeForm1.formData.type == 1 && !createReturnExchangeForm2.formData.courier_type){
            Message.error(t('returnExchange.courierType')+ ' ' + t('base.noEmpty'))
            return false
        }else if(createReturnExchangeForm1.formData.type == 1 && !createReturnExchangeForm2.formData.courier_no){
            Message.error(t('returnExchange.courierNo')+ ' ' + t('base.noEmpty'))
            return false
        }else if(createReturnExchangeForm1.formData.type == 2 && !!createReturnExchangeForm2.formData.courier_type && !createReturnExchangeForm2.formData.courier_no){
            Message.error(t('returnExchange.courierNo')+ ' ' + t('base.noEmpty'))
            return false
        }else if(!!createReturnExchangeForm3.formData.swap_courier_type && !createReturnExchangeForm3.formData.swap_courier_no){
            Message.error(t('returnExchange.swapCourierNo')+ ' ' + t('base.noEmpty'))
            return false
        }else if(createReturnExchangeForm1.formData.type == 2 && !createReturnExchangeForm3.formData.swap_timestamp_plan){
            Message.error(t('returnExchange.swapTimestampPlan')+ ' ' + t('base.noEmpty'))
            return false
        }else if(selected.length == 0){
            Message.error(t('returnExchange.selectProduct'))
            return false
        }

        for(let i=0; i<selected.length; i++){
            let item = selected[i]

            // 退货、换货时
            if(createReturnExchangeForm1.formData.type == 1 && !item.back_quantity){
                Message.error(t('returnExchange.backQuantity')+ ' ' + t('base.noEmpty'))
                return false
            }

            // 换货时
            if(createReturnExchangeForm1.formData.type == 2){
                if(!item.swap_type_val){
                    Message.error(t('returnExchange.swapType')+ ' ' + t('base.noEmpty'))
                    return false
                }else if(item.back_quantity === ''){
                    Message.error(t('returnExchange.backQuantity')+ ' ' + t('base.noEmpty'))
                    return false
                }else if(item.swap_type_val == 2 && !item.bom){
                    Message.error(t('returnExchange.bom2')+ ' ' + t('base.noEmpty'))
                    return false
                }else if(!item.swap_quantity){
                    Message.error(t('returnExchange.swapQuantity')+ ' ' + t('base.noEmpty'))
                    return false
                }else if(item.swap_quantity <= 0 ){
                    Message.error(t('returnExchange.swapQuantity')+ ' ' + t('order.greaterThan0'))
                    return false
                }else if(item.swap_type_val == 1 && !item.swap_inventory_code){
                    Message.error(t('returnExchange.swapInventoryCode2')+ ' ' + t('base.noEmpty'))
                    return false
                }else if(!item.swap_inventory){
                    Message.error(t('returnExchange.warehouse')+ ' ' + t('base.noEmpty'))
                    return false
                }
            }
        }
        
        let order_timestamp = dateToTimestamp(rowData.order_timestamp)
        let delivery_timestamp = dateToTimestamp(selected[0].delivery_date) 
        let back_timestamp = Number(dateToTimestamp(createReturnExchangeForm2.formData.back_timestamp.split(' ')[0]))
        let swap_timestamp_plan = Number(dateToTimestamp(createReturnExchangeForm3.formData.swap_timestamp_plan.split(' ')[0]))
        let timestamp = order_timestamp > delivery_timestamp? order_timestamp : delivery_timestamp

        // console.log(order_timestamp, delivery_timestamp, back_timestamp, swap_timestamp_plan, timestamp,'timestamp')

        if(back_timestamp < timestamp){
            Modal.warning({
                title: t('base.tip'),
                titleAlign:'start',
                content: order_timestamp > delivery_timestamp? t('order.returnDateTip2') : t('order.returnDateTip'),
                hideCancel:true,
                okText:t('base.ok'),
                cancelText:t('base.cancel'),
                onOk:()=>{}
            })
            return false
        }else if(createReturnExchangeForm1.formData.type == 2 && swap_timestamp_plan < timestamp){
            Modal.warning({
                title: t('base.tip'),
                titleAlign:'start',
                content: order_timestamp > delivery_timestamp? t('order.planDateTip2') : t('order.planDateTip'),
                hideCancel:true,
                okText:t('base.ok'),
                cancelText:t('base.cancel'),
                onOk:()=>{}
            })
            return false
        }

        return true
    }

    // 确认创建退换货单
    const handleReturnOk = async ()=>{
        let { rowData, createReturnExchangeForm1, createReturnExchangeForm2, createReturnExchangeForm3, selected } = {...returnExchangeForm.value}
        // console.log(rowData,createReturnExchangeForm1,createReturnExchangeForm2,createReturnExchangeForm2,selected,'ccccc')

        let arr = []
        selected.forEach(i=>{
            if(createReturnExchangeForm1.formData.type == 1){ // 退货
                arr.push({
                    ...createReturnExchangeForm1.formData,
                    ...createReturnExchangeForm2.formData,
                    status:1, // 状态默认写死为1：处理中
                    source:createReturnExchangeForm1.formData.source_val,
                    discount: createReturnExchangeForm1.formData.discount == ''? 0 : createReturnExchangeForm1.formData.discount,
                    back_timestamp:dateToTimestamp(createReturnExchangeForm2.formData.back_timestamp),
                    stock_out_id:i.stock_out_id,
                    order_line_id:i.order_line_id,
                    erp_line_no:i.erp_line_no == '-'? '' : i.erp_line_no,
                    sku:i.sku,
                    inventory_code:i.inventory_code,
                    quantity: i.back_quantity,
                    instruction:i.instruction || ''
                })
            }else{ // 换货
                arr.push({
                    ...createReturnExchangeForm1.formData,
                    ...createReturnExchangeForm2.formData,
                    ...createReturnExchangeForm3.formData,
                    status:1, // 状态默认写死为1：处理中
                    source:createReturnExchangeForm1.formData.source_val,
                    back_timestamp:dateToTimestamp(createReturnExchangeForm2.formData.back_timestamp),
                    swap_timestamp_plan: dateToTimestamp(createReturnExchangeForm3.formData.swap_timestamp_plan),
                    stock_out_id:i.stock_out_id,
                    order_line_id:i.order_line_id,
                    erp_line_no:i.erp_line_no == '-'? '' : i.erp_line_no,
                    sku:i.sku,
                    inventory_code:i.inventory_code,
                    quantity: i.back_quantity,
                    swap_inventory_code: i.swap_type_val == 1? i.swap_inventory_code_val : i.bom.split('|')[0].trim(),
                    swap_inventory:i.swap_inventory_val,
                    swap_quantity:i.swap_quantity,
                    instruction:i.instruction || ''
                })
            }
        })
        // console.log(arr,'pppp')

        let res = await OrderApi.getInstance().createReturnExchangeOrder(arr, rowData.id, createReturnExchangeForm1.formData.type)
        if(res.code == 0){
            Message.success(t('base.success'))
            getOrderHead()
        }else{
            Message.error(res.msg)
        }
    }

    // 补寄校验
    const onReissueBeforeOk = async()=>{
        let { rowData, reissueForm2, table } = {...reissueForm.value}

        if(!reissueForm2.formData.back_reason_type){
            Message.error(t('order.reasonType')+ ' ' + t('base.noEmpty'))
            return false
        }else if(!reissueForm2.formData.back_reason){
            Message.error(t('order.reason')+ ' ' + t('base.noEmpty'))
            return false
        }else if(!reissueForm2.formData.swap_timestamp_plan ){
            Message.error(t('order.reissueTimestamp')+ ' ' + t('base.noEmpty'))
            return false
        }else if(!!reissueForm2.formData.swap_courier_type && !reissueForm2.formData.swap_courier_no){
            Message.error(t('returnExchange.swapCourierNo')+ ' ' + t('base.noEmpty'))
            return false
        }else if(!!reissueForm2.formData.swap_courier_no && !reissueForm2.formData.swap_courier_type){
            Message.error(t('returnExchange.swapCourierType')+ ' ' + t('base.noEmpty'))
            return false
        }else if(!reissueForm2.formData.swap_timestamp_plan){
            Message.error(t('returnExchange.swapTimestampPlan')+ ' ' + t('base.noEmpty'))
            return false
        }

        if(table.datas.length == 0){
            Message.error(t('order.selectProduct'))
            return false
        }

        for(let i=0; i<table.datas.length; i++){
            let item = table.datas[i]

            // console.log(item.swap_type_val, item.swap_inventory_code,'mmkk11')
            if(!item.swap_type_val){
                Message.error(t('order.reissueType')+ ' ' + t('base.noEmpty'))
                return false
            }else if(!item.swap_inventory_code){
                Message.error(t('order.swapInventoryCode')+ ' ' + t('base.noEmpty'))
                return false
            }else if(!item.swap_quantity){
                Message.error(t('order.reissueQuantity')+ ' ' + t('base.noEmpty'))
                return false
            }else if(!item.swap_inventory){
                Message.error(t('returnExchange.warehouse')+ ' ' + t('base.noEmpty'))
                return false
            }
        }

        let order_timestamp = dateToTimestamp(rowData.order_timestamp)
        let swap_timestamp_plan = Number(dateToTimestamp(reissueForm2.formData.swap_timestamp_plan.split(' ')[0]))
        if(swap_timestamp_plan < order_timestamp){
            Modal.warning({
                title: t('base.tip'),
                titleAlign:'start',
                content: t('order.reissueDateTip'),
                hideCancel:true,
                okText:t('base.ok'),
                cancelText:t('base.cancel'),
                onOk:()=>{}
            })
            return false
        }

        await createReissue()
        if(reissueHasError.value){
            return false
        }

        return true
    }

    // 确认创建补寄单
    const createReissue = async ()=>{
        let { rowData, reissueForm1, reissueForm2, table } = {...reissueForm.value}
        // console.log(rowData, reissueForm1, reissueForm2, table,'ccccc')

        let arr = []
        table.datas.forEach(i=>{
            let obj = {
                source:reissueForm1.formData.source_val,
                swap_timestamp_plan: dateToTimestamp(reissueForm2.formData.swap_timestamp_plan),
                back_reason_type: Number(reissueForm2.formData.back_reason_type),
                swap_sku:i.swap_sku,
                swap_inventory_code: i.swap_inventory_code_val,
                swap_inventory:i.swap_inventory_val,
                swap_quantity:i.swap_quantity,
                quantity:i.swap_quantity,
                instruction: i.instruction,
            }
            arr.push({
                ...reissueForm1.formData,
                ...reissueForm2.formData,
                ...obj
            })
        })

        let res = await OrderApi.getInstance().createReturnExchangeOrder(arr, rowData.id, reissueForm1.formData.type)
        if(res.code == 0){
            Message.success(t('base.success'))
            reissueHasError.value = false
            getOrderHead()
        }else{
            reissueHasError.value = true
            Message.error(res.msg)
        }
    }

    // 返修校验
    const onReturnFactoryBeforeOk = async()=>{
        let { returnFactoryForm2, returnFactoryForm3, selected } = {...returnFactoryForm.value}

        if(!returnFactoryForm2.formData.back_reason_type){
            Message.error(t('returnExchange.returnFactoryReasonType')+ ' ' + t('base.noEmpty'))
            return false
        }else if(!returnFactoryForm2.formData.back_reason){
            Message.error(t('returnExchange.returnFactoryReason')+ ' ' + t('base.noEmpty'))
            return false
        }else if(!returnFactoryForm2.formData.back_timestamp ){
            Message.error(t('returnExchange.backTimestamp')+ ' ' + t('base.noEmpty'))
            return false
        }else if(!returnFactoryForm2.formData.courier_type){
            Message.error(t('returnExchange.courierType')+ ' ' + t('base.noEmpty'))
            return false
        }else if(!returnFactoryForm2.formData.courier_no){
            Message.error(t('returnExchange.courierNo')+ ' ' + t('base.noEmpty'))
            return false
        }else if(!!returnFactoryForm3.formData.swap_courier_type && !returnFactoryForm3.formData.swap_courier_no){
            Message.error(t('returnExchange.returnFactoryCourierNo2')+ ' ' + t('base.noEmpty'))
            return false
        }else if(!returnFactoryForm3.formData.swap_timestamp_plan){
            Message.error(t('returnExchange.returnFactoryTimestampPlan2')+ ' ' + t('base.noEmpty'))
            return false
        }else if(selected.length == 0){
            Message.error(t('returnExchange.selectReturnFactoryProduct'))
            return false
        }

        for(let i=0; i<selected.length; i++){
            let item = selected[i]
            if(!item.back_quantity){
                Message.error(t('returnExchange.backQuantity')+ ' ' + t('base.noEmpty'))
                return false
            }else if(!item.swap_quantity){
                Message.error(t('returnExchange.returnFactoryQty')+ ' ' + t('base.noEmpty'))
                return false
            }else if(item.swap_quantity <= 0 ){
                Message.error(t('returnExchange.returnFactoryQty')+ ' ' + t('order.greaterThan0'))
                return false
            }else if(item.swap_quantity > item.ship_qty - item.returning_factory_qty){
                Message.error(t('returnExchange.exceedingReturnFactoryQty'))
                return false
            }else if(!item.swap_inventory_code){
                Message.error(t('returnExchange.inventoryCode')+ ' ' + t('base.noEmpty'))
                return false
            }else if(!item.swap_inventory){
                Message.error(t('returnExchange.warehouse')+ ' ' + t('base.noEmpty'))
                return false
            }
        }

        // console.log(rowData.value,'rowData.value', rowData.value.order_timestamp, selected[0].delivery_date)
        let order_timestamp = dateToTimestamp(rowData.value.order_timestamp)
        let delivery_timestamp = dateToTimestamp(selected[0].delivery_date) 
        let back_timestamp = Number(dateToTimestamp(returnFactoryForm2.formData.back_timestamp.split(' ')[0]))
        let swap_timestamp_plan = Number(dateToTimestamp(returnFactoryForm3.formData.swap_timestamp_plan.split(' ')[0]))
        let timestamp = order_timestamp > delivery_timestamp? order_timestamp : delivery_timestamp

        // console.log(order_timestamp, delivery_timestamp, back_timestamp, swap_timestamp_plan, timestamp,'timestamp')
            
        if(back_timestamp < timestamp){
            Modal.warning({
                title: t('base.tip'),
                titleAlign:'start',
                content: order_timestamp > delivery_timestamp? t('order.returnDateTip2') : t('order.returnDateTip'),
                hideCancel:true,
                okText:t('base.ok'),
                cancelText:t('base.cancel'),
                onOk:()=>{}
            })
            return false
        }else if(swap_timestamp_plan < timestamp){
            Modal.warning({
                title: t('base.tip'),
                titleAlign:'start',
                content: order_timestamp > delivery_timestamp? t('order.planDateTip2') : t('order.planDateTip'),
                hideCancel:true,
                okText:t('base.ok'),
                cancelText:t('base.cancel'),
                onOk:()=>{}
            })
            return false
        }

        await createReturnFactory()
        if(returnFactoryHasError.value){
            return false
        }
        return true
    }

    // 确认创建返修单
    const createReturnFactory = async ()=>{
        let { rowData, returnFactoryForm1, returnFactoryForm2, returnFactoryForm3, selected } = {...returnFactoryForm.value}

        let arr = []
        selected.forEach(i=>{
            arr.push({
                ...returnFactoryForm1.formData,
                ...returnFactoryForm2.formData,
                ...returnFactoryForm3.formData,
                status:1, // 状态默认写死为1：处理中
                source:returnFactoryForm1.formData.source_val,
                back_timestamp:dateToTimestamp(returnFactoryForm2.formData.back_timestamp),
                swap_timestamp_plan: dateToTimestamp(returnFactoryForm3.formData.swap_timestamp_plan),
                stock_out_id:i.stock_out_id,
                order_line_id:i.order_line_id,
                erp_line_no:i.erp_line_no == '-'? '' : i.erp_line_no,
                sku:i.sku,
                inventory_code:i.inventory_code,
                quantity: i.back_quantity,
                swap_quantity:i.swap_quantity,
                swap_inventory_code: i.swap_inventory_code_val,
                swap_inventory:i.swap_inventory_val,
                instruction:i.instruction || ''
            })
        })
        // console.log(arr,'pppp', rowData.id, returnFactoryForm1.formData.type)

        let res = await OrderApi.getInstance().createReturnExchangeOrder(arr, rowData.id, 4)
        if(res.code == 0){
            Message.success(t('base.success'))
            returnFactoryHasError.value = false
            getOrderHead()
        }else{
            returnFactoryHasError.value = true
            Message.error(res.msg)
        }
    }

    // 获取取消SO记录
    const getCancelSORecord = async(row)=>{
        let param = {
            order_id:row.id
        }
        cancelSORecordTable.value.configs.loading = true
        let res = await OrderApi.getInstance().getCancelSORecord(param)
        if(res.code == 0){
            res.data.length > 0 && res.data.forEach((i,index)=>{
                i.No = index + 1
            })
            cancelSORecordTable.value.datas = res.data
            cancelSORecordTable.value.configs.loading = false
        }else{
            Message.error(res.msg)
        }
    }

    // 发货申请-获取订单行列表
    const getShipOrderLineList = async (row)=>{
        let res = await OrderApi.getInstance().getOrderShipmentEnabled(row.id)
        if(res.code == 0){
            return res.data
        }else{
            Message.error(res.msg)
        }   
    }

    // 订单行上根据sku、quantity显示预计发货时间
    const getPlanDateBySKUQTY = async(row)=>{
        let param = {
            sku: row.sku,
            quantity: row.quantity,
        }
        lockTable.value.configs.loading = true
        let res = await OrderApi.getInstance().getPlanDateBySKUQTY(param)
        if(res.code == 0){
            res.data.length > 0 && res.data.forEach((i, index)=>{
                i.serial = index + 1
                i.inventory_type = i.type == 'in_stock'? t('inventoryLock.inStock') : i.type == 'in_transit'? t('inventoryLock.inTransit') : t('inventoryLock.productionPlan')
                i.eta = !i.eta? '-' : timestampToDate(i.eta * 1000).split(' ')[0]
            })
            lockTable.value.datas = res.data
            lockTable.value.configs.loading = false
        }else{
            Message.error(res.msg)
        }   
    }

    // 库存锁定列表
    const getLockInventoryList = async(row)=>{
        let param = {
            order_id: row.id,
        }
        inventoryLockTable.value.configs.loading = true
        let res = await OrderApi.getInstance().getLockInventoryList(param)
        if(res.code == 0){
            res.data.length > 0 && res.data.forEach((i, index)=>{
                i.serial = index + 1
                i.inventory_type_val = i.inventory_type
                i.inventory_type = i.inventory_type == 'in_stock'? t('inventoryLock.inStock') : i.inventory_type == 'in_transit'? t('inventoryLock.inTransit') : t('inventoryLock.productionPlan')
                i.plan_timestamp = !i.plan_timestamp? '-' : timestampToDate(i.plan_timestamp * 1000).split(' ')[0]
                i.reserved_quantity = i.reserved_quantity == undefined? 0 : i.reserved_quantity
                i.lock_status_val = i.lock_status
                i.lock_status = i.lock_status === 0? t('inventoryLock.overdue') : i.lock_status == 1? t('inventoryLock.locked') : t('inventoryLock.finish')
            })
            inventoryLockTable.value.datas = res.data
            inventoryLockTable.value.configs.loading = false
        }else{
            Message.error(res.msg)
        }   
    }

    // 锁定库存
    const lockInventory = async()=>{
        let res = await OrderApi.getInstance().lockInventory(rowData.value.id)
        if(res.code == 0){
            Message.success(t('inventoryLock.lockSuccessful'))
            getLockInventoryList(rowData.value)
            inventoryLockTable.value.configs.loading = false
        }else{
            Message.error(res.msg)
        }   
    }

    // 释放库存
    const releaseInventory = async()=>{
        let res = await OrderApi.getInstance().releaseInventory(rowData.value.id)
        if(res.code == 0){
            Message.success(t('inventoryLock.releaseSuccessful'))
            getLockInventoryList(rowData.value)
            inventoryLockTable.value.configs.loading = false
        }else{
            Message.error(res.msg)
        }   
    }

    // 修改订单/取消SO-获取锁定订单状态
    const getOrderLockStatus = async(row)=>{
        let res = await OrderApi.getInstance().getOrderLockStatus(row.id)
        if(res.code == 0){
            return res.data
        }else{
            Message.error(res.msg)
        }   
    }


    // 根据渠道获取对应国家运费
    const getFreight = async (order_channel_type, country)=>{
        let param = {
            order_channel_type: order_channel_type == 5? 1 :  order_channel_type,
            country:country,
            timeliness: createOrderForm1.formData.delivery_timeliness,
        }
        let res = await OrderApi.getInstance().getFreight(param)
        if(res.code == 0){
            return res.data? res.data : 0
        }else{
            Message.error(res.msg)
        }
    }

    // 获取物流公司
    const getCourierType = async ()=>{
        let res = await OrderApi.getInstance().getCourierType({dict_code: "courier"})
        if(res.code == 0){
            let item = deliverForm.formField.find(i=> i.key == 'courier_type')
            item.options = []
            res.data.length > 0 && res.data.forEach(i=>{
                item.options.push({
                    label: i.dict_sub_name,
                    value: i.dict_sub_value,
                })
            })
        }else{
            Message.error(res.msg)
        }
    }

    // 获取默认仓库
    const getDefaultWarehouse = async ()=>{
        let res = await OrderApi.getInstance().getCourierType({dict_code: "warehouse",dict_sub_code:'warehouse-default'})
        if(res.code == 0){
            defaultWarehouse.value = res.data[0].dict_sub_value
        }else{
            Message.error(res.msg)
        }
    }

    // 获取用户地址信息
    const getCustomer = async (customer_id)=>{
        customerInfo_loading.value = true
        let res = await OrderApi.getInstance().getCustomer(customer_id)
        if(res.code == 0){
            customerInfo.value = {
                ...res.data,
                countryCity: !res.data.city? `${res.data.country} / -` : `${res.data.country} / ${res.data.city}`
            }
            customerInfo_loading.value = false
        }else{
            Message.error(res.msg)
        }
    }

    const getCustomerInvoice = async (customer_invoice_id)=>{
        customerInfo_loading.value = true
        let res = await OrderApi.getInstance().getCustomer(customer_invoice_id)
        if(res.code == 0){
            customerInfo2.value = {
                ...res.data,
                countryCity: !res.data.city? `${res.data.country} / -` : `${res.data.country} / ${res.data.city}`
            }
            customerInfo_loading.value = false
        }else{
            Message.error(res.msg)
        }
    }

    // 获取支付方式
    const getPaymentType = async ()=>{
        let res = await OrderApi.getInstance().getCourierType({dict_code: "dealer",dict_sub_code:'payment_type'})
        if(res.code == 0){
            let item = createOrderForm1.formField.find(i=> i.key == 'payment_type')
            item.options = []
            res.data.length > 0 && res.data.forEach(i=>{
                item.options.push({
                    value:i.dict_sub_value,
                    label:i.dict_sub_name,
                    paymentTypeDiscount:i.dict_sub_value == 'SEPA'? 0.02 : i.dict_sub_value == 'DZB'? 0.01 : 0,
                    paymentTypeDiscount2: 0, // i.dict_sub_value == 'DZB'? 0.03 : 0,
                    disabled:false,
                })
            })

            paymentTypeOptions.value = item.options
        }else{
            Message.error(res.msg)
        }
    }

    // 获取订单来源类型 和 erp客户编码
    const getOrderSource = async ()=>{
        let res = await OrderApi.getInstance().getOrderSource({status:'A'})
        if(res.code == 0){
            let queryFormItem = queryForm.formField.find(i=> i.key == 'source')
            let item = createOrderForm1.formField.find(i=> i.key == 'source')
            let customerItem = addBaseInfoForm.formField.find(i=> i.key == 'source')
            
            queryFormItem.options = []
            item.options = []
            customerItem.options = []
            res.data.length > 0 && res.data.forEach(i=>{
                if(i.id && i.id != '1' && i.type != 1){
                    customerItem.options.push({
                        label:i.customer_name,
                        value:i.id, // 来源类型 
                        code: i.customer_number, // erp客户编码
                        type: i.type, // 客户类型
                        disabled: i.type == 1,
                    })
                }

                item.options.push({
                    label:i.id == 1? `Shopify | ${i.customer_number}` : i.prepaid_flag == 1? i.active_flag == 0? `* ${i.customer_name} | ${i.customer_number} | ${t('order.prepaidCustomer')}` : `${i.customer_name} | ${i.customer_number} | ${t('order.prepaidCustomer')}` : i.active_flag == 0? `* ${i.customer_name} | ${i.customer_number}` : `${i.customer_name} | ${i.customer_number}`,
                    value:i.id, // 来源类型 
                    code: i.customer_number, // erp客户编码
                    disabled: i.id == 1 || i.customer_name == 'Insurance',
                    type: i.type,
                    tax_flag: i.tax_flag, // 是否含税
                    prepaid_flag: i.prepaid_flag, // 是否为预付款客户
                    payment: i.payment, // 支付方式
                    payment_type_discount: i.payment_type_discount === undefined? '' : `${i.payment_type_discount}`, // 默认支付折扣
                    payment_with_days_discount: i.payment_with_days_discount === undefined? '0.01' : `${i.payment_with_days_discount}`,
                    payment_day: `${i.payment_day}`, // 默认账期
                    shipping_cost: i.shipping_cost == undefined? '' : `${i.shipping_cost}`, // 默认运费
                    active_flag: i.active_flag, // 是否活跃
                })

                if(i.id){
                    orderSource.value[i.id] = i.id == 1? 'Shopify' : i.customer_name
                }
            })
            // console.log(orderSource.value,'mmmmmm12')
            res.data.length > 0 && res.data.forEach(i=>{
                queryFormItem.options.push({
                    label: i.id == '1'? 'Shopify' : i.customer_name,
                    value:i.id, // 来源类型
                })
            })
        }else{
            Message.error(res.msg)
        }
    }

    // 获取税率
    const getTax = async ()=>{
        let res = await OrderApi.getInstance().getTax()
        if(res.code == 0){
            let item = createOrderForm1.formField.find(i=>i.key == 'tax_rate')
            item.options = []
            taxRateOption.value = []

            for(let key in res.data){
                item.options.push({
                    label:`${Number(key) * 100}% (${res.data[key]})`,
                    value:key
                })
                taxRateOption.value.push({
                    label:`${Number(key) * 100}% (${res.data[key]})`,
                    value:key
                })
            }
            // console.log(taxRateOption.value,'taxRateOption')
        }else{
            Message.error(res.msg)
        }
    }

    // 获取仓库
    const getWarehouse = async ()=>{
        let res = await OrderApi.getInstance().getWarehouse()
        if(res.code == 0){
            res.data.length > 0 && res.data.forEach(i=>{
                warehouseOptions.value.push({
                    label: `${i.description} (${i.subinventory_name})`,
                    value: i.subinventory_name,
                })
            })
        }else{
            Message.error(res.msg)
        }
    }

    // 根据仓库查库存
    // const getInventories = async (warehouse,sku)=>{
    //     let param = {
    //         sku:sku,
    //         warehouse: warehouse,
    //     }
    //     let res = await OrderApi.getInstance().getInventories2(param)
    //     if(res.code == 0){
    //         return res.data[0].qty? res.data[0].qty : 0
    //     }else{
    //         Message.error(res.msg)
    //     }
    // }

    // 根据仓库，获取计划出库数量
    // const getSchedulingQuantity = async (warehouse, inventoryCode)=>{
    //     let param = {
    //         inventory_codes: inventoryCode,
    //         warehouse: warehouse,
    //     }
    //     let res = await OrderApi.getInstance().getSchedulingQuantity(param)
    //     if(res.code == 0){
    //         return res.data && res.data.length > 0? res.data[0].quantity : 0
    //     }else{
    //         Message.error(res.msg)
    //     }
    // }

    // 获取国家下拉配置
    const getCountry = async ()=>{
        let res = await OrderApi.getInstance().getCountry({enable_flag:1})
        if(res.code == 0){
            let item = queryForm.formField.find(i=> i.key == 'country')
            let createItem = createOrderForm3.formField.find(i=> i.key == 'country')
            let customerItem = addBaseInfoForm.formField.find(i=> i.key == 'country')
            let customerItem1 = addAddressInfoForm.formField.find(i=> i.key == 'country')
            let customerItem2 = addInvoiceAddressForm.formField.find(i=> i.key == 'country')
            
            item.options = []
            createItem.options = []
            customerItem.options = []
            customerItem1.options = []
            customerItem2.options = []

            res.data.forEach(i=>{
                item.options.push({
                    label:i.country,
                    value:i.country
                })
                createItem.options.push({
                    label:i.country,
                    value:i.country
                })
                customerItem.options.push({
                    label:i.country,
                    value:i.country,
                    code:i.country_code, // 国家编码
                })
                customerItem1.options.push({
                    label:i.country,
                    value:i.country,
                    code:i.country_code, // 国家编码
                })
                customerItem2.options.push({
                    label:i.country,
                    value:i.country,
                    code:i.country_code, // 国家编码
                })
            })
        }else{
            Message.error(res.msg)
        }
    }

    // 获取退款原因类型
    const getRefundReasonType = async ()=>{
        let res = await OrderApi.getInstance().getCourierType({dict_code: "order",dict_sub_code: "refund_reason_type"})
        if(res.code == 0){
            let item = refundForm.formField.find(i=> i.key == 'reason_type')
            item.options = []
            res.data.length > 0 && res.data.forEach(i=>{
                item.options.push({
                    label:i.dict_sub_name,
                    value:i.dict_sub_value,
                })

                reasonTypeObj.value[i.dict_sub_value] = i.dict_sub_name
            })
        }else{
            Message.error(res.msg)
        }
    }

    // 获取发货方式
    const getDeliveryType = async ()=>{
        let res = await OrderApi.getInstance().getCourierType({dict_code: "order",dict_sub_code: "delivery_type"})
        if(res.code == 0){
            let item = createOrderForm1.formField.find(i=> i.key == 'delivery_type')
            item.options = []
            res.data.length > 0 && res.data.forEach(i=>{
                item.options.push({
                    label:i.dict_sub_name,
                    value:i.dict_sub_value,
                })
            })
        }else{
            Message.error(res.msg)
        }
    }

    // 获取订单用途
    const getOrderUse = async ()=>{
        let res = await OrderApi.getInstance().getCourierType({dict_code: "erp",dict_sub_code: "no_sales_use"})
        if(res.code == 0){
            let item = createOrderForm1.formField.find(i=> i.key == 'order_use')
            item.options = []
            res.data.length > 0 && res.data.forEach(i=>{
                item.options.push({
                    label:i.dict_sub_name,
                    value:i.dict_sub_value,
                })
            })
        }else{
            Message.error(res.msg)
        }
    }

    // 校验发货日期区间
    const vaildShipDateRange = async (row)=>{
        // console.log(row,'rowww')
        let param = {
            timestamp: dateToTimestamp(getNowDate())
        }

        let res = await OrderApi.getInstance().vaildShipDateRange(param,row.source_val)
        if(res.code == 0){
            return res.data
        }else{
            Message.error(res.msg)
        }
    }

    // 获取发货记录
    const getDeliverRecord = async (row)=>{
        // console.log(row,'row')
        let param = {
            order_id:row.id,
        }
        let page_num = recordTable.value.configs.pagination.current
        let page_szie = recordTable.value.configs.pagination.pageSize
        recordTable.value.configs.loading = true
        let res = await OrderApi.getInstance().getDeliverRecord(param,page_num, page_szie)
        if(res.code == 0){
            recordTable.value.datas = []
            res.data.records.length > 0 && res.data.records.forEach((item,index)=>{
                recordTable.value.datas.push({
                    ...item,
                    No: index + 1,
                    status: outboundStatus.value[item.status],
                    order_name: row.order_name,
                    order_line_no: row.order_line_no,
                    sku: item.product_map.sku,
                    courier_no: !item.courier_no? '-' : item.courier_no,
                    courier_status: !item.courier_status? '-' : courierStatus.value[item.courier_status],
                    courier_type: !item.courier_type? '-' : item.courier_type,
                    ship_qty: item.ship_qty == undefined? '-' : item.ship_qty,
                    delivery_number: item.delivery_number == undefined? '-' : item.delivery_number,
                    product_name: item.product_map == undefined? '-' : item.product_map.english_name,
                    model: item.product_map == undefined? '-' : item.product_map.model == undefined? '-' : item.product_map.model,
                    model_year: item.product_map == undefined? '-' : item.product_map.model_year == undefined? '-' : item.product_map.model_year,
                    brand_name: item.product_map == undefined? '-' : item.product_map.brand_name == undefined? '-' : item.product_map.brand_name,
                    part_name: item.product_map == undefined? '-' : item.product_map.part_name == undefined? '-' : item.product_map.part_name,
                    delivery_date: item.delivery_date == undefined? '-' : timestampToDate(item.delivery_date * 1000),
                })
            })
            recordTable.value.configs.pagination.total = res.data.total
            recordTable.value.configs.pagination.current = res.data.current
            recordTable.value.configs.loading = false
        }else{
            Message.error(res.msg)
        }
    }

    // 订单行版本查询
    const getOrderLineRecord = async (row)=>{
        let param = {
            orderLineId:row.id
        }
        let page_num = versionTable.value.configs.pagination.current
        let page_size = versionTable.value.configs.pagination.pageSize
        versionTable.value.configs.loading = true
        let res = await OrderApi.getInstance().getOrderLineRecord(param,page_num,page_size)
        if(res.code == 0){
            res.data.records.length > 0 && res.data.records.forEach((i,index)=>{
                i.No = index + 1
                i.sku = i.sku == undefined? '-' : i.sku
                i.name = i.name == undefined? '-' : i.name
                i.orderLineNo = i.orderLineNo == undefined? '-' : i.orderLineNo
                i.userName = i.userName == undefined? '-' : i.userName
                i.amount = i.amount == undefined? '-' : formatMoney(i,'amount','EUR'),
                i.payAmount = i.payAmount == undefined? '-' : formatMoney(i,'payAmount','EUR'),
                i.quantity = i.quantity == undefined? '-' : i.quantity
                i.inventoryCode = i.inventoryCode == undefined? '-' : i.inventoryCode
                i.taxRate = i.taxRate == undefined? '-' : i.taxRate * 100 + '%'
                i.handleTimestamp = i.handleTimestamp == undefined? '-' : timestampToDate(i.handleTimestamp * 1000)
                i.versionTime = i.versionTime == undefined? '-' : timestampToDate(i.versionTime)
            })

            versionTable.value.datas = res.data.records
            versionTable.value.configs.loading = false
            versionTable.value.configs.pagination.total = res.data.total
        }else{
            Message.error(res.msg)
        }
    }

    // 获取物流id
    const getCourierId = async ()=>{
        let param = {
            courier_type: deliverForm.formData.courier_type,
            courier_no: deliverForm.formData.courier_no,
            courier_url: deliverForm.formData.courier_url,
            courier_status:0,
        }
        let res = await OrderApi.getInstance().getCourierId(param)
        if(res.code == 0){
            courierId.value = res.data.id
        }else{
            Message.error(res.msg)
        }
    }

    // 获取退款记录
    const getRefundRecord = async (row)=>{
        refundRecordTable.value.configs.loading = true
        let res = await OrderApi.getInstance().getRefundRecord({order_id:row.id})
        if(res.code == 0){
            res.data.forEach((item,index)=>{
                item.No = index + 1
                item.order_amount = formatMoney(item, 'order_amount', 'EUR') 
                item.refund_amount = formatMoney(item, 'refund_amount', 'EUR') 
                // 退款与红字导入：没红字的退款没有退款日期（后端不返回这个字段）
                item.refund_timestamp = !item.refund_timestamp? '-' : timestampToDate(item.refund_timestamp * 1000)
                item.reason_type = !item.reason_type? '-' : reasonTypeObj.value[item.reason_type]
                item.reason = !item.reason? '-' : item.reason
                item.credit_note_no = !item.credit_note_no? '-' : item.credit_note_no
            })
            refundRecordTable.value.datas = res.data
            refundRecordTable.value.configs.loading = false
        }else{
            Message.error(res.msg)
        }
    }

    // 获取客户名称--列表查询
    const getCustomerNameList = async ()=>{
        let res = await OrderApi.getInstance().getCustomerList()
        if(res.code == 0){
            const queryItem = queryForm.formField.find(i=> i.key == 'customer_entity_id')
            queryItem.options = []
            res.data.length > 0 && res.data.forEach(i=>{
                queryItem.options.push({
                    label: i.name,
                    value: i.id, 
                })
            })
        }else{
            Message.error(res.msg)
        }
    }

    // 获取客户名称--创建订单
    const getCustomerList = async ()=>{
        let res = await OrderApi.getInstance().getCustomerList()
        if(res.code == 0){
            customerList.value = res.data
            const item = createOrderForm3.formField.find(i=> i.key == 'customer_entity_id')
            item.options= []
            res.data.length > 0 && res.data.forEach(i=>{
                item.options.push({
                    label: orderSource.value[i.source] == undefined? i.name : i.name + ' | ' + orderSource.value[i.source],
                    value: i.id, 
                    source: i.source,
                })
            })
        }else{
            Message.error(res.msg)
        }
    }

    // 获取客户地址--创建订单
    const getCustomerAddressList = async ()=>{
        // console.log(createOrderForm3.formData.customer_entity_id,'kkk',createOrderForm3.formData)
        let param = {
            customer_entity_id:createOrderForm3.formData.customer_entity_id,
        }
        let res = await OrderApi.getInstance().getCustomerAddressList(param)
        if(res.code == 0){
            customerAddressList.value = res.data
            const item = createOrderForm3.formField.find(i=> i.key == 'customer_id')
            const customer_invoice_item = createOrderForm3.formField.find(i=> i.key == 'customer_invoice_id')
            item.options= []
            customer_invoice_item.options= []
            res.data.length > 0 && res.data.forEach(i=>{
                i.city = i.city == undefined? '/' : i.city
                item.options.push({
                    label: i.first_flag == 1? `* ${i.name_show}, ${i.city}, ${i.address}` : `${i.name_show}, ${i.city}, ${i.address}`,
                    value: i.id, 
                    name: i.name,
                })
                customer_invoice_item.options.push({
                    label: i.first_flag == 1?  `* ${i.name_show}, ${i.city}, ${i.address}` : `${i.name_show}, ${i.city}, ${i.address}`,
                    value: i.id, 
                    name: i.name,
                })
            })
            // console.log(item,'item')
        }else{
            Message.error(res.msg)
        }
    }

    // 获取创建人
    const getUser = async()=>{
        let res = await OrderApi.getInstance().getUser()
        if(res.code == 0){
            const item = queryForm.formField.find(i=> i.key == 'create_by')
            item.options = []
            res.data.length > 0 && res.data.forEach(i=>{
                item.options.push({
                    label: i.user_name,
                    value: i.id,
                })
            })
        }else{
            Message.error(res.msg)
        }
    }

    // 获取产品列表,拿到SKU下拉数据
    const getProductList = async (category_code)=>{
        let res = !category_code
                  ? await OrderApi.getInstance().getProductList({inventory_item_status_code: 'Active'}) 
                  : await OrderApi.getInstance().getProductList({category_code: category_code, inventory_item_status_code: 'Active'})

        if(res.code == 0){
            let item = queryForm.formField.find(i=> i.key == 'sku')
            item.options = []
            skuOptions.value = []
            res.data.length > 0 && res.data.forEach(i=>{
                skuOptions.value.push({
                    label:i.sku,
                    value:i.sku,
                    code:i.inventory_code,
                    category_code: i.category_code,
                })
                item.options.push({
                    label:i.sku,
                    value:i.sku,
                })
            })

            productList.value = res.data
        }else{
            Message.error(res.msg)
        }
    }

    // 获取预开发票号
    const getPreInvoiceNo = async (row)=>{
        let res = await OrderApi.getInstance().getPreInvoiceNo(row.id, 1)
        if(res.code == 0){
            Modal.info({
                title: t('base.tip'),
                titleAlign: 'start',
                content: t('order.preInvoiceNo') + '' + `【${res.data.invoice_no}】`,
                okText: t('base.ok'),
                onOk: () => {
                    getOrderHead()
                }
            })
        }else{
            Message.error(res.msg)
        }
    }

    // 根据sku，获取整车价格
    const getBikePriceBySku = async (item, row)=>{
        let param = {
            inventory_code:item.inventory_code,
            customer_number:createOrderForm1.formData.customer_erp_code
        }
        table.value.configs.loading = true
        let res = await FinancialApi.getInstance().getBikePriceBySku(param)
        if(res.code == 0){
            if(res.data.length > 0){
                row.priceIsNull = false
                if(createOrderForm1.formData.tax_type == 0){
                    row.amount = res.data[0].unit_price
                    if(row.amount != res.data[0].unit_price && row.syncNewPrice){
                        Modal.warning({
                            title: t('base.tip'),
                            titleAlign:'start',
                            width:500,
                            content: t('order.syncUnitPriceTip'),
                            hideCancel:true,
                            okText:t('base.ok'),
                        })
                    }else if(row.syncNewPrice){
                        Modal.warning({
                            title: t('base.tip'),
                            titleAlign:'start',
                            width:500,
                            content: t('order.syncUnitPriceTip2'),
                            hideCancel:true,
                            okText:t('base.ok'),
                        })
                    }

                    quantityChange(formatterToPoint(row.amount),row,'amount')
                } 
                if(createOrderForm1.formData.tax_type == 1){
                    row.pre_tax_amount = res.data[0].unit_price
                    if(row.pre_tax_amount != res.data[0].unit_price && row.syncNewPrice){
                        Modal.warning({
                            title: t('base.tip'),
                            titleAlign:'start',
                            width:500,
                            content: t('order.syncUnitPriceTip'),
                            hideCancel:true,
                            okText:t('base.ok'),
                        })
                    }else if(row.syncNewPrice){
                        Modal.warning({
                            title: t('base.tip'),
                            titleAlign:'start',
                            width:500,
                            content: t('order.syncUnitPriceTip2'),
                            hideCancel:true,
                            okText:t('base.ok'),
                        })
                    }

                    row.category_code = item.category_code
                    quantityChange(formatterToPoint(row.pre_tax_amount),row,'pre_tax_amount')
                }
            }else{
                // console.log(item,'row ddd', item.category_code)
                if(item.category_code == '000.000'){
                    row.pre_tax_amount = ''
                    row.amount = ''
                    row.amountDisabled = createOrderForm1.formData.tax_type == 1
                    row.preTaxAmountDisabled = false
                }else{
                    row.priceIsNull = true
                    row.sku = ''
                    row.disabled = false
                    Modal.warning({
                        title: t('base.tip'),
                        titleAlign:'start',
                        width:700,
                        content: ()=> h('div',{},[
                            h('div',{style:{paddingLeft:'7px',paddingBottom:'10px',color:'#ed923b',fontWeight:'bold'}},t('order.priceTip1')),
                            h('div',{style:{color:'#ed923b'}},[
                                h('div',{style:{}},t('order.priceTip2')),
                                h('div',{style:{}},t('order.priceTip3')),
                            ]),
                        ]),
                        hideCancel:true,
                        okText:t('base.ok'),
                        onOk:()=>{},
                    })
                }
            }
        }else{
            Message.error(res.msg)
        }
    }

    // 虚拟订单获取整车价目表
    const getPriceBySkuForVirtualOrder = async(row)=>{
        let param = {
            sku:row.sku,
            customer_number:createOrderForm1.formData.customer_erp_code
        }
        let res = await FinancialApi.getInstance().getBikePriceBySku(param)
        if(res.code == 0){
            return res.data
        }else{
            Message.error(res.msg)
        }
    }

    const editCustomer = (customer_entity_id)=>{
        router.push({path:'/Customers/CustomerList', query:{customer_entity_id:customer_entity_id,fromPage:'OrderList/OrderList'}})
    }

    // 获取已签收的实物订单的订单行
    const getPhysicalOrderLine = async (row)=>{
        let param = {
            order_id: row.id,
        }
        let res = await OrderApi.getInstance().getPhysicalOrderLine(param)
        if(res.code == 0){
            createServiceLineTable.value.datas = []
            // console.log(getNowDate(),'getNowDate()')
            let limitDate = Number(dateToTimestamp(`${getNowDate()} 00:00:00`) ) // + 24 * 60 * 60 * 15
            // console.log(limitDate,'limitDate')
            
            res.data.length > 0 && res.data.forEach((i,index)=>{
                // console.log((limitDate - i.sign_time)/(24 * 60 * 60), parseInt((limitDate - i.sign_time)/(24 * 60 * 60)),'ppppppp')
                createServiceLineTable.value.datas.push({
                    ...i,
                    serial: index + 1,
                    order_name: i.order_name,
                    bind_sku: i.sku,
                    bind_order_line_id: i.order_line_id,
                    stock_out_id: i.id,
                    product_name: i.product_map? i.product_map.english_name : '-',
                    ship_qty: i.ship_qty,
                    service_count: i.service_count,
                    sign_time_val: i.sign_time,
                    sign_time: i.sign_time == undefined? '-' : timestampToDate(i.sign_time * 1000),
                    disabled: i.sign_time == undefined || i.ship_qty == i.service_count || parseInt((limitDate - i.sign_time)/(24 * 60 * 60)) <= 14,
                })
            })

            // console.log(createServiceLineTable.value.datas,'mmkk')
        }else{
            Message.error(res.msg)
        }
    }

    // 确认勾选的实物订单行
    const onCreateServiceLineBeforeOk = ()=>{
        if(createServiceLineTable.value.configs.selected.length == 0){
            Message.error(t('base.selectData'))
            return false
        }
        handle('createServiceOrder')
        return true
    }

    // 勾选实物订单行-单选
    const createServiceLineTableSelectRow = (selected)=>{
        createServiceLineTable.value.configs.selected = selected
    }

    // 勾选实物订单行-多选
    const createServiceLineTableSelectAllRow = (selected)=>{
        createServiceLineTable.value.configs.selected = selected
    }

    // 取消创建业务订单生成订单
    const handleCancelCreateOrder = ()=>{
        if(history.state.fromPage == 'DealerBusinessOrder'){
            router.push('/OrderList/DealerBusinessOrder')
        }
        if(history.state.fromPage == 'B2BShopOrder'){
            router.push('/OrderList/B2BShopOrderList')
        }
    }

    // 编辑经销商业务订单/B2B Shop订单，补充信息
    const editbusinessOrder = async (row)=>{
        // console.log(row,'editbusinessOrder row')
        editOrderloading.value = true
        createOrderVisible.value = true
        orderOperateType.value = 'add'
        orderTitle.value = t('order.create')
                
        await getCustomerList()
        await getTax()
        await getPaymentType()

        // 基本信息-禁用的字段
        let item = createOrderForm1.formField.find(i=> i.key == 'user_note')
        item.show = true
        createOrderForm1.formField.forEach(i=>{
            if(i.key == 'order_type') i.disabled = true
            if(i.key == 'order_name') i.disabled = history.state.fromPage == 'B2BShopOrder'
            if(i.key == 'source') i.disabled = true 
            if(i.key == 'order_channel_type') i.disabled = true
            if(i.key == 'delivery_type') i.disabled = false 
            if(i.key == 'tax_type') i.disabled = true
            if(i.key == 'payment_type') i.disabled = false
            if(i.key == 'payment_type_discount') i.disabled = true
            if(i.key == 'pay_type_discount') i.disabled = true
            if(i.key == 'user_note') i.disabled = true
            if(i.key == 'order_category'){
                i.show = true
                i.disabled = true
                createOrderForm1.formField.find(i=>i.key == 'order_category').showItemPreText = false
            } 
            if(i.key == 'cargo_freight' && history.state.fromPage == 'B2BShopOrder') i.showItemPreText = true
        })
        createOrderForm3.formField.forEach(i=>{
            i.disabled = !['customer_id','customer_invoice_id'].includes(i.key)  // 不禁用
            i.addIcon = false // 禁止新增客户名称
        })

        // 基础信息填充
        let source_item = createOrderForm1.formField.find(i=> i.key == 'source')
        let source_optItem = source_item.options.find(i=> i.value == row.source_val)
        console.log(source_optItem,'source_optItem')
        
        if(history.state.fromPage == 'B2BShopOrder'){
            // console.log(row.cargo_freight,'b2b')
            createOrderForm1.formData.order_name = row.order_category == 'bike'? `${row.dealer_order_name}_${source_optItem.code}` :  `${row.dealer_order_name}-P_${source_optItem.code}`
            createOrderForm1.formData.order_status = 7 
            createOrderForm1.formData.dealer_order_id = row.id  // B2B Shop订单id
            createOrderForm1.formData.delivery_type = row.delivery_type
            createOrderForm1.formData.tax_rate = row.tax_rate == 0? '0.00' : row.tax_rate == 0.2? '0.20' : `${row.tax_rate}`
            createOrderForm1.formData.cargo_freight = row.cargo_freight == '-'? 0 : row.cargo_freight.split(' ')[1]
            b2bCargoFreight.value = row.cargo_freight == '-'? 0 : row.cargo_freight.split(' ')[1]
            createOrderForm1.formData.order_category = row.order_category == 'bike'? 1 : 2
            createOrderForm1.formData.delivery_timeliness = row.order_channel_type != 1? '' : row.delivery_timeliness == undefined? 0 : row.delivery_timeliness
        }

        if(history.state.fromPage == 'DealerBusinessOrder'){
            createOrderForm1.formData.business_order_id = row.id  // 经销商OOS业务订单id
            createOrderForm1.formData.cargo_freight = 0 
        } 
        
        createOrderForm1.formData.order_type = 0
        createOrderForm1.formData.source = row.source_val
        createOrderForm1.formData.order_channel_type = row.order_channel_type
        createOrderForm1.formData.customer_erp_code = source_optItem.code
        createOrderForm1.formData.courier_status = 0
        createOrderForm1.formData.tax_type = source_optItem.tax_flag == 'Y'? 0 : 1
        createOrderForm1.formData.payment_type = source_optItem.payment

        // 设置支付折扣，现金折扣，账期下拉配置
        console.log(source_optItem,'b2b source_optItem')
        setDiscountOpt(source_optItem)

        // 获取渠道运费
        shipping_cost.value = source_optItem.shipping_cost === ''? '' : Number(source_optItem.shipping_cost)
        console.log(shipping_cost.value, 'shipping_cost 渠道运费33333')

        createOrderForm1.formData.pay_type_discount = 0
        createOrderForm1.formData.order_timestamp = row.order_timestamp
        createOrderForm1.formData.user_note = row.user_note

        handleCreateOrderSelectChange(row.source_val, '', 'source')

        // 重置数据
        createOrderForm1.formData.order_no = ''
        if(history.state.fromPage != 'B2BShopOrder'){ 
            createOrderForm1.formData.order_name = ''
            createOrderForm1.formData.order_status = ''
            createOrderForm1.formData.delivery_type = ''
        }
        
        createOrderForm1.formData.predict_week_date = ''
        createOrderForm1.formData.predict_delivery_week = ''
        createOrderForm1.formData.predict_delivery_year = ''
        createOrderForm1.formData.instruction = ''
        createOrderForm1.formData.earliest_ship_timestamp = ''

        // 客户信息填充
        let customer_item = createOrderForm3.formField.find(i=> i.key == 'customer_entity_id')
        let customer_optItem = customer_item.options.find(i=> i.source == row.source_val)
        console.log(customer_optItem,'customer_optItem')
        
        createOrderForm3.formData.customer_entity_id = customer_optItem.value
        createOrderForm3.formData.file_lang_code = row.file_lang_code
        handleCreateOrderSelectChange3(customer_optItem.value, '', 'customer_entity_id', row)

        if(createOrderForm3.formData.country !== '') setLangTemp()

        createOrderForm1.formField.forEach(i=>{
            if(i.key == 'payment_type'){
                i.required = createOrderForm3.formData.customer_type == 1
            } 
            if(i.key == 'order_status'){
                let item = i.options.find(m=> m.value == 6)
                item.disabled = true
            } 
            if(i.key == 'courier_status'){
                let item = i.options.find(m=> m.value == 5)
                item.disabled = true
            } 
            if(i.key == 'delivery_timeliness'){
                i.show = createOrderForm1.formData.order_channel_type == 1 && createOrderForm1.formData.delivery_type == 'courier'
            }
        })

        // 金额汇总信息填充
        if(history.state.fromPage == 'B2BShopOrder'){
            let cargo_freight = row.cargo_freight == '-'? 0 : Number(row.cargo_freight.split('€ ')[1])
            row.order_amount_val = row.order_amount.indexOf('€ ') > -1? row.order_amount.split('€ ')[1] : row.order_amount
            row.order_discount_val = row.order_discount == '-'? '' : row.order_discount.indexOf('€ ') > -1? multiply(Number(row.order_discount.split('€ ')[1]), add(row.tax_rate, 1)) : multiply(Number(row.order_discount), add(row.tax_rate, 1))
            row.order_tax_val = row.order_tax == '-'? '' : row.order_tax.indexOf('€ ') > -1? row.order_tax.split('€ ')[1] : row.order_tax
            row.pay_amount_val =  row.pay_amount == '-'? '' : row.pay_amount.indexOf('€ ') > -1? row.pay_amount.split('€ ')[1] : row.pay_amount
            row.order_amount_val = add(subtract(row.pay_amount_val, multiply(cargo_freight, add(row.tax_rate, 1))), row.order_discount_val)
        }else{
            row.order_amount_val = row.order_amount.indexOf('€ ') > -1? row.order_amount.split('€ ')[1] : row.order_amount
            row.order_discount_val = row.order_discount == '-'? '' : row.order_discount.indexOf('€ ') > -1? row.order_discount.split('€ ')[1] : row.order_discount
            row.order_tax_val = row.order_tax == '-'? '' : row.order_tax.indexOf('€ ') > -1? row.order_tax.split('€ ')[1] : row.order_tax
            row.pay_amount_val =  row.pay_amount == '-'? '' : row.pay_amount.indexOf('€ ') > -1? row.pay_amount.split('€ ')[1] : row.pay_amount
        }
       
        createOrderForm2.formData.order_amount = timezoneOffset.value == '-8'? Number(row.order_amount_val).toFixed(2) : formatterToComma(Number(row.order_amount_val), timezoneOffset.value == '-8')
        createOrderForm2.formData.quantity = row.quantity
        createOrderForm2.formData.order_discount = !row.order_discount_val? 0 : timezoneOffset.value == '-8'? Number(row.order_discount_val).toFixed(2) : formatterToComma(Number(row.order_discount_val).toFixed(2), timezoneOffset.value == '-8')
        createOrderForm2.formData.extra_discount = !row.extra_discount? 0 : timezoneOffset.value == '-8'? Number(row.extra_discount) : formatterToComma(Number(row.extra_discount), timezoneOffset.value == '-8')
        createOrderForm2.formData.order_tax = timezoneOffset.value == '-8'? Number(row.order_tax_val) : formatterToComma(Number(row.order_tax_val), timezoneOffset.value == '-8')
        createOrderForm2.formData.pay_amount = timezoneOffset.value == '-8'? Number(row.pay_amount_val).toFixed(2) : formatterToComma(Number(row.pay_amount_val), timezoneOffset.value == '-8')
          
        if(history.state.fromPage != 'B2BShopOrder'){
            getLastOrderNumber(createOrderForm1.formData.source)
        }
        

        // 不含税/含税，订单行显示的字段
        await businessOrderLine(row) // 获取经销商业务订单行/B2B Shop订单行
        orderLineTable.value.columns = []
        if(createOrderForm1.formData.tax_type == 1){ // 不含税
            orderLineColumns.value.forEach(i=>{
                if(i.show !== undefined){
                    i.show = true
                }
                if((i.show !== undefined && i.show) || i.show == undefined){
                    orderLineTable.value.columns.push(i)
                }
            })
        }else{ // 含税
            orderLineColumns.value.forEach(i=>{
                if(i.show !== undefined) i.show = false
                if((i.show !== undefined && i.show) || i.show == undefined){
                    orderLineTable.value.columns.push(i)
                }
            })
        }

        skuOptions.value = []
        if(createOrderForm1.formData.order_category == 0){
                productList.value.forEach(i=>{
                    skuOptions.value.push({
                        label:i.sku,
                        value:i.sku,
                        code:i.inventory_code,
                        category_code: i.category_code,
                    })
                })
        }else if(createOrderForm1.formData.order_category == 1){
                productList.value.forEach(i=>{
                    if(i.category_code == '627.501'){
                        skuOptions.value.push({
                            label:i.sku,
                            value:i.sku,
                            code:i.inventory_code,
                            category_code: i.category_code,
                        })
                    }
                })
        }else if(createOrderForm1.formData.order_category == 2){
                productList.value.forEach(i=>{
                    if(i.category_code == '000.000'){
                        skuOptions.value.push({
                            label:i.sku,
                            value:i.sku,
                            code:i.inventory_code,
                            category_code: i.category_code,
                        })
                    }
                })
        }

        // 订单行信息填充
        if(orderLineTable.value.datas.length > 0){
            let arr = [], tax_rate = ''
            if(history.state.fromPage == 'B2BShopOrder'){
                let tax_rate_item = taxRateOption.value.find(i=>i.value == createOrderForm1.formData.tax_rate)
                tax_rate = tax_rate_item.label
            }
            let tax_rate_val = createOrderForm1.formData.tax_rate
            orderLineTable.value.datas.forEach((i,index)=>{
                arr.push({
                    serial: index + 1,
                    id: history.state.fromPage == 'B2BShopOrder'? '' : i.id,
                    sku:i.sku,
                    inventory_code:i.inventory_code,
                    name:i.product_name,
                    frame_color: i.product_map.frame_color? i.product_map.frame_color : '-',
                    torque:i.torque,
                    amount: timezoneOffset.value == '-8'? multiply(Number(i.amount_val), 1 + Number(tax_rate_val)) : formatterToComma(multiply(Number(i.amount_val), 1 + Number(tax_rate_val)).toFixed(2), timezoneOffset.value == '-8'),
                    pre_tax_amount:timezoneOffset.value == '-8'? Number(i.amount_val).toFixed(2) : formatterToComma(Number(i.amount_val).toFixed(2), timezoneOffset.value == '-8'),
                    quantity:i.quantity,
                    discount_rate:i.discount_rate == undefined? '' : Number(i.discount_rate),
                    pre_tax_discount: history.state.fromPage == 'DealerBusinessOrder'? '' : i.discount_val,
                    discount: history.state.fromPage == 'DealerBusinessOrder'? '' : i.discount_val == ''? '' : multiply(i.discount, add(Number(tax_rate_val), 1)),
                    pre_tax_extra_discount: '',
                    extra_discount: '',
                    pay_amount: timezoneOffset.value == '-8'? multiply(Number(i.pay_amount_val), 1 + Number(tax_rate_val)) : formatterToComma(multiply(Number(i.pay_amount_val), 1 + Number(tax_rate_val)).toFixed(2), timezoneOffset.value == '-8'),
                    pre_tax_pay_amount: timezoneOffset.value == '-8'? Number(i.pay_amount_val).toFixed(2) : formatterToComma(Number(i.pay_amount_val).toFixed(2), timezoneOffset.value == '-8'),
                    tax_rate: history.state.fromPage == 'B2BShopOrder'? tax_rate : i.tax_rate,
                    tax_rate_val: Number(tax_rate_val),
                    order_tax: timezoneOffset.value == '-8'? multiply(divide(Number(i.pay_amount_val), 1 + Number(tax_rate_val)), Number(tax_rate_val)).toFixed(2) : formatterToComma(multiply(divide(Number(i.pay_amount_val), 1 + Number(tax_rate_val)), Number(tax_rate_val)).toFixed(2), timezoneOffset.value == '-8'),
                    handle_timestamp:createOrderForm1.formData.order_channel_type == 1? getNowDate() : i.handle_timestamp_val == '-'? '' : i.handle_timestamp_val,
                    disabled: createOrderForm1.formData.tax_type == 1,
                    preTaxExtraDiscountDisabled: true,
                    amountDisabled: i.product_code == '627.501',
                    preTaxAmountDisabled: i.product_code == '627.501',
                    skuDisabled: false,
                    quantityDisabled: true,
                    shipDateDisabled: false,
                    line_order_amount: multiply(Number(i.amount_val), i.quantity),
                    product_code: i.product_map.category_code,
                    user_comment: i.user_comment,
                    enable: createOrderForm1.formData.order_channel_type == 1 || createOrderForm1.formData.order_channel_type == 5,
                })
            })
            orderLineTable.value.datas = JSON.parse(JSON.stringify(arr))
        }
        editOrderloading.value = false
     
        // 延时调用，等国家赋值完成
        setTimeout(()=>{
            console.log('国家赋值完成')
            cargoFreightNeedChange.value = true
            computeCargoFreight()
        }, 3000)
    }

    // 获取业务订单的行数据
    const businessOrderLine = async (row)=>{
        let param = {}
        if(history.state.fromPage == 'DealerBusinessOrder') param.business_order_id = row.id
        if(history.state.fromPage == 'B2BShopOrder') param.dealer_order_id = row.id

        let res = history.state.fromPage == 'DealerBusinessOrder'
                    ? await DealerApi.getInstance().getDealerOrderLine(param) 
                    : await DealerApi.getInstance().getB2BOrderLine(param) 

        if(res.code == 0){

            if(history.state.fromPage == 'B2BShopOrder'){
                res.data = row.order_category == 'bike'
                        ? res.data.filter(item => item.product_map.category_code == '627.501' && item.ordered_flag == 0)
                        : res.data.filter(item => item.product_map.category_code == '000.000' && item.ordered_flag == 0)
            }

            res.data.length > 0 && res.data.forEach(i=>{
                i.inventory_code = i.inventory_code == undefined? '-' : i.inventory_code
                i.product_name = i.product_map == undefined? '-' : i.product_map.english_name
                i.frame_color = i.product_map == undefined? '-' : i.product_map.frame_color? i.product_map.frame_color : '-'
                i.torque = i.product_map == undefined? '-' : i.product_map.frame_nm == undefined? '-' : i.product_map.frame_nm + 'NM'
                i.quantity = i.quantity == undefined? '-' : i.quantity
                i.discount_rate = i.discount_rate == undefined? '' : i.discount_rate
                i.amount_val = i.amount
                i.discount_val = history.state.fromPage == 'DealerBusinessOrder'? '' : i.discount == undefined? '' : i.discount
                i.extra_discount = ''
                i.pay_amount_val = i.pay_amount
                i.amount = formatMoney(i,'amount','EUR') 
                i.pay_amount = formatMoney(i,'pay_amount','EUR')
                i.pre_amount = i.pre_amount == undefined? '-' : formatMoney(i,'pre_amount','EUR'),
                i.handle_timestamp_val = i.handle_timestamp == undefined? '-' : timestampToDate(i.handle_timestamp * 1000),
                i.tax_rate = ''
                i.user_comment = i.user_comment == undefined? '-' : i.user_comment
            })
            orderLineTable.value.datas = JSON.parse(JSON.stringify(res.data))
            // console.log(orderLineTable.value.datas, 'hhjjkk', res.data)
        }else{
            Message.error(res.msg)
        }
    }

    const getLastOrderNumber = async(source)=>{
        let param = {
            source:source,
        }
        let res = await OrderApi.getInstance().getLastOrderNumber(param)
        if(res.code == 0){
            lastValidOrderNo.value = createOrderForm1.formData.order_channel_type != 1?  '' : res.data == undefined? '--' : res.data.max_number
            let item = createOrderForm1.formField.find(i=> i.key == 'order_name')
            item.showItemPreText = lastValidOrderNo.value !== ''

            createOrderForm1.formData.order_name = createOrderForm1.formData.order_channel_type != 1?  '' : res.data == undefined? '--' : res.data.next_number
        }else{
            Message.error(res.msg)
        }
    }

    // 创建预付款订单，补充信息
    const createPrepaidOrder = async (row)=>{
        editOrderloading.value = true
        createOrderVisible.value = true
        orderOperateType.value = 'createPrepaidOrder'
        orderTitle.value = t('prepaidOrder.createPrepaidOrder')
                
        await getCustomerList()
        await businessOrderLine(row)
        await getTax()
        await getPaymentType()

        // 基本信息-禁用的字段
        let item = createOrderForm1.formField.find(i=> i.key == 'user_note')
        item.show = true
        createOrderForm1.formField.forEach(i=>{
            if(i.key == 'order_type') i.disabled = true
            if(i.key == 'source') i.disabled = true 
            if(i.key == 'order_channel_type') i.disabled = true
            if(i.key == 'order_name') i.disabled = true
            if(i.key == 'delivery_type') i.disabled = false 
            if(i.key == 'order_timestamp') i.disabled = true
            if(i.key == 'tax_rate') i.disabled = true
            if(i.key == 'tax_rate') i.disabled = true
            if(i.key == 'payment_type') i.disabled = false
            if(i.key == 'payment_type_discount') i.disabled = true
            if(i.key == 'pay_type_discount') i.disabled = true
            if(i.key == 'user_note') i.disabled = true
        })
        createOrderForm3.formField.forEach(i=>{
            i.disabled = !['customer_id','customer_invoice_id'].includes(i.key) // 不禁用
            i.addIcon = false // 禁止新增客户名称
        })

        // 基础信息填充
        let source_item = createOrderForm1.formField.find(i=> i.key == 'source')
        let source_optItem = source_item.options.find(i=> i.value == row.source_val)


        createOrderForm1.formData.erp_no = row.erp_no
        createOrderForm1.formData.order_id = row.id
        createOrderForm1.formData.order_no = row.order_no
        createOrderForm1.formData.order_type = row.order_type_val
        createOrderForm1.formData.order_use = row.order_use
        createOrderForm1.formData.back_flag = row.back_flag_val
        createOrderForm1.formData.source = row.source_val
        createOrderForm1.formData.order_channel_type = row.order_channel_type_val
        createOrderForm1.formData.customer_erp_code = row.customer_erp_code
        createOrderForm1.formData.order_name = row.order_name
        createOrderForm1.formData.order_status = row.order_status_val
        createOrderForm1.formData.courier_status = row.courier_status_val
        createOrderForm1.formData.tax_rate = row.tax_rate_val
        createOrderForm1.formData.tax_type = Number(row.tax_type)
        createOrderForm1.formData.payment_type = row.payment_type

        // 设置支付折扣，现金折扣，账期下拉配置
        setDiscountOpt(source_optItem)


        createOrderForm1.formData.payment_type_discount = !row.payment_type_discount? '0' : row.payment_type_discount,
        createOrderForm1.formData.pay_with_days_discount_rate = row.pay_with_days_discount_rate == undefined? '0' : row.pay_with_days_discount_rate
        createOrderForm1.formData.payment_day = row.payment_day == undefined? '0' : `${row.payment_day}`
        // createOrderForm1.formData.payment_type_discount = !row.payment_type_discount? '0' : row.payment_type_discount.indexOf('%') > -1? row.payment_type_discount : Number(row.payment_type_discount) * 100 + '%'
        createOrderForm1.formData.pay_type_discount = !row.pay_type_discount? 0 : timezoneOffset.value == '-8'? Number(row.pay_type_discount) : formatterToComma(Number(row.pay_type_discount), timezoneOffset.value == '-8')
        createOrderForm1.formData.cargo_freight = row.cargo_freight == '-'? 0 : timezoneOffset.value == '-8'? Number(row.cargo_freight.split('€')[1].trim()) : formatterToComma(Number(row.cargo_freight.split('€')[1].trim()), timezoneOffset.value == '-8')
        createOrderForm1.formData.instruction = row.instruction
        createOrderForm1.formData.order_timestamp = row.order_timestamp
        createOrderForm1.formData.earliest_ship_timestamp = row.earliest_ship_timestamp
        createOrderForm1.formData.predict_week_date = !row.predict_week_date? '' : row.predict_week_date
        createOrderForm1.formData.predict_delivery_week = !row.predict_delivery_week? '' : row.predict_delivery_week
        createOrderForm1.formData.predict_delivery_year = !row.predict_delivery_year? '' : `${row.predict_delivery_year}`
        
        // 客户信息填充
        createOrderForm3.formData.customer_entity_id = row.customer_entity_id
        createOrderForm3.formData.customer_id = row.customer_id
        createOrderForm3.formData.customer_invoice_id = row.customer_invoice_id
        createOrderForm3.formData.name2 = row.name2 || ''
        createOrderForm3.formData.customer_email = row.customer_email
        createOrderForm3.formData.customer_type = Number(row.customer_type_val)
        createOrderForm3.formData.country = row.country
        createOrderForm3.formData.customer_name = row.customer_name
        createOrderForm3.formData.file_lang_code = row.file_lang_code

        if(createOrderForm3.formData.country !== '') setLangTemp()

        // 金额汇总信息填充
        createOrderForm2.formData.order_amount = ''
        createOrderForm2.formData.quantity = ''
        createOrderForm2.formData.order_discount = ''
        createOrderForm2.formData.extra_discount = '' 
        createOrderForm2.formData.order_tax = ''
        createOrderForm2.formData.pay_amount = ''
        createOrderForm2.formData.pay_with_days_discount = ''

        getCustomerAddressList()

        // 不含税/含税，订单行显示的字段
        orderLineTable.value.columns = []
        if(createOrderForm1.formData.tax_type == 1){ // 不含税
            orderLineColumns.value.forEach(i=>{
                if(i.show !== undefined){
                    i.show = true
                }
                if((i.show !== undefined && i.show) || i.show == undefined){
                    orderLineTable.value.columns.push(i)
                }
            })
        }else{ // 含税
            orderLineColumns.value.forEach(i=>{
                if(i.show !== undefined) i.show = false
                if((i.show !== undefined && i.show) || i.show == undefined){
                    orderLineTable.value.columns.push(i)
                }
            })
        }

        // 订单行信息填充
        showAddOrderLineBtn.value = false
        // console.log(createPrePayOrderTable.value.configs.selected,'sel')
        if(createPrePayOrderTable.value.configs.selected.length > 0){
            let arr = []
            createPrePayOrderTable.value.configs.selected.forEach((i,index)=>{
                arr.push({
                    serial: index + 1,
                    id: i.id,
                    order_id:row.id,
                    sku:i.sku,
                    inventory_code:i.inventory_code,
                    name:i.product_name,
                    frame_color: i.product_map == undefined? '-' : i.product_map.frame_color? i.product_map.frame_color : '-',
                    torque:i.torque,
                    pre_tax_amount: timezoneOffset.value == '-8'? divide(Number(i.amount_val), 1 + Number(row.tax_rate_val)) : formatterToComma(divide(Number(i.amount_val), 1 + Number(row.tax_rate_val)).toFixed(2), timezoneOffset.value == '-8'),
                    amount:timezoneOffset.value == '-8'? Number(i.amount_val).toFixed(2) : formatterToComma(Number(i.amount_val).toFixed(2), timezoneOffset.value == '-8'),
                    max_quantity: i.quantity - i.prepaid_quantity,
                    quantity:'',
                    discount_rate:i.discount_rate == undefined? '' : Number(i.discount_rate),
                    pre_tax_discount: timezoneOffset.value == '-8'? divide(Number(i.discount_val), 1 + Number(row.tax_rate_val)) : formatterToComma(divide(Number(i.discount_val), 1 + Number(row.tax_rate_val)).toFixed(2), timezoneOffset.value == '-8'),
                    discount: !i.discount_val? '' : timezoneOffset.value == '-8'? Number(i.discount_val) : formatterToComma(Number(i.discount_val), timezoneOffset.value == '-8'),
                    pre_tax_extra_discount: timezoneOffset.value == '-8'? divide(Number(i.extra_discount), 1 + Number(row.tax_rate_val)) : formatterToComma(divide(Number(i.extra_discount), 1 + Number(row.tax_rate_val)).toFixed(2), timezoneOffset.value == '-8'),
                    extra_discount: !i.extra_discount? '' : timezoneOffset.value == '-8'? Number(i.extra_discount) : formatterToComma(Number(i.extra_discount), timezoneOffset.value == '-8'),
                    pre_tax_pay_amount: timezoneOffset.value == '-8'? divide(Number(i.pay_amount_val), 1 + Number(row.tax_rate_val)) : formatterToComma(divide(Number(i.pay_amount_val), 1 + Number(row.tax_rate_val)).toFixed(2), timezoneOffset.value == '-8'),
                    pay_amount: timezoneOffset.value == '-8'? Number(i.pay_amount_val).toFixed(2) : formatterToComma(Number(i.pay_amount_val).toFixed(2), timezoneOffset.value == '-8'),
                    tax_rate:i.tax_rate,
                    tax_rate_val:row.tax_rate_val,
                    order_tax:  timezoneOffset.value == '-8'? multiply(divide(Number(i.pay_amount_val), 1 + Number(row.tax_rate_val)), Number(row.tax_rate_val)).toFixed(2) : formatterToComma(multiply(divide(Number(i.pay_amount_val), 1 + Number(row.tax_rate_val)), Number(row.tax_rate_val)).toFixed(2), timezoneOffset.value == '-8'),
                    handle_timestamp:i.handle_timestamp_val == '-'? '' : i.handle_timestamp_val,
                    disabled: createOrderForm1.formData.tax_type == 1,
                    preTaxExtraDiscountDisabled: true,
                    amountDisabled: i.product_code == '627.501',
                    preTaxAmountDisabled: i.product_code == '627.501',
                    skuDisabled: true,
                    quantityDisabled: false,
                    shipDateDisabled: false,
                    line_order_amount: multiply(Number(i.amount_val), i.quantity),
                    erp_line_no: i.erp_line_no,
                    product_code: i.product_map == undefined? '' : i.product_map.category_code? i.product_map.category_code : '',
                    order_line_no: i.order_line_no == '-'? '' : i.order_line_no,
                    enable: createOrderForm1.formData.order_channel_type == 1 || createOrderForm1.formData.order_channel_type == 5,
                })
            })
            orderLineTable.value.datas = arr
        }
        editOrderloading.value = false
    }

    // 获取收货地址,列表按收货地址查询
    const getAddressName = async (val)=>{
        let param = {
            name:val,
        }
        let item = queryForm.formField.find(i=> i.key == 'customer_id')
        item.loading = true
        let res = await OrderApi.getInstance().getCustomerAddressList(param)
        if(res.code == 0){
            item.options = []
            res.data.length > 0 && res.data.forEach(i=>{
                item.options.push({
                    label: i.name,
                    value: i.id,
                })
            })
            item.loading = false
            
        }else{
            Message.error(res.msg)
        }
    }

    // 获取默认地址
    const getDefaultAddress = async ()=>{
        let param = {
            dict_code: "config",
            dict_sub_code: "factory_default",
            dict_sub_name: "address",
        }
        let res = await CustomerApi.getInstance().getDefaultAddress(param)
        if(res.code == 0){
            return res.data[0].dict_sub_value
        }else{
            Message.error(res.msg)
        }
    }

    // 根据pick_up id获取客户信息及新的ERP Code
    const getERPCodeAndCustomerByPickUpId = async (id)=>{
        let param = {
            id: id,
        }
        let res = await OrderApi.getInstance().getERPCodeAndCustomerByPickUpId(param)
        if(res.code == 0){
            return res.data[0]
        }else{
            Message.error(res.msg)
        }
    }

    // 获取支付折扣下拉配置
    const getPayDiscountConfig = async()=>{
        let param = {
            dict_code: "dealer",
            dict_sub_code:'payment_type_discount',
        }
        let res = await OrderApi.getInstance().getPayDiscountConfig(param)
        if(res.code == 0){
            pay_discount_arr.value = res.data
            console.log(pay_discount_arr.value, 'pay_discount_arr')
        }else{
            Message.error(res.msg)
        }
    }

    // 获取现金折扣下拉配置
    const getCashDiscountConfig = async()=>{
        let param = {
            dict_code: "dealer",
            dict_sub_code:'payment_with_days_discount',
        }
        let res = await OrderApi.getInstance().getCashDiscountConfig(param)
        if(res.code == 0){
            cash_discount_arr.value = res.data
            console.log(cash_discount_arr.value, 'cash_discount_arr')
        }else{
            Message.error(res.msg)
        }
    }

    // 获取账期下拉配置
    const getPayDayConfig = async()=>{
        let param = {
            dict_code: "dealer",
            dict_sub_code:'payment_type_day',
        }
        let res = await OrderApi.getInstance().getPayDayConfig(param)
        if(res.code == 0){
            pay_day_arr.value = res.data
            console.log(pay_day_arr.value, 'pay_day_arr')
        }else{
            Message.error(res.msg)
        }
    }

    // 获取账期下拉配置
    const getCashDiscountPayDayConfig = async()=>{
        let param = {
            dict_code: "dealer",
            dict_sub_code:'payment_with_days_day',
        }
        let res = await OrderApi.getInstance().getCashDiscountPayDayConfig(param)
        if(res.code == 0){
            let item = createOrderForm1.formField.find(i=> i.key == 'pay_with_days_day')
            item.options = []
            res.data.forEach(i=>{
                item.options.push({
                    label: i.dict_sub_name,
                    value: i.dict_sub_value,
                })
            })
        }else{
            Message.error(res.msg)
        }
    }

    // 获取是否欧盟国际语言模板
    const getEUFlagLang = async(country)=>{
        let param = {
            country: country,
        }
        let res = await OrderApi.getInstance().getEUFlagLang(param)
        if(res.code == 0){
            if(res.data.length > 0) return res.data[0]
        }else{
            Message.error(res.msg)
        }
    }

    // 处理查询面板伸缩时表格高度
    const resetTableHeight = (clientHeight)=>{
        const headerHeight = document.querySelector('.arco-layout-header').clientHeight
        const breadcrumbHeight = document.querySelector('.arco-page-header-with-breadcrumb').clientHeight
        const searchContentDomHeight = document.querySelector('.queryPanel').clientHeight
        const pageHeight = 50
        const footerHeight = document.querySelector('.footer').clientHeight
        table.value.configs.scroll.y = clientHeight - headerHeight - breadcrumbHeight - searchContentDomHeight - pageHeight - footerHeight - 80
    }

    // 设置14天/90天 内支付折扣数据
    const set14discount = ()=>{
        let item = createOrderForm2.formField.find(i=> i.key == 'pay_with_days_discount')

        createOrderForm2.formData.pay_with_days_discount = Number(multiply(Number(formatterToPoint(createOrderForm2.formData.pay_amount)), Number(createOrderForm1.formData.pay_with_days_discount_rate)).toFixed(2))
        createOrderForm2.formData.pay_with_days_discount = formatterToComma(Number(createOrderForm2.formData.pay_with_days_discount), String(createOrderForm2.formData.order_amount).indexOf('.') != -1)


        // if(createOrderForm1.formData.payment_type == 'by invoice'){
        //     item.name = 'order.payWithin14daysDiscount'
        //     createOrderForm2.formData.pay_with_days_discount = Number(multiply(Number(formatterToPoint(createOrderForm2.formData.pay_amount)), 0.01).toFixed(2))
        //     createOrderForm2.formData.pay_with_days_discount = formatterToComma(Number(createOrderForm2.formData.pay_with_days_discount), String(createOrderForm2.formData.order_amount).indexOf('.') != -1)
        // }else if(createOrderForm1.formData.payment_type == 'By Invoice 90 days'){
        //     item.name = 'order.payWithin90daysDiscount'
        //     createOrderForm2.formData.pay_with_days_discount = Number(multiply(Number(formatterToPoint(createOrderForm2.formData.pay_amount)), 0.02).toFixed(2))
        //     createOrderForm2.formData.pay_with_days_discount = formatterToComma(Number(createOrderForm2.formData.pay_with_days_discount), String(createOrderForm2.formData.order_amount).indexOf('.') != -1)
        // }else{
        //     item.name = 'order.payWithin14daysDiscount'
        //     createOrderForm2.formData.pay_with_days_discount = 0
        // }
    }

    // 预计发货日期
    const setHandleTimestampDisabledDate = (current)=>{
        // console.log(current,'current')
        let everyDate = timestampToDate(new Date(current).getTime()).split(' ')[0] // 日期组件每天日期
        let everyDateTimestamp = dateToTimestamp(everyDate)
        let orderTimestamp = createOrderForm1.formData.order_timestamp? dateToTimestamp(createOrderForm1.formData.order_timestamp.split(' ')[0]) : ''

        if(orderTimestamp !== '' && everyDateTimestamp < orderTimestamp){
            return true
        }else if(orderTimestamp !== '' && everyDateTimestamp >= orderTimestamp){
            return false
        }
    }

    // 计算订单头运费
    const computeCargoFreight = async (type, row, qtyVal)=>{
        console.log(cargoFreightNeedChange.value,'cargoFreightNeedChange.value')
        let country = createOrderForm1.formData.order_channel_type == 1 || createOrderForm1.formData.order_channel_type == 5? createOrderForm3.formData.country : 'ALL'        

        // 渠道没有配置运费，则取国家运费
        console.log(shipping_cost.value === '','渠道运费 数值')
        if(shipping_cost.value === '' || (shipping_cost.value !== '' && createOrderForm1.formData.delivery_timeliness == 1)){
            console.log('国家运费')
            if(createOrderForm1.formData.order_channel_type !== '' && country !== '' && cargoFreightNeedChange.value){
                unit_freight.value = await getFreight(createOrderForm1.formData.order_channel_type, country)
            }
        }else{
            console.log('渠道运费')
            unit_freight.value = shipping_cost.value
        }

        console.log(unit_freight.value,'运费单价')

        let limit_date = dateToTimestamp('2025-1-15') // 2025/1/15开始，创建的订单按运费新规则
        let order_date = dateToTimestamp(createOrderForm1.formData.order_timestamp) // 当前订单日期

        console.log(order_date >= limit_date, 'date', order_date, limit_date)
        if(order_date >= limit_date){
            let bike_qty = 0
            if(type && type == 'keyIsQuantity'){ // 订单行，整车数量发生变化
                if(row.product_code == '627.501')  bike_qty = qtyVal
                orderLineTable.value.datas.forEach(i=>{
                    if(i.product_code == '627.501' && i.sku !== row.sku){
                        bike_qty += i.quantity
                    }
                })
            }else{
                orderLineTable.value.datas.forEach(i=>{
                    if(i.product_code == '627.501'){
                        bike_qty += i.quantity
                    }
                })
            }
            console.log(bike_qty, createOrderForm1.formData.delivery_type, 'qty')

            if(bike_qty !== 0 && createOrderForm1.formData.delivery_type != 'self-pickup'){
                createOrderForm1.formData.cargo_freight = multiply(bike_qty, unit_freight.value)  
            }
        }
    }

    watch(localeStore,(val)=>{
        resetTableHeight(val.clientHeight)
    })

    // 监听国家变化，获取运费单价，计算订单头运费
    watch(()=>createOrderForm3.formData.country, async(newval, oldval)=>{
        console.log(newval, 'new old 国家', oldval)
        if(orderOperateType.value == 'edit' && oldval !== ''){
            console.log('监听国家变化，获取运费单价')
            let order_channel_type = createOrderForm1.formData.order_channel_type
            if(order_channel_type != undefined && order_channel_type !== '' && (order_channel_type == 0 || order_channel_type == 1)){
                cargoFreightNeedChange.value = true
                computeCargoFreight()
            }
        }else if(orderOperateType.value == 'add'){
            console.log('监听国家变化，获取运费单价 222222')
            let order_channel_type = createOrderForm1.formData.order_channel_type
            if(order_channel_type != undefined && order_channel_type !== '' && (order_channel_type == 0 || order_channel_type == 1)){
                cargoFreightNeedChange.value = true
                computeCargoFreight()
            }
        }
        
    })

    // 监听订单类别变化，获取运费单价，计算订单头运费
    // console.log('监听订单类别变化，获取运费单价',createOrderForm1.formData.order_channel_type)
    watch(()=>createOrderForm1.formData.order_channel_type, async(newval, oldval)=>{
        console.log(newval, 'new old订单类别', oldval)
        if(orderOperateType.value == 'edit' && oldval !== ''){
            console.log('监听订单类别变化，获取运费单价')
            if((newval == 0 || newval == 1) && !!createOrderForm3.formData.country){
                cargoFreightNeedChange.value = true
                computeCargoFreight()
            }
        }else if(orderOperateType.value == 'add'){
            console.log('监听订单类别变化，获取运费单价 2222')
            if((newval == 0 || newval == 1) && !!createOrderForm3.formData.country){
                cargoFreightNeedChange.value = true
                computeCargoFreight()
            }
        }
    })

    // 监听物流方式，自提方式，运费取0
    watch(()=>createOrderForm1.formData.delivery_type, (val)=>{
        if(val == 'self-pickup'){
            createOrderForm1.formData.cargo_freight = 0
        }  
    })

    // 监听订单行长度，计算运费金额
    watch(()=>orderLineTable.value.datas.length, (newval, oldval)=>{
        console.log(newval, 'new old 订单行', oldval)
        if(orderOperateType.value == 'edit' && oldval !== 0){
            console.log('订单行长度，获取运费单价')
            computeCargoFreight()
        }else if(orderOperateType.value == 'add'){
            console.log('订单行长度，获取运费单价 2222')
            computeCargoFreight()
        }
    })

    // 监听订单头运费，计算汇总运费（区分2b：订单头运费为不含税金额 和 2c：订单头金额是含税金额）
    watch(()=>createOrderForm1.formData.cargo_freight, (val)=>{
        // console.log(val,'vvvbbb')
        if(createOrderForm1.formData.order_channel_type == 1 || createOrderForm1.formData.order_channel_type == 5){
            createOrderForm2.formData.total_freight = formatterToComma(multiply(formatterToPoint(val), 1 + Number(createOrderForm1.formData.tax_rate)).toFixed(2), String(createOrderForm2.formData.order_amount).indexOf('.') != -1)
        }else if(createOrderForm1.formData.order_channel_type == 0){
            createOrderForm2.formData.total_freight = formatterToComma(val, String(createOrderForm2.formData.order_amount).indexOf('.') != -1)
        }

        // console.log(createOrderForm2.formData.total_freight,'total_freight kkkkkk')
    })

    // 计算汇总-实际支付金额   支付金额 = 订单金额 - 支付折扣 - 各行折扣总和 - 运费
    watch(()=>createOrderForm2.formData.order_amount,(val)=>{
        console.log(val,'汇总金额', createOrderForm1.formData)
        let discount_rate = createOrderForm1.formData.payment_type_discount  //createOrderForm1.formData.payment_type == 'SEPA'? 0.02 : createOrderForm1.formData.payment_type == 'DZB'? 0.01 : 0
        let pre_tax_pay_amount_total = divide(subtract(formatterToPoint(createOrderForm2.formData.order_amount),formatterToPoint(createOrderForm2.formData.order_discount)),1+Number(createOrderForm1.formData.tax_rate))
        let pre_tax_pay_amount_total_new = createOrderForm1.formData.order_channel_type == 5? add(multiply(pre_tax_pay_amount_total, 0.05), pre_tax_pay_amount_total) : pre_tax_pay_amount_total
        // console.log(pre_tax_pay_amount_total_new, 'pre_tax_pay_amount_total_new  22222')
        // 计算支付折扣金额
        createOrderForm1.formData.pay_type_discount = formatterToComma(multiply(pre_tax_pay_amount_total_new, discount_rate).toFixed(2), String(createOrderForm2.formData.order_amount).indexOf('.') != -1)
        // if(createOrderForm1.formData.payment_type == 'SEPA' && createOrderForm2.formData.order_amount !== ''){
        //     createOrderForm1.formData.pay_type_discount = formatterToComma(multiply(pre_tax_pay_amount_total_new, discount_rate).toFixed(2), String(createOrderForm2.formData.order_amount).indexOf('.') != -1)
        // }else if(createOrderForm1.formData.payment_type == 'DZB' && createOrderForm2.formData.order_amount !== ''){
        //     createOrderForm1.formData.pay_type_discount = formatterToComma(multiply(pre_tax_pay_amount_total_new, discount_rate).toFixed(2), String(createOrderForm2.formData.order_amount).indexOf('.') != -1)
        // }

        let pay_type_discount = multiply(formatterToPoint(createOrderForm1.formData.pay_type_discount), 1 + Number(createOrderForm1.formData.tax_rate))
        createOrderForm2.formData.total_payment_discount = formatterToComma(add(pay_type_discount, 0).toFixed(2), String(createOrderForm2.formData.order_amount).indexOf('.') != -1)
        if(createOrderForm1.formData.order_channel_type == 1 || createOrderForm1.formData.order_channel_type == 5){
            createOrderForm2.formData.total_freight = formatterToComma(multiply(formatterToPoint(createOrderForm1.formData.cargo_freight), 1 + Number(createOrderForm1.formData.tax_rate)).toFixed(2), String(createOrderForm2.formData.order_amount).indexOf('.') != -1)
            // console.log(createOrderForm2.formData.total_freight, 'total_freight 111')
        }else if(createOrderForm1.formData.order_channel_type == 0){
            createOrderForm2.formData.total_freight = formatterToComma(createOrderForm1.formData.cargo_freight, String(createOrderForm2.formData.order_amount).indexOf('.') != -1)
            // console.log(createOrderForm2.formData.total_freight, 'total_freight 222')
        }

        let order_amount = formatterToPoint(createOrderForm2.formData.order_amount)
        let order_discount = formatterToPoint(createOrderForm2.formData.order_discount)
        let extra_discount = formatterToPoint(createOrderForm2.formData.extra_discount)
        let cargo_freight = formatterToPoint(createOrderForm2.formData.total_freight)

        let c2c_extra_amount = 0
        createOrderForm2.formData.c2c_extra_amount = 0
        if(createOrderForm1.formData.order_channel_type == 5){
            createOrderForm2.formData.c2c_extra_amount = multiply(subtract(order_amount, order_discount), 0.05).toFixed(2)
            c2c_extra_amount = createOrderForm2.formData.c2c_extra_amount
        }

        if(!!order_discount && !!extra_discount && cargo_freight !== ''){
            // console.log('1',cargo_freight, subtract(add(add(order_discount,extra_discount), formatterToPoint(createOrderForm2.formData.total_payment_discount)),cargo_freight))
            createOrderForm2.formData.pay_amount = Number(subtract(add(order_amount,c2c_extra_amount), subtract(add(add(order_discount,extra_discount), formatterToPoint(createOrderForm2.formData.total_payment_discount)),cargo_freight)).toFixed(2))
            createOrderForm2.formData.pay_amount = formatterToComma(Number(createOrderForm2.formData.pay_amount), String(createOrderForm2.formData.order_amount).indexOf('.') != -1)
        }else if(!!order_discount && !!extra_discount && cargo_freight === ''){
            // console.log('2')
            createOrderForm2.formData.pay_amount = Number(subtract(add(order_amount,c2c_extra_amount), add(add(order_discount,extra_discount), formatterToPoint(createOrderForm2.formData.total_payment_discount))).toFixed(2))
            createOrderForm2.formData.pay_amount = formatterToComma(Number(createOrderForm2.formData.pay_amount), String(createOrderForm2.formData.order_amount).indexOf('.') != -1)
        }else if(!!order_discount && !extra_discount && cargo_freight !== ''){
            // console.log('3')
            createOrderForm2.formData.pay_amount = Number(subtract(add(order_amount,c2c_extra_amount), subtract(add(order_discount, formatterToPoint(createOrderForm2.formData.total_payment_discount)),cargo_freight)).toFixed(2))
            createOrderForm2.formData.pay_amount = formatterToComma(Number(createOrderForm2.formData.pay_amount), String(createOrderForm2.formData.order_amount).indexOf('.') != -1)
        }else if(!order_discount && !!extra_discount && cargo_freight !== ''){
            // console.log('4')
            createOrderForm2.formData.pay_amount = Number(subtract(add(order_amount,c2c_extra_amount), subtract(add(extra_discount, formatterToPoint(createOrderForm2.formData.total_payment_discount)),cargo_freight)).toFixed(2))
            createOrderForm2.formData.pay_amount = formatterToComma(Number(createOrderForm2.formData.pay_amount), String(createOrderForm2.formData.order_amount).indexOf('.') != -1)
        }else if(!order_discount && !extra_discount && cargo_freight !== ''){
            // console.log('5')
            createOrderForm2.formData.pay_amount = Number(subtract(add(order_amount,c2c_extra_amount), subtract(createOrderForm2.formData.total_payment_discount, cargo_freight)).toFixed(2))
            createOrderForm2.formData.pay_amount = formatterToComma(Number(createOrderForm2.formData.pay_amount), String(createOrderForm2.formData.order_amount).indexOf('.') != -1)
        }else{
            // console.log('6')
            createOrderForm2.formData.pay_amount = Number(add(order_amount,c2c_extra_amount))
            createOrderForm2.formData.pay_amount = formatterToComma(Number(createOrderForm2.formData.pay_amount), String(createOrderForm2.formData.order_amount).indexOf('.') != -1)
        }

        if(createOrderForm1.formData.payment_type == 'By Invoice'){
            set14discount()
        }else{
            createOrderForm2.formData.pay_with_days_discount = 0
        }
    })

    // 监听订单折扣，计算汇总-支付金额
    watch(()=>createOrderForm2.formData.order_discount,(val)=>{
        let discount_rate = createOrderForm1.formData.payment_type_discount  //createOrderForm1.formData.payment_type == 'SEPA'? 0.02 : createOrderForm1.formData.payment_type == 'DZB'? 0.01 : 0
        let pre_tax_pay_amount_total = divide(subtract(formatterToPoint(createOrderForm2.formData.order_amount),formatterToPoint(createOrderForm2.formData.order_discount)),1+Number(createOrderForm1.formData.tax_rate))
        let pre_tax_pay_amount_total_new = createOrderForm1.formData.order_channel_type == 5? add(multiply(pre_tax_pay_amount_total, 0.05), pre_tax_pay_amount_total) : pre_tax_pay_amount_total
        // console.log(pre_tax_pay_amount_total_new, 'pre_tax_pay_amount_total_new 333333')
        // 计算支付折扣金额
        createOrderForm1.formData.pay_type_discount = formatterToComma(multiply(pre_tax_pay_amount_total_new, discount_rate).toFixed(2), String(createOrderForm2.formData.order_amount).indexOf('.') != -1)
        // if(createOrderForm1.formData.payment_type == 'SEPA' && createOrderForm2.formData.order_amount !== ''){
        //     createOrderForm1.formData.pay_type_discount = formatterToComma(multiply(pre_tax_pay_amount_total_new, discount_rate).toFixed(2), String(createOrderForm2.formData.order_amount).indexOf('.') != -1)
        // }else if(createOrderForm1.formData.payment_type == 'DZB' && createOrderForm2.formData.order_amount !== ''){
        //     createOrderForm1.formData.pay_type_discount = formatterToComma(multiply(pre_tax_pay_amount_total_new, discount_rate).toFixed(2), String(createOrderForm2.formData.order_amount).indexOf('.') != -1)
        // }

        let pay_type_discount = multiply(formatterToPoint(createOrderForm1.formData.pay_type_discount), 1 + Number(createOrderForm1.formData.tax_rate))
        createOrderForm2.formData.total_payment_discount = formatterToComma(add(pay_type_discount, 0).toFixed(2), String(createOrderForm2.formData.order_amount).indexOf('.') != -1)
        if(createOrderForm1.formData.order_channel_type == 1 || createOrderForm1.formData.order_channel_type == 5){
            createOrderForm2.formData.total_freight = formatterToComma(multiply(formatterToPoint(createOrderForm1.formData.cargo_freight), 1 + Number(createOrderForm1.formData.tax_rate)).toFixed(2), String(createOrderForm2.formData.order_amount).indexOf('.') != -1)
        }else if(createOrderForm1.formData.order_channel_type == 0){
            createOrderForm2.formData.total_freight = formatterToComma(createOrderForm1.formData.cargo_freight, String(createOrderForm2.formData.order_amount).indexOf('.') != -1)
        }

        let order_amount = formatterToPoint(createOrderForm2.formData.order_amount)
        let order_discount = formatterToPoint(createOrderForm2.formData.order_discount)
        let extra_discount = formatterToPoint(createOrderForm2.formData.extra_discount)
        let cargo_freight = formatterToPoint(createOrderForm2.formData.total_freight)

        let c2c_extra_amount = 0
        createOrderForm2.formData.c2c_extra_amount = 0
        if(createOrderForm1.formData.order_channel_type == 5){
            createOrderForm2.formData.c2c_extra_amount = multiply(subtract(order_amount, order_discount), 0.05).toFixed(2)
            c2c_extra_amount = createOrderForm2.formData.c2c_extra_amount
        }

        if(order_amount !== '' && !!extra_discount){
            // console.log('11',createOrderForm2.formData.total_freight)
            createOrderForm2.formData.pay_amount = Number(subtract(add(order_amount,c2c_extra_amount), subtract(add(add(order_discount,extra_discount), formatterToPoint(createOrderForm2.formData.total_payment_discount)),cargo_freight)).toFixed(2))
            createOrderForm2.formData.pay_amount = formatterToComma(Number(createOrderForm2.formData.pay_amount), String(createOrderForm2.formData.order_amount).indexOf('.') != -1)
        }else if(order_amount !== '' && !extra_discount){
            // console.log('22')
            createOrderForm2.formData.pay_amount = Number(subtract(add(order_amount,c2c_extra_amount), subtract(add(order_discount, formatterToPoint(createOrderForm2.formData.total_payment_discount)),cargo_freight)).toFixed(2))
            createOrderForm2.formData.pay_amount = formatterToComma(Number(createOrderForm2.formData.pay_amount), String(createOrderForm2.formData.order_amount).indexOf('.') != -1)
        }else if(order_amount === '' && !!extra_discount){
            // console.log('33')
            createOrderForm2.formData.pay_amount = Number(subtract(add(order_amount,c2c_extra_amount), subtract(add(extra_discount, formatterToPoint(createOrderForm2.formData.total_payment_discount)),cargo_freight)).toFixed(2))
            createOrderForm2.formData.pay_amount = formatterToComma(Number(createOrderForm2.formData.pay_amount), String(createOrderForm2.formData.order_amount).indexOf('.') != -1)
        }

        if(createOrderForm1.formData.payment_type == 'By Invoice'){
            set14discount()
        }else{
            createOrderForm2.formData.pay_with_days_discount = 0
        }
    })

    // 监听额外折扣，计算汇总-支付金额
    watch(()=>createOrderForm2.formData.extra_discount,(val)=>{
        let discount_rate = createOrderForm1.formData.payment_type_discount  // createOrderForm1.formData.payment_type == 'SEPA'? 0.02 : createOrderForm1.formData.payment_type == 'DZB'? 0.01 : 0
        let pre_tax_pay_amount_total = divide(subtract(formatterToPoint(createOrderForm2.formData.order_amount),formatterToPoint(createOrderForm2.formData.order_discount)),1+Number(createOrderForm1.formData.tax_rate))
        let pre_tax_pay_amount_total_new = createOrderForm1.formData.order_channel_type == 5? add(multiply(pre_tax_pay_amount_total, 0.05), pre_tax_pay_amount_total) : pre_tax_pay_amount_total
        // console.log(pre_tax_pay_amount_total_new, 'pre_tax_pay_amount_total_new 44444')
        // 计算支付折扣金额
        createOrderForm1.formData.pay_type_discount = formatterToComma(multiply(pre_tax_pay_amount_total_new, discount_rate).toFixed(2), String(createOrderForm2.formData.order_amount).indexOf('.') != -1)

        // if(createOrderForm1.formData.payment_type == 'SEPA' && createOrderForm2.formData.order_amount !== ''){
        //     createOrderForm1.formData.pay_type_discount = formatterToComma(multiply(pre_tax_pay_amount_total_new, discount_rate).toFixed(2), String(createOrderForm2.formData.order_amount).indexOf('.') != -1)
        // }else if(createOrderForm1.formData.payment_type == 'DZB' && createOrderForm2.formData.order_amount !== ''){
        //     createOrderForm1.formData.pay_type_discount = formatterToComma(multiply(pre_tax_pay_amount_total_new, discount_rate).toFixed(2), String(createOrderForm2.formData.order_amount).indexOf('.') != -1)
        // }
        
        let pay_type_discount = multiply(formatterToPoint(createOrderForm1.formData.pay_type_discount), 1 + Number(createOrderForm1.formData.tax_rate))
        createOrderForm2.formData.total_payment_discount = formatterToComma(add(pay_type_discount, 0).toFixed(2), String(createOrderForm2.formData.order_amount).indexOf('.') != -1)
        if(createOrderForm1.formData.order_channel_type == 1 || createOrderForm1.formData.order_channel_type == 5){
            createOrderForm2.formData.total_freight = formatterToComma(multiply(formatterToPoint(createOrderForm1.formData.cargo_freight), 1 + Number(createOrderForm1.formData.tax_rate)).toFixed(2), String(createOrderForm2.formData.order_amount).indexOf('.') != -1)
        }else if(createOrderForm1.formData.order_channel_type == 0){
            createOrderForm2.formData.total_freight = formatterToComma(createOrderForm1.formData.cargo_freight, String(createOrderForm2.formData.order_amount).indexOf('.') != -1)
        }

        let order_amount = formatterToPoint(createOrderForm2.formData.order_amount)
        let order_discount = formatterToPoint(createOrderForm2.formData.order_discount)
        let extra_discount = formatterToPoint(createOrderForm2.formData.extra_discount)
        let cargo_freight = formatterToPoint(createOrderForm2.formData.total_freight)

        let c2c_extra_amount = 0
        createOrderForm2.formData.c2c_extra_amount = 0
        if(createOrderForm1.formData.order_channel_type == 5){
            createOrderForm2.formData.c2c_extra_amount = multiply(subtract(order_amount, order_discount), 0.05).toFixed(2)
            c2c_extra_amount = createOrderForm2.formData.c2c_extra_amount
        }

        if(order_amount !== '' && extra_discount !== ''){
            // console.log('111',createOrderForm2.formData.total_freight)
            createOrderForm2.formData.pay_amount = Number(subtract(add(order_amount,c2c_extra_amount), subtract(add(add(order_discount,extra_discount), formatterToPoint(createOrderForm2.formData.total_payment_discount)),cargo_freight)).toFixed(2))
            createOrderForm2.formData.pay_amount = formatterToComma(Number(createOrderForm2.formData.pay_amount), String(createOrderForm2.formData.order_amount).indexOf('.') != -1)
        }else if(order_amount !== '' && extra_discount === ''){
            // console.log('222')
            createOrderForm2.formData.pay_amount = Number(subtract(add(order_amount,c2c_extra_amount), subtract(add(order_discount, formatterToPoint(createOrderForm2.formData.total_payment_discount)),cargo_freight)).toFixed(2))
            createOrderForm2.formData.pay_amount = formatterToComma(Number(createOrderForm2.formData.pay_amount), String(createOrderForm2.formData.order_amount).indexOf('.') != -1)
        }else if(order_amount === '' && extra_discount !== ''){
            // console.log('333')
            createOrderForm2.formData.pay_amount = Number(subtract(add(order_amount,c2c_extra_amount), subtract(add(extra_discount, formatterToPoint(createOrderForm2.formData.total_payment_discount)),cargo_freight)).toFixed(2))
            createOrderForm2.formData.pay_amount = formatterToComma(Number(createOrderForm2.formData.pay_amount), String(createOrderForm2.formData.order_amount).indexOf('.') != -1)
        }

        if(createOrderForm1.formData.payment_type == 'By Invoice'){
            set14discount()
        }else{
            createOrderForm2.formData.pay_with_days_discount = 0
        }
    })

    // 监听支付金额，计算汇总-税额   税额 = ((订单金额-折扣)/(1+税率))*税率 ， 折扣金额 = 支付折扣 + 各行折扣总和
    watch(()=>createOrderForm2.formData.pay_amount,(val)=>{
        let tax_rate = createOrderForm1.formData.tax_rate
        if(tax_rate != ''){ 
            createOrderForm2.formData.order_tax = Number(multiply(divide(formatterToPoint(val), 1 + Number(createOrderForm1.formData.tax_rate)), Number(createOrderForm1.formData.tax_rate)).toFixed(2))
            createOrderForm2.formData.order_tax = formatterToComma(Number(createOrderForm2.formData.order_tax), String(createOrderForm2.formData.order_amount).indexOf('.') != -1)
        }

        let item = createOrderForm2.formField.find(i=>i.key == 'pay_amount')
        item.error = createOrderForm2.formData.pay_amount < 0
        item.helpMasg = item.error? 'The payment amount is less than 0. Please check if the order amount and discount are incorrect.' : ''
        item.validateStatus = item.error? 'error' : ''
    })

    // 计算汇总-监听运费总金额，计算支付金额   支付金额 = 订单金额 - 支付折扣 - 各行折扣总和 - 总运费
    watch(()=>createOrderForm2.formData.total_freight,(val)=>{
        // console.log('总运费', val)
        let discount_rate = createOrderForm1.formData.payment_type_discount  // createOrderForm1.formData.payment_type == 'SEPA'? 0.02 : createOrderForm1.formData.payment_type == 'DZB'? 0.01 : 0
        let pre_tax_pay_amount_total = divide(subtract(formatterToPoint(createOrderForm2.formData.order_amount),formatterToPoint(createOrderForm2.formData.order_discount)),1+Number(createOrderForm1.formData.tax_rate))
        let pre_tax_pay_amount_total_new = createOrderForm1.formData.order_channel_type == 5? add(multiply(pre_tax_pay_amount_total, 0.05), pre_tax_pay_amount_total) : pre_tax_pay_amount_total
        // console.log(pre_tax_pay_amount_total_new, 'pre_tax_pay_amount_total_new 5555555')
        // 计算支付折扣金额
        createOrderForm1.formData.pay_type_discount = formatterToComma(multiply(pre_tax_pay_amount_total_new, discount_rate).toFixed(2), String(createOrderForm2.formData.order_amount).indexOf('.') != -1)

        // if(createOrderForm1.formData.payment_type == 'SEPA' && createOrderForm2.formData.order_amount !== ''){
        //     createOrderForm1.formData.pay_type_discount = formatterToComma(multiply(pre_tax_pay_amount_total_new, discount_rate).toFixed(2), String(createOrderForm2.formData.order_amount).indexOf('.') != -1)
        // }else if(createOrderForm1.formData.payment_type == 'DZB' && createOrderForm2.formData.order_amount !== ''){
        //     createOrderForm1.formData.pay_type_discount = formatterToComma(multiply(pre_tax_pay_amount_total_new, discount_rate).toFixed(2), String(createOrderForm2.formData.order_amount).indexOf('.') != -1)
        // }

        let pay_type_discount = multiply(formatterToPoint(createOrderForm1.formData.pay_type_discount), 1 + Number(createOrderForm1.formData.tax_rate))
        createOrderForm2.formData.total_payment_discount = formatterToComma(add(pay_type_discount, 0).toFixed(2), String(createOrderForm2.formData.order_amount).indexOf('.') != -1)

        let order_amount = formatterToPoint(createOrderForm2.formData.order_amount)
        let order_discount = formatterToPoint(createOrderForm2.formData.order_discount)
        let extra_discount = formatterToPoint(createOrderForm2.formData.extra_discount)
        let cargo_freight = formatterToPoint(val)

        let c2c_extra_amount = 0
        createOrderForm2.formData.c2c_extra_amount = 0
        if(createOrderForm1.formData.order_channel_type == 5){
            createOrderForm2.formData.c2c_extra_amount = multiply(subtract(order_amount, order_discount), 0.05).toFixed(2)
            c2c_extra_amount = createOrderForm2.formData.c2c_extra_amount
        }

        if(!!order_discount && !!extra_discount && cargo_freight !== ''){
            // console.log('1',cargo_freight, subtract(add(add(order_discount,extra_discount), formatterToPoint(createOrderForm2.formData.total_payment_discount)),cargo_freight))
            createOrderForm2.formData.pay_amount = Number(subtract(add(order_amount,c2c_extra_amount), subtract(add(add(order_discount,extra_discount), formatterToPoint(createOrderForm2.formData.total_payment_discount)),cargo_freight)).toFixed(2))
            createOrderForm2.formData.pay_amount = formatterToComma(Number(createOrderForm2.formData.pay_amount), String(createOrderForm2.formData.order_amount).indexOf('.') != -1)
        }else if(!!order_discount && !!extra_discount && cargo_freight === ''){
            // console.log('2')
            createOrderForm2.formData.pay_amount = Number(subtract(add(order_amount,c2c_extra_amount), add(add(order_discount,extra_discount), formatterToPoint(createOrderForm2.formData.total_payment_discount))).toFixed(2))
            createOrderForm2.formData.pay_amount = formatterToComma(Number(createOrderForm2.formData.pay_amount), String(createOrderForm2.formData.order_amount).indexOf('.') != -1)
        }else if(!!order_discount && !extra_discount && cargo_freight !== ''){
            // console.log('3')
            createOrderForm2.formData.pay_amount = Number(subtract(add(order_amount,c2c_extra_amount), subtract(add(order_discount, formatterToPoint(createOrderForm2.formData.total_payment_discount)),cargo_freight)).toFixed(2))
            createOrderForm2.formData.pay_amount = formatterToComma(Number(createOrderForm2.formData.pay_amount), String(createOrderForm2.formData.order_amount).indexOf('.') != -1)
        }else if(!order_discount && !!extra_discount && cargo_freight !== ''){
            // console.log('4')
            createOrderForm2.formData.pay_amount = Number(subtract(add(order_amount,c2c_extra_amount), subtract(add(extra_discount, formatterToPoint(createOrderForm2.formData.total_payment_discount)),cargo_freight)).toFixed(2))
            createOrderForm2.formData.pay_amount = formatterToComma(Number(createOrderForm2.formData.pay_amount), String(createOrderForm2.formData.order_amount).indexOf('.') != -1)
        }else if(!order_discount && !extra_discount && cargo_freight !== ''){
            // console.log('5')
            createOrderForm2.formData.pay_amount = Number(subtract(add(order_amount,c2c_extra_amount), subtract(createOrderForm2.formData.total_payment_discount, cargo_freight)).toFixed(2))
            createOrderForm2.formData.pay_amount = formatterToComma(Number(createOrderForm2.formData.pay_amount), String(createOrderForm2.formData.order_amount).indexOf('.') != -1)
        }else{
            // console.log('6')
            createOrderForm2.formData.pay_amount = Number(add(order_amount,c2c_extra_amount))
            createOrderForm2.formData.pay_amount = formatterToComma(Number(createOrderForm2.formData.pay_amount), String(createOrderForm2.formData.order_amount).indexOf('.') != -1)
        }

        if(createOrderForm1.formData.payment_type == 'By Invoice'){
            set14discount()
        }else{
            createOrderForm2.formData.pay_with_days_discount = 0
        }
    })



    onMounted(async ()=>{
        getCourierType()
        await getOrderSource()
        getCountry()
        getProductList()
        getDeliveryType()
        getPayDiscountConfig()
        getCashDiscountConfig()
        getPayDayConfig()
        getCashDiscountPayDayConfig()
        getWarehouseConfig()

        nextTick(()=>{
            const clientHeight = document.body.clientHeight
            resetTableHeight(clientHeight)
        })

        let roleArr = userInfo.role.split(',')
        isFinance.value = roleArr.some(i=> i == '4')

        if(history.state.fromPage == 'DealerBusinessOrder'){
            fromPage.value = history.state.fromPage
            let dealerPreOrdreData = JSON.parse(history.state.row)
            editbusinessOrder(dealerPreOrdreData)
        }else if(history.state.fromPage == 'B2BShopOrder'){
            fromPage.value = history.state.fromPage
            let B2BShopOrderData = JSON.parse(history.state.row)
            editbusinessOrder(B2BShopOrderData)
        }else{
            getWarehouse()
            getDefaultWarehouse()
            getCustomerNameList()
            getOrderHead()
            getRefundReasonType()
            getUser()
            getOrderUse()
        }

        if(route.query.fromPage == 'DealerBusinessOrder2' || route.query.fromPage == 'B2BShopOrder2'){
            queryForm.formData.order_name = route.query.order_name
            getOrderHead()
        }
        
        is_hepha_customer.value = userInfo.role == 16
    })

</script>

<style lang="less" scoped>

.queryPanel{
    display: flex;
    // margin-bottom:7px;
    padding:7px;
    background: #fff;
    border-bottom: 1px dashed #ccc;

    .queryPanel_form{
        display: flex;
        flex:14;
        flex-direction: column;
        height: 33px;
        overflow: hidden;

        /deep/ .arco-form-layout-inline .arco-form-item{
            margin-bottom:0;
        }
    }

    .queryPanel_form_show{
        height: auto;
        overflow: visible;
    }

    .queryPanel_btn{
        display: flex;
        flex:1;
        // flex-direction: column;
        justify-content: center;
        align-items: center;
        border-left:1px solid #eee;
        padding-left:5px;

        .openBtn{
            display: inline-block;
            padding: 3px 10px;
            margin: 2px 5px 0 5px;
            width: 80px;
            text-align: center;
            color: #165dff;
            cursor: pointer;
            border: 1px solid #165dff;
            border-radius:2px;
        }
    }

    /deep/ .arco-form-item-label-col > .arco-form-item-label{
        font-size:12px;
    }

    .form_btn{
        margin:5px 5px 3px;
        width:70px;
    }
}

/deep/ .operayeBox {
    margin-bottom: 7px;
    background: #fff;
    padding: 5px 24px 5px;
}

/deep/ .arco-btn-group{
    vertical-align: bottom;
}
/deep/ .arco-btn-group .arco-btn:first-child,
/deep/ .arco-btn-group .arco-btn:last-child{
    background: #165dff;
    color: #fff;
}

/deep/ .arco-table-th{
    background: #fff;
    border-bottom: 1px solid #eee;
    border-right: 1px solid #eee;
    // padding: 0px 0;
    font-size: 13px;
    font-weight: 600;
}

/deep/ .arco-table-td{
    padding: 0;
    // border-bottom: none;
    border-right: 1px solid #eee;
}

/deep/ .arco-table-container{
    padding-bottom:0;
}

/deep/ .arco-table-cell-fixed-expand{
    margin-bottom:15px;
}

/deep/ .arco-pagination-options .arco-select,
/deep/ .arco-pagination-jumper .arco-pagination-jumper-input input{
    background: #e7e7e7;
}

/deep/  button:focus,
/deep/  button:focus-visible{
    outline: none;
}

/deep/.childrenTable{
    .arco-table-th{
        background-color: #333 !important;
        color: #fff;
        border-bottom: 1px solid #eee;
        padding: 0;
        font-weight: 300;
        font-size:12px;
    }
    .arco-table-td{
        padding: 0;
        background-color: #ddd !important;
    }

    .arco-icon-filter{
        color: #fff;
    }
}

.orderLineTable{
    /deep/ .arco-input-wrapper,
    /deep/ .arco-select-view-single,
    /deep/ .arco-picker{
        background-color: #fff;
        border: 1px solid #ccc;
    }
    /deep/ .arco-input-disabled,
    /deep/ .arco-select-view-disabled,
    /deep/ .arco-picker-disabled{
        background-color: #f2f3f5;
        border-color: transparent;
    }
}

/deep/ .arco-picker-size-medium input,
/deep/ .arco-input-wrapper .arco-input.arco-input-size-medium,
/deep/ .arco-select-view-single.arco-select-view-size-medium .arco-select-view-input{
    font-size:12px;
}

/deep/ .arco-picker-size-medium{
    height: 28px;
}

.amountBlock{
    position: relative;
    font-size:13px;
    color:#666;
    p{
        margin:0px;

        span{
            display: inline-block;
            width: 120px;
        }
    }
}

.amountBlock2{
    position: relative;
    font-size:13px;
    color:#666;
    p{
        margin:0px;

        span{
            display: inline-block;
            width: 70px;
        }
    }
}

.arrowTop{
    position: absolute;
    top: 10px;
    left: -15px;
}

.arrowBottom{
    top: 60px;
}

 .deliverModalForm,.addForm{
    /deep/ .arco-input-wrapper,
    /deep/ .arco-form-item-content,
    /deep/ .arco-select-view-single,
    /deep/ .arco-picker-size-medium{
        height: 37px;
        min-height: 37px;
    }

    /deep/ .arco-form > div{
        margin-left: 70px !important;
    }
}

.deliverTable{
        /deep/ .arco-table-th{
            background-color: #333 !important;
            color: #fff;
            border-bottom: 1px solid #eee;
            padding: 0;
            font-weight: 300;
            font-size:12px;
        }
}

/deep/ .arco-checkbox-disabled .arco-checkbox-icon {
    background-color: #ccc;
    border-color: #ccc;
}

/deep/ .arco-collapse-item-content{
    padding-left:10px;
}

/deep/ .arco-form-item-layout-inline{
    margin-right:0;
}

.courierNo{
    padding: 15px 0;
    font-size: 20px;
    font-weight: bold;
}

.formTip{
    color: red;
    font-size: 13px;
    margin-left: 222px;
    margin-top: -13px;
}

/deep/ .arco-divider-vertical{
    margin: 0 5px;
}

.courierMesg{
    font-size:14px;
    color:#adb0b3;
}

.diabledDanger{
    margin:3px;
    width:120px;
    background: #ff8978;
}

.danger{
    margin:3px;
    width:120px;
    background: #f64616;
}

.disabledSuccess{
    margin:3px;
    width:120px;
    background-color: #caec85;
}

.success{
    margin:3px;
    width:120px;
    background-color: #78be1e;
}

.disabledWarning{
    margin:3px;
    width:120px;
    background-color: #f5d362;
}

.warning{
    margin:3px;
    width:120px;
    background-color: #f0aa00;
}

.createOrderForm{
    min-width: 70%;
    max-width:75%;
    margin:0 auto;
    padding:20px;

    /deep/ .arco-form{
        display: block;
        text-align: center;
    }

    /deep/ .arco-input-wrapper .arco-input{
        height: 30px;
        width:100%;
    }

    /deep/ .arco-select,
    /deep/ .arco-picker{
        height: 40px;
    }
}

.fullscreenIcon{
    float:right;
    margin-top:-18px;
    cursor: pointer;
}

.tableScreenFullIcon{
    float: right;
    margin-bottom: 10px;
    padding-right: 10px;
    cursor:pointer;
}

.customer_info{
    font-size:12px;
    color: #666;
    padding: 0 10px;
    line-height: 18px;
}

.orderLineTable{
    /deep/ .arco-pagination{
        display:none;
    }
}

.addIcon{
    margin-top:15px;
    width:99%;
    border: 1px dashed #ccc;
    color:#333;
    text-align: center;
    cursor:pointer;

    &:hover{
        background: #fff;
        opacity: .5;
    }
}

.createOrderForm{
    /deep/ .arco-form-item-status-error {
        .arco-form-item-message-help{
            text-align: left;
        }
    }
}

/deep/ .arco-form-item-message-help{
    color: red;
}

.remark_content{
    display:inline-block;
    width:180px;
    line-height:12px;
    white-space:nowrap;
    overflow:hidden;
    text-overflow:ellipsis;
    cursor: pointer;
}
.user_comment{
    display:inline-block;
    width:120px;
    line-height:12px;
    white-space:nowrap;
    overflow:hidden;
    text-overflow:ellipsis;
    cursor: pointer;
}

.remark{
    padding: 3px;
    background: #f5f5f5;
    cursor: pointer;
}

.footerBtn{
    width:100%;
    margin: 10px auto;
    text-align: right;
}

/deep/ .arco-divider-text{
    font-weight: bold;
}

/deep/ .arco-spin-loading .arco-spin-mask-icon{
    top:15%;
}

.editOrderTitle{
    font-weight:bold;
    text-align: center;
}

.edit_icon{
    float:right;
    color: #4080ff;
    cursor:pointer;
}

.itemPreText{
    color: #165dff;
    width: 480px;
    text-align: left;
    font-size:12px;
}

.itemAfterText{
    margin-top: -15px;
}

/deep/ .arco-popover-popup-content{
    padding: 8px 16px;
}

/deep/ .arco-alert{
    padding: 0 8px;
    width:420px;
}

.searchFilter{
    padding: 20px;
    background: #fff;
    box-shadow: 0px 5px 15px 0px rgba(0, 0, 0, 0.12), 0px 15px 35px 0px rgba(60, 66, 87, 0.08);
}

/deep/ .arco-table-filters svg{
    color: #fff;
}
</style>
